/* tslint:disable */
/* eslint-disable */
/**
 * BuLLy documentation
 * BuLLy Server
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redteclab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import globalAxios from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction
} from "./common";
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, BaseAPI} from "./base";
export const AddressDetailsCountryCodeEnum = {
  De: "DE"
};
export const AddressGet403MessageEnum = {
  AddressErrorAccessForbidden: "address.error.access.forbidden",
  CustomerDataErrorAccessForbidden: "customerData.error.access.forbidden"
};
export const AmountV1CurrencyEnum = {
  Eur: "EUR",
  Chf: "CHF"
};
export const BadRequestCheckoutController400MessageEnum = {
  ValidationException: "Validation Exception",
  VoucherInvalid: "voucher.invalid",
  OverdraftsExisting: "overdrafts.existing"
};
export const BillingAddressTypeEnum = {
  Billing: "billing"
};
export const BillingAddressV1TypeEnum = {
  Billing: "BILLING"
};
export const BillingRequestV2TypeEnum = {
  Billing: "billing"
};
export const BillingResponseV2TypeEnum = {
  Billing: "billing"
};
export const BillingResponseV2WithNowDataTypeEnum = {
  Billing: "billing"
};
export const CartDiscountsV2TypeEnum = {
  Voucher: "voucher",
  Redpoints: "redpoints"
};
export const CartEntryItemERxV2MedicationTypeEnum = {
  Pzn: "pzn",
  Composite: "composite",
  ActiveSubstance: "activeSubstance",
  Freetext: "freetext"
};
export const CartEntryItemV2NowProductGroupEnum = {
  Nextday: "nextday",
  None: "none",
  SamedayNextday: "sameday_nextday"
};
export const CartEntryItemV2EntryTypeEnum = {
  Article: "article",
  Service: "service",
  Set: "set"
};
export const CartGroupEntryERxV2TypeEnum = {
  PrivatePrescription: "privatePrescription",
  FreePrescription: "freePrescription",
  InsurancePrescription: "insurancePrescription"
};
export const CartGroupEntryV2TypeEnum = {
  OdsSection: "odsSection",
  PrivatePrescription: "privatePrescription",
  FreePrescription: "freePrescription",
  InsurancePrescription: "insurancePrescription",
  NoPrescription: "noPrescription",
  BonusSection: "bonusSection"
};
export const CartMessageV2TypeEnum = {
  Error: "error",
  Warn: "warn",
  Info: "info"
};
/**
 *
 * @export
 * @enum {string}
 */
export const CartPrescriptionTypeV2 = {
  NoPrescription: "noPrescription",
  PrivatePrescription: "privatePrescription",
  InsurancePrescription: "insurancePrescription",
  FreePrescription: "freePrescription"
};
export const CartV2RedPointsRegistrationStatusEnum = {
  NoMember: "NO_MEMBER",
  Pending: "PENDING",
  Subscribed: "SUBSCRIBED"
};
export const CheckoutBillingAddressTypeEnum = {
  Billing: "billing"
};
export const CheckoutCarrierEntriesTypeEnum = {
  DiscountRemoved: "discountRemoved",
  PositionRemoved: "positionRemoved",
  PositionPriceChanged: "positionPriceChanged",
  DiscountApplied: "discountApplied"
};
export const CheckoutCustomerMasterDataRedPointsRegistrationStatusEnum = {
  NoMember: "NO_MEMBER",
  Pending: "PENDING",
  Subscribed: "SUBSCRIBED"
};
export const CheckoutDiscountTypeEnum = {
  Voucher: "voucher",
  Redpoints: "redpoints"
};
export const CheckoutDocumentPositionNowProductGroupEnum = {
  Nextday: "nextday",
  None: "none",
  SamedayNextday: "sameday_nextday"
};
export const CheckoutDocumentPositionPrescriptionTypeEnum = {
  NoPrescription: "noPrescription",
  PrivatePrescription: "privatePrescription",
  InsurancePrescription: "insurancePrescription",
  FreePrescription: "freePrescription"
};
export const CheckoutDocumentPositionEntryTypeEnum = {
  Set: "set",
  Service: "service",
  Article: "article"
};
export const CheckoutDocumentPositionERxMedicationTypeEnum = {
  Pzn: "pzn",
  Composite: "composite",
  ActiveSubstance: "activeSubstance",
  Freetext: "freetext"
};
export const CheckoutDocumentPositionERxNowProductGroupEnum = {
  Nextday: "nextday",
  None: "none",
  SamedayNextday: "sameday_nextday"
};
export const CheckoutDoorDeliveryAddressTypeEnum = {
  Shipping: "shipping",
  Billing: "billing"
};
export const CheckoutOrderDocumentTypeEnum = {
  OdsSection: "odsSection",
  PrivatePrescription: "privatePrescription",
  FreePrescription: "freePrescription",
  InsurancePrescription: "insurancePrescription",
  NoPrescription: "noPrescription"
};
export const CheckoutOrderDocumentERxTypeEnum = {
  PrivatePrescription: "privatePrescription",
  FreePrescription: "freePrescription",
  InsurancePrescription: "insurancePrescription"
};
export const CheckoutOrderMasterDataSubOrderTypesIncludedEnum = {
  MarketPlace: "MarketPlace",
  Now: "Now",
  ShopApothekeEurope: "ShopApothekeEurope"
};
export const CheckoutPaymentRequestPaymentKindEnum = {
  Applepay: "applepay",
  DirectEbanking: "directEbanking",
  Klarna: "klarna",
  KlarnaPaynow: "klarna_paynow",
  NativeCashOnDelivery: "nativeCashOnDelivery",
  NativeDirectDebit: "nativeDirectDebit",
  NativeInvoice: "nativeInvoice",
  NativePostFinance: "nativePostFinance",
  NativePrepayment: "nativePrepayment",
  Paypal: "paypal",
  Ratepay: "ratepay",
  Scheme: "scheme",
  Twint: "twint"
};
export const CheckoutPaymentRequestMerchantAccountEnum = {
  ShopApothekeDirectSales: "ShopApothekeDirectSales",
  EuropaApotheek: "EuropaApotheek",
  ShopApothekeEcom: "ShopApothekeECOM",
  ShopApotheke: "Shop-Apotheke",
  ShopApothekeAt: "Shop-ApothekeAT",
  ShopApothekeIt: "Shop-ApothekeIT"
};
export const CheckoutPaymentResponsePaymentKindEnum = {
  Applepay: "applepay",
  DirectEbanking: "directEbanking",
  Klarna: "klarna",
  KlarnaPaynow: "klarna_paynow",
  NativeCashOnDelivery: "nativeCashOnDelivery",
  NativeDirectDebit: "nativeDirectDebit",
  NativeInvoice: "nativeInvoice",
  NativePostFinance: "nativePostFinance",
  NativePrepayment: "nativePrepayment",
  Paypal: "paypal",
  Ratepay: "ratepay",
  Scheme: "scheme",
  Twint: "twint"
};
export const CheckoutPaymentResponseMerchantAccountEnum = {
  ShopApothekeDirectSales: "ShopApothekeDirectSales",
  EuropaApotheek: "EuropaApotheek",
  ShopApothekeEcom: "ShopApothekeECOM",
  ShopApotheke: "Shop-Apotheke",
  ShopApothekeAt: "Shop-ApothekeAT",
  ShopApothekeIt: "Shop-ApothekeIT"
};
export const CheckoutPaymentsActionTypeEnum = {
  Await: "await",
  Donate: "donate",
  QrCode: "qrCode",
  Redirect: "redirect",
  Sdk: "sdk",
  ThreeDs2Challenge: "threeDS2Challenge",
  ThreeDs2Fingerprint: "threeDS2Fingerprint",
  Voucher: "voucher",
  WechatpaySdk: "wechatpaySDK"
};
export const CheckoutPickupStationAddressTypeEnum = {
  PickupStation: "pickupStation"
};
export const CheckoutShippingAddressRequestV1ClientPlatformEnum = {
  WebDesktop: "web_desktop",
  WebMobile: "web_mobile",
  Ios: "ios",
  Android: "android"
};
export const CheckoutSubOrderOrderTypeEnum = {
  Standard: "standard",
  Subscription: "subscription",
  Guest: "guest"
};
export const ClaimPrescriptionByInsuranceNumberInvalidObjectErrorTypeEnum = {
  NoMatch: "no_match",
  Redeemed: "redeemed",
  Deleted: "deleted",
  GeneralError: "general_error"
};
/**
 * state of the co-Payment exemption
 * @export
 * @enum {string}
 */
export const CoPaymentStatus = {
  CoPayment: "coPayment",
  NoCoPayment: "noCoPayment",
  _27aSgbv: "27aSGBV"
};
export const ConfirmationDataResponseV1CustomerStatusEnum = {
  Existing: "EXISTING",
  New: "NEW"
};
/**
 * entity that pays for the prescription
 * @export
 * @enum {string}
 */
export const CoverageType = {
  Gkv: "GKV",
  Bg: "BG",
  Uk: "UK"
};
export const CreateOrder400MessageEnum = {
  RequestBodyValidation: "checkout.error.requestBody.validation",
  RedPointsReservation: "checkout.error.redPoints.reservation",
  RequestBodyValidationNowSlotOrderCreationExpired:
    "checkout.error.requestBody.validation.NOW_SLOT_ORDER_CREATION_EXPIRED"
};
export const CreatePayment400MessageEnum = {
  RequestBodyValidation: "payment.error.requestBody.validation",
  RedPointsReservation: "payment.error.redPoints.reservation"
};
export const DeliveryAddressV1TypeEnum = {
  Shipping: "SHIPPING",
  Pickupstation: "PICKUPSTATION"
};
export const DeliveryV1DeliveryModeServiceEnum = {
  Express: "EXPRESS",
  Standard: "STANDARD"
};
export const DisableResponseV1ResponseEnum = {
  DetailSuccessfullyDisabled: "detail-successfully-disabled",
  AllDetailsSuccessfullyDisabled: "all-details-successfully-disabled"
};
export const DiscountTypeEnum = {
  Voucher: "voucher",
  Redpoints: "redpoints"
};
export const DocumentLinkV3DoctypeEnum = {
  ExternalLmivpdf: "externalLMIVPDF",
  ExternalProductPdf: "externalProductPDF",
  Importantpharmaceuticalnotices: "IMPORTANTPHARMACEUTICALNOTICES",
  InternalLmivpdf: "internalLMIVPDF",
  InternalProductPdf: "internalProductPDF"
};
export const DocumentPositionPrescriptionTypeEnum = {
  NoPrescription: "noPrescription",
  PrivatePrescription: "privatePrescription",
  InsurancePrescription: "insurancePrescription",
  FreePrescription: "freePrescription"
};
export const DocumentPositionEntryTypeEnum = {
  Set: "set",
  Service: "service",
  Article: "article"
};
export const DocumentPositionERxMedicationTypeEnum = {
  Pzn: "pzn",
  Composite: "composite",
  ActiveSubstance: "activeSubstance",
  Freetext: "freetext"
};
export const DoorDeliveryAddressTypeEnum = {
  Shipping: "shipping",
  Billing: "billing"
};
export const GetCarriersV1GroupEnum = {
  Dhl: "DHL",
  Hermes: "HERMES",
  Thermomed: "THERMOMED",
  Diepost: "DIEPOST"
};
export const GetCarriersV1ShippingMethodEnum = {
  Standard: "STANDARD",
  Express: "EXPRESS"
};
export const GtmDataLayerResponseCountryCodeEnum = {
  De: "DE",
  Fr: "FR",
  Ch: "CH",
  It: "IT",
  At: "AT"
};
export const GtmDataLayerResponseEnvironmentEnum = {
  Reference: "reference",
  Production: "production"
};
export const GtmDataLayerResponseLanguageEnum = {
  De: "de",
  Fr: "fr",
  It: "it"
};
/**
 *
 * @export
 * @enum {string}
 */
export const InsuranceType = {
  Public: "public",
  Private: "private"
};
export const InvalidParamCreateAddressKeyEnum = {
  Missing: "parameter.error.missing",
  Invalid: "parameter.error.invalid",
  LimitsExceeding: "parameter.error.limitsExceeding"
};
export const InvalidParamUpdateAddressKeyEnum = {
  Missing: "parameter.error.missing",
  Invalid: "parameter.error.invalid",
  LimitsExceeding: "parameter.error.limitsExceeding"
};
export const KlarnaDataErrorKeyEnum = {
  ValidationInput: "klarna-data-adapter.error.validation.input",
  Server: "klarna-data-adapter.error.server"
};
/**
 * legalEntity identifier, e.g. MILANO, currently used to distinguish IT tenant and IT milano
 * @export
 * @enum {string}
 */
export const LegalEntityPropertyEnum = {
  Milano: "MILANO"
};
/**
 * A document may be provided in the context of a prescription type. This information can be used to group documents wihtin the UI. Note that this property will default to **none** if a document cannot be associated with a prescription type. An invoice having prescription type **none** will usually indicate an OTC order.
 * @export
 * @enum {string}
 */
export const LetterboxPrescriptionTypeV1 = {
  None: "none",
  InsurancePrescription: "insurance_prescription",
  PrivatePrescription: "private_prescription"
};
export const MaxDosageCartRequestedItemPrescriptionTypeEnum = {
  OdsSection: "odsSection",
  PrivatePrescription: "privatePrescription",
  FreePrescription: "freePrescription",
  InsurancePrescription: "insurancePrescription",
  NoPrescription: "noPrescription"
};
/**
 * Name of the maximum dosage group
 * @export
 * @enum {string}
 */
export const MaxDosageGroups = {
  SingletonProduct: "maxdosage.groups.singletonProduct",
  Abfhrtabl: "maxdosage.groups.abführtabl",
  Abfhrtrop: "maxdosage.groups.abführtrop",
  Abfhrzpf: "maxdosage.groups.abführzäpf",
  Aciclovir: "maxdosage.groups.aciclovir",
  AlOxid: "maxdosage.groups.al_oxid",
  AlOxidfl: "maxdosage.groups.al_oxidfl",
  AlOxidgr: "maxdosage.groups.al_oxidgr",
  Allergant: "maxdosage.groups.allergant",
  Allergie: "maxdosage.groups.allergie",
  Amorolfin: "maxdosage.groups.amorolfin",
  Antazida: "maxdosage.groups.antazida",
  Antikoag: "maxdosage.groups.antikoag",
  Beclometha: "maxdosage.groups.beclometha",
  Bifonazol: "maxdosage.groups.bifonazol",
  CetirizFl: "maxdosage.groups.cetiriz_fl",
  CetirizTr: "maxdosage.groups.cetiriz_tr",
  Clotrimkpg: "maxdosage.groups.clotrimkpg",
  Clotrimvcr: "maxdosage.groups.clotrimvcr",
  Clotrvag: "maxdosage.groups.clotrvag",
  Dextrome2: "maxdosage.groups.dextrome2",
  Dextrometh: "maxdosage.groups.dextrometh",
  Diclogel: "maxdosage.groups.diclogel",
  DiphDoxyl: "maxdosage.groups.diph_doxyl",
  Durchfall: "maxdosage.groups.durchfall",
  Eisen: "maxdosage.groups.eisen",
  Eisenfl: "maxdosage.groups.eisenfl",
  Erklsus: "maxdosage.groups.erkälsus",
  Erkltung: "maxdosage.groups.erkältung",
  Etilefrin: "maxdosage.groups.etilefrin",
  Flohsamen: "maxdosage.groups.flohsamen",
  Flohsamen2: "maxdosage.groups.flohsamen2",
  Fluorgel: "maxdosage.groups.fluorgel",
  Hals3: "maxdosage.groups.hals_3",
  Halschmerz: "maxdosage.groups.halschmerz",
  Halsschmer: "maxdosage.groups.halsschmer",
  Halsschmfl: "maxdosage.groups.halsschmfl",
  Hautpilz: "maxdosage.groups.hautpilz",
  Hautpilzf: "maxdosage.groups.hautpilzf",
  Ibulokal: "maxdosage.groups.ibulokal",
  Ibuprofen: "maxdosage.groups.ibuprofen",
  Ibuprofflu: "maxdosage.groups.ibuprofflu",
  Ibuprofsup: "maxdosage.groups.ibuprofsup",
  Loperamid: "maxdosage.groups.loperamid",
  Minoxidil: "maxdosage.groups.minoxidil",
  Orlistat: "maxdosage.groups.orlistat",
  Pcm: "maxdosage.groups.pcm",
  Pcmflss: "maxdosage.groups.pcmflüss",
  Pcmkomb: "maxdosage.groups.pcmkomb",
  Pcmkombi: "maxdosage.groups.pcmkombi",
  Pentofuryl: "maxdosage.groups.pentofuryl",
  Schleimfl: "maxdosage.groups.schleimfl",
  Schleimls: "maxdosage.groups.schleimlös",
  Schmerzen1: "maxdosage.groups.schmerzen1",
  Schmerzen2: "maxdosage.groups.schmerzen2",
  Schmerzen3: "maxdosage.groups.schmerzen3",
  Schmerzen5: "maxdosage.groups.schmerzen5",
  Schmerzpfl: "maxdosage.groups.schmerzpfl",
  Schnupfen: "maxdosage.groups.schnupfen",
  Triptane: "maxdosage.groups.triptane",
  Vaprino: "maxdosage.groups.vaprino",
  Vitamd3fl: "maxdosage.groups.vitamd3fl",
  Vitamind3: "maxdosage.groups.vitamind3"
};
export const MaxDosageOrderHistoryRequestedItemV1PrescriptionTypeEnum = {
  OdsSection: "odsSection",
  PrivatePrescription: "privatePrescription",
  FreePrescription: "freePrescription",
  InsurancePrescription: "insurancePrescription",
  NoPrescription: "noPrescription"
};
/**
 * Unit of dosage values
 * @export
 * @enum {string}
 */
export const MaxDosageProductUnits = {
  Package: "product.attribute.unit.package",
  Pcs: "product.attribute.unit.pcs",
  Ml: "product.attribute.unit.ml",
  G: "product.attribute.unit.g"
};
export const MaxDosageRequestV1OrderedItemsInnerPrescriptionTypeEnum = {
  OdsSection: "odsSection",
  PrivatePrescription: "privatePrescription",
  FreePrescription: "freePrescription",
  InsurancePrescription: "insurancePrescription",
  NoPrescription: "noPrescription"
};
export const MigrateAddresses400MessageEnum = {
  AddressErrorRequestInvalid: "address.error.request.invalid"
};
export const MigrateAddressesRequestV1AddressesInnerSalutationEnum = {
  Mr: "mr",
  Mrs: "mrs",
  Unspecified: "unspecified"
};
export const MigrateAddressesRequestV1AddressesInnerTypeEnum = {
  Billing: "billing",
  Shipping: "shipping",
  PickupStation: "pickupStation"
};
export const MiraklAttachmentRequestV2TypeEnum = {
  ImagePng: "image/png",
  ImageJpg: "image/jpg",
  ApplicationPdf: "application/pdf"
};
export const MiraklMessagesV2MessagesInnerFromEnum = {
  Customer: "CUSTOMER",
  Shop: "SHOP",
  Operator: "OPERATOR"
};
export const MiraklMessagingOrderLineV2StatusEnum = {
  Staging: "STAGING",
  WaitingAcceptance: "WAITING_ACCEPTANCE",
  WaitingDebit: "WAITING_DEBIT",
  WaitingDebitPayment: "WAITING_DEBIT_PAYMENT",
  Shipping: "SHIPPING",
  Shipped: "SHIPPED",
  ToCollect: "TO_COLLECT",
  Received: "RECEIVED",
  Closed: "CLOSED",
  Refused: "REFUSED",
  Canceled: "CANCELED",
  IncidentOpen: "INCIDENT_OPEN",
  Refunded: "REFUNDED"
};
export const MiraklReasonV2TypeEnum = {
  IncidentOpen: "INCIDENT_OPEN",
  OrderMessaging: "ORDER_MESSAGING"
};
export const NewsletterRequestV1SexEnum = {
  M: "m",
  F: "f",
  D: "d"
};
export const NowPickupSlotTypeEnum = {
  SameDay: "sameDay",
  NextDay: "nextDay",
  ThirdDay: "thirdDay"
};
export const NowPickupSlotPickupDayEnum = {
  Heute: "heute",
  Morgen: "morgen"
};
export const NowSlotTypeEnum = {
  SameDay: "sameDay",
  NextDay: "nextDay"
};
export const NowSlotExtendedTypeEnum = {
  SameDay: "sameDay",
  NextDay: "nextDay"
};
export const NowSlotPickupTypeEnum = {
  SameDay: "sameDay",
  NextDay: "nextDay"
};
export const NowSlotPickupPickupDayEnum = {
  Heute: "heute",
  Morgen: "morgen"
};
export const NowV1InitCartResponseEnvEnum = {
  Local: "local",
  Development: "development",
  Staging: "staging",
  Production: "production"
};
export const NowV1InitCartResponsePlatformEnum = {
  Web: "web",
  Ios: "ios",
  Android: "android"
};
export const OdsPatchCartRequestV1ProductsInnerPrescriptionTypeEnum = {
  PrivatePrescription: "privatePrescription",
  FreePrescription: "freePrescription",
  NoPrescription: "noPrescription",
  InsurancePrescription: "insurancePrescription"
};
export const OfferDetailsV1OfferFlagsEnum = {
  BestOffer: "bestOffer",
  ServiceOffer: "serviceOffer",
  IsPromotionSet: "isPromotionSet"
};
export const OfferDetailsV1NowProductGroupEnum = {
  Nextday: "nextday",
  None: "none",
  SamedayNextday: "sameday_nextday"
};
export const OfferDetailsV1OfferTypeEnum = {
  Mirakl: "MIRAKL",
  Sae: "SAE"
};
export const OfferRequestPrescriptionTypeEnum = {
  PrivatePrescription: "privatePrescription",
  FreePrescription: "freePrescription",
  InsurancePrescription: "insurancePrescription",
  NoPrescription: "noPrescription"
};
export const OfferV1NowProductGroupEnum = {
  Nextday: "nextday",
  None: "none",
  SamedayNextday: "sameday_nextday"
};
export const OfferV1OfferFlagsEnum = {
  BestOffer: "bestOffer",
  ServiceOffer: "serviceOffer",
  IsPromotionSet: "isPromotionSet"
};
export const OfferV1OfferTypeEnum = {
  Sae: "SAE",
  Mirakl: "MIRAKL"
};
export const OptimizelyDecisionTypeEnum = {
  Feature: "feature",
  Experiment: "experiment"
};
export const OrderDocumentTypeEnum = {
  OdsSection: "odsSection",
  PrivatePrescription: "privatePrescription",
  FreePrescription: "freePrescription",
  InsurancePrescription: "insurancePrescription",
  NoPrescription: "noPrescription"
};
export const OrderDocumentERxTypeEnum = {
  PrivatePrescription: "privatePrescription",
  FreePrescription: "freePrescription",
  InsurancePrescription: "insurancePrescription"
};
export const OrderDocumentItemsV1PrescriptionTypeEnum = {
  NoPrescription: "noPrescription",
  PrivatePrescription: "privatePrescription",
  InsurancePrescription: "insurancePrescription",
  FreePrescription: "freePrescription"
};
export const OrderDocumentItemsV1EntryTypeEnum = {
  Set: "set",
  Service: "service",
  Article: "article"
};
export const OrderMasterDataSubOrderTypesIncludedEnum = {
  MarketPlace: "MarketPlace",
  Now: "Now",
  ShopApothekeEurope: "ShopApothekeEurope"
};
export const OrderPaymentV1MerchantAccountEnum = {
  ShopApothekeDirectSales: "ShopApothekeDirectSales",
  EuropaApotheek: "EuropaApotheek",
  ShopApothekeEcom: "ShopApothekeECOM",
  ShopApotheke: "Shop-Apotheke",
  ShopApothekeAt: "Shop-ApothekeAT",
  ShopApothekeIt: "Shop-ApothekeIT"
};
/**
 * Therapy correlating packaging size in accord with N-Notation (N stands for standard size in German (Normgröße)).  * `NOT_AFFECTED` - Not specified (Keine Angabe)  * `NOT_THERAPY_ORIENTED` - Not a therapy correlating packaging size (Keine therapiegerechte Packungsgröße)  * `N1` - Standard size 1 (Normgröße 1)  * `N2` - Standard size 2 (Normgröße 2)  * `N3` - Standard size 3 (Normgröße 3)  * `NOT_AFFECTED` - Not affected (Nicht betroffen von der Packungsgrößenverordnung)
 * @export
 * @enum {string}
 */
export const PackageNormSizeCode = {
  NotSpecified: "NOT_SPECIFIED",
  NotTherapyOriented: "NOT_THERAPY_ORIENTED",
  N1: "N1",
  N2: "N2",
  N3: "N3",
  NotAffected: "NOT_AFFECTED"
};
export const PaymentMerchantAccountEnum = {
  ShopApothekeDirectSales: "ShopApothekeDirectSales",
  EuropaApotheek: "EuropaApotheek",
  ShopApothekeEcom: "ShopApothekeECOM",
  ShopApotheke: "Shop-Apotheke",
  ShopApothekeAt: "Shop-ApothekeAT",
  ShopApothekeIt: "Shop-ApothekeIT"
};
export const PaymentMethodV1GroupEnum = {
  Ratepay: "ratepay",
  Klarna: "klarna",
  Paypal: "paypal",
  NativeInvoice: "nativeInvoice",
  NativeDirectDebit: "nativeDirectDebit",
  NativePrepayment: "nativePrepayment",
  NativeCashOnDelivery: "nativeCashOnDelivery",
  Twint: "twint",
  Applepay: "applepay",
  CreditCard: "creditCard"
};
export const PaymentMethodV1TypeEnum = {
  Applepay: "applepay",
  DirectEbanking: "directEbanking",
  Klarna: "klarna",
  KlarnaPaynow: "klarna_paynow",
  NativeCashOnDelivery: "nativeCashOnDelivery",
  NativeDirectDebit: "nativeDirectDebit",
  NativeInvoice: "nativeInvoice",
  NativePostFinance: "nativePostFinance",
  NativePrepayment: "nativePrepayment",
  Paypal: "paypal",
  Ratepay: "ratepay",
  Scheme: "scheme",
  Twint: "twint"
};
export const PaymentMethodsResponseV1UnavailableServicesEnum = {
  Ac: "ac",
  Pmc: "pmc",
  Sds: "sds",
  Kds: "kds"
};
export const PaymentsDetailsRequestV1PaymentMethodTypeEnum = {
  Applepay: "applepay",
  DirectEbanking: "directEbanking",
  Klarna: "klarna",
  KlarnaPaynow: "klarna_paynow",
  Paypal: "paypal",
  Ratepay: "ratepay",
  Scheme: "scheme"
};
export const PaymentsRequestCreditCardV1TypeEnum = {
  Scheme: "scheme"
};
export const PaymentsRequestRecurringV1TypeEnum = {
  Scheme: "scheme",
  Paypal: "paypal"
};
export const PaymentsRequestSimpleV1TypeEnum = {
  Applepay: "applepay",
  DirectEbanking: "directEbanking",
  Klarna: "klarna",
  KlarnaPaynow: "klarna_paynow",
  NativeCashOnDelivery: "nativeCashOnDelivery",
  NativeDirectDebit: "nativeDirectDebit",
  NativeInvoice: "nativeInvoice",
  NativePostFinance: "nativePostFinance",
  NativePrepayment: "nativePrepayment",
  Paypal: "paypal",
  Ratepay: "ratepay",
  Twint: "twint"
};
export const PaymentsRequestV1ChannelEnum = {
  IOs: "iOS",
  Adroid: "Adroid",
  Web: "Web"
};
export const PaymentsRequestV1RecurringProcessingModelEnum = {
  CardOnFile: "CardOnFile",
  Subscription: "Subscription",
  UnscheduledCardOnFile: "UnscheduledCardOnFile"
};
export const PaymentsRequestV1ShopperInteractionEnum = {
  Ecommerce: "Ecommerce",
  Moto: "Moto",
  Pos: "POS"
};
export const PaymentsResponseV1UnavailableServicesEnum = {
  Ac: "ac",
  Kds: "kds",
  Os: "os"
};
export const PaymentsShopperNameGenderEnum = {
  Male: "MALE",
  Female: "FEMALE",
  Unknown: "UNKNOWN"
};
/**
 * group of person for prescription for more info ERX-883
 * @export
 * @enum {string}
 */
export const PersonGroup = {
  Soz: "SOZ",
  Bvg: "BVG",
  Sva1: "SVA1",
  Sva2: "SVA2",
  Asy: "ASY",
  None: "NONE"
};
export const PickupStationAddressTypeEnum = {
  PickupStation: "pickupStation"
};
export const PickupStationRequestV2TypeEnum = {
  PickupStation: "pickupStation"
};
export const PickupStationResponseV2TypeEnum = {
  PickupStation: "pickupStation"
};
/**
 *
 * @export
 * @enum {string}
 */
export const PicsClinicalRelevance = {
  Unknown: "UNKNOWN",
  NoInteraction: "NO_INTERACTION",
  ProductSpecific: "PRODUCT_SPECIFIC",
  Low: "LOW",
  Medium: "MEDIUM",
  Serious: "SERIOUS",
  Contraindicated: "CONTRAINDICATED"
};
/**
 *
 * @export
 * @enum {string}
 */
export const PicsDirection = {
  NoDirection: "NO_DIRECTION",
  Unidirectional: "UNIDIRECTIONAL",
  Bidirectional: "BIDIRECTIONAL"
};
/**
 *
 * @export
 * @enum {string}
 */
export const PicsFrequency = {
  VeryOften: "VERY_OFTEN",
  Often: "OFTEN",
  Occasionally: "OCCASIONALLY",
  Seldom: "SELDOM",
  VerySeldom: "VERY_SELDOM",
  Unknown: "UNKNOWN"
};
/**
 *
 * @export
 * @enum {string}
 */
export const PicsIgnoreReason = {
  NotMarketable: "NOT_MARKETABLE",
  ConsultationRequired: "CONSULTATION_REQUIRED",
  UnknownProduct: "UNKNOWN_PRODUCT"
};
/**
 *
 * @export
 * @enum {string}
 */
export const PicsInteractionStatus = {
  NoInteractionsFound: "NO_INTERACTIONS_FOUND",
  DrugDrugInteractionsFound: "DRUG_DRUG_INTERACTIONS_FOUND",
  OnlyDrugFoodInteractionsFound: "ONLY_DRUG_FOOD_INTERACTIONS_FOUND",
  InteractionsPossible: "INTERACTIONS_POSSIBLE"
};
/**
 *
 * @export
 * @enum {string}
 */
export const PicsInteractionType = {
  Food: "DRUG_FOOD",
  Drug: "DRUG_DRUG"
};
/**
 *
 * @export
 * @enum {string}
 */
export const PicsPlausibility = {
  Unknown: "UNKNOWN",
  Plausible: "PLAUSIBLE",
  Proved: "PROVED"
};
/**
 *
 * @export
 * @enum {string}
 */
export const PicsSourceAssessment = {
  Unknown: "UNKNOWN",
  Insufficient: "INSUFFICIENT",
  Weak: "WEAK",
  Sufficient: "SUFFICIENT",
  Good: "GOOD"
};
export const PimABDASubstanceV1TypeEnum = {
  /**
   * Specifying an active substance (Wirkstoff)
   */
  ACTIVE: 0,
  /**
   * Specifying an additive substance (Hilfsstoff)
   */
  ADDITIVE: 1
};
export const PimDocumentV1TypeEnum = {
  InternalHw: "internal-hw",
  InternalLv: "internal-lv",
  InternalBp: "internal-bp",
  ExternalLv: "external-lv",
  ExternalBp: "external-bp"
};
export const PimProductV1LifestyleProductEnum = {
  True: "true",
  TrueWithExceptions: "true_with_exceptions",
  False: "false"
};
export const PimProductV1NowProductGroupEnum = {
  None: "none",
  SamedayNextday: "sameday_nextday",
  Nextday: "nextday"
};
export const PimProductV1StockStatusEnum = {
  Available: "available",
  OutOfSale: "out_of_sale",
  OutOfStock: "out_of_stock",
  NotInCatalog: "not_in_catalog",
  Free: "free",
  Service: "service",
  Variant: "variant"
};
export const PimProductV1TypeEnum = {
  Article: "article",
  Service: "service",
  Set: "set"
};
export const PimProductWithNotepadAndOffersV1LifestyleProductEnum = {
  True: "true",
  TrueWithExceptions: "true_with_exceptions",
  False: "false"
};
export const PimProductWithNotepadAndOffersV1NowProductGroupEnum = {
  None: "none",
  SamedayNextday: "sameday_nextday",
  Nextday: "nextday"
};
export const PimProductWithNotepadAndOffersV1StockStatusEnum = {
  Available: "available",
  OutOfSale: "out_of_sale",
  OutOfStock: "out_of_stock",
  NotInCatalog: "not_in_catalog",
  Free: "free",
  Service: "service",
  Variant: "variant"
};
export const PimProductWithNotepadAndOffersV1TypeEnum = {
  Article: "article",
  Service: "service",
  Set: "set"
};
export const PimProductWithVariantsV1LifestyleProductEnum = {
  True: "true",
  TrueWithExceptions: "true_with_exceptions",
  False: "false"
};
export const PimProductWithVariantsV1NowProductGroupEnum = {
  None: "none",
  SamedayNextday: "sameday_nextday",
  Nextday: "nextday"
};
export const PimProductWithVariantsV1StockStatusEnum = {
  Available: "available",
  OutOfSale: "out_of_sale",
  OutOfStock: "out_of_stock",
  NotInCatalog: "not_in_catalog",
  Free: "free",
  Service: "service",
  Variant: "variant"
};
export const PimProductWithVariantsV1TypeEnum = {
  Article: "article",
  Service: "service",
  Set: "set"
};
export const PimRedirectV1TypeEnum = {
  Product: "product",
  Category: "category"
};
export const PimVATV1CodeEnum = {
  XxXx: "XX_XX",
  DeSr: "DE_SR",
  DeRr: "DE_RR",
  AtSr: "AT_SR",
  AtTs: "AT_TS",
  AtBi: "AT_BI",
  FrSr: "FR_SR",
  FrRr: "FR_RR",
  FrUt: "FR_UT",
  FrPr: "FR_PR",
  ItSr: "IT_SR",
  ItRr: "IT_RR",
  ItFb: "IT_FB",
  ChSr: "CH_SR",
  ChRr: "CH_RR"
};
export const PimVariantAttributeV1TypeEnum = {
  Color: "COLOR",
  List: "LIST",
  Text: "TEXT"
};
export const PimWeightMetricValueV1UnitEnum = {
  Microgram: "MICROGRAM",
  Milligram: "MILLIGRAM",
  Gram: "GRAM",
  Kilogram: "KILOGRAM",
  Ton: "TON",
  Grain: "GRAIN",
  Denier: "DENIER",
  Once: "ONCE",
  Marc: "MARC",
  Livre: "LIVRE",
  Ounce: "OUNCE",
  Pound: "POUND"
};
export const PrescriptionPrescriptionTypeEnum = {
  InsurancePrescription: "insurancePrescription",
  PrivatePrescription: "privatePrescription",
  FreePrescription: "freePrescription",
  NoPrescription: "noPrescription"
};
export const PrescriptionMedicationTypeEnum = {
  Pzn: "pzn",
  Composite: "composite",
  ActiveSubstance: "activeSubstance",
  Freetext: "freetext"
};
export const PrescriptionV3PrescriptionTypeEnum = {
  InsurancePrescription: "insurancePrescription",
  PrivatePrescription: "privatePrescription",
  FreePrescription: "freePrescription",
  NoPrescription: "noPrescription"
};
export const PrescriptionV3MedicationTypeEnum = {
  Pzn: "pzn",
  Composite: "composite",
  ActiveSubstance: "activeSubstance",
  Freetext: "freetext"
};
export const PriceV3TypeEnum = {
  Retail: "retail",
  List: "list",
  NoPrescription: "noPrescription",
  InsurancePrescription: "insurancePrescription",
  FreePrescription: "freePrescription",
  PrivatePrescription: "privatePrescription"
};
/**
 * Statement about the availability of the article at the supplier. No statement about availability at wholesale nor about marketability.  * `NOT_SPECIFIED` - Not specified (keine Angabe)  * `OUT_OF_DISTR` - Out of distribution (außer Vertrieb) but allowed to be sold out except marketability states something against (e.g. NOT_TRADEABLE)  * `DISTRIBUTED` - Being distributed (im Vertrieb)  * `RETREATED` - Retreated (zurückgezogen (Lagerware ist nicht zur Abgabe und zum Abverkauf bestimmt)) and not allowed to be sold out
 * @export
 * @enum {string}
 */
export const ProductDistributionStatus = {
  NotSpecified: "NOT_SPECIFIED",
  OutOfDistr: "OUT_OF_DISTR",
  Distributed: "DISTRIBUTED",
  Retreated: "RETREATED"
};
/**
 * What phase of the life cycle is the product in?  * `TRADED` - Being traded (im Handel)  * `OUT_OF_DISTR` - Out of distribution (außer Vertrieb)  * `NOT_TRADEABLE` - Not tradeable (nicht verkehrsfähig)
 * @export
 * @enum {string}
 */
export const ProductLifecycleStatus = {
  Traded: "TRADED",
  OutOfDistr: "OUT_OF_DISTR",
  BeforeLaunch: "BEFORE_LAUNCH",
  NotTradeable: "NOT_TRADEABLE"
};
/**
 * Allowance to trade with the product.  * `NOT_SPECIFIED` - Not specified (keine Angabe)  * `NOT_TRADEABLE` - Not tradeable (nicht verkehrsfähig)  * `TRADEABLE` - Tradeable product (verkehrsfähig)  * `AUDIT` - Being audited (Verkehrsfähigkeit in Prüfung)
 * @export
 * @enum {string}
 */
export const ProductMarketAllowanceStatus = {
  NotSpecified: "NOT_SPECIFIED",
  NotTradeable: "NOT_TRADEABLE",
  Tradeable: "TRADEABLE",
  Audit: "AUDIT"
};
export const ProductV3NowProductGroupEnum = {
  None: "none",
  SamedayNextday: "sameday_nextday",
  Nextday: "nextday"
};
export const ProductWithVariantsV3NowProductGroupEnum = {
  None: "none",
  SamedayNextday: "sameday_nextday",
  Nextday: "nextday"
};
export const RecentOrdersOfferResponseV1NowProductGroupEnum = {
  Nextday: "nextday",
  None: "none",
  SamedayNextday: "sameday_nextday"
};
export const RecentOrdersOfferResponseV1OfferFlagsEnum = {
  BestOffer: "bestOffer",
  ServiceOffer: "serviceOffer",
  IsPromotionSet: "isPromotionSet"
};
export const RecentOrdersOfferResponseV1OfferTypeEnum = {
  Sae: "SAE",
  Mirakl: "MIRAKL"
};
export const RecentOrdersV1ProductLifestyleProductEnum = {
  True: "true",
  TrueWithExceptions: "true_with_exceptions",
  False: "false"
};
export const RecentOrdersV1ProductNowProductGroupEnum = {
  None: "none",
  SamedayNextday: "sameday_nextday",
  Nextday: "nextday"
};
export const RecentOrdersV1ProductStockStatusEnum = {
  Available: "available",
  OutOfSale: "out_of_sale",
  OutOfStock: "out_of_stock",
  NotInCatalog: "not_in_catalog",
  Free: "free",
  Service: "service",
  Variant: "variant"
};
export const RecentOrdersV1ProductTypeEnum = {
  Article: "article",
  Service: "service",
  Set: "set"
};
export const RedPointsCalculationItemTypeEnum = {
  Item: "item",
  Voucher: "voucher",
  Total: "total"
};
export const RedPointsCalculationItemRxTypeEnum = {
  Insuranceprescription: "INSURANCEPRESCRIPTION",
  Privateprescription: "PRIVATEPRESCRIPTION",
  Freeprescription: "FREEPRESCRIPTION",
  Noprescription: "NOPRESCRIPTION"
};
export const RedPointsOrderOrderStatusEnum = {
  Reserved: "RESERVED",
  Ordered: "ORDERED",
  Exported: "EXPORTED",
  Shipped: "SHIPPED",
  Canceled: "CANCELED"
};
export const RedPointsOrderOrderTypeEnum = {
  Abo: "ABO",
  Normal: "NORMAL",
  Subscription: "SUBSCRIPTION"
};
export const RedPointsPointsPerItemRxRxTypeEnum = {
  Freeprescription: "FREEPRESCRIPTION",
  Insuranceprescription: "INSURANCEPRESCRIPTION",
  Noprescription: "NOPRESCRIPTION",
  Privateprescription: "PRIVATEPRESCRIPTION"
};
export const RedpointsInterestedRequestBodyV1OnboardTypeEnum = {
  Manual: "MANUAL",
  Auto: "AUTO",
  Checkout: "CHECKOUT"
};
export const RedpointsRegistrationstatusResponseV1StatusEnum = {
  NoMember: "NO_MEMBER",
  Pending: "PENDING",
  Subscribed: "SUBSCRIBED"
};
/**
 *
 * @export
 * @enum {string}
 */
export const SalutationV1 = {
  Mr: "mr",
  Mrs: "mrs",
  Unspecified: "unspecified",
  Diverse: "diverse"
};
export const SellerV1IsAllowedToEvaluateMessageEnum = {
  AlreadyEvaluated: "seller.evaluation.error.alreadyEvaluated",
  WrongOrderStatus: "seller.evaluation.error.wrongOrderStatus"
};
export const SellerV1ShopAdditionalFieldsInnerCodeEnum = {
  Imprint: "imprint",
  ReturnPolicy2: "return-policy-2"
};
export const SellerV1ShopAdditionalFieldsInnerTypeEnum = {
  Textarea: "TEXTAREA"
};
export const SensitiveExpiredErrorEnum = {
  Unauthorized: "Unauthorized"
};
export const SensitiveExpiredMessageEnum = {
  SensitiveLoginExpired: "sensitive.login.expired"
};
export const ShippingRequestV2TypeEnum = {
  Shipping: "shipping"
};
export const ShippingResponseV2TypeEnum = {
  Shipping: "shipping"
};
export const ShippingResponseV2WithNowDataTypeEnum = {
  Shipping: "shipping"
};
export const SubOrderOrderTypeEnum = {
  Standard: "standard",
  Subscription: "subscription",
  Guest: "guest"
};
export const SubOrderStatusEnum = {
  New: "new",
  WaitingForPrepayment: "waitingForPrepayment",
  Processing: "processing",
  Dispatched: "dispatched",
  Canceled: "canceled",
  Closed: "closed"
};
export const SubOrderDiscountsV1VoucherTypeEnum = {
  Fix: "FIX",
  Percentage: "PERCENTAGE",
  Redpoints: "REDPOINTS"
};
export const SubOrderV1OrderTypeEnum = {
  Standard: "STANDARD",
  Subscription: "SUBSCRIPTION",
  Guest: "GUEST"
};
/**
 *
 * @export
 * @enum {string}
 */
export const SubscriptionStatus = {
  New: "new",
  Subscribed: "subscribed",
  Unsubscribed: "unsubscribed",
  OptinAwaiting: "optin_awaiting"
};
/**
 * Possible subscription types
 * @export
 * @enum {string}
 */
export const SubscriptionTypeV1 = {
  Newsletter: "newsletter",
  Redpoints: "redpoints"
};
/**
 * * `substituted` - substitution successful * `substituted_with_same_pzn` - substitution successful with original product * `not_able_to_substitute` - substitution not possible, because pharmaceutical/technical/logistical reasons * `error` - http error other than 2**
 * @export
 * @enum {string}
 */
export const SubstitutionStates = {
  Substituted: "substituted",
  SubstitutedWithSamePzn: "substituted_with_same_pzn",
  NotAbleToSubstitute: "not_able_to_substitute",
  Error: "error"
};
/**
 * Possible status values provided by the swap-service after it attempted to swap the eRX item
 * @export
 * @enum {string}
 */
export const SubstitutionStatus = {
  Substituted: "substituted",
  NotAbleToSubstitute: "not_able_to_substitute",
  NotAllowedToSubstitute: "not_allowed_to_substitute",
  SubstitutedWithSamePzn: "substituted_with_same_pzn",
  Error: "error"
};
/**
 * * `DEFAULT` - Exchange according to discount contract (Rabattvertrag) * `MANUAL` - Products that can only be exchanged manually by a pharmacist. * `NOT_POSSIBLE` - no substitution possible (fallback) * `RESTRICTED` - Product substitution is restricted because they are excluded or autidem * `KEEP_PRODUCT` - original product will be returned exclusively if available * `ACCIDENT_DEFAULT` - DEFAULT exchange for accident prescriptions (BG, UK) * `ACCIDENT_RESTRICTED`- RESTRICTED exchange for accident prescriptions (BG, UK)
 * @export
 * @enum {string}
 */
export const SubstitutionTypes = {
  Default: "DEFAULT",
  Manual: "MANUAL",
  NotPossible: "NOT_POSSIBLE",
  Restricted: "RESTRICTED",
  KeepProduct: "KEEP_PRODUCT",
  AccidentDefault: "ACCIDENT_DEFAULT",
  AccidentRestricted: "ACCIDENT_RESTRICTED"
};
export const SuccessGetAccountCustomerRedPointsMembershipEnum = {
  NoMember: "NO_MEMBER",
  Pending: "PENDING",
  Subscribed: "SUBSCRIBED"
};
export const SuccessGetAddressesWithAndWithoutNowDataAddressesInnerTypeEnum = {
  PickupStation: "pickupStation"
};
export const SuccessGetDoorDeliveryAddressesAddressesInnerTypeEnum = {
  Shipping: "shipping"
};
export const SuccessGetDoorDeliveryAddressesWithNowDataAddressesInnerTypeEnum = {
  Shipping: "shipping"
};
export const UnsubscribeSubscriptionRequestV1ActionEnum = {
  Unsubscribe: "unsubscribe"
};
export const UserDocumentPositionPrescriptionTypeEnum = {
  NoPrescription: "noPrescription",
  PrivatePrescription: "privatePrescription",
  InsurancePrescription: "insurancePrescription",
  FreePrescription: "freePrescription"
};
export const UserDocumentPositionEntryTypeEnum = {
  Set: "set",
  Service: "service",
  Article: "article"
};
export const UserDocumentPositionERxMedicationTypeEnum = {
  Pzn: "pzn",
  Composite: "composite",
  ActiveSubstance: "activeSubstance",
  Freetext: "freetext"
};
export const UserOrderDocumentERxTypeEnum = {
  PrivatePrescription: "privatePrescription",
  FreePrescription: "freePrescription",
  InsurancePrescription: "insurancePrescription"
};
export const UserSubOrderOrderTypeEnum = {
  Standard: "standard",
  Subscription: "subscription",
  Guest: "guest"
};
export const UserV1OnboardTypeEnum = {
  Manual: "MANUAL",
  Manualeav: "MANUALEAV",
  Auto: "AUTO",
  Checkout: "CHECKOUT",
  Checkouteav: "CHECKOUTEAV"
};
export const ZavaProviderEnum = {
  Zava: "zava"
};
export const ZavaDataProviderEnum = {
  Zava: "zava"
};
/**
 * ASAPServiceApi - axios parameter creator
 * @export
 */
export const ASAPServiceApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @summary Returns a list of inventory information objects for requested products.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {Set<string>} products List with products (id or PZN in Germany) the inventory status is being requested for.
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInventoryByProductIds: async (tenant, products, X_Request_ID, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("getInventoryByProductIds", "tenant", tenant);
      // verify required parameter 'products' is not null or undefined
      assertParamExists("getInventoryByProductIds", "products", products);
      const localVarPath = `/asap/v1/{tenant}/inventory`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication basicAuth required
      // http basic authentication required
      setBasicAuthToObject(localVarRequestOptions, configuration);
      if (products) {
        localVarQueryParameter["products"] = Array.from(products).join(COLLECTION_FORMATS.csv);
      }
      if (X_Request_ID != null) {
        localVarHeaderParameter["X-Request-ID"] = String(X_Request_ID);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * ASAPServiceApi - functional programming interface
 * @export
 */
export const ASAPServiceApiFp = function (configuration) {
  const localVarAxiosParamCreator = ASAPServiceApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Returns a list of inventory information objects for requested products.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {Set<string>} products List with products (id or PZN in Germany) the inventory status is being requested for.
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getInventoryByProductIds(tenant, products, X_Request_ID, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getInventoryByProductIds(
        tenant,
        products,
        X_Request_ID,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * ASAPServiceApi - factory interface
 * @export
 */
export const ASAPServiceApiFactory = function (configuration, basePath, axios) {
  const localVarFp = ASAPServiceApiFp(configuration);
  return {
    /**
     *
     * @summary Returns a list of inventory information objects for requested products.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {Set<string>} products List with products (id or PZN in Germany) the inventory status is being requested for.
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInventoryByProductIds(tenant, products, X_Request_ID, options) {
      return localVarFp
        .getInventoryByProductIds(tenant, products, X_Request_ID, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * ASAPServiceApi - object-oriented interface
 * @export
 * @class ASAPServiceApi
 * @extends {BaseAPI}
 */
export class ASAPServiceApi extends BaseAPI {
  /**
   *
   * @summary Returns a list of inventory information objects for requested products.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {Set<string>} products List with products (id or PZN in Germany) the inventory status is being requested for.
   * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ASAPServiceApi
   */
  getInventoryByProductIds(tenant, products, X_Request_ID, options) {
    return ASAPServiceApiFp(this.configuration)
      .getInventoryByProductIds(tenant, products, X_Request_ID, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * AccountControllerApi - axios parameter creator
 * @export
 */
export const AccountControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Used by the customer to retrieve all its orders.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {number} [page]
     * @param {number} [itemsPerPage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1TenantOrdersGet: async (tenant, page, itemsPerPage, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("accountV1TenantOrdersGet", "tenant", tenant);
      const localVarPath = `/account/v1/{tenant}/orders`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }
      if (itemsPerPage !== undefined) {
        localVarQueryParameter["itemsPerPage"] = itemsPerPage;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Used by a customer to retrieve a single order.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1TenantOrdersOrderNumberGet: async (tenant, orderNumber, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("accountV1TenantOrdersOrderNumberGet", "tenant", tenant);
      // verify required parameter 'orderNumber' is not null or undefined
      assertParamExists("accountV1TenantOrdersOrderNumberGet", "orderNumber", orderNumber);
      const localVarPath = `/account/v1/{tenant}/orders/{orderNumber}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"orderNumber"}}`, encodeURIComponent(String(orderNumber)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Returns customer data including EAV customer and RedPointsMembership.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1TenantUserGet: async (tenant, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("accountV1TenantUserGet", "tenant", tenant);
      const localVarPath = `/account/v1/{tenant}/user`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * AccountControllerApi - functional programming interface
 * @export
 */
export const AccountControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = AccountControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * Used by the customer to retrieve all its orders.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {number} [page]
     * @param {number} [itemsPerPage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountV1TenantOrdersGet(tenant, page, itemsPerPage, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accountV1TenantOrdersGet(
        tenant,
        page,
        itemsPerPage,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Used by a customer to retrieve a single order.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountV1TenantOrdersOrderNumberGet(tenant, orderNumber, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accountV1TenantOrdersOrderNumberGet(
        tenant,
        orderNumber,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Returns customer data including EAV customer and RedPointsMembership.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountV1TenantUserGet(tenant, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accountV1TenantUserGet(tenant, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * AccountControllerApi - factory interface
 * @export
 */
export const AccountControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = AccountControllerApiFp(configuration);
  return {
    /**
     * Used by the customer to retrieve all its orders.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {number} [page]
     * @param {number} [itemsPerPage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1TenantOrdersGet(tenant, page, itemsPerPage, options) {
      return localVarFp
        .accountV1TenantOrdersGet(tenant, page, itemsPerPage, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Used by a customer to retrieve a single order.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1TenantOrdersOrderNumberGet(tenant, orderNumber, options) {
      return localVarFp
        .accountV1TenantOrdersOrderNumberGet(tenant, orderNumber, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Returns customer data including EAV customer and RedPointsMembership.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1TenantUserGet(tenant, options) {
      return localVarFp.accountV1TenantUserGet(tenant, options).then((request) => request(axios, basePath));
    }
  };
};
/**
 * AccountControllerApi - object-oriented interface
 * @export
 * @class AccountControllerApi
 * @extends {BaseAPI}
 */
export class AccountControllerApi extends BaseAPI {
  /**
   * Used by the customer to retrieve all its orders.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {number} [page]
   * @param {number} [itemsPerPage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountControllerApi
   */
  accountV1TenantOrdersGet(tenant, page, itemsPerPage, options) {
    return AccountControllerApiFp(this.configuration)
      .accountV1TenantOrdersGet(tenant, page, itemsPerPage, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Used by a customer to retrieve a single order.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} orderNumber
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountControllerApi
   */
  accountV1TenantOrdersOrderNumberGet(tenant, orderNumber, options) {
    return AccountControllerApiFp(this.configuration)
      .accountV1TenantOrdersOrderNumberGet(tenant, orderNumber, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Returns customer data including EAV customer and RedPointsMembership.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountControllerApi
   */
  accountV1TenantUserGet(tenant, options) {
    return AccountControllerApiFp(this.configuration)
      .accountV1TenantUserGet(tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * AccountControllerV2Api - axios parameter creator
 * @export
 */
export const AccountControllerV2ApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Internal API endpoint secured by the PRS Basic Auth Credentials. Fetches customer data (including EAV customers) from the CDS or LMS and returns it. The data is only used by the product-review-service. The call to the CDS is secured by another, different set of Basic Auth credentials.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} customerNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV2TenantLanguageCustomerNumberGet: async (tenant, language, customerNumber, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("accountV2TenantLanguageCustomerNumberGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("accountV2TenantLanguageCustomerNumberGet", "language", language);
      // verify required parameter 'customerNumber' is not null or undefined
      assertParamExists("accountV2TenantLanguageCustomerNumberGet", "customerNumber", customerNumber);
      const localVarPath = `/account/v2/{tenant}/{language}/{customerNumber}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"customerNumber"}}`, encodeURIComponent(String(customerNumber)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication basicAuth required
      // http basic authentication required
      setBasicAuthToObject(localVarRequestOptions, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Used by the customer to retrieve all its orders.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {number} [page]
     * @param {number} [itemsPerPage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV2TenantLanguageOrdersGet: async (tenant, language, page, itemsPerPage, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("accountV2TenantLanguageOrdersGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("accountV2TenantLanguageOrdersGet", "language", language);
      const localVarPath = `/account/v2/{tenant}/{language}/orders`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }
      if (itemsPerPage !== undefined) {
        localVarQueryParameter["itemsPerPage"] = itemsPerPage;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Used by a customer to retrieve a single order.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} orderNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV2TenantLanguageOrdersOrderNumberGet: async (tenant, language, orderNumber, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("accountV2TenantLanguageOrdersOrderNumberGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("accountV2TenantLanguageOrdersOrderNumberGet", "language", language);
      // verify required parameter 'orderNumber' is not null or undefined
      assertParamExists("accountV2TenantLanguageOrdersOrderNumberGet", "orderNumber", orderNumber);
      const localVarPath = `/account/v2/{tenant}/{language}/orders/{orderNumber}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"orderNumber"}}`, encodeURIComponent(String(orderNumber)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Returns customer data including EAV customer and RedPointsMembership.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV2TenantLanguageUserGet: async (tenant, language, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("accountV2TenantLanguageUserGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("accountV2TenantLanguageUserGet", "language", language);
      const localVarPath = `/account/v2/{tenant}/{language}/user`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * AccountControllerV2Api - functional programming interface
 * @export
 */
export const AccountControllerV2ApiFp = function (configuration) {
  const localVarAxiosParamCreator = AccountControllerV2ApiAxiosParamCreator(configuration);
  return {
    /**
     * Internal API endpoint secured by the PRS Basic Auth Credentials. Fetches customer data (including EAV customers) from the CDS or LMS and returns it. The data is only used by the product-review-service. The call to the CDS is secured by another, different set of Basic Auth credentials.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} customerNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountV2TenantLanguageCustomerNumberGet(tenant, language, customerNumber, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accountV2TenantLanguageCustomerNumberGet(
        tenant,
        language,
        customerNumber,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Used by the customer to retrieve all its orders.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {number} [page]
     * @param {number} [itemsPerPage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountV2TenantLanguageOrdersGet(tenant, language, page, itemsPerPage, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accountV2TenantLanguageOrdersGet(
        tenant,
        language,
        page,
        itemsPerPage,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Used by a customer to retrieve a single order.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} orderNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountV2TenantLanguageOrdersOrderNumberGet(tenant, language, orderNumber, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accountV2TenantLanguageOrdersOrderNumberGet(
        tenant,
        language,
        orderNumber,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Returns customer data including EAV customer and RedPointsMembership.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountV2TenantLanguageUserGet(tenant, language, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accountV2TenantLanguageUserGet(
        tenant,
        language,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * AccountControllerV2Api - factory interface
 * @export
 */
export const AccountControllerV2ApiFactory = function (configuration, basePath, axios) {
  const localVarFp = AccountControllerV2ApiFp(configuration);
  return {
    /**
     * Internal API endpoint secured by the PRS Basic Auth Credentials. Fetches customer data (including EAV customers) from the CDS or LMS and returns it. The data is only used by the product-review-service. The call to the CDS is secured by another, different set of Basic Auth credentials.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} customerNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV2TenantLanguageCustomerNumberGet(tenant, language, customerNumber, options) {
      return localVarFp
        .accountV2TenantLanguageCustomerNumberGet(tenant, language, customerNumber, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Used by the customer to retrieve all its orders.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {number} [page]
     * @param {number} [itemsPerPage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV2TenantLanguageOrdersGet(tenant, language, page, itemsPerPage, options) {
      return localVarFp
        .accountV2TenantLanguageOrdersGet(tenant, language, page, itemsPerPage, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Used by a customer to retrieve a single order.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} orderNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV2TenantLanguageOrdersOrderNumberGet(tenant, language, orderNumber, options) {
      return localVarFp
        .accountV2TenantLanguageOrdersOrderNumberGet(tenant, language, orderNumber, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Returns customer data including EAV customer and RedPointsMembership.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV2TenantLanguageUserGet(tenant, language, options) {
      return localVarFp
        .accountV2TenantLanguageUserGet(tenant, language, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * AccountControllerV2Api - object-oriented interface
 * @export
 * @class AccountControllerV2Api
 * @extends {BaseAPI}
 */
export class AccountControllerV2Api extends BaseAPI {
  /**
   * Internal API endpoint secured by the PRS Basic Auth Credentials. Fetches customer data (including EAV customers) from the CDS or LMS and returns it. The data is only used by the product-review-service. The call to the CDS is secured by another, different set of Basic Auth credentials.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {string} customerNumber
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountControllerV2Api
   */
  accountV2TenantLanguageCustomerNumberGet(tenant, language, customerNumber, options) {
    return AccountControllerV2ApiFp(this.configuration)
      .accountV2TenantLanguageCustomerNumberGet(tenant, language, customerNumber, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Used by the customer to retrieve all its orders.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {number} [page]
   * @param {number} [itemsPerPage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountControllerV2Api
   */
  accountV2TenantLanguageOrdersGet(tenant, language, page, itemsPerPage, options) {
    return AccountControllerV2ApiFp(this.configuration)
      .accountV2TenantLanguageOrdersGet(tenant, language, page, itemsPerPage, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Used by a customer to retrieve a single order.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {string} orderNumber
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountControllerV2Api
   */
  accountV2TenantLanguageOrdersOrderNumberGet(tenant, language, orderNumber, options) {
    return AccountControllerV2ApiFp(this.configuration)
      .accountV2TenantLanguageOrdersOrderNumberGet(tenant, language, orderNumber, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Returns customer data including EAV customer and RedPointsMembership.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountControllerV2Api
   */
  accountV2TenantLanguageUserGet(tenant, language, options) {
    return AccountControllerV2ApiFp(this.configuration)
      .accountV2TenantLanguageUserGet(tenant, language, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * AddressControllerApi - axios parameter creator
 * @export
 */
export const AddressControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @summary Endpoint for migrating addresses (for internal usage only)
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {MigrateAddressesRequestV1} MigrateAddressesRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addressesV2TenantAddressesPost: async (tenant, MigrateAddressesRequestV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("addressesV2TenantAddressesPost", "tenant", tenant);
      // verify required parameter 'MigrateAddressesRequestV1' is not null or undefined
      assertParamExists("addressesV2TenantAddressesPost", "MigrateAddressesRequestV1", MigrateAddressesRequestV1);
      const localVarPath = `/addresses/v2/{tenant}/addresses`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        MigrateAddressesRequestV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Endpoint to get the ZIP of the default door delivery address of a customer. The endpoint is needed for the NOW Modals
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addressesV2TenantDefaultZipGet: async (tenant, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("addressesV2TenantDefaultZipGet", "tenant", tenant);
      const localVarPath = `/addresses/v2/{tenant}/defaultZip`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Endpoint to get door delivery addresses of a customer. Door delivery addresses are billing + shipping (excluding pickupStation) addresses
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addressesV2TenantDoorDeliveryGet: async (tenant, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("addressesV2TenantDoorDeliveryGet", "tenant", tenant);
      const localVarPath = `/addresses/v2/{tenant}/doorDelivery`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Endpoint to get all addresses of a customer with ability to exclude pickupStation addresses that also include \'now service\' data.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {'web_desktop' | 'web_mobile' | 'ios' | 'android'} [clientPlatform] The number of items to skip before starting to collect the result set
     * @param {Array<'billing' | 'pickupStation' | 'shipping'>} [types] used to get specific types of addresses
     * @param {string} [orderDraftId] Id of odrder draft that is needed for fetching Now data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addressesV2TenantGet: async (tenant, clientPlatform, types, orderDraftId, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("addressesV2TenantGet", "tenant", tenant);
      const localVarPath = `/addresses/v2/{tenant}`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (clientPlatform !== undefined) {
        localVarQueryParameter["clientPlatform"] = clientPlatform;
      }
      if (types) {
        localVarQueryParameter["types"] = types;
      }
      if (orderDraftId !== undefined) {
        localVarQueryParameter["orderDraftId"] = orderDraftId;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Endpoint to delete an address given address id
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addressesV2TenantIdDelete: async (tenant, id, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("addressesV2TenantIdDelete", "tenant", tenant);
      // verify required parameter 'id' is not null or undefined
      assertParamExists("addressesV2TenantIdDelete", "id", id);
      const localVarPath = `/addresses/v2/{tenant}/{id}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "DELETE", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Endpoint to update an address given address id
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} id
     * @param {AddressesV2TenantIdPutRequest} AddressesV2TenantIdPutRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addressesV2TenantIdPut: async (tenant, id, AddressesV2TenantIdPutRequest, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("addressesV2TenantIdPut", "tenant", tenant);
      // verify required parameter 'id' is not null or undefined
      assertParamExists("addressesV2TenantIdPut", "id", id);
      // verify required parameter 'AddressesV2TenantIdPutRequest' is not null or undefined
      assertParamExists("addressesV2TenantIdPut", "AddressesV2TenantIdPutRequest", AddressesV2TenantIdPutRequest);
      const localVarPath = `/addresses/v2/{tenant}/{id}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "PUT", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        AddressesV2TenantIdPutRequest,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Endpoint to get door delivery addresses of a customer. Door delivery addresses are billing + shipping (excluding pickupStation) addresses that also include \'now service\' data.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderDraftId
     * @param {'web_desktop' | 'web_mobile' | 'ios' | 'android'} [clientPlatform] The number of items to skip before starting to collect the result set
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    addressesV2TenantOrderDraftIdDoorDeliveryGet: async (tenant, orderDraftId, clientPlatform, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("addressesV2TenantOrderDraftIdDoorDeliveryGet", "tenant", tenant);
      // verify required parameter 'orderDraftId' is not null or undefined
      assertParamExists("addressesV2TenantOrderDraftIdDoorDeliveryGet", "orderDraftId", orderDraftId);
      const localVarPath = `/addresses/v2/{tenant}/{orderDraftId}/doorDelivery`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (clientPlatform !== undefined) {
        localVarQueryParameter["clientPlatform"] = clientPlatform;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Endpoint to get pickupStation addresses of a customer
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addressesV2TenantPickupStationDeliveryGet: async (tenant, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("addressesV2TenantPickupStationDeliveryGet", "tenant", tenant);
      const localVarPath = `/addresses/v2/{tenant}/pickupStationDelivery`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Endpoint to create an address
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {AddressesV2TenantPostRequest} AddressesV2TenantPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addressesV2TenantPost: async (tenant, AddressesV2TenantPostRequest, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("addressesV2TenantPost", "tenant", tenant);
      // verify required parameter 'AddressesV2TenantPostRequest' is not null or undefined
      assertParamExists("addressesV2TenantPost", "AddressesV2TenantPostRequest", AddressesV2TenantPostRequest);
      const localVarPath = `/addresses/v2/{tenant}`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        AddressesV2TenantPostRequest,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * AddressControllerApi - functional programming interface
 * @export
 */
export const AddressControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = AddressControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Endpoint for migrating addresses (for internal usage only)
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {MigrateAddressesRequestV1} MigrateAddressesRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addressesV2TenantAddressesPost(tenant, MigrateAddressesRequestV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addressesV2TenantAddressesPost(
        tenant,
        MigrateAddressesRequestV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Endpoint to get the ZIP of the default door delivery address of a customer. The endpoint is needed for the NOW Modals
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addressesV2TenantDefaultZipGet(tenant, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addressesV2TenantDefaultZipGet(tenant, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Endpoint to get door delivery addresses of a customer. Door delivery addresses are billing + shipping (excluding pickupStation) addresses
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addressesV2TenantDoorDeliveryGet(tenant, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addressesV2TenantDoorDeliveryGet(tenant, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Endpoint to get all addresses of a customer with ability to exclude pickupStation addresses that also include \'now service\' data.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {'web_desktop' | 'web_mobile' | 'ios' | 'android'} [clientPlatform] The number of items to skip before starting to collect the result set
     * @param {Array<'billing' | 'pickupStation' | 'shipping'>} [types] used to get specific types of addresses
     * @param {string} [orderDraftId] Id of odrder draft that is needed for fetching Now data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addressesV2TenantGet(tenant, clientPlatform, types, orderDraftId, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addressesV2TenantGet(
        tenant,
        clientPlatform,
        types,
        orderDraftId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Endpoint to delete an address given address id
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addressesV2TenantIdDelete(tenant, id, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addressesV2TenantIdDelete(tenant, id, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Endpoint to update an address given address id
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} id
     * @param {AddressesV2TenantIdPutRequest} AddressesV2TenantIdPutRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addressesV2TenantIdPut(tenant, id, AddressesV2TenantIdPutRequest, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addressesV2TenantIdPut(
        tenant,
        id,
        AddressesV2TenantIdPutRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Endpoint to get door delivery addresses of a customer. Door delivery addresses are billing + shipping (excluding pickupStation) addresses that also include \'now service\' data.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderDraftId
     * @param {'web_desktop' | 'web_mobile' | 'ios' | 'android'} [clientPlatform] The number of items to skip before starting to collect the result set
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async addressesV2TenantOrderDraftIdDoorDeliveryGet(tenant, orderDraftId, clientPlatform, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addressesV2TenantOrderDraftIdDoorDeliveryGet(
        tenant,
        orderDraftId,
        clientPlatform,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Endpoint to get pickupStation addresses of a customer
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addressesV2TenantPickupStationDeliveryGet(tenant, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addressesV2TenantPickupStationDeliveryGet(
        tenant,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Endpoint to create an address
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {AddressesV2TenantPostRequest} AddressesV2TenantPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addressesV2TenantPost(tenant, AddressesV2TenantPostRequest, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addressesV2TenantPost(
        tenant,
        AddressesV2TenantPostRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * AddressControllerApi - factory interface
 * @export
 */
export const AddressControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = AddressControllerApiFp(configuration);
  return {
    /**
     *
     * @summary Endpoint for migrating addresses (for internal usage only)
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {MigrateAddressesRequestV1} MigrateAddressesRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addressesV2TenantAddressesPost(tenant, MigrateAddressesRequestV1, options) {
      return localVarFp
        .addressesV2TenantAddressesPost(tenant, MigrateAddressesRequestV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Endpoint to get the ZIP of the default door delivery address of a customer. The endpoint is needed for the NOW Modals
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addressesV2TenantDefaultZipGet(tenant, options) {
      return localVarFp.addressesV2TenantDefaultZipGet(tenant, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Endpoint to get door delivery addresses of a customer. Door delivery addresses are billing + shipping (excluding pickupStation) addresses
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addressesV2TenantDoorDeliveryGet(tenant, options) {
      return localVarFp.addressesV2TenantDoorDeliveryGet(tenant, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Endpoint to get all addresses of a customer with ability to exclude pickupStation addresses that also include \'now service\' data.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {'web_desktop' | 'web_mobile' | 'ios' | 'android'} [clientPlatform] The number of items to skip before starting to collect the result set
     * @param {Array<'billing' | 'pickupStation' | 'shipping'>} [types] used to get specific types of addresses
     * @param {string} [orderDraftId] Id of odrder draft that is needed for fetching Now data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addressesV2TenantGet(tenant, clientPlatform, types, orderDraftId, options) {
      return localVarFp
        .addressesV2TenantGet(tenant, clientPlatform, types, orderDraftId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Endpoint to delete an address given address id
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addressesV2TenantIdDelete(tenant, id, options) {
      return localVarFp.addressesV2TenantIdDelete(tenant, id, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Endpoint to update an address given address id
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} id
     * @param {AddressesV2TenantIdPutRequest} AddressesV2TenantIdPutRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addressesV2TenantIdPut(tenant, id, AddressesV2TenantIdPutRequest, options) {
      return localVarFp
        .addressesV2TenantIdPut(tenant, id, AddressesV2TenantIdPutRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Endpoint to get door delivery addresses of a customer. Door delivery addresses are billing + shipping (excluding pickupStation) addresses that also include \'now service\' data.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderDraftId
     * @param {'web_desktop' | 'web_mobile' | 'ios' | 'android'} [clientPlatform] The number of items to skip before starting to collect the result set
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    addressesV2TenantOrderDraftIdDoorDeliveryGet(tenant, orderDraftId, clientPlatform, options) {
      return localVarFp
        .addressesV2TenantOrderDraftIdDoorDeliveryGet(tenant, orderDraftId, clientPlatform, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Endpoint to get pickupStation addresses of a customer
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addressesV2TenantPickupStationDeliveryGet(tenant, options) {
      return localVarFp
        .addressesV2TenantPickupStationDeliveryGet(tenant, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Endpoint to create an address
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {AddressesV2TenantPostRequest} AddressesV2TenantPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addressesV2TenantPost(tenant, AddressesV2TenantPostRequest, options) {
      return localVarFp
        .addressesV2TenantPost(tenant, AddressesV2TenantPostRequest, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * AddressControllerApi - object-oriented interface
 * @export
 * @class AddressControllerApi
 * @extends {BaseAPI}
 */
export class AddressControllerApi extends BaseAPI {
  /**
   *
   * @summary Endpoint for migrating addresses (for internal usage only)
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {MigrateAddressesRequestV1} MigrateAddressesRequestV1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AddressControllerApi
   */
  addressesV2TenantAddressesPost(tenant, MigrateAddressesRequestV1, options) {
    return AddressControllerApiFp(this.configuration)
      .addressesV2TenantAddressesPost(tenant, MigrateAddressesRequestV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Endpoint to get the ZIP of the default door delivery address of a customer. The endpoint is needed for the NOW Modals
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AddressControllerApi
   */
  addressesV2TenantDefaultZipGet(tenant, options) {
    return AddressControllerApiFp(this.configuration)
      .addressesV2TenantDefaultZipGet(tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Endpoint to get door delivery addresses of a customer. Door delivery addresses are billing + shipping (excluding pickupStation) addresses
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AddressControllerApi
   */
  addressesV2TenantDoorDeliveryGet(tenant, options) {
    return AddressControllerApiFp(this.configuration)
      .addressesV2TenantDoorDeliveryGet(tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Endpoint to get all addresses of a customer with ability to exclude pickupStation addresses that also include \'now service\' data.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {'web_desktop' | 'web_mobile' | 'ios' | 'android'} [clientPlatform] The number of items to skip before starting to collect the result set
   * @param {Array<'billing' | 'pickupStation' | 'shipping'>} [types] used to get specific types of addresses
   * @param {string} [orderDraftId] Id of odrder draft that is needed for fetching Now data.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AddressControllerApi
   */
  addressesV2TenantGet(tenant, clientPlatform, types, orderDraftId, options) {
    return AddressControllerApiFp(this.configuration)
      .addressesV2TenantGet(tenant, clientPlatform, types, orderDraftId, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Endpoint to delete an address given address id
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AddressControllerApi
   */
  addressesV2TenantIdDelete(tenant, id, options) {
    return AddressControllerApiFp(this.configuration)
      .addressesV2TenantIdDelete(tenant, id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Endpoint to update an address given address id
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} id
   * @param {AddressesV2TenantIdPutRequest} AddressesV2TenantIdPutRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AddressControllerApi
   */
  addressesV2TenantIdPut(tenant, id, AddressesV2TenantIdPutRequest, options) {
    return AddressControllerApiFp(this.configuration)
      .addressesV2TenantIdPut(tenant, id, AddressesV2TenantIdPutRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Endpoint to get door delivery addresses of a customer. Door delivery addresses are billing + shipping (excluding pickupStation) addresses that also include \'now service\' data.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} orderDraftId
   * @param {'web_desktop' | 'web_mobile' | 'ios' | 'android'} [clientPlatform] The number of items to skip before starting to collect the result set
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof AddressControllerApi
   */
  addressesV2TenantOrderDraftIdDoorDeliveryGet(tenant, orderDraftId, clientPlatform, options) {
    return AddressControllerApiFp(this.configuration)
      .addressesV2TenantOrderDraftIdDoorDeliveryGet(tenant, orderDraftId, clientPlatform, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Endpoint to get pickupStation addresses of a customer
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AddressControllerApi
   */
  addressesV2TenantPickupStationDeliveryGet(tenant, options) {
    return AddressControllerApiFp(this.configuration)
      .addressesV2TenantPickupStationDeliveryGet(tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Endpoint to create an address
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {AddressesV2TenantPostRequest} AddressesV2TenantPostRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AddressControllerApi
   */
  addressesV2TenantPost(tenant, AddressesV2TenantPostRequest, options) {
    return AddressControllerApiFp(this.configuration)
      .addressesV2TenantPost(tenant, AddressesV2TenantPostRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * AdyenCheckoutConnectorControllerApi - axios parameter creator
 * @export
 */
export const AdyenCheckoutConnectorControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * adyen platform - get account holder
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {GetAccountHolderRequest} GetAccountHolderRequest Request payload for getting account holder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adyenV1TenantPlatformGetAccountHolderPost: async (tenant, GetAccountHolderRequest, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("adyenV1TenantPlatformGetAccountHolderPost", "tenant", tenant);
      // verify required parameter 'GetAccountHolderRequest' is not null or undefined
      assertParamExists(
        "adyenV1TenantPlatformGetAccountHolderPost",
        "GetAccountHolderRequest",
        GetAccountHolderRequest
      );
      const localVarPath = `/adyen/v1/{tenant}/platform/getAccountHolder`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication basicAuth required
      // http basic authentication required
      setBasicAuthToObject(localVarRequestOptions, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        GetAccountHolderRequest,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * AdyenCheckoutConnectorControllerApi - functional programming interface
 * @export
 */
export const AdyenCheckoutConnectorControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = AdyenCheckoutConnectorControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * adyen platform - get account holder
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {GetAccountHolderRequest} GetAccountHolderRequest Request payload for getting account holder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adyenV1TenantPlatformGetAccountHolderPost(tenant, GetAccountHolderRequest, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.adyenV1TenantPlatformGetAccountHolderPost(
        tenant,
        GetAccountHolderRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * AdyenCheckoutConnectorControllerApi - factory interface
 * @export
 */
export const AdyenCheckoutConnectorControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = AdyenCheckoutConnectorControllerApiFp(configuration);
  return {
    /**
     * adyen platform - get account holder
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {GetAccountHolderRequest} GetAccountHolderRequest Request payload for getting account holder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adyenV1TenantPlatformGetAccountHolderPost(tenant, GetAccountHolderRequest, options) {
      return localVarFp
        .adyenV1TenantPlatformGetAccountHolderPost(tenant, GetAccountHolderRequest, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * AdyenCheckoutConnectorControllerApi - object-oriented interface
 * @export
 * @class AdyenCheckoutConnectorControllerApi
 * @extends {BaseAPI}
 */
export class AdyenCheckoutConnectorControllerApi extends BaseAPI {
  /**
   * adyen platform - get account holder
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {GetAccountHolderRequest} GetAccountHolderRequest Request payload for getting account holder
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdyenCheckoutConnectorControllerApi
   */
  adyenV1TenantPlatformGetAccountHolderPost(tenant, GetAccountHolderRequest, options) {
    return AdyenCheckoutConnectorControllerApiFp(this.configuration)
      .adyenV1TenantPlatformGetAccountHolderPost(tenant, GetAccountHolderRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * AppCheckoutConfigControllerApi - axios parameter creator
 * @export
 */
export const AppCheckoutConfigControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Used by app to retrieve checkout config
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {AppCheckoutConfigV1TenantLanguagePostRequest} AppCheckoutConfigV1TenantLanguagePostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    appCheckoutConfigV1TenantLanguagePost: async (
      tenant,
      language,
      AppCheckoutConfigV1TenantLanguagePostRequest,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("appCheckoutConfigV1TenantLanguagePost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("appCheckoutConfigV1TenantLanguagePost", "language", language);
      // verify required parameter 'AppCheckoutConfigV1TenantLanguagePostRequest' is not null or undefined
      assertParamExists(
        "appCheckoutConfigV1TenantLanguagePost",
        "AppCheckoutConfigV1TenantLanguagePostRequest",
        AppCheckoutConfigV1TenantLanguagePostRequest
      );
      const localVarPath = `/app-checkout-config/v1/{tenant}/{language}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        AppCheckoutConfigV1TenantLanguagePostRequest,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * AppCheckoutConfigControllerApi - functional programming interface
 * @export
 */
export const AppCheckoutConfigControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = AppCheckoutConfigControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * Used by app to retrieve checkout config
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {AppCheckoutConfigV1TenantLanguagePostRequest} AppCheckoutConfigV1TenantLanguagePostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async appCheckoutConfigV1TenantLanguagePost(
      tenant,
      language,
      AppCheckoutConfigV1TenantLanguagePostRequest,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.appCheckoutConfigV1TenantLanguagePost(
        tenant,
        language,
        AppCheckoutConfigV1TenantLanguagePostRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * AppCheckoutConfigControllerApi - factory interface
 * @export
 */
export const AppCheckoutConfigControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = AppCheckoutConfigControllerApiFp(configuration);
  return {
    /**
     * Used by app to retrieve checkout config
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {AppCheckoutConfigV1TenantLanguagePostRequest} AppCheckoutConfigV1TenantLanguagePostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    appCheckoutConfigV1TenantLanguagePost(tenant, language, AppCheckoutConfigV1TenantLanguagePostRequest, options) {
      return localVarFp
        .appCheckoutConfigV1TenantLanguagePost(tenant, language, AppCheckoutConfigV1TenantLanguagePostRequest, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * AppCheckoutConfigControllerApi - object-oriented interface
 * @export
 * @class AppCheckoutConfigControllerApi
 * @extends {BaseAPI}
 */
export class AppCheckoutConfigControllerApi extends BaseAPI {
  /**
   * Used by app to retrieve checkout config
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {AppCheckoutConfigV1TenantLanguagePostRequest} AppCheckoutConfigV1TenantLanguagePostRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AppCheckoutConfigControllerApi
   */
  appCheckoutConfigV1TenantLanguagePost(tenant, language, AppCheckoutConfigV1TenantLanguagePostRequest, options) {
    return AppCheckoutConfigControllerApiFp(this.configuration)
      .appCheckoutConfigV1TenantLanguagePost(tenant, language, AppCheckoutConfigV1TenantLanguagePostRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * AppConfigControllerV1Api - axios parameter creator
 * @export
 */
export const AppConfigControllerV1ApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Used by a guest user to retrieve app config
     * @param {string} [countryId] filterCriteriaField CountryId
     * @param {string} [osName] filterCriteriaField OSName
     * @param {string} [osVersion] filterCriteriaField OSVersion
     * @param {string} [appVersion] filterCriteriaField AppVersion
     * @param {string} [language] filterCriteriaField Language
     * @param {string} [environment] filterCriteriaField Env
     * @param {string} [deviceType] filterCriteriaField DeviceType
     * @param {string} [buildType] filterCriteriaField BuildType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    appConfigV1Get: async (
      countryId,
      osName,
      osVersion,
      appVersion,
      language,
      environment,
      deviceType,
      buildType,
      options = {}
    ) => {
      const localVarPath = `/app-config/v1`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (countryId !== undefined) {
        localVarQueryParameter["countryId"] = countryId;
      }
      if (osName !== undefined) {
        localVarQueryParameter["osName"] = osName;
      }
      if (osVersion !== undefined) {
        localVarQueryParameter["osVersion"] = osVersion;
      }
      if (appVersion !== undefined) {
        localVarQueryParameter["appVersion"] = appVersion;
      }
      if (language !== undefined) {
        localVarQueryParameter["language"] = language;
      }
      if (environment !== undefined) {
        localVarQueryParameter["environment"] = environment;
      }
      if (deviceType !== undefined) {
        localVarQueryParameter["deviceType"] = deviceType;
      }
      if (buildType !== undefined) {
        localVarQueryParameter["buildType"] = buildType;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * AppConfigControllerV1Api - functional programming interface
 * @export
 */
export const AppConfigControllerV1ApiFp = function (configuration) {
  const localVarAxiosParamCreator = AppConfigControllerV1ApiAxiosParamCreator(configuration);
  return {
    /**
     * Used by a guest user to retrieve app config
     * @param {string} [countryId] filterCriteriaField CountryId
     * @param {string} [osName] filterCriteriaField OSName
     * @param {string} [osVersion] filterCriteriaField OSVersion
     * @param {string} [appVersion] filterCriteriaField AppVersion
     * @param {string} [language] filterCriteriaField Language
     * @param {string} [environment] filterCriteriaField Env
     * @param {string} [deviceType] filterCriteriaField DeviceType
     * @param {string} [buildType] filterCriteriaField BuildType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async appConfigV1Get(
      countryId,
      osName,
      osVersion,
      appVersion,
      language,
      environment,
      deviceType,
      buildType,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.appConfigV1Get(
        countryId,
        osName,
        osVersion,
        appVersion,
        language,
        environment,
        deviceType,
        buildType,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * AppConfigControllerV1Api - factory interface
 * @export
 */
export const AppConfigControllerV1ApiFactory = function (configuration, basePath, axios) {
  const localVarFp = AppConfigControllerV1ApiFp(configuration);
  return {
    /**
     * Used by a guest user to retrieve app config
     * @param {string} [countryId] filterCriteriaField CountryId
     * @param {string} [osName] filterCriteriaField OSName
     * @param {string} [osVersion] filterCriteriaField OSVersion
     * @param {string} [appVersion] filterCriteriaField AppVersion
     * @param {string} [language] filterCriteriaField Language
     * @param {string} [environment] filterCriteriaField Env
     * @param {string} [deviceType] filterCriteriaField DeviceType
     * @param {string} [buildType] filterCriteriaField BuildType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    appConfigV1Get(countryId, osName, osVersion, appVersion, language, environment, deviceType, buildType, options) {
      return localVarFp
        .appConfigV1Get(countryId, osName, osVersion, appVersion, language, environment, deviceType, buildType, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * AppConfigControllerV1Api - object-oriented interface
 * @export
 * @class AppConfigControllerV1Api
 * @extends {BaseAPI}
 */
export class AppConfigControllerV1Api extends BaseAPI {
  /**
   * Used by a guest user to retrieve app config
   * @param {string} [countryId] filterCriteriaField CountryId
   * @param {string} [osName] filterCriteriaField OSName
   * @param {string} [osVersion] filterCriteriaField OSVersion
   * @param {string} [appVersion] filterCriteriaField AppVersion
   * @param {string} [language] filterCriteriaField Language
   * @param {string} [environment] filterCriteriaField Env
   * @param {string} [deviceType] filterCriteriaField DeviceType
   * @param {string} [buildType] filterCriteriaField BuildType
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AppConfigControllerV1Api
   */
  appConfigV1Get(countryId, osName, osVersion, appVersion, language, environment, deviceType, buildType, options) {
    return AppConfigControllerV1ApiFp(this.configuration)
      .appConfigV1Get(countryId, osName, osVersion, appVersion, language, environment, deviceType, buildType, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * AuthControllerApi - axios parameter creator
 * @export
 */
export const AuthControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {EnableRequestV1} EnableRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authV1TenantEnablePost: async (tenant, EnableRequestV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("authV1TenantEnablePost", "tenant", tenant);
      // verify required parameter 'EnableRequestV1' is not null or undefined
      assertParamExists("authV1TenantEnablePost", "EnableRequestV1", EnableRequestV1);
      const localVarPath = `/auth/v1/{tenant}/enable`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(EnableRequestV1, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} version public key version
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authV1TenantKeyVersionGet: async (version, tenant, options = {}) => {
      // verify required parameter 'version' is not null or undefined
      assertParamExists("authV1TenantKeyVersionGet", "version", version);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("authV1TenantKeyVersionGet", "tenant", tenant);
      const localVarPath = `/auth/v1/{tenant}/key/{version}`
        .replace(`{${"version"}}`, encodeURIComponent(String(version)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authV1TenantLoginGuestGet: async (tenant, Sae_Device_Type, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("authV1TenantLoginGuestGet", "tenant", tenant);
      const localVarPath = `/auth/v1/{tenant}/login/guest`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (Sae_Device_Type != null) {
        localVarHeaderParameter["Sae-Device-Type"] = String(Sae_Device_Type);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {LoginRequestV1} LoginRequestV1
     * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    authV1TenantLoginPost: async (tenant, LoginRequestV1, Sae_Device_Type, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("authV1TenantLoginPost", "tenant", tenant);
      // verify required parameter 'LoginRequestV1' is not null or undefined
      assertParamExists("authV1TenantLoginPost", "LoginRequestV1", LoginRequestV1);
      const localVarPath = `/auth/v1/{tenant}/login`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (Sae_Device_Type != null) {
        localVarHeaderParameter["Sae-Device-Type"] = String(Sae_Device_Type);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(LoginRequestV1, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {UpdateRequestV1} UpdateRequestV1
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    authV1TenantPasswordPost: async (tenant, UpdateRequestV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("authV1TenantPasswordPost", "tenant", tenant);
      // verify required parameter 'UpdateRequestV1' is not null or undefined
      assertParamExists("authV1TenantPasswordPost", "UpdateRequestV1", UpdateRequestV1);
      const localVarPath = `/auth/v1/{tenant}/password`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(UpdateRequestV1, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authV1TenantRefreshGet: async (tenant, Sae_Device_Type, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("authV1TenantRefreshGet", "tenant", tenant);
      const localVarPath = `/auth/v1/{tenant}/refresh`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (Sae_Device_Type != null) {
        localVarHeaderParameter["Sae-Device-Type"] = String(Sae_Device_Type);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {RegisterRequestV1} RegisterRequestV1
     * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    authV1TenantRegisterPost: async (tenant, RegisterRequestV1, Sae_Device_Type, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("authV1TenantRegisterPost", "tenant", tenant);
      // verify required parameter 'RegisterRequestV1' is not null or undefined
      assertParamExists("authV1TenantRegisterPost", "RegisterRequestV1", RegisterRequestV1);
      const localVarPath = `/auth/v1/{tenant}/register`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (Sae_Device_Type != null) {
        localVarHeaderParameter["Sae-Device-Type"] = String(Sae_Device_Type);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(RegisterRequestV1, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Used by the customer to get a reset token for resetting his password. The x-shop-auth-token is required for this endpoint.
     * @param {string} customerNumber QueryParam customerNumber
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    authV1TenantResetGet: async (customerNumber, tenant, options = {}) => {
      // verify required parameter 'customerNumber' is not null or undefined
      assertParamExists("authV1TenantResetGet", "customerNumber", customerNumber);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("authV1TenantResetGet", "tenant", tenant);
      const localVarPath = `/auth/v1/{tenant}/reset`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (customerNumber !== undefined) {
        localVarQueryParameter["customerNumber"] = customerNumber;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {ResetRequestV1} ResetRequestV1
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    authV1TenantResetPost: async (tenant, ResetRequestV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("authV1TenantResetPost", "tenant", tenant);
      // verify required parameter 'ResetRequestV1' is not null or undefined
      assertParamExists("authV1TenantResetPost", "ResetRequestV1", ResetRequestV1);
      const localVarPath = `/auth/v1/{tenant}/reset`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(ResetRequestV1, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {LoginRequestV2} LoginRequestV2
     * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    authV2TenantLoginPost: async (tenant, LoginRequestV2, Sae_Device_Type, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("authV2TenantLoginPost", "tenant", tenant);
      // verify required parameter 'LoginRequestV2' is not null or undefined
      assertParamExists("authV2TenantLoginPost", "LoginRequestV2", LoginRequestV2);
      const localVarPath = `/auth/v2/{tenant}/login`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (Sae_Device_Type != null) {
        localVarHeaderParameter["Sae-Device-Type"] = String(Sae_Device_Type);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(LoginRequestV2, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authV2TenantLogoutPost: async (tenant, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("authV2TenantLogoutPost", "tenant", tenant);
      const localVarPath = `/auth/v2/{tenant}/logout`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {UpdatePasswordRequestV2} UpdatePasswordRequestV2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authV2TenantPasswordPatch: async (tenant, UpdatePasswordRequestV2, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("authV2TenantPasswordPatch", "tenant", tenant);
      // verify required parameter 'UpdatePasswordRequestV2' is not null or undefined
      assertParamExists("authV2TenantPasswordPatch", "UpdatePasswordRequestV2", UpdatePasswordRequestV2);
      const localVarPath = `/auth/v2/{tenant}/password`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "PATCH", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        UpdatePasswordRequestV2,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {RegisterRequestV2} RegisterRequestV2
     * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authV2TenantRegisterPost: async (tenant, RegisterRequestV2, Sae_Device_Type, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("authV2TenantRegisterPost", "tenant", tenant);
      // verify required parameter 'RegisterRequestV2' is not null or undefined
      assertParamExists("authV2TenantRegisterPost", "RegisterRequestV2", RegisterRequestV2);
      const localVarPath = `/auth/v2/{tenant}/register`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (Sae_Device_Type != null) {
        localVarHeaderParameter["Sae-Device-Type"] = String(Sae_Device_Type);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(RegisterRequestV2, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Triggers the password reset process
     * @param {string} email Email Address Query Param
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authV2TenantResetGet: async (email, tenant, options = {}) => {
      // verify required parameter 'email' is not null or undefined
      assertParamExists("authV2TenantResetGet", "email", email);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("authV2TenantResetGet", "tenant", tenant);
      const localVarPath = `/auth/v2/{tenant}/reset`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (email !== undefined) {
        localVarQueryParameter["email"] = email;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Set the new password for the customers account with the help of the Reset Token
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {PasswordResetRequestV2} PasswordResetRequestV2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authV2TenantResetPost: async (tenant, PasswordResetRequestV2, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("authV2TenantResetPost", "tenant", tenant);
      // verify required parameter 'PasswordResetRequestV2' is not null or undefined
      assertParamExists("authV2TenantResetPost", "PasswordResetRequestV2", PasswordResetRequestV2);
      const localVarPath = `/auth/v2/{tenant}/reset`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        PasswordResetRequestV2,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Verifies the Customers Password Reset Token. The password reset token must be set in the Authorization header
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authV2TenantResetVerifyGet: async (tenant, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("authV2TenantResetVerifyGet", "tenant", tenant);
      const localVarPath = `/auth/v2/{tenant}/reset/verify`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {ValidateCustomersPasswordRequestV2} ValidateCustomersPasswordRequestV2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authV2TenantValidateCustomersPasswordPost: async (tenant, ValidateCustomersPasswordRequestV2, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("authV2TenantValidateCustomersPasswordPost", "tenant", tenant);
      // verify required parameter 'ValidateCustomersPasswordRequestV2' is not null or undefined
      assertParamExists(
        "authV2TenantValidateCustomersPasswordPost",
        "ValidateCustomersPasswordRequestV2",
        ValidateCustomersPasswordRequestV2
      );
      const localVarPath = `/auth/v2/{tenant}/validateCustomersPassword`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        ValidateCustomersPasswordRequestV2,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {LoginRequestV3} LoginRequestV3
     * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authV3TenantLoginPost: async (tenant, LoginRequestV3, Sae_Device_Type, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("authV3TenantLoginPost", "tenant", tenant);
      // verify required parameter 'LoginRequestV3' is not null or undefined
      assertParamExists("authV3TenantLoginPost", "LoginRequestV3", LoginRequestV3);
      const localVarPath = `/auth/v3/{tenant}/login`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (Sae_Device_Type != null) {
        localVarHeaderParameter["Sae-Device-Type"] = String(Sae_Device_Type);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(LoginRequestV3, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * AuthControllerApi - functional programming interface
 * @export
 */
export const AuthControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = AuthControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {EnableRequestV1} EnableRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authV1TenantEnablePost(tenant, EnableRequestV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authV1TenantEnablePost(
        tenant,
        EnableRequestV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} version public key version
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authV1TenantKeyVersionGet(version, tenant, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authV1TenantKeyVersionGet(version, tenant, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authV1TenantLoginGuestGet(tenant, Sae_Device_Type, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authV1TenantLoginGuestGet(
        tenant,
        Sae_Device_Type,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {LoginRequestV1} LoginRequestV1
     * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async authV1TenantLoginPost(tenant, LoginRequestV1, Sae_Device_Type, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authV1TenantLoginPost(
        tenant,
        LoginRequestV1,
        Sae_Device_Type,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {UpdateRequestV1} UpdateRequestV1
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async authV1TenantPasswordPost(tenant, UpdateRequestV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authV1TenantPasswordPost(
        tenant,
        UpdateRequestV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authV1TenantRefreshGet(tenant, Sae_Device_Type, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authV1TenantRefreshGet(
        tenant,
        Sae_Device_Type,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {RegisterRequestV1} RegisterRequestV1
     * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async authV1TenantRegisterPost(tenant, RegisterRequestV1, Sae_Device_Type, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authV1TenantRegisterPost(
        tenant,
        RegisterRequestV1,
        Sae_Device_Type,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Used by the customer to get a reset token for resetting his password. The x-shop-auth-token is required for this endpoint.
     * @param {string} customerNumber QueryParam customerNumber
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async authV1TenantResetGet(customerNumber, tenant, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authV1TenantResetGet(customerNumber, tenant, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {ResetRequestV1} ResetRequestV1
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async authV1TenantResetPost(tenant, ResetRequestV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authV1TenantResetPost(tenant, ResetRequestV1, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {LoginRequestV2} LoginRequestV2
     * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async authV2TenantLoginPost(tenant, LoginRequestV2, Sae_Device_Type, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authV2TenantLoginPost(
        tenant,
        LoginRequestV2,
        Sae_Device_Type,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authV2TenantLogoutPost(tenant, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authV2TenantLogoutPost(tenant, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {UpdatePasswordRequestV2} UpdatePasswordRequestV2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authV2TenantPasswordPatch(tenant, UpdatePasswordRequestV2, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authV2TenantPasswordPatch(
        tenant,
        UpdatePasswordRequestV2,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {RegisterRequestV2} RegisterRequestV2
     * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authV2TenantRegisterPost(tenant, RegisterRequestV2, Sae_Device_Type, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authV2TenantRegisterPost(
        tenant,
        RegisterRequestV2,
        Sae_Device_Type,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Triggers the password reset process
     * @param {string} email Email Address Query Param
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authV2TenantResetGet(email, tenant, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authV2TenantResetGet(email, tenant, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Set the new password for the customers account with the help of the Reset Token
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {PasswordResetRequestV2} PasswordResetRequestV2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authV2TenantResetPost(tenant, PasswordResetRequestV2, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authV2TenantResetPost(
        tenant,
        PasswordResetRequestV2,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Verifies the Customers Password Reset Token. The password reset token must be set in the Authorization header
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authV2TenantResetVerifyGet(tenant, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authV2TenantResetVerifyGet(tenant, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {ValidateCustomersPasswordRequestV2} ValidateCustomersPasswordRequestV2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authV2TenantValidateCustomersPasswordPost(tenant, ValidateCustomersPasswordRequestV2, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authV2TenantValidateCustomersPasswordPost(
        tenant,
        ValidateCustomersPasswordRequestV2,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {LoginRequestV3} LoginRequestV3
     * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authV3TenantLoginPost(tenant, LoginRequestV3, Sae_Device_Type, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authV3TenantLoginPost(
        tenant,
        LoginRequestV3,
        Sae_Device_Type,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * AuthControllerApi - factory interface
 * @export
 */
export const AuthControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = AuthControllerApiFp(configuration);
  return {
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {EnableRequestV1} EnableRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authV1TenantEnablePost(tenant, EnableRequestV1, options) {
      return localVarFp
        .authV1TenantEnablePost(tenant, EnableRequestV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} version public key version
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authV1TenantKeyVersionGet(version, tenant, options) {
      return localVarFp.authV1TenantKeyVersionGet(version, tenant, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authV1TenantLoginGuestGet(tenant, Sae_Device_Type, options) {
      return localVarFp
        .authV1TenantLoginGuestGet(tenant, Sae_Device_Type, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {LoginRequestV1} LoginRequestV1
     * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    authV1TenantLoginPost(tenant, LoginRequestV1, Sae_Device_Type, options) {
      return localVarFp
        .authV1TenantLoginPost(tenant, LoginRequestV1, Sae_Device_Type, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {UpdateRequestV1} UpdateRequestV1
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    authV1TenantPasswordPost(tenant, UpdateRequestV1, options) {
      return localVarFp
        .authV1TenantPasswordPost(tenant, UpdateRequestV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authV1TenantRefreshGet(tenant, Sae_Device_Type, options) {
      return localVarFp
        .authV1TenantRefreshGet(tenant, Sae_Device_Type, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {RegisterRequestV1} RegisterRequestV1
     * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    authV1TenantRegisterPost(tenant, RegisterRequestV1, Sae_Device_Type, options) {
      return localVarFp
        .authV1TenantRegisterPost(tenant, RegisterRequestV1, Sae_Device_Type, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Used by the customer to get a reset token for resetting his password. The x-shop-auth-token is required for this endpoint.
     * @param {string} customerNumber QueryParam customerNumber
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    authV1TenantResetGet(customerNumber, tenant, options) {
      return localVarFp
        .authV1TenantResetGet(customerNumber, tenant, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {ResetRequestV1} ResetRequestV1
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    authV1TenantResetPost(tenant, ResetRequestV1, options) {
      return localVarFp
        .authV1TenantResetPost(tenant, ResetRequestV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {LoginRequestV2} LoginRequestV2
     * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    authV2TenantLoginPost(tenant, LoginRequestV2, Sae_Device_Type, options) {
      return localVarFp
        .authV2TenantLoginPost(tenant, LoginRequestV2, Sae_Device_Type, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authV2TenantLogoutPost(tenant, options) {
      return localVarFp.authV2TenantLogoutPost(tenant, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {UpdatePasswordRequestV2} UpdatePasswordRequestV2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authV2TenantPasswordPatch(tenant, UpdatePasswordRequestV2, options) {
      return localVarFp
        .authV2TenantPasswordPatch(tenant, UpdatePasswordRequestV2, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {RegisterRequestV2} RegisterRequestV2
     * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authV2TenantRegisterPost(tenant, RegisterRequestV2, Sae_Device_Type, options) {
      return localVarFp
        .authV2TenantRegisterPost(tenant, RegisterRequestV2, Sae_Device_Type, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Triggers the password reset process
     * @param {string} email Email Address Query Param
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authV2TenantResetGet(email, tenant, options) {
      return localVarFp.authV2TenantResetGet(email, tenant, options).then((request) => request(axios, basePath));
    },
    /**
     * Set the new password for the customers account with the help of the Reset Token
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {PasswordResetRequestV2} PasswordResetRequestV2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authV2TenantResetPost(tenant, PasswordResetRequestV2, options) {
      return localVarFp
        .authV2TenantResetPost(tenant, PasswordResetRequestV2, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Verifies the Customers Password Reset Token. The password reset token must be set in the Authorization header
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authV2TenantResetVerifyGet(tenant, options) {
      return localVarFp.authV2TenantResetVerifyGet(tenant, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {ValidateCustomersPasswordRequestV2} ValidateCustomersPasswordRequestV2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authV2TenantValidateCustomersPasswordPost(tenant, ValidateCustomersPasswordRequestV2, options) {
      return localVarFp
        .authV2TenantValidateCustomersPasswordPost(tenant, ValidateCustomersPasswordRequestV2, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {LoginRequestV3} LoginRequestV3
     * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authV3TenantLoginPost(tenant, LoginRequestV3, Sae_Device_Type, options) {
      return localVarFp
        .authV3TenantLoginPost(tenant, LoginRequestV3, Sae_Device_Type, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * AuthControllerApi - object-oriented interface
 * @export
 * @class AuthControllerApi
 * @extends {BaseAPI}
 */
export class AuthControllerApi extends BaseAPI {
  /**
   *
   * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
   * @param {EnableRequestV1} EnableRequestV1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthControllerApi
   */
  authV1TenantEnablePost(tenant, EnableRequestV1, options) {
    return AuthControllerApiFp(this.configuration)
      .authV1TenantEnablePost(tenant, EnableRequestV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} version public key version
   * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthControllerApi
   */
  authV1TenantKeyVersionGet(version, tenant, options) {
    return AuthControllerApiFp(this.configuration)
      .authV1TenantKeyVersionGet(version, tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
   * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthControllerApi
   */
  authV1TenantLoginGuestGet(tenant, Sae_Device_Type, options) {
    return AuthControllerApiFp(this.configuration)
      .authV1TenantLoginGuestGet(tenant, Sae_Device_Type, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
   * @param {LoginRequestV1} LoginRequestV1
   * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof AuthControllerApi
   */
  authV1TenantLoginPost(tenant, LoginRequestV1, Sae_Device_Type, options) {
    return AuthControllerApiFp(this.configuration)
      .authV1TenantLoginPost(tenant, LoginRequestV1, Sae_Device_Type, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
   * @param {UpdateRequestV1} UpdateRequestV1
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof AuthControllerApi
   */
  authV1TenantPasswordPost(tenant, UpdateRequestV1, options) {
    return AuthControllerApiFp(this.configuration)
      .authV1TenantPasswordPost(tenant, UpdateRequestV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
   * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthControllerApi
   */
  authV1TenantRefreshGet(tenant, Sae_Device_Type, options) {
    return AuthControllerApiFp(this.configuration)
      .authV1TenantRefreshGet(tenant, Sae_Device_Type, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
   * @param {RegisterRequestV1} RegisterRequestV1
   * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof AuthControllerApi
   */
  authV1TenantRegisterPost(tenant, RegisterRequestV1, Sae_Device_Type, options) {
    return AuthControllerApiFp(this.configuration)
      .authV1TenantRegisterPost(tenant, RegisterRequestV1, Sae_Device_Type, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Used by the customer to get a reset token for resetting his password. The x-shop-auth-token is required for this endpoint.
   * @param {string} customerNumber QueryParam customerNumber
   * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof AuthControllerApi
   */
  authV1TenantResetGet(customerNumber, tenant, options) {
    return AuthControllerApiFp(this.configuration)
      .authV1TenantResetGet(customerNumber, tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
   * @param {ResetRequestV1} ResetRequestV1
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof AuthControllerApi
   */
  authV1TenantResetPost(tenant, ResetRequestV1, options) {
    return AuthControllerApiFp(this.configuration)
      .authV1TenantResetPost(tenant, ResetRequestV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
   * @param {LoginRequestV2} LoginRequestV2
   * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof AuthControllerApi
   */
  authV2TenantLoginPost(tenant, LoginRequestV2, Sae_Device_Type, options) {
    return AuthControllerApiFp(this.configuration)
      .authV2TenantLoginPost(tenant, LoginRequestV2, Sae_Device_Type, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthControllerApi
   */
  authV2TenantLogoutPost(tenant, options) {
    return AuthControllerApiFp(this.configuration)
      .authV2TenantLogoutPost(tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {UpdatePasswordRequestV2} UpdatePasswordRequestV2
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthControllerApi
   */
  authV2TenantPasswordPatch(tenant, UpdatePasswordRequestV2, options) {
    return AuthControllerApiFp(this.configuration)
      .authV2TenantPasswordPatch(tenant, UpdatePasswordRequestV2, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
   * @param {RegisterRequestV2} RegisterRequestV2
   * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthControllerApi
   */
  authV2TenantRegisterPost(tenant, RegisterRequestV2, Sae_Device_Type, options) {
    return AuthControllerApiFp(this.configuration)
      .authV2TenantRegisterPost(tenant, RegisterRequestV2, Sae_Device_Type, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Triggers the password reset process
   * @param {string} email Email Address Query Param
   * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthControllerApi
   */
  authV2TenantResetGet(email, tenant, options) {
    return AuthControllerApiFp(this.configuration)
      .authV2TenantResetGet(email, tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Set the new password for the customers account with the help of the Reset Token
   * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
   * @param {PasswordResetRequestV2} PasswordResetRequestV2
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthControllerApi
   */
  authV2TenantResetPost(tenant, PasswordResetRequestV2, options) {
    return AuthControllerApiFp(this.configuration)
      .authV2TenantResetPost(tenant, PasswordResetRequestV2, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Verifies the Customers Password Reset Token. The password reset token must be set in the Authorization header
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthControllerApi
   */
  authV2TenantResetVerifyGet(tenant, options) {
    return AuthControllerApiFp(this.configuration)
      .authV2TenantResetVerifyGet(tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
   * @param {ValidateCustomersPasswordRequestV2} ValidateCustomersPasswordRequestV2
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthControllerApi
   */
  authV2TenantValidateCustomersPasswordPost(tenant, ValidateCustomersPasswordRequestV2, options) {
    return AuthControllerApiFp(this.configuration)
      .authV2TenantValidateCustomersPasswordPost(tenant, ValidateCustomersPasswordRequestV2, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
   * @param {LoginRequestV3} LoginRequestV3
   * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthControllerApi
   */
  authV3TenantLoginPost(tenant, LoginRequestV3, Sae_Device_Type, options) {
    return AuthControllerApiFp(this.configuration)
      .authV3TenantLoginPost(tenant, LoginRequestV3, Sae_Device_Type, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * CarriersControllerApi - axios parameter creator
 * @export
 */
export const CarriersControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    carriersV1TenantFreeShippingThresholdsGet: async (tenant, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("carriersV1TenantFreeShippingThresholdsGet", "tenant", tenant);
      const localVarPath = `/carriers/v1/{tenant}/freeShippingThresholds`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    carriersV1TenantGet: async (tenant, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("carriersV1TenantGet", "tenant", tenant);
      const localVarPath = `/carriers/v1/{tenant}`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Use OrderDraft instead of Cart to derive query parameters for the SHIPSe request
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderDraftId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    carriersV1TenantOrderDraftIdGet: async (tenant, orderDraftId, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("carriersV1TenantOrderDraftIdGet", "tenant", tenant);
      // verify required parameter 'orderDraftId' is not null or undefined
      assertParamExists("carriersV1TenantOrderDraftIdGet", "orderDraftId", orderDraftId);
      const localVarPath = `/carriers/v1/{tenant}/{orderDraftId}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Find all shipping methods for order draft ID
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderDraftId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    carriersV1TenantShippingMethodsOrderDraftIdGet: async (tenant, orderDraftId, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("carriersV1TenantShippingMethodsOrderDraftIdGet", "tenant", tenant);
      // verify required parameter 'orderDraftId' is not null or undefined
      assertParamExists("carriersV1TenantShippingMethodsOrderDraftIdGet", "orderDraftId", orderDraftId);
      const localVarPath = `/carriers/v1/{tenant}/shippingMethods/{orderDraftId}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * CarriersControllerApi - functional programming interface
 * @export
 */
export const CarriersControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = CarriersControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async carriersV1TenantFreeShippingThresholdsGet(tenant, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.carriersV1TenantFreeShippingThresholdsGet(
        tenant,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async carriersV1TenantGet(tenant, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.carriersV1TenantGet(tenant, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Use OrderDraft instead of Cart to derive query parameters for the SHIPSe request
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderDraftId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async carriersV1TenantOrderDraftIdGet(tenant, orderDraftId, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.carriersV1TenantOrderDraftIdGet(
        tenant,
        orderDraftId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Find all shipping methods for order draft ID
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderDraftId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async carriersV1TenantShippingMethodsOrderDraftIdGet(tenant, orderDraftId, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.carriersV1TenantShippingMethodsOrderDraftIdGet(
        tenant,
        orderDraftId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * CarriersControllerApi - factory interface
 * @export
 */
export const CarriersControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = CarriersControllerApiFp(configuration);
  return {
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    carriersV1TenantFreeShippingThresholdsGet(tenant, options) {
      return localVarFp
        .carriersV1TenantFreeShippingThresholdsGet(tenant, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    carriersV1TenantGet(tenant, options) {
      return localVarFp.carriersV1TenantGet(tenant, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Use OrderDraft instead of Cart to derive query parameters for the SHIPSe request
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderDraftId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    carriersV1TenantOrderDraftIdGet(tenant, orderDraftId, options) {
      return localVarFp
        .carriersV1TenantOrderDraftIdGet(tenant, orderDraftId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Find all shipping methods for order draft ID
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderDraftId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    carriersV1TenantShippingMethodsOrderDraftIdGet(tenant, orderDraftId, options) {
      return localVarFp
        .carriersV1TenantShippingMethodsOrderDraftIdGet(tenant, orderDraftId, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * CarriersControllerApi - object-oriented interface
 * @export
 * @class CarriersControllerApi
 * @extends {BaseAPI}
 */
export class CarriersControllerApi extends BaseAPI {
  /**
   *
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CarriersControllerApi
   */
  carriersV1TenantFreeShippingThresholdsGet(tenant, options) {
    return CarriersControllerApiFp(this.configuration)
      .carriersV1TenantFreeShippingThresholdsGet(tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CarriersControllerApi
   */
  carriersV1TenantGet(tenant, options) {
    return CarriersControllerApiFp(this.configuration)
      .carriersV1TenantGet(tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Use OrderDraft instead of Cart to derive query parameters for the SHIPSe request
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} orderDraftId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CarriersControllerApi
   */
  carriersV1TenantOrderDraftIdGet(tenant, orderDraftId, options) {
    return CarriersControllerApiFp(this.configuration)
      .carriersV1TenantOrderDraftIdGet(tenant, orderDraftId, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Find all shipping methods for order draft ID
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} orderDraftId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CarriersControllerApi
   */
  carriersV1TenantShippingMethodsOrderDraftIdGet(tenant, orderDraftId, options) {
    return CarriersControllerApiFp(this.configuration)
      .carriersV1TenantShippingMethodsOrderDraftIdGet(tenant, orderDraftId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * CarriersControllerV2Api - axios parameter creator
 * @export
 */
export const CarriersControllerV2ApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {boolean} [isCoolingRequired] boolean flag for receiving carriers supporting cooling
     * @param {boolean} [hasPrescription] boolean flag for receiving carriers supporting shipping for rx offers
     * @param {number} [amountToPay] amount to pay carriers
     * @param {boolean} [allowExpressCarriers] boolean flag for receiving carriers supporting express
     * @param {string} [group] string value for grouping of carrier related products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    carriersV2TenantGet: async (
      tenant,
      isCoolingRequired,
      hasPrescription,
      amountToPay,
      allowExpressCarriers,
      group,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("carriersV2TenantGet", "tenant", tenant);
      const localVarPath = `/carriers/v2/{tenant}`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (isCoolingRequired !== undefined) {
        localVarQueryParameter["isCoolingRequired"] = isCoolingRequired;
      }
      if (hasPrescription !== undefined) {
        localVarQueryParameter["hasPrescription"] = hasPrescription;
      }
      if (amountToPay !== undefined) {
        localVarQueryParameter["amountToPay"] = amountToPay;
      }
      if (allowExpressCarriers !== undefined) {
        localVarQueryParameter["allowExpressCarriers"] = allowExpressCarriers;
      }
      if (group !== undefined) {
        localVarQueryParameter["group"] = group;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * CarriersControllerV2Api - functional programming interface
 * @export
 */
export const CarriersControllerV2ApiFp = function (configuration) {
  const localVarAxiosParamCreator = CarriersControllerV2ApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {boolean} [isCoolingRequired] boolean flag for receiving carriers supporting cooling
     * @param {boolean} [hasPrescription] boolean flag for receiving carriers supporting shipping for rx offers
     * @param {number} [amountToPay] amount to pay carriers
     * @param {boolean} [allowExpressCarriers] boolean flag for receiving carriers supporting express
     * @param {string} [group] string value for grouping of carrier related products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async carriersV2TenantGet(
      tenant,
      isCoolingRequired,
      hasPrescription,
      amountToPay,
      allowExpressCarriers,
      group,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.carriersV2TenantGet(
        tenant,
        isCoolingRequired,
        hasPrescription,
        amountToPay,
        allowExpressCarriers,
        group,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * CarriersControllerV2Api - factory interface
 * @export
 */
export const CarriersControllerV2ApiFactory = function (configuration, basePath, axios) {
  const localVarFp = CarriersControllerV2ApiFp(configuration);
  return {
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {boolean} [isCoolingRequired] boolean flag for receiving carriers supporting cooling
     * @param {boolean} [hasPrescription] boolean flag for receiving carriers supporting shipping for rx offers
     * @param {number} [amountToPay] amount to pay carriers
     * @param {boolean} [allowExpressCarriers] boolean flag for receiving carriers supporting express
     * @param {string} [group] string value for grouping of carrier related products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    carriersV2TenantGet(tenant, isCoolingRequired, hasPrescription, amountToPay, allowExpressCarriers, group, options) {
      return localVarFp
        .carriersV2TenantGet(
          tenant,
          isCoolingRequired,
          hasPrescription,
          amountToPay,
          allowExpressCarriers,
          group,
          options
        )
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * CarriersControllerV2Api - object-oriented interface
 * @export
 * @class CarriersControllerV2Api
 * @extends {BaseAPI}
 */
export class CarriersControllerV2Api extends BaseAPI {
  /**
   *
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {boolean} [isCoolingRequired] boolean flag for receiving carriers supporting cooling
   * @param {boolean} [hasPrescription] boolean flag for receiving carriers supporting shipping for rx offers
   * @param {number} [amountToPay] amount to pay carriers
   * @param {boolean} [allowExpressCarriers] boolean flag for receiving carriers supporting express
   * @param {string} [group] string value for grouping of carrier related products
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CarriersControllerV2Api
   */
  carriersV2TenantGet(tenant, isCoolingRequired, hasPrescription, amountToPay, allowExpressCarriers, group, options) {
    return CarriersControllerV2ApiFp(this.configuration)
      .carriersV2TenantGet(
        tenant,
        isCoolingRequired,
        hasPrescription,
        amountToPay,
        allowExpressCarriers,
        group,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * CartControllerV2Api - axios parameter creator
 * @export
 */
export const CartControllerV2ApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Endpoint to delete the existing cart, if it exists
     * @param {string} tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartV2TenantDelete: async (tenant, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("cartV2TenantDelete", "tenant", tenant);
      const localVarPath = `/cart/v2/{tenant}`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "DELETE", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} tenant
     * @param {string} hashedToken
     * @param {string} Accept_Language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartV2TenantEntriesERxHashedTokenDelete: async (tenant, hashedToken, Accept_Language, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("cartV2TenantEntriesERxHashedTokenDelete", "tenant", tenant);
      // verify required parameter 'hashedToken' is not null or undefined
      assertParamExists("cartV2TenantEntriesERxHashedTokenDelete", "hashedToken", hashedToken);
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists("cartV2TenantEntriesERxHashedTokenDelete", "Accept_Language", Accept_Language);
      const localVarPath = `/cart/v2/{tenant}/entries/eRx/{hashedToken}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"hashedToken"}}`, encodeURIComponent(String(hashedToken)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "DELETE", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (Accept_Language != null) {
        localVarHeaderParameter["Accept-Language"] = String(Accept_Language);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * create or update eRx entries providing eRx hashedTokens
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {Array<string>} request_body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartV2TenantEntriesERxPost: async (tenant, Accept_Language, request_body, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("cartV2TenantEntriesERxPost", "tenant", tenant);
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists("cartV2TenantEntriesERxPost", "Accept_Language", Accept_Language);
      // verify required parameter 'request_body' is not null or undefined
      assertParamExists("cartV2TenantEntriesERxPost", "request_body", request_body);
      const localVarPath = `/cart/v2/{tenant}/entries/eRx`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (Accept_Language != null) {
        localVarHeaderParameter["Accept-Language"] = String(Accept_Language);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(request_body, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * create multiple cartEntries
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {CartV2CartEntriesRequestV1} CartV2CartEntriesRequestV1
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {boolean} [isNowSelected]
     * @param {string} [slotId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartV2TenantEntriesPost: async (
      tenant,
      Accept_Language,
      CartV2CartEntriesRequestV1,
      purgeMessages,
      nowZipCode,
      isNowSelected,
      slotId,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("cartV2TenantEntriesPost", "tenant", tenant);
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists("cartV2TenantEntriesPost", "Accept_Language", Accept_Language);
      // verify required parameter 'CartV2CartEntriesRequestV1' is not null or undefined
      assertParamExists("cartV2TenantEntriesPost", "CartV2CartEntriesRequestV1", CartV2CartEntriesRequestV1);
      const localVarPath = `/cart/v2/{tenant}/entries`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (purgeMessages !== undefined) {
        localVarQueryParameter["purgeMessages"] = purgeMessages;
      }
      if (nowZipCode !== undefined) {
        localVarQueryParameter["nowZipCode"] = nowZipCode;
      }
      if (isNowSelected !== undefined) {
        localVarQueryParameter["isNowSelected"] = isNowSelected;
      }
      if (slotId !== undefined) {
        localVarQueryParameter["slotId"] = slotId;
      }
      if (Accept_Language != null) {
        localVarHeaderParameter["Accept-Language"] = String(Accept_Language);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        CartV2CartEntriesRequestV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} tenant
     * @param {string} offerId
     * @param {string} Accept_Language
     * @param {string} prescriptionType
     * @param {string} [nowZipCode]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    cartV2TenantEntryOfferIdDelete: async (
      tenant,
      offerId,
      Accept_Language,
      prescriptionType,
      nowZipCode,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("cartV2TenantEntryOfferIdDelete", "tenant", tenant);
      // verify required parameter 'offerId' is not null or undefined
      assertParamExists("cartV2TenantEntryOfferIdDelete", "offerId", offerId);
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists("cartV2TenantEntryOfferIdDelete", "Accept_Language", Accept_Language);
      // verify required parameter 'prescriptionType' is not null or undefined
      assertParamExists("cartV2TenantEntryOfferIdDelete", "prescriptionType", prescriptionType);
      const localVarPath = `/cart/v2/{tenant}/entry/{offerId}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"offerId"}}`, encodeURIComponent(String(offerId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "DELETE", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (prescriptionType !== undefined) {
        localVarQueryParameter["prescriptionType"] = prescriptionType;
      }
      if (nowZipCode !== undefined) {
        localVarQueryParameter["nowZipCode"] = nowZipCode;
      }
      if (Accept_Language != null) {
        localVarHeaderParameter["Accept-Language"] = String(Accept_Language);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * create or update cartEntry
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {CartV2CartEntryRequestV1} CartV2CartEntryRequestV1
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    cartV2TenantEntryPost: async (
      tenant,
      Accept_Language,
      CartV2CartEntryRequestV1,
      purgeMessages,
      nowZipCode,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("cartV2TenantEntryPost", "tenant", tenant);
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists("cartV2TenantEntryPost", "Accept_Language", Accept_Language);
      // verify required parameter 'CartV2CartEntryRequestV1' is not null or undefined
      assertParamExists("cartV2TenantEntryPost", "CartV2CartEntryRequestV1", CartV2CartEntryRequestV1);
      const localVarPath = `/cart/v2/{tenant}/entry`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (purgeMessages !== undefined) {
        localVarQueryParameter["purgeMessages"] = purgeMessages;
      }
      if (nowZipCode !== undefined) {
        localVarQueryParameter["nowZipCode"] = nowZipCode;
      }
      if (Accept_Language != null) {
        localVarHeaderParameter["Accept-Language"] = String(Accept_Language);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        CartV2CartEntryRequestV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * replace cartEntry
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {CartV2CartReplaceEntryRequestV1} CartV2CartReplaceEntryRequestV1
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    cartV2TenantEntryReplacePost: async (
      tenant,
      Accept_Language,
      CartV2CartReplaceEntryRequestV1,
      purgeMessages,
      nowZipCode,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("cartV2TenantEntryReplacePost", "tenant", tenant);
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists("cartV2TenantEntryReplacePost", "Accept_Language", Accept_Language);
      // verify required parameter 'CartV2CartReplaceEntryRequestV1' is not null or undefined
      assertParamExists(
        "cartV2TenantEntryReplacePost",
        "CartV2CartReplaceEntryRequestV1",
        CartV2CartReplaceEntryRequestV1
      );
      const localVarPath = `/cart/v2/{tenant}/entry/replace`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (purgeMessages !== undefined) {
        localVarQueryParameter["purgeMessages"] = purgeMessages;
      }
      if (nowZipCode !== undefined) {
        localVarQueryParameter["nowZipCode"] = nowZipCode;
      }
      if (Accept_Language != null) {
        localVarHeaderParameter["Accept-Language"] = String(Accept_Language);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        CartV2CartReplaceEntryRequestV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Get new or existing cart for customer (including guests)
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    cartV2TenantGet: async (tenant, Accept_Language, purgeMessages, nowZipCode, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("cartV2TenantGet", "tenant", tenant);
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists("cartV2TenantGet", "Accept_Language", Accept_Language);
      const localVarPath = `/cart/v2/{tenant}`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (purgeMessages !== undefined) {
        localVarQueryParameter["purgeMessages"] = purgeMessages;
      }
      if (nowZipCode !== undefined) {
        localVarQueryParameter["nowZipCode"] = nowZipCode;
      }
      if (Accept_Language != null) {
        localVarHeaderParameter["Accept-Language"] = String(Accept_Language);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Provides information about the cart data
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartV2TenantMetadataGet: async (tenant, Accept_Language, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("cartV2TenantMetadataGet", "tenant", tenant);
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists("cartV2TenantMetadataGet", "Accept_Language", Accept_Language);
      const localVarPath = `/cart/v2/{tenant}/metadata`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (Accept_Language != null) {
        localVarHeaderParameter["Accept-Language"] = String(Accept_Language);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Get new or existing cart for customer (including guests) - miniature format
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {boolean} [disableRefresh]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    cartV2TenantMinicartGet: async (tenant, Accept_Language, disableRefresh, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("cartV2TenantMinicartGet", "tenant", tenant);
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists("cartV2TenantMinicartGet", "Accept_Language", Accept_Language);
      const localVarPath = `/cart/v2/{tenant}/minicart`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (disableRefresh !== undefined) {
        localVarQueryParameter["disableRefresh"] = disableRefresh;
      }
      if (Accept_Language != null) {
        localVarHeaderParameter["Accept-Language"] = String(Accept_Language);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Updates the collectiveOrder or prescriptionFollows status for the customer (including guests)
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {CartV2TenantPutRequest} CartV2TenantPutRequest
     * @param {string} [nowZipCode]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    cartV2TenantPut: async (tenant, Accept_Language, CartV2TenantPutRequest, nowZipCode, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("cartV2TenantPut", "tenant", tenant);
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists("cartV2TenantPut", "Accept_Language", Accept_Language);
      // verify required parameter 'CartV2TenantPutRequest' is not null or undefined
      assertParamExists("cartV2TenantPut", "CartV2TenantPutRequest", CartV2TenantPutRequest);
      const localVarPath = `/cart/v2/{tenant}`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "PUT", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (nowZipCode !== undefined) {
        localVarQueryParameter["nowZipCode"] = nowZipCode;
      }
      if (Accept_Language != null) {
        localVarHeaderParameter["Accept-Language"] = String(Accept_Language);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        CartV2TenantPutRequest,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    cartV2TenantRedpointsDelete: async (tenant, Accept_Language, purgeMessages, nowZipCode, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("cartV2TenantRedpointsDelete", "tenant", tenant);
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists("cartV2TenantRedpointsDelete", "Accept_Language", Accept_Language);
      const localVarPath = `/cart/v2/{tenant}/redpoints`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "DELETE", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (purgeMessages !== undefined) {
        localVarQueryParameter["purgeMessages"] = purgeMessages;
      }
      if (nowZipCode !== undefined) {
        localVarQueryParameter["nowZipCode"] = nowZipCode;
      }
      if (Accept_Language != null) {
        localVarHeaderParameter["Accept-Language"] = String(Accept_Language);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {CartV2RedPointsRequestV1} CartV2RedPointsRequestV1
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    cartV2TenantRedpointsPost: async (
      tenant,
      Accept_Language,
      CartV2RedPointsRequestV1,
      purgeMessages,
      nowZipCode,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("cartV2TenantRedpointsPost", "tenant", tenant);
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists("cartV2TenantRedpointsPost", "Accept_Language", Accept_Language);
      // verify required parameter 'CartV2RedPointsRequestV1' is not null or undefined
      assertParamExists("cartV2TenantRedpointsPost", "CartV2RedPointsRequestV1", CartV2RedPointsRequestV1);
      const localVarPath = `/cart/v2/{tenant}/redpoints`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (purgeMessages !== undefined) {
        localVarQueryParameter["purgeMessages"] = purgeMessages;
      }
      if (nowZipCode !== undefined) {
        localVarQueryParameter["nowZipCode"] = nowZipCode;
      }
      if (Accept_Language != null) {
        localVarHeaderParameter["Accept-Language"] = String(Accept_Language);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        CartV2RedPointsRequestV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {CartV2VoucherRequestV1} CartV2VoucherRequestV1
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    cartV2TenantVoucherPost: async (
      tenant,
      Accept_Language,
      CartV2VoucherRequestV1,
      purgeMessages,
      nowZipCode,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("cartV2TenantVoucherPost", "tenant", tenant);
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists("cartV2TenantVoucherPost", "Accept_Language", Accept_Language);
      // verify required parameter 'CartV2VoucherRequestV1' is not null or undefined
      assertParamExists("cartV2TenantVoucherPost", "CartV2VoucherRequestV1", CartV2VoucherRequestV1);
      const localVarPath = `/cart/v2/{tenant}/voucher`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (purgeMessages !== undefined) {
        localVarQueryParameter["purgeMessages"] = purgeMessages;
      }
      if (nowZipCode !== undefined) {
        localVarQueryParameter["nowZipCode"] = nowZipCode;
      }
      if (Accept_Language != null) {
        localVarHeaderParameter["Accept-Language"] = String(Accept_Language);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        CartV2VoucherRequestV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} tenant
     * @param {string} voucherCode
     * @param {string} Accept_Language
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    cartV2TenantVoucherVoucherCodeDelete: async (tenant, voucherCode, Accept_Language, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("cartV2TenantVoucherVoucherCodeDelete", "tenant", tenant);
      // verify required parameter 'voucherCode' is not null or undefined
      assertParamExists("cartV2TenantVoucherVoucherCodeDelete", "voucherCode", voucherCode);
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists("cartV2TenantVoucherVoucherCodeDelete", "Accept_Language", Accept_Language);
      const localVarPath = `/cart/v2/{tenant}/voucher/{voucherCode}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"voucherCode"}}`, encodeURIComponent(String(voucherCode)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "DELETE", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (Accept_Language != null) {
        localVarHeaderParameter["Accept-Language"] = String(Accept_Language);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * CartControllerV2Api - functional programming interface
 * @export
 */
export const CartControllerV2ApiFp = function (configuration) {
  const localVarAxiosParamCreator = CartControllerV2ApiAxiosParamCreator(configuration);
  return {
    /**
     * Endpoint to delete the existing cart, if it exists
     * @param {string} tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cartV2TenantDelete(tenant, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartV2TenantDelete(tenant, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} tenant
     * @param {string} hashedToken
     * @param {string} Accept_Language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cartV2TenantEntriesERxHashedTokenDelete(tenant, hashedToken, Accept_Language, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartV2TenantEntriesERxHashedTokenDelete(
        tenant,
        hashedToken,
        Accept_Language,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * create or update eRx entries providing eRx hashedTokens
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {Array<string>} request_body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cartV2TenantEntriesERxPost(tenant, Accept_Language, request_body, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartV2TenantEntriesERxPost(
        tenant,
        Accept_Language,
        request_body,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * create multiple cartEntries
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {CartV2CartEntriesRequestV1} CartV2CartEntriesRequestV1
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {boolean} [isNowSelected]
     * @param {string} [slotId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cartV2TenantEntriesPost(
      tenant,
      Accept_Language,
      CartV2CartEntriesRequestV1,
      purgeMessages,
      nowZipCode,
      isNowSelected,
      slotId,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartV2TenantEntriesPost(
        tenant,
        Accept_Language,
        CartV2CartEntriesRequestV1,
        purgeMessages,
        nowZipCode,
        isNowSelected,
        slotId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} tenant
     * @param {string} offerId
     * @param {string} Accept_Language
     * @param {string} prescriptionType
     * @param {string} [nowZipCode]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async cartV2TenantEntryOfferIdDelete(tenant, offerId, Accept_Language, prescriptionType, nowZipCode, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartV2TenantEntryOfferIdDelete(
        tenant,
        offerId,
        Accept_Language,
        prescriptionType,
        nowZipCode,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * create or update cartEntry
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {CartV2CartEntryRequestV1} CartV2CartEntryRequestV1
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async cartV2TenantEntryPost(tenant, Accept_Language, CartV2CartEntryRequestV1, purgeMessages, nowZipCode, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartV2TenantEntryPost(
        tenant,
        Accept_Language,
        CartV2CartEntryRequestV1,
        purgeMessages,
        nowZipCode,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * replace cartEntry
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {CartV2CartReplaceEntryRequestV1} CartV2CartReplaceEntryRequestV1
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async cartV2TenantEntryReplacePost(
      tenant,
      Accept_Language,
      CartV2CartReplaceEntryRequestV1,
      purgeMessages,
      nowZipCode,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartV2TenantEntryReplacePost(
        tenant,
        Accept_Language,
        CartV2CartReplaceEntryRequestV1,
        purgeMessages,
        nowZipCode,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Get new or existing cart for customer (including guests)
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async cartV2TenantGet(tenant, Accept_Language, purgeMessages, nowZipCode, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartV2TenantGet(
        tenant,
        Accept_Language,
        purgeMessages,
        nowZipCode,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Provides information about the cart data
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cartV2TenantMetadataGet(tenant, Accept_Language, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartV2TenantMetadataGet(
        tenant,
        Accept_Language,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Get new or existing cart for customer (including guests) - miniature format
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {boolean} [disableRefresh]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async cartV2TenantMinicartGet(tenant, Accept_Language, disableRefresh, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartV2TenantMinicartGet(
        tenant,
        Accept_Language,
        disableRefresh,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Updates the collectiveOrder or prescriptionFollows status for the customer (including guests)
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {CartV2TenantPutRequest} CartV2TenantPutRequest
     * @param {string} [nowZipCode]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async cartV2TenantPut(tenant, Accept_Language, CartV2TenantPutRequest, nowZipCode, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartV2TenantPut(
        tenant,
        Accept_Language,
        CartV2TenantPutRequest,
        nowZipCode,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async cartV2TenantRedpointsDelete(tenant, Accept_Language, purgeMessages, nowZipCode, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartV2TenantRedpointsDelete(
        tenant,
        Accept_Language,
        purgeMessages,
        nowZipCode,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {CartV2RedPointsRequestV1} CartV2RedPointsRequestV1
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async cartV2TenantRedpointsPost(
      tenant,
      Accept_Language,
      CartV2RedPointsRequestV1,
      purgeMessages,
      nowZipCode,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartV2TenantRedpointsPost(
        tenant,
        Accept_Language,
        CartV2RedPointsRequestV1,
        purgeMessages,
        nowZipCode,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {CartV2VoucherRequestV1} CartV2VoucherRequestV1
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async cartV2TenantVoucherPost(tenant, Accept_Language, CartV2VoucherRequestV1, purgeMessages, nowZipCode, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartV2TenantVoucherPost(
        tenant,
        Accept_Language,
        CartV2VoucherRequestV1,
        purgeMessages,
        nowZipCode,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} tenant
     * @param {string} voucherCode
     * @param {string} Accept_Language
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async cartV2TenantVoucherVoucherCodeDelete(tenant, voucherCode, Accept_Language, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartV2TenantVoucherVoucherCodeDelete(
        tenant,
        voucherCode,
        Accept_Language,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * CartControllerV2Api - factory interface
 * @export
 */
export const CartControllerV2ApiFactory = function (configuration, basePath, axios) {
  const localVarFp = CartControllerV2ApiFp(configuration);
  return {
    /**
     * Endpoint to delete the existing cart, if it exists
     * @param {string} tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartV2TenantDelete(tenant, options) {
      return localVarFp.cartV2TenantDelete(tenant, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} tenant
     * @param {string} hashedToken
     * @param {string} Accept_Language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartV2TenantEntriesERxHashedTokenDelete(tenant, hashedToken, Accept_Language, options) {
      return localVarFp
        .cartV2TenantEntriesERxHashedTokenDelete(tenant, hashedToken, Accept_Language, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * create or update eRx entries providing eRx hashedTokens
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {Array<string>} request_body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartV2TenantEntriesERxPost(tenant, Accept_Language, request_body, options) {
      return localVarFp
        .cartV2TenantEntriesERxPost(tenant, Accept_Language, request_body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * create multiple cartEntries
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {CartV2CartEntriesRequestV1} CartV2CartEntriesRequestV1
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {boolean} [isNowSelected]
     * @param {string} [slotId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartV2TenantEntriesPost(
      tenant,
      Accept_Language,
      CartV2CartEntriesRequestV1,
      purgeMessages,
      nowZipCode,
      isNowSelected,
      slotId,
      options
    ) {
      return localVarFp
        .cartV2TenantEntriesPost(
          tenant,
          Accept_Language,
          CartV2CartEntriesRequestV1,
          purgeMessages,
          nowZipCode,
          isNowSelected,
          slotId,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} tenant
     * @param {string} offerId
     * @param {string} Accept_Language
     * @param {string} prescriptionType
     * @param {string} [nowZipCode]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    cartV2TenantEntryOfferIdDelete(tenant, offerId, Accept_Language, prescriptionType, nowZipCode, options) {
      return localVarFp
        .cartV2TenantEntryOfferIdDelete(tenant, offerId, Accept_Language, prescriptionType, nowZipCode, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * create or update cartEntry
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {CartV2CartEntryRequestV1} CartV2CartEntryRequestV1
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    cartV2TenantEntryPost(tenant, Accept_Language, CartV2CartEntryRequestV1, purgeMessages, nowZipCode, options) {
      return localVarFp
        .cartV2TenantEntryPost(tenant, Accept_Language, CartV2CartEntryRequestV1, purgeMessages, nowZipCode, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * replace cartEntry
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {CartV2CartReplaceEntryRequestV1} CartV2CartReplaceEntryRequestV1
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    cartV2TenantEntryReplacePost(
      tenant,
      Accept_Language,
      CartV2CartReplaceEntryRequestV1,
      purgeMessages,
      nowZipCode,
      options
    ) {
      return localVarFp
        .cartV2TenantEntryReplacePost(
          tenant,
          Accept_Language,
          CartV2CartReplaceEntryRequestV1,
          purgeMessages,
          nowZipCode,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Get new or existing cart for customer (including guests)
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    cartV2TenantGet(tenant, Accept_Language, purgeMessages, nowZipCode, options) {
      return localVarFp
        .cartV2TenantGet(tenant, Accept_Language, purgeMessages, nowZipCode, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Provides information about the cart data
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartV2TenantMetadataGet(tenant, Accept_Language, options) {
      return localVarFp
        .cartV2TenantMetadataGet(tenant, Accept_Language, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get new or existing cart for customer (including guests) - miniature format
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {boolean} [disableRefresh]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    cartV2TenantMinicartGet(tenant, Accept_Language, disableRefresh, options) {
      return localVarFp
        .cartV2TenantMinicartGet(tenant, Accept_Language, disableRefresh, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Updates the collectiveOrder or prescriptionFollows status for the customer (including guests)
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {CartV2TenantPutRequest} CartV2TenantPutRequest
     * @param {string} [nowZipCode]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    cartV2TenantPut(tenant, Accept_Language, CartV2TenantPutRequest, nowZipCode, options) {
      return localVarFp
        .cartV2TenantPut(tenant, Accept_Language, CartV2TenantPutRequest, nowZipCode, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    cartV2TenantRedpointsDelete(tenant, Accept_Language, purgeMessages, nowZipCode, options) {
      return localVarFp
        .cartV2TenantRedpointsDelete(tenant, Accept_Language, purgeMessages, nowZipCode, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {CartV2RedPointsRequestV1} CartV2RedPointsRequestV1
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    cartV2TenantRedpointsPost(tenant, Accept_Language, CartV2RedPointsRequestV1, purgeMessages, nowZipCode, options) {
      return localVarFp
        .cartV2TenantRedpointsPost(
          tenant,
          Accept_Language,
          CartV2RedPointsRequestV1,
          purgeMessages,
          nowZipCode,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {CartV2VoucherRequestV1} CartV2VoucherRequestV1
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    cartV2TenantVoucherPost(tenant, Accept_Language, CartV2VoucherRequestV1, purgeMessages, nowZipCode, options) {
      return localVarFp
        .cartV2TenantVoucherPost(tenant, Accept_Language, CartV2VoucherRequestV1, purgeMessages, nowZipCode, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} tenant
     * @param {string} voucherCode
     * @param {string} Accept_Language
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    cartV2TenantVoucherVoucherCodeDelete(tenant, voucherCode, Accept_Language, options) {
      return localVarFp
        .cartV2TenantVoucherVoucherCodeDelete(tenant, voucherCode, Accept_Language, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * CartControllerV2Api - object-oriented interface
 * @export
 * @class CartControllerV2Api
 * @extends {BaseAPI}
 */
export class CartControllerV2Api extends BaseAPI {
  /**
   * Endpoint to delete the existing cart, if it exists
   * @param {string} tenant
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CartControllerV2Api
   */
  cartV2TenantDelete(tenant, options) {
    return CartControllerV2ApiFp(this.configuration)
      .cartV2TenantDelete(tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} tenant
   * @param {string} hashedToken
   * @param {string} Accept_Language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CartControllerV2Api
   */
  cartV2TenantEntriesERxHashedTokenDelete(tenant, hashedToken, Accept_Language, options) {
    return CartControllerV2ApiFp(this.configuration)
      .cartV2TenantEntriesERxHashedTokenDelete(tenant, hashedToken, Accept_Language, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * create or update eRx entries providing eRx hashedTokens
   * @param {string} tenant
   * @param {string} Accept_Language
   * @param {Array<string>} request_body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CartControllerV2Api
   */
  cartV2TenantEntriesERxPost(tenant, Accept_Language, request_body, options) {
    return CartControllerV2ApiFp(this.configuration)
      .cartV2TenantEntriesERxPost(tenant, Accept_Language, request_body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * create multiple cartEntries
   * @param {string} tenant
   * @param {string} Accept_Language
   * @param {CartV2CartEntriesRequestV1} CartV2CartEntriesRequestV1
   * @param {boolean} [purgeMessages]
   * @param {string} [nowZipCode]
   * @param {boolean} [isNowSelected]
   * @param {string} [slotId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CartControllerV2Api
   */
  cartV2TenantEntriesPost(
    tenant,
    Accept_Language,
    CartV2CartEntriesRequestV1,
    purgeMessages,
    nowZipCode,
    isNowSelected,
    slotId,
    options
  ) {
    return CartControllerV2ApiFp(this.configuration)
      .cartV2TenantEntriesPost(
        tenant,
        Accept_Language,
        CartV2CartEntriesRequestV1,
        purgeMessages,
        nowZipCode,
        isNowSelected,
        slotId,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} tenant
   * @param {string} offerId
   * @param {string} Accept_Language
   * @param {string} prescriptionType
   * @param {string} [nowZipCode]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof CartControllerV2Api
   */
  cartV2TenantEntryOfferIdDelete(tenant, offerId, Accept_Language, prescriptionType, nowZipCode, options) {
    return CartControllerV2ApiFp(this.configuration)
      .cartV2TenantEntryOfferIdDelete(tenant, offerId, Accept_Language, prescriptionType, nowZipCode, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * create or update cartEntry
   * @param {string} tenant
   * @param {string} Accept_Language
   * @param {CartV2CartEntryRequestV1} CartV2CartEntryRequestV1
   * @param {boolean} [purgeMessages]
   * @param {string} [nowZipCode]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof CartControllerV2Api
   */
  cartV2TenantEntryPost(tenant, Accept_Language, CartV2CartEntryRequestV1, purgeMessages, nowZipCode, options) {
    return CartControllerV2ApiFp(this.configuration)
      .cartV2TenantEntryPost(tenant, Accept_Language, CartV2CartEntryRequestV1, purgeMessages, nowZipCode, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * replace cartEntry
   * @param {string} tenant
   * @param {string} Accept_Language
   * @param {CartV2CartReplaceEntryRequestV1} CartV2CartReplaceEntryRequestV1
   * @param {boolean} [purgeMessages]
   * @param {string} [nowZipCode]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof CartControllerV2Api
   */
  cartV2TenantEntryReplacePost(
    tenant,
    Accept_Language,
    CartV2CartReplaceEntryRequestV1,
    purgeMessages,
    nowZipCode,
    options
  ) {
    return CartControllerV2ApiFp(this.configuration)
      .cartV2TenantEntryReplacePost(
        tenant,
        Accept_Language,
        CartV2CartReplaceEntryRequestV1,
        purgeMessages,
        nowZipCode,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get new or existing cart for customer (including guests)
   * @param {string} tenant
   * @param {string} Accept_Language
   * @param {boolean} [purgeMessages]
   * @param {string} [nowZipCode]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof CartControllerV2Api
   */
  cartV2TenantGet(tenant, Accept_Language, purgeMessages, nowZipCode, options) {
    return CartControllerV2ApiFp(this.configuration)
      .cartV2TenantGet(tenant, Accept_Language, purgeMessages, nowZipCode, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Provides information about the cart data
   * @param {string} tenant
   * @param {string} Accept_Language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CartControllerV2Api
   */
  cartV2TenantMetadataGet(tenant, Accept_Language, options) {
    return CartControllerV2ApiFp(this.configuration)
      .cartV2TenantMetadataGet(tenant, Accept_Language, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get new or existing cart for customer (including guests) - miniature format
   * @param {string} tenant
   * @param {string} Accept_Language
   * @param {boolean} [disableRefresh]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof CartControllerV2Api
   */
  cartV2TenantMinicartGet(tenant, Accept_Language, disableRefresh, options) {
    return CartControllerV2ApiFp(this.configuration)
      .cartV2TenantMinicartGet(tenant, Accept_Language, disableRefresh, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Updates the collectiveOrder or prescriptionFollows status for the customer (including guests)
   * @param {string} tenant
   * @param {string} Accept_Language
   * @param {CartV2TenantPutRequest} CartV2TenantPutRequest
   * @param {string} [nowZipCode]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof CartControllerV2Api
   */
  cartV2TenantPut(tenant, Accept_Language, CartV2TenantPutRequest, nowZipCode, options) {
    return CartControllerV2ApiFp(this.configuration)
      .cartV2TenantPut(tenant, Accept_Language, CartV2TenantPutRequest, nowZipCode, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} tenant
   * @param {string} Accept_Language
   * @param {boolean} [purgeMessages]
   * @param {string} [nowZipCode]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof CartControllerV2Api
   */
  cartV2TenantRedpointsDelete(tenant, Accept_Language, purgeMessages, nowZipCode, options) {
    return CartControllerV2ApiFp(this.configuration)
      .cartV2TenantRedpointsDelete(tenant, Accept_Language, purgeMessages, nowZipCode, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} tenant
   * @param {string} Accept_Language
   * @param {CartV2RedPointsRequestV1} CartV2RedPointsRequestV1
   * @param {boolean} [purgeMessages]
   * @param {string} [nowZipCode]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof CartControllerV2Api
   */
  cartV2TenantRedpointsPost(tenant, Accept_Language, CartV2RedPointsRequestV1, purgeMessages, nowZipCode, options) {
    return CartControllerV2ApiFp(this.configuration)
      .cartV2TenantRedpointsPost(tenant, Accept_Language, CartV2RedPointsRequestV1, purgeMessages, nowZipCode, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} tenant
   * @param {string} Accept_Language
   * @param {CartV2VoucherRequestV1} CartV2VoucherRequestV1
   * @param {boolean} [purgeMessages]
   * @param {string} [nowZipCode]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof CartControllerV2Api
   */
  cartV2TenantVoucherPost(tenant, Accept_Language, CartV2VoucherRequestV1, purgeMessages, nowZipCode, options) {
    return CartControllerV2ApiFp(this.configuration)
      .cartV2TenantVoucherPost(tenant, Accept_Language, CartV2VoucherRequestV1, purgeMessages, nowZipCode, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} tenant
   * @param {string} voucherCode
   * @param {string} Accept_Language
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof CartControllerV2Api
   */
  cartV2TenantVoucherVoucherCodeDelete(tenant, voucherCode, Accept_Language, options) {
    return CartControllerV2ApiFp(this.configuration)
      .cartV2TenantVoucherVoucherCodeDelete(tenant, voucherCode, Accept_Language, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * CartControllerV3Api - axios parameter creator
 * @export
 */
export const CartControllerV3ApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Get new or existing cart for customer (including guests)
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} Accept_Language
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {boolean} [isNowSelected]
     * @param {string} [slotId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartServiceCartGetCartLocalized: async (
      language,
      tenant,
      Accept_Language,
      purgeMessages,
      nowZipCode,
      isNowSelected,
      slotId,
      options = {}
    ) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("cartServiceCartGetCartLocalized", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("cartServiceCartGetCartLocalized", "tenant", tenant);
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists("cartServiceCartGetCartLocalized", "Accept_Language", Accept_Language);
      const localVarPath = `/{language}/cart/v3/{tenant}`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (purgeMessages !== undefined) {
        localVarQueryParameter["purgeMessages"] = purgeMessages;
      }
      if (nowZipCode !== undefined) {
        localVarQueryParameter["nowZipCode"] = nowZipCode;
      }
      if (isNowSelected !== undefined) {
        localVarQueryParameter["isNowSelected"] = isNowSelected;
      }
      if (slotId !== undefined) {
        localVarQueryParameter["slotId"] = slotId;
      }
      if (Accept_Language != null) {
        localVarHeaderParameter["Accept-Language"] = String(Accept_Language);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * create or update cartEntry
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} Accept_Language
     * @param {CartV2CartEntryRequestV1} CartV2CartEntryRequestV1
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {boolean} [isNowSelected]
     * @param {string} [slotId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartServiceCartPostCartEntryLocalized: async (
      language,
      tenant,
      Accept_Language,
      CartV2CartEntryRequestV1,
      purgeMessages,
      nowZipCode,
      isNowSelected,
      slotId,
      options = {}
    ) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("cartServiceCartPostCartEntryLocalized", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("cartServiceCartPostCartEntryLocalized", "tenant", tenant);
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists("cartServiceCartPostCartEntryLocalized", "Accept_Language", Accept_Language);
      // verify required parameter 'CartV2CartEntryRequestV1' is not null or undefined
      assertParamExists("cartServiceCartPostCartEntryLocalized", "CartV2CartEntryRequestV1", CartV2CartEntryRequestV1);
      const localVarPath = `/{language}/cart/v3/{tenant}/entry`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (purgeMessages !== undefined) {
        localVarQueryParameter["purgeMessages"] = purgeMessages;
      }
      if (nowZipCode !== undefined) {
        localVarQueryParameter["nowZipCode"] = nowZipCode;
      }
      if (isNowSelected !== undefined) {
        localVarQueryParameter["isNowSelected"] = isNowSelected;
      }
      if (slotId !== undefined) {
        localVarQueryParameter["slotId"] = slotId;
      }
      if (Accept_Language != null) {
        localVarHeaderParameter["Accept-Language"] = String(Accept_Language);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        CartV2CartEntryRequestV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * create multiple cartEntries
     * @param {string} language
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {CartV2CartEntriesRequestV1} CartV2CartEntriesRequestV1
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {boolean} [isNowSelected]
     * @param {string} [slotId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageCartV3TenantEntriesPost: async (
      language,
      tenant,
      Accept_Language,
      CartV2CartEntriesRequestV1,
      purgeMessages,
      nowZipCode,
      isNowSelected,
      slotId,
      options = {}
    ) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageCartV3TenantEntriesPost", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageCartV3TenantEntriesPost", "tenant", tenant);
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists("languageCartV3TenantEntriesPost", "Accept_Language", Accept_Language);
      // verify required parameter 'CartV2CartEntriesRequestV1' is not null or undefined
      assertParamExists("languageCartV3TenantEntriesPost", "CartV2CartEntriesRequestV1", CartV2CartEntriesRequestV1);
      const localVarPath = `/{language}/cart/v3/{tenant}/entries`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (purgeMessages !== undefined) {
        localVarQueryParameter["purgeMessages"] = purgeMessages;
      }
      if (nowZipCode !== undefined) {
        localVarQueryParameter["nowZipCode"] = nowZipCode;
      }
      if (isNowSelected !== undefined) {
        localVarQueryParameter["isNowSelected"] = isNowSelected;
      }
      if (slotId !== undefined) {
        localVarQueryParameter["slotId"] = slotId;
      }
      if (Accept_Language != null) {
        localVarHeaderParameter["Accept-Language"] = String(Accept_Language);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        CartV2CartEntriesRequestV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} offerId
     * @param {string} Accept_Language
     * @param {string} prescriptionType
     * @param {string} [nowZipCode]
     * @param {boolean} [isNowSelected]
     * @param {string} [slotId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageCartV3TenantEntryOfferIdDelete: async (
      language,
      tenant,
      offerId,
      Accept_Language,
      prescriptionType,
      nowZipCode,
      isNowSelected,
      slotId,
      options = {}
    ) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageCartV3TenantEntryOfferIdDelete", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageCartV3TenantEntryOfferIdDelete", "tenant", tenant);
      // verify required parameter 'offerId' is not null or undefined
      assertParamExists("languageCartV3TenantEntryOfferIdDelete", "offerId", offerId);
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists("languageCartV3TenantEntryOfferIdDelete", "Accept_Language", Accept_Language);
      // verify required parameter 'prescriptionType' is not null or undefined
      assertParamExists("languageCartV3TenantEntryOfferIdDelete", "prescriptionType", prescriptionType);
      const localVarPath = `/{language}/cart/v3/{tenant}/entry/{offerId}`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"offerId"}}`, encodeURIComponent(String(offerId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "DELETE", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (prescriptionType !== undefined) {
        localVarQueryParameter["prescriptionType"] = prescriptionType;
      }
      if (nowZipCode !== undefined) {
        localVarQueryParameter["nowZipCode"] = nowZipCode;
      }
      if (isNowSelected !== undefined) {
        localVarQueryParameter["isNowSelected"] = isNowSelected;
      }
      if (slotId !== undefined) {
        localVarQueryParameter["slotId"] = slotId;
      }
      if (Accept_Language != null) {
        localVarHeaderParameter["Accept-Language"] = String(Accept_Language);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Get new or existing cart for customer (including guests) - miniature format
     * @param {string} language
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {boolean} [disableRefresh]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageCartV3TenantMinicartGet: async (language, tenant, Accept_Language, disableRefresh, options = {}) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageCartV3TenantMinicartGet", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageCartV3TenantMinicartGet", "tenant", tenant);
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists("languageCartV3TenantMinicartGet", "Accept_Language", Accept_Language);
      const localVarPath = `/{language}/cart/v3/{tenant}/minicart`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (disableRefresh !== undefined) {
        localVarQueryParameter["disableRefresh"] = disableRefresh;
      }
      if (Accept_Language != null) {
        localVarHeaderParameter["Accept-Language"] = String(Accept_Language);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Updates the collectiveOrder or prescriptionFollows status for the customer (including guests)
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} Accept_Language
     * @param {CartV2TenantPutRequest} CartV2TenantPutRequest
     * @param {string} [nowZipCode]
     * @param {boolean} [isNowSelected]
     * @param {string} [slotId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageCartV3TenantPut: async (
      language,
      tenant,
      Accept_Language,
      CartV2TenantPutRequest,
      nowZipCode,
      isNowSelected,
      slotId,
      options = {}
    ) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageCartV3TenantPut", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageCartV3TenantPut", "tenant", tenant);
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists("languageCartV3TenantPut", "Accept_Language", Accept_Language);
      // verify required parameter 'CartV2TenantPutRequest' is not null or undefined
      assertParamExists("languageCartV3TenantPut", "CartV2TenantPutRequest", CartV2TenantPutRequest);
      const localVarPath = `/{language}/cart/v3/{tenant}`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "PUT", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (nowZipCode !== undefined) {
        localVarQueryParameter["nowZipCode"] = nowZipCode;
      }
      if (isNowSelected !== undefined) {
        localVarQueryParameter["isNowSelected"] = isNowSelected;
      }
      if (slotId !== undefined) {
        localVarQueryParameter["slotId"] = slotId;
      }
      if (Accept_Language != null) {
        localVarHeaderParameter["Accept-Language"] = String(Accept_Language);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        CartV2TenantPutRequest,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} Accept_Language
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {boolean} [isNowSelected]
     * @param {string} [slotId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageCartV3TenantRedpointsDelete: async (
      language,
      tenant,
      Accept_Language,
      purgeMessages,
      nowZipCode,
      isNowSelected,
      slotId,
      options = {}
    ) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageCartV3TenantRedpointsDelete", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageCartV3TenantRedpointsDelete", "tenant", tenant);
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists("languageCartV3TenantRedpointsDelete", "Accept_Language", Accept_Language);
      const localVarPath = `/{language}/cart/v3/{tenant}/redpoints`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "DELETE", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (purgeMessages !== undefined) {
        localVarQueryParameter["purgeMessages"] = purgeMessages;
      }
      if (nowZipCode !== undefined) {
        localVarQueryParameter["nowZipCode"] = nowZipCode;
      }
      if (isNowSelected !== undefined) {
        localVarQueryParameter["isNowSelected"] = isNowSelected;
      }
      if (slotId !== undefined) {
        localVarQueryParameter["slotId"] = slotId;
      }
      if (Accept_Language != null) {
        localVarHeaderParameter["Accept-Language"] = String(Accept_Language);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} Accept_Language
     * @param {CartV2RedPointsRequestV1} CartV2RedPointsRequestV1
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {boolean} [isNowSelected]
     * @param {string} [slotId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageCartV3TenantRedpointsPost: async (
      language,
      tenant,
      Accept_Language,
      CartV2RedPointsRequestV1,
      purgeMessages,
      nowZipCode,
      isNowSelected,
      slotId,
      options = {}
    ) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageCartV3TenantRedpointsPost", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageCartV3TenantRedpointsPost", "tenant", tenant);
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists("languageCartV3TenantRedpointsPost", "Accept_Language", Accept_Language);
      // verify required parameter 'CartV2RedPointsRequestV1' is not null or undefined
      assertParamExists("languageCartV3TenantRedpointsPost", "CartV2RedPointsRequestV1", CartV2RedPointsRequestV1);
      const localVarPath = `/{language}/cart/v3/{tenant}/redpoints`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (purgeMessages !== undefined) {
        localVarQueryParameter["purgeMessages"] = purgeMessages;
      }
      if (nowZipCode !== undefined) {
        localVarQueryParameter["nowZipCode"] = nowZipCode;
      }
      if (isNowSelected !== undefined) {
        localVarQueryParameter["isNowSelected"] = isNowSelected;
      }
      if (slotId !== undefined) {
        localVarQueryParameter["slotId"] = slotId;
      }
      if (Accept_Language != null) {
        localVarHeaderParameter["Accept-Language"] = String(Accept_Language);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        CartV2RedPointsRequestV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} Accept_Language
     * @param {CartV2VoucherRequestV1} CartV2VoucherRequestV1
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {boolean} [isNowSelected]
     * @param {string} [slotId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageCartV3TenantVoucherPost: async (
      language,
      tenant,
      Accept_Language,
      CartV2VoucherRequestV1,
      purgeMessages,
      nowZipCode,
      isNowSelected,
      slotId,
      options = {}
    ) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageCartV3TenantVoucherPost", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageCartV3TenantVoucherPost", "tenant", tenant);
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists("languageCartV3TenantVoucherPost", "Accept_Language", Accept_Language);
      // verify required parameter 'CartV2VoucherRequestV1' is not null or undefined
      assertParamExists("languageCartV3TenantVoucherPost", "CartV2VoucherRequestV1", CartV2VoucherRequestV1);
      const localVarPath = `/{language}/cart/v3/{tenant}/voucher`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (purgeMessages !== undefined) {
        localVarQueryParameter["purgeMessages"] = purgeMessages;
      }
      if (nowZipCode !== undefined) {
        localVarQueryParameter["nowZipCode"] = nowZipCode;
      }
      if (isNowSelected !== undefined) {
        localVarQueryParameter["isNowSelected"] = isNowSelected;
      }
      if (slotId !== undefined) {
        localVarQueryParameter["slotId"] = slotId;
      }
      if (Accept_Language != null) {
        localVarHeaderParameter["Accept-Language"] = String(Accept_Language);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        CartV2VoucherRequestV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} voucherCode
     * @param {string} Accept_Language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageCartV3TenantVoucherVoucherCodeDelete: async (
      language,
      tenant,
      voucherCode,
      Accept_Language,
      options = {}
    ) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageCartV3TenantVoucherVoucherCodeDelete", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageCartV3TenantVoucherVoucherCodeDelete", "tenant", tenant);
      // verify required parameter 'voucherCode' is not null or undefined
      assertParamExists("languageCartV3TenantVoucherVoucherCodeDelete", "voucherCode", voucherCode);
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists("languageCartV3TenantVoucherVoucherCodeDelete", "Accept_Language", Accept_Language);
      const localVarPath = `/{language}/cart/v3/{tenant}/voucher/{voucherCode}`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"voucherCode"}}`, encodeURIComponent(String(voucherCode)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "DELETE", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (Accept_Language != null) {
        localVarHeaderParameter["Accept-Language"] = String(Accept_Language);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * CartControllerV3Api - functional programming interface
 * @export
 */
export const CartControllerV3ApiFp = function (configuration) {
  const localVarAxiosParamCreator = CartControllerV3ApiAxiosParamCreator(configuration);
  return {
    /**
     * Get new or existing cart for customer (including guests)
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} Accept_Language
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {boolean} [isNowSelected]
     * @param {string} [slotId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cartServiceCartGetCartLocalized(
      language,
      tenant,
      Accept_Language,
      purgeMessages,
      nowZipCode,
      isNowSelected,
      slotId,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartServiceCartGetCartLocalized(
        language,
        tenant,
        Accept_Language,
        purgeMessages,
        nowZipCode,
        isNowSelected,
        slotId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * create or update cartEntry
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} Accept_Language
     * @param {CartV2CartEntryRequestV1} CartV2CartEntryRequestV1
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {boolean} [isNowSelected]
     * @param {string} [slotId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cartServiceCartPostCartEntryLocalized(
      language,
      tenant,
      Accept_Language,
      CartV2CartEntryRequestV1,
      purgeMessages,
      nowZipCode,
      isNowSelected,
      slotId,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartServiceCartPostCartEntryLocalized(
        language,
        tenant,
        Accept_Language,
        CartV2CartEntryRequestV1,
        purgeMessages,
        nowZipCode,
        isNowSelected,
        slotId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * create multiple cartEntries
     * @param {string} language
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {CartV2CartEntriesRequestV1} CartV2CartEntriesRequestV1
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {boolean} [isNowSelected]
     * @param {string} [slotId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageCartV3TenantEntriesPost(
      language,
      tenant,
      Accept_Language,
      CartV2CartEntriesRequestV1,
      purgeMessages,
      nowZipCode,
      isNowSelected,
      slotId,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageCartV3TenantEntriesPost(
        language,
        tenant,
        Accept_Language,
        CartV2CartEntriesRequestV1,
        purgeMessages,
        nowZipCode,
        isNowSelected,
        slotId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} offerId
     * @param {string} Accept_Language
     * @param {string} prescriptionType
     * @param {string} [nowZipCode]
     * @param {boolean} [isNowSelected]
     * @param {string} [slotId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageCartV3TenantEntryOfferIdDelete(
      language,
      tenant,
      offerId,
      Accept_Language,
      prescriptionType,
      nowZipCode,
      isNowSelected,
      slotId,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageCartV3TenantEntryOfferIdDelete(
        language,
        tenant,
        offerId,
        Accept_Language,
        prescriptionType,
        nowZipCode,
        isNowSelected,
        slotId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Get new or existing cart for customer (including guests) - miniature format
     * @param {string} language
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {boolean} [disableRefresh]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageCartV3TenantMinicartGet(language, tenant, Accept_Language, disableRefresh, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageCartV3TenantMinicartGet(
        language,
        tenant,
        Accept_Language,
        disableRefresh,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Updates the collectiveOrder or prescriptionFollows status for the customer (including guests)
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} Accept_Language
     * @param {CartV2TenantPutRequest} CartV2TenantPutRequest
     * @param {string} [nowZipCode]
     * @param {boolean} [isNowSelected]
     * @param {string} [slotId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageCartV3TenantPut(
      language,
      tenant,
      Accept_Language,
      CartV2TenantPutRequest,
      nowZipCode,
      isNowSelected,
      slotId,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageCartV3TenantPut(
        language,
        tenant,
        Accept_Language,
        CartV2TenantPutRequest,
        nowZipCode,
        isNowSelected,
        slotId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} Accept_Language
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {boolean} [isNowSelected]
     * @param {string} [slotId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageCartV3TenantRedpointsDelete(
      language,
      tenant,
      Accept_Language,
      purgeMessages,
      nowZipCode,
      isNowSelected,
      slotId,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageCartV3TenantRedpointsDelete(
        language,
        tenant,
        Accept_Language,
        purgeMessages,
        nowZipCode,
        isNowSelected,
        slotId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} Accept_Language
     * @param {CartV2RedPointsRequestV1} CartV2RedPointsRequestV1
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {boolean} [isNowSelected]
     * @param {string} [slotId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageCartV3TenantRedpointsPost(
      language,
      tenant,
      Accept_Language,
      CartV2RedPointsRequestV1,
      purgeMessages,
      nowZipCode,
      isNowSelected,
      slotId,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageCartV3TenantRedpointsPost(
        language,
        tenant,
        Accept_Language,
        CartV2RedPointsRequestV1,
        purgeMessages,
        nowZipCode,
        isNowSelected,
        slotId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} Accept_Language
     * @param {CartV2VoucherRequestV1} CartV2VoucherRequestV1
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {boolean} [isNowSelected]
     * @param {string} [slotId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageCartV3TenantVoucherPost(
      language,
      tenant,
      Accept_Language,
      CartV2VoucherRequestV1,
      purgeMessages,
      nowZipCode,
      isNowSelected,
      slotId,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageCartV3TenantVoucherPost(
        language,
        tenant,
        Accept_Language,
        CartV2VoucherRequestV1,
        purgeMessages,
        nowZipCode,
        isNowSelected,
        slotId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} voucherCode
     * @param {string} Accept_Language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageCartV3TenantVoucherVoucherCodeDelete(language, tenant, voucherCode, Accept_Language, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageCartV3TenantVoucherVoucherCodeDelete(
        language,
        tenant,
        voucherCode,
        Accept_Language,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * CartControllerV3Api - factory interface
 * @export
 */
export const CartControllerV3ApiFactory = function (configuration, basePath, axios) {
  const localVarFp = CartControllerV3ApiFp(configuration);
  return {
    /**
     * Get new or existing cart for customer (including guests)
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} Accept_Language
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {boolean} [isNowSelected]
     * @param {string} [slotId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartServiceCartGetCartLocalized(
      language,
      tenant,
      Accept_Language,
      purgeMessages,
      nowZipCode,
      isNowSelected,
      slotId,
      options
    ) {
      return localVarFp
        .cartServiceCartGetCartLocalized(
          language,
          tenant,
          Accept_Language,
          purgeMessages,
          nowZipCode,
          isNowSelected,
          slotId,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * create or update cartEntry
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} Accept_Language
     * @param {CartV2CartEntryRequestV1} CartV2CartEntryRequestV1
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {boolean} [isNowSelected]
     * @param {string} [slotId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartServiceCartPostCartEntryLocalized(
      language,
      tenant,
      Accept_Language,
      CartV2CartEntryRequestV1,
      purgeMessages,
      nowZipCode,
      isNowSelected,
      slotId,
      options
    ) {
      return localVarFp
        .cartServiceCartPostCartEntryLocalized(
          language,
          tenant,
          Accept_Language,
          CartV2CartEntryRequestV1,
          purgeMessages,
          nowZipCode,
          isNowSelected,
          slotId,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * create multiple cartEntries
     * @param {string} language
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {CartV2CartEntriesRequestV1} CartV2CartEntriesRequestV1
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {boolean} [isNowSelected]
     * @param {string} [slotId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageCartV3TenantEntriesPost(
      language,
      tenant,
      Accept_Language,
      CartV2CartEntriesRequestV1,
      purgeMessages,
      nowZipCode,
      isNowSelected,
      slotId,
      options
    ) {
      return localVarFp
        .languageCartV3TenantEntriesPost(
          language,
          tenant,
          Accept_Language,
          CartV2CartEntriesRequestV1,
          purgeMessages,
          nowZipCode,
          isNowSelected,
          slotId,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} offerId
     * @param {string} Accept_Language
     * @param {string} prescriptionType
     * @param {string} [nowZipCode]
     * @param {boolean} [isNowSelected]
     * @param {string} [slotId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageCartV3TenantEntryOfferIdDelete(
      language,
      tenant,
      offerId,
      Accept_Language,
      prescriptionType,
      nowZipCode,
      isNowSelected,
      slotId,
      options
    ) {
      return localVarFp
        .languageCartV3TenantEntryOfferIdDelete(
          language,
          tenant,
          offerId,
          Accept_Language,
          prescriptionType,
          nowZipCode,
          isNowSelected,
          slotId,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Get new or existing cart for customer (including guests) - miniature format
     * @param {string} language
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {boolean} [disableRefresh]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageCartV3TenantMinicartGet(language, tenant, Accept_Language, disableRefresh, options) {
      return localVarFp
        .languageCartV3TenantMinicartGet(language, tenant, Accept_Language, disableRefresh, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Updates the collectiveOrder or prescriptionFollows status for the customer (including guests)
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} Accept_Language
     * @param {CartV2TenantPutRequest} CartV2TenantPutRequest
     * @param {string} [nowZipCode]
     * @param {boolean} [isNowSelected]
     * @param {string} [slotId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageCartV3TenantPut(
      language,
      tenant,
      Accept_Language,
      CartV2TenantPutRequest,
      nowZipCode,
      isNowSelected,
      slotId,
      options
    ) {
      return localVarFp
        .languageCartV3TenantPut(
          language,
          tenant,
          Accept_Language,
          CartV2TenantPutRequest,
          nowZipCode,
          isNowSelected,
          slotId,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} Accept_Language
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {boolean} [isNowSelected]
     * @param {string} [slotId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageCartV3TenantRedpointsDelete(
      language,
      tenant,
      Accept_Language,
      purgeMessages,
      nowZipCode,
      isNowSelected,
      slotId,
      options
    ) {
      return localVarFp
        .languageCartV3TenantRedpointsDelete(
          language,
          tenant,
          Accept_Language,
          purgeMessages,
          nowZipCode,
          isNowSelected,
          slotId,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} Accept_Language
     * @param {CartV2RedPointsRequestV1} CartV2RedPointsRequestV1
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {boolean} [isNowSelected]
     * @param {string} [slotId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageCartV3TenantRedpointsPost(
      language,
      tenant,
      Accept_Language,
      CartV2RedPointsRequestV1,
      purgeMessages,
      nowZipCode,
      isNowSelected,
      slotId,
      options
    ) {
      return localVarFp
        .languageCartV3TenantRedpointsPost(
          language,
          tenant,
          Accept_Language,
          CartV2RedPointsRequestV1,
          purgeMessages,
          nowZipCode,
          isNowSelected,
          slotId,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} Accept_Language
     * @param {CartV2VoucherRequestV1} CartV2VoucherRequestV1
     * @param {boolean} [purgeMessages]
     * @param {string} [nowZipCode]
     * @param {boolean} [isNowSelected]
     * @param {string} [slotId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageCartV3TenantVoucherPost(
      language,
      tenant,
      Accept_Language,
      CartV2VoucherRequestV1,
      purgeMessages,
      nowZipCode,
      isNowSelected,
      slotId,
      options
    ) {
      return localVarFp
        .languageCartV3TenantVoucherPost(
          language,
          tenant,
          Accept_Language,
          CartV2VoucherRequestV1,
          purgeMessages,
          nowZipCode,
          isNowSelected,
          slotId,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} voucherCode
     * @param {string} Accept_Language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageCartV3TenantVoucherVoucherCodeDelete(language, tenant, voucherCode, Accept_Language, options) {
      return localVarFp
        .languageCartV3TenantVoucherVoucherCodeDelete(language, tenant, voucherCode, Accept_Language, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * CartControllerV3Api - object-oriented interface
 * @export
 * @class CartControllerV3Api
 * @extends {BaseAPI}
 */
export class CartControllerV3Api extends BaseAPI {
  /**
   * Get new or existing cart for customer (including guests)
   * @param {string} language
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} Accept_Language
   * @param {boolean} [purgeMessages]
   * @param {string} [nowZipCode]
   * @param {boolean} [isNowSelected]
   * @param {string} [slotId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CartControllerV3Api
   */
  cartServiceCartGetCartLocalized(
    language,
    tenant,
    Accept_Language,
    purgeMessages,
    nowZipCode,
    isNowSelected,
    slotId,
    options
  ) {
    return CartControllerV3ApiFp(this.configuration)
      .cartServiceCartGetCartLocalized(
        language,
        tenant,
        Accept_Language,
        purgeMessages,
        nowZipCode,
        isNowSelected,
        slotId,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * create or update cartEntry
   * @param {string} language
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} Accept_Language
   * @param {CartV2CartEntryRequestV1} CartV2CartEntryRequestV1
   * @param {boolean} [purgeMessages]
   * @param {string} [nowZipCode]
   * @param {boolean} [isNowSelected]
   * @param {string} [slotId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CartControllerV3Api
   */
  cartServiceCartPostCartEntryLocalized(
    language,
    tenant,
    Accept_Language,
    CartV2CartEntryRequestV1,
    purgeMessages,
    nowZipCode,
    isNowSelected,
    slotId,
    options
  ) {
    return CartControllerV3ApiFp(this.configuration)
      .cartServiceCartPostCartEntryLocalized(
        language,
        tenant,
        Accept_Language,
        CartV2CartEntryRequestV1,
        purgeMessages,
        nowZipCode,
        isNowSelected,
        slotId,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * create multiple cartEntries
   * @param {string} language
   * @param {string} tenant
   * @param {string} Accept_Language
   * @param {CartV2CartEntriesRequestV1} CartV2CartEntriesRequestV1
   * @param {boolean} [purgeMessages]
   * @param {string} [nowZipCode]
   * @param {boolean} [isNowSelected]
   * @param {string} [slotId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CartControllerV3Api
   */
  languageCartV3TenantEntriesPost(
    language,
    tenant,
    Accept_Language,
    CartV2CartEntriesRequestV1,
    purgeMessages,
    nowZipCode,
    isNowSelected,
    slotId,
    options
  ) {
    return CartControllerV3ApiFp(this.configuration)
      .languageCartV3TenantEntriesPost(
        language,
        tenant,
        Accept_Language,
        CartV2CartEntriesRequestV1,
        purgeMessages,
        nowZipCode,
        isNowSelected,
        slotId,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} language
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} offerId
   * @param {string} Accept_Language
   * @param {string} prescriptionType
   * @param {string} [nowZipCode]
   * @param {boolean} [isNowSelected]
   * @param {string} [slotId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CartControllerV3Api
   */
  languageCartV3TenantEntryOfferIdDelete(
    language,
    tenant,
    offerId,
    Accept_Language,
    prescriptionType,
    nowZipCode,
    isNowSelected,
    slotId,
    options
  ) {
    return CartControllerV3ApiFp(this.configuration)
      .languageCartV3TenantEntryOfferIdDelete(
        language,
        tenant,
        offerId,
        Accept_Language,
        prescriptionType,
        nowZipCode,
        isNowSelected,
        slotId,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get new or existing cart for customer (including guests) - miniature format
   * @param {string} language
   * @param {string} tenant
   * @param {string} Accept_Language
   * @param {boolean} [disableRefresh]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CartControllerV3Api
   */
  languageCartV3TenantMinicartGet(language, tenant, Accept_Language, disableRefresh, options) {
    return CartControllerV3ApiFp(this.configuration)
      .languageCartV3TenantMinicartGet(language, tenant, Accept_Language, disableRefresh, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Updates the collectiveOrder or prescriptionFollows status for the customer (including guests)
   * @param {string} language
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} Accept_Language
   * @param {CartV2TenantPutRequest} CartV2TenantPutRequest
   * @param {string} [nowZipCode]
   * @param {boolean} [isNowSelected]
   * @param {string} [slotId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CartControllerV3Api
   */
  languageCartV3TenantPut(
    language,
    tenant,
    Accept_Language,
    CartV2TenantPutRequest,
    nowZipCode,
    isNowSelected,
    slotId,
    options
  ) {
    return CartControllerV3ApiFp(this.configuration)
      .languageCartV3TenantPut(
        language,
        tenant,
        Accept_Language,
        CartV2TenantPutRequest,
        nowZipCode,
        isNowSelected,
        slotId,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} language
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} Accept_Language
   * @param {boolean} [purgeMessages]
   * @param {string} [nowZipCode]
   * @param {boolean} [isNowSelected]
   * @param {string} [slotId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CartControllerV3Api
   */
  languageCartV3TenantRedpointsDelete(
    language,
    tenant,
    Accept_Language,
    purgeMessages,
    nowZipCode,
    isNowSelected,
    slotId,
    options
  ) {
    return CartControllerV3ApiFp(this.configuration)
      .languageCartV3TenantRedpointsDelete(
        language,
        tenant,
        Accept_Language,
        purgeMessages,
        nowZipCode,
        isNowSelected,
        slotId,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} language
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} Accept_Language
   * @param {CartV2RedPointsRequestV1} CartV2RedPointsRequestV1
   * @param {boolean} [purgeMessages]
   * @param {string} [nowZipCode]
   * @param {boolean} [isNowSelected]
   * @param {string} [slotId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CartControllerV3Api
   */
  languageCartV3TenantRedpointsPost(
    language,
    tenant,
    Accept_Language,
    CartV2RedPointsRequestV1,
    purgeMessages,
    nowZipCode,
    isNowSelected,
    slotId,
    options
  ) {
    return CartControllerV3ApiFp(this.configuration)
      .languageCartV3TenantRedpointsPost(
        language,
        tenant,
        Accept_Language,
        CartV2RedPointsRequestV1,
        purgeMessages,
        nowZipCode,
        isNowSelected,
        slotId,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} language
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} Accept_Language
   * @param {CartV2VoucherRequestV1} CartV2VoucherRequestV1
   * @param {boolean} [purgeMessages]
   * @param {string} [nowZipCode]
   * @param {boolean} [isNowSelected]
   * @param {string} [slotId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CartControllerV3Api
   */
  languageCartV3TenantVoucherPost(
    language,
    tenant,
    Accept_Language,
    CartV2VoucherRequestV1,
    purgeMessages,
    nowZipCode,
    isNowSelected,
    slotId,
    options
  ) {
    return CartControllerV3ApiFp(this.configuration)
      .languageCartV3TenantVoucherPost(
        language,
        tenant,
        Accept_Language,
        CartV2VoucherRequestV1,
        purgeMessages,
        nowZipCode,
        isNowSelected,
        slotId,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} language
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} voucherCode
   * @param {string} Accept_Language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CartControllerV3Api
   */
  languageCartV3TenantVoucherVoucherCodeDelete(language, tenant, voucherCode, Accept_Language, options) {
    return CartControllerV3ApiFp(this.configuration)
      .languageCartV3TenantVoucherVoucherCodeDelete(language, tenant, voucherCode, Accept_Language, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * CategoriesControllerApi - axios parameter creator
 * @export
 */
export const CategoriesControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @param {'at-dev' | 'ch-dev' | 'com-dev' | 'es-dev' | 'fr-dev' | 'it-dev'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {string} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageCategoriesV2TenantGet: async (tenant, language, fields, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageCategoriesV2TenantGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageCategoriesV2TenantGet", "language", language);
      const localVarPath = `/{language}/categories/v2/{tenant}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (fields !== undefined) {
        localVarQueryParameter["fields"] = fields;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'ch-dev' | 'com-dev' | 'es-dev' | 'fr-dev' | 'it-dev'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {string} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageCategoriesV2TenantIdGet: async (id, tenant, language, fields, options = {}) => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("languageCategoriesV2TenantIdGet", "id", id);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageCategoriesV2TenantIdGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageCategoriesV2TenantIdGet", "language", language);
      const localVarPath = `/{language}/categories/v2/{tenant}/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (fields !== undefined) {
        localVarQueryParameter["fields"] = fields;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * CategoriesControllerApi - functional programming interface
 * @export
 */
export const CategoriesControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = CategoriesControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {'at-dev' | 'ch-dev' | 'com-dev' | 'es-dev' | 'fr-dev' | 'it-dev'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {string} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageCategoriesV2TenantGet(tenant, language, fields, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageCategoriesV2TenantGet(
        tenant,
        language,
        fields,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'ch-dev' | 'com-dev' | 'es-dev' | 'fr-dev' | 'it-dev'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {string} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageCategoriesV2TenantIdGet(id, tenant, language, fields, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageCategoriesV2TenantIdGet(
        id,
        tenant,
        language,
        fields,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * CategoriesControllerApi - factory interface
 * @export
 */
export const CategoriesControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = CategoriesControllerApiFp(configuration);
  return {
    /**
     *
     * @param {'at-dev' | 'ch-dev' | 'com-dev' | 'es-dev' | 'fr-dev' | 'it-dev'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {string} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageCategoriesV2TenantGet(tenant, language, fields, options) {
      return localVarFp
        .languageCategoriesV2TenantGet(tenant, language, fields, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'ch-dev' | 'com-dev' | 'es-dev' | 'fr-dev' | 'it-dev'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {string} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageCategoriesV2TenantIdGet(id, tenant, language, fields, options) {
      return localVarFp
        .languageCategoriesV2TenantIdGet(id, tenant, language, fields, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * CategoriesControllerApi - object-oriented interface
 * @export
 * @class CategoriesControllerApi
 * @extends {BaseAPI}
 */
export class CategoriesControllerApi extends BaseAPI {
  /**
   *
   * @param {'at-dev' | 'ch-dev' | 'com-dev' | 'es-dev' | 'fr-dev' | 'it-dev'} tenant ControllerParam tenant
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {string} [fields] QueryParam fields
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoriesControllerApi
   */
  languageCategoriesV2TenantGet(tenant, language, fields, options) {
    return CategoriesControllerApiFp(this.configuration)
      .languageCategoriesV2TenantGet(tenant, language, fields, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} id PathParam id
   * @param {'at-dev' | 'ch-dev' | 'com-dev' | 'es-dev' | 'fr-dev' | 'it-dev'} tenant ControllerParam tenant
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {string} [fields] QueryParam fields
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoriesControllerApi
   */
  languageCategoriesV2TenantIdGet(id, tenant, language, fields, options) {
    return CategoriesControllerApiFp(this.configuration)
      .languageCategoriesV2TenantIdGet(id, tenant, language, fields, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * CheckoutControllerV1Api - axios parameter creator
 * @export
 */
export const CheckoutControllerV1ApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Unset chosen payment for checkoutId / orderDraftId
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyDraftDeletePayment: async (tenant, orderDraftId, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("bullyDraftDeletePayment", "tenant", tenant);
      // verify required parameter 'orderDraftId' is not null or undefined
      assertParamExists("bullyDraftDeletePayment", "orderDraftId", orderDraftId);
      const localVarPath = `/checkout/v1/{tenant}/{orderDraftId}/payment`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "DELETE", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Get existing order draft with orderDraftId
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyDraftGetDraft: async (tenant, orderDraftId, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("bullyDraftGetDraft", "tenant", tenant);
      // verify required parameter 'orderDraftId' is not null or undefined
      assertParamExists("bullyDraftGetDraft", "orderDraftId", orderDraftId);
      const localVarPath = `/checkout/v1/{tenant}/{orderDraftId}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * As the flag is now set while starting the checkout this endpoint is deprecated! Sets prescriptionFollows flag on draft\'s orderMasterData
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {CheckoutOrderMasterDataRequestV1} CheckoutOrderMasterDataRequestV1
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    bullyDraftPatchOrderMasterData: async (tenant, orderDraftId, CheckoutOrderMasterDataRequestV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("bullyDraftPatchOrderMasterData", "tenant", tenant);
      // verify required parameter 'orderDraftId' is not null or undefined
      assertParamExists("bullyDraftPatchOrderMasterData", "orderDraftId", orderDraftId);
      // verify required parameter 'CheckoutOrderMasterDataRequestV1' is not null or undefined
      assertParamExists(
        "bullyDraftPatchOrderMasterData",
        "CheckoutOrderMasterDataRequestV1",
        CheckoutOrderMasterDataRequestV1
      );
      const localVarPath = `/checkout/v1/{tenant}/{orderDraftId}/orderMasterData`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "PATCH", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        CheckoutOrderMasterDataRequestV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Update or set billing address for checkoutId / orderDraftId
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {CheckoutBillingAddressRequestV1} CheckoutBillingAddressRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyDraftPutBillingAddress: async (tenant, orderDraftId, CheckoutBillingAddressRequestV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("bullyDraftPutBillingAddress", "tenant", tenant);
      // verify required parameter 'orderDraftId' is not null or undefined
      assertParamExists("bullyDraftPutBillingAddress", "orderDraftId", orderDraftId);
      // verify required parameter 'CheckoutBillingAddressRequestV1' is not null or undefined
      assertParamExists(
        "bullyDraftPutBillingAddress",
        "CheckoutBillingAddressRequestV1",
        CheckoutBillingAddressRequestV1
      );
      const localVarPath = `/checkout/v1/{tenant}/{orderDraftId}/billingAddress`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "PUT", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        CheckoutBillingAddressRequestV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Update or set chosen carrier for checkoutId / orderDraftId
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {CheckoutCarrierRequestBody} CheckoutCarrierRequestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyDraftPutCarrier: async (tenant, orderDraftId, CheckoutCarrierRequestBody, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("bullyDraftPutCarrier", "tenant", tenant);
      // verify required parameter 'orderDraftId' is not null or undefined
      assertParamExists("bullyDraftPutCarrier", "orderDraftId", orderDraftId);
      // verify required parameter 'CheckoutCarrierRequestBody' is not null or undefined
      assertParamExists("bullyDraftPutCarrier", "CheckoutCarrierRequestBody", CheckoutCarrierRequestBody);
      const localVarPath = `/checkout/v1/{tenant}/{orderDraftId}/carrier`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "PUT", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        CheckoutCarrierRequestBody,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * updates carriers (standard, market place and now) in orderDraft given orderDraftId, subOrderId and carrierList.
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {CheckoutCarrierListUpdateRequestBody} CheckoutCarrierListUpdateRequestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyDraftPutCarriers: async (tenant, orderDraftId, CheckoutCarrierListUpdateRequestBody, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("bullyDraftPutCarriers", "tenant", tenant);
      // verify required parameter 'orderDraftId' is not null or undefined
      assertParamExists("bullyDraftPutCarriers", "orderDraftId", orderDraftId);
      // verify required parameter 'CheckoutCarrierListUpdateRequestBody' is not null or undefined
      assertParamExists(
        "bullyDraftPutCarriers",
        "CheckoutCarrierListUpdateRequestBody",
        CheckoutCarrierListUpdateRequestBody
      );
      const localVarPath = `/checkout/v1/{tenant}/{orderDraftId}/carriers`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "PUT", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        CheckoutCarrierListUpdateRequestBody,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Update or set chosen payment for checkoutId / orderDraftId
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {CheckoutPaymentRequest} CheckoutPaymentRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyDraftPutPayment: async (tenant, orderDraftId, CheckoutPaymentRequest, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("bullyDraftPutPayment", "tenant", tenant);
      // verify required parameter 'orderDraftId' is not null or undefined
      assertParamExists("bullyDraftPutPayment", "orderDraftId", orderDraftId);
      // verify required parameter 'CheckoutPaymentRequest' is not null or undefined
      assertParamExists("bullyDraftPutPayment", "CheckoutPaymentRequest", CheckoutPaymentRequest);
      const localVarPath = `/checkout/v1/{tenant}/{orderDraftId}/payment`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "PUT", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        CheckoutPaymentRequest,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Update customer\'s phone number in checkout billing address step for billingAddressId / orderDraftId
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {CheckoutPhoneNumberRequestV1} CheckoutPhoneNumberRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyDraftPutPhoneNumber: async (tenant, orderDraftId, CheckoutPhoneNumberRequestV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("bullyDraftPutPhoneNumber", "tenant", tenant);
      // verify required parameter 'orderDraftId' is not null or undefined
      assertParamExists("bullyDraftPutPhoneNumber", "orderDraftId", orderDraftId);
      // verify required parameter 'CheckoutPhoneNumberRequestV1' is not null or undefined
      assertParamExists("bullyDraftPutPhoneNumber", "CheckoutPhoneNumberRequestV1", CheckoutPhoneNumberRequestV1);
      const localVarPath = `/checkout/v1/{tenant}/{orderDraftId}/phoneNumber`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "PUT", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        CheckoutPhoneNumberRequestV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Update or set shipping address for checkoutId / orderDraftId
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {CheckoutShippingAddressRequestV1} CheckoutShippingAddressRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyDraftPutShippingAddress: async (tenant, orderDraftId, CheckoutShippingAddressRequestV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("bullyDraftPutShippingAddress", "tenant", tenant);
      // verify required parameter 'orderDraftId' is not null or undefined
      assertParamExists("bullyDraftPutShippingAddress", "orderDraftId", orderDraftId);
      // verify required parameter 'CheckoutShippingAddressRequestV1' is not null or undefined
      assertParamExists(
        "bullyDraftPutShippingAddress",
        "CheckoutShippingAddressRequestV1",
        CheckoutShippingAddressRequestV1
      );
      const localVarPath = `/checkout/v1/{tenant}/{orderDraftId}/shippingAddress`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "PUT", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        CheckoutShippingAddressRequestV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Updates orderDraft with payment that is allowed for zero amount order
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyDraftPutZeroAmountPayment: async (tenant, orderDraftId, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("bullyDraftPutZeroAmountPayment", "tenant", tenant);
      // verify required parameter 'orderDraftId' is not null or undefined
      assertParamExists("bullyDraftPutZeroAmountPayment", "orderDraftId", orderDraftId);
      const localVarPath = `/checkout/v1/{tenant}/{orderDraftId}/zeroAmountPayment`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "PUT", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Determines price change on the fly for the given carrier (Does not persist to order draft)
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {CheckoutCarrierListCalculatePriceRequestBody} CheckoutCarrierListCalculatePriceRequestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkoutV1TenantOrderDraftIdCarrierCalculatePricePost: async (
      tenant,
      orderDraftId,
      CheckoutCarrierListCalculatePriceRequestBody,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("checkoutV1TenantOrderDraftIdCarrierCalculatePricePost", "tenant", tenant);
      // verify required parameter 'orderDraftId' is not null or undefined
      assertParamExists("checkoutV1TenantOrderDraftIdCarrierCalculatePricePost", "orderDraftId", orderDraftId);
      // verify required parameter 'CheckoutCarrierListCalculatePriceRequestBody' is not null or undefined
      assertParamExists(
        "checkoutV1TenantOrderDraftIdCarrierCalculatePricePost",
        "CheckoutCarrierListCalculatePriceRequestBody",
        CheckoutCarrierListCalculatePriceRequestBody
      );
      const localVarPath = `/checkout/v1/{tenant}/{orderDraftId}/carrier/calculatePrice`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        CheckoutCarrierListCalculatePriceRequestBody,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Creates order from order-draft.
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {string} Accept_Language
     * @param {CheckoutSubmitOrderRequestV1} CheckoutSubmitOrderRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkoutV1TenantOrderDraftIdOrderPost: async (
      tenant,
      orderDraftId,
      Accept_Language,
      CheckoutSubmitOrderRequestV1,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("checkoutV1TenantOrderDraftIdOrderPost", "tenant", tenant);
      // verify required parameter 'orderDraftId' is not null or undefined
      assertParamExists("checkoutV1TenantOrderDraftIdOrderPost", "orderDraftId", orderDraftId);
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists("checkoutV1TenantOrderDraftIdOrderPost", "Accept_Language", Accept_Language);
      // verify required parameter 'CheckoutSubmitOrderRequestV1' is not null or undefined
      assertParamExists(
        "checkoutV1TenantOrderDraftIdOrderPost",
        "CheckoutSubmitOrderRequestV1",
        CheckoutSubmitOrderRequestV1
      );
      const localVarPath = `/checkout/v1/{tenant}/{orderDraftId}/order`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (Accept_Language != null) {
        localVarHeaderParameter["Accept-Language"] = String(Accept_Language);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        CheckoutSubmitOrderRequestV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Create new checkout process
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {CheckoutCreateDataRequestV1} [CheckoutCreateDataRequestV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkoutV1TenantPost: async (tenant, Accept_Language, CheckoutCreateDataRequestV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("checkoutV1TenantPost", "tenant", tenant);
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists("checkoutV1TenantPost", "Accept_Language", Accept_Language);
      const localVarPath = `/checkout/v1/{tenant}`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (Accept_Language != null) {
        localVarHeaderParameter["Accept-Language"] = String(Accept_Language);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        CheckoutCreateDataRequestV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Creates order from order-draft (for use with QuickCheckout non-logged-in flow). [See more](https://jira.shop-apotheke.com/browse/WSSSH-916)
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {string} Accept_Language
     * @param {QuickCheckoutSubmitOrderRequestV1} QuickCheckoutSubmitOrderRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkoutV1TenantQuickOrderDraftIdOrderPost: async (
      tenant,
      orderDraftId,
      Accept_Language,
      QuickCheckoutSubmitOrderRequestV1,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("checkoutV1TenantQuickOrderDraftIdOrderPost", "tenant", tenant);
      // verify required parameter 'orderDraftId' is not null or undefined
      assertParamExists("checkoutV1TenantQuickOrderDraftIdOrderPost", "orderDraftId", orderDraftId);
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists("checkoutV1TenantQuickOrderDraftIdOrderPost", "Accept_Language", Accept_Language);
      // verify required parameter 'QuickCheckoutSubmitOrderRequestV1' is not null or undefined
      assertParamExists(
        "checkoutV1TenantQuickOrderDraftIdOrderPost",
        "QuickCheckoutSubmitOrderRequestV1",
        QuickCheckoutSubmitOrderRequestV1
      );
      const localVarPath = `/checkout/v1/{tenant}/quick/{orderDraftId}/order`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (Accept_Language != null) {
        localVarHeaderParameter["Accept-Language"] = String(Accept_Language);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        QuickCheckoutSubmitOrderRequestV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Change the orderType field in the sub-orders from Integration Quick Checkout
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {OrderTypeQuickCheckoutOrderRequestV1} OrderTypeQuickCheckoutOrderRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkoutV1TenantQuickOrderDraftIdOrderTypePatch: async (
      tenant,
      orderDraftId,
      OrderTypeQuickCheckoutOrderRequestV1,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("checkoutV1TenantQuickOrderDraftIdOrderTypePatch", "tenant", tenant);
      // verify required parameter 'orderDraftId' is not null or undefined
      assertParamExists("checkoutV1TenantQuickOrderDraftIdOrderTypePatch", "orderDraftId", orderDraftId);
      // verify required parameter 'OrderTypeQuickCheckoutOrderRequestV1' is not null or undefined
      assertParamExists(
        "checkoutV1TenantQuickOrderDraftIdOrderTypePatch",
        "OrderTypeQuickCheckoutOrderRequestV1",
        OrderTypeQuickCheckoutOrderRequestV1
      );
      const localVarPath = `/checkout/v1/{tenant}/quick/{orderDraftId}/order-type`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "PATCH", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        OrderTypeQuickCheckoutOrderRequestV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Creates order from order-draft (for use with QuickCheckout logged-in flow). [See more](https://jira.shop-apotheke.com/browse/WSSSH-518)
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {string} Accept_Language
     * @param {PreAuthedQuickCheckoutSubmitOrderRequestV1} PreAuthedQuickCheckoutSubmitOrderRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkoutV1TenantQuickOrderDraftIdPreAuthedOrderPost: async (
      tenant,
      orderDraftId,
      Accept_Language,
      PreAuthedQuickCheckoutSubmitOrderRequestV1,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("checkoutV1TenantQuickOrderDraftIdPreAuthedOrderPost", "tenant", tenant);
      // verify required parameter 'orderDraftId' is not null or undefined
      assertParamExists("checkoutV1TenantQuickOrderDraftIdPreAuthedOrderPost", "orderDraftId", orderDraftId);
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists("checkoutV1TenantQuickOrderDraftIdPreAuthedOrderPost", "Accept_Language", Accept_Language);
      // verify required parameter 'PreAuthedQuickCheckoutSubmitOrderRequestV1' is not null or undefined
      assertParamExists(
        "checkoutV1TenantQuickOrderDraftIdPreAuthedOrderPost",
        "PreAuthedQuickCheckoutSubmitOrderRequestV1",
        PreAuthedQuickCheckoutSubmitOrderRequestV1
      );
      const localVarPath = `/checkout/v1/{tenant}/quick/{orderDraftId}/pre-authed-order`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (Accept_Language != null) {
        localVarHeaderParameter["Accept-Language"] = String(Accept_Language);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        PreAuthedQuickCheckoutSubmitOrderRequestV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Create new quick ERX checkout process
     * @param {string} tenant
     * @param {HashedTokensPayload} HashedTokensPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkoutV1TenantQuickPost: async (tenant, HashedTokensPayload, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("checkoutV1TenantQuickPost", "tenant", tenant);
      // verify required parameter 'HashedTokensPayload' is not null or undefined
      assertParamExists("checkoutV1TenantQuickPost", "HashedTokensPayload", HashedTokensPayload);
      const localVarPath = `/checkout/v1/{tenant}/quick`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(HashedTokensPayload, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * CheckoutControllerV1Api - functional programming interface
 * @export
 */
export const CheckoutControllerV1ApiFp = function (configuration) {
  const localVarAxiosParamCreator = CheckoutControllerV1ApiAxiosParamCreator(configuration);
  return {
    /**
     * Unset chosen payment for checkoutId / orderDraftId
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bullyDraftDeletePayment(tenant, orderDraftId, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bullyDraftDeletePayment(tenant, orderDraftId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Get existing order draft with orderDraftId
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bullyDraftGetDraft(tenant, orderDraftId, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bullyDraftGetDraft(tenant, orderDraftId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * As the flag is now set while starting the checkout this endpoint is deprecated! Sets prescriptionFollows flag on draft\'s orderMasterData
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {CheckoutOrderMasterDataRequestV1} CheckoutOrderMasterDataRequestV1
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async bullyDraftPatchOrderMasterData(tenant, orderDraftId, CheckoutOrderMasterDataRequestV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bullyDraftPatchOrderMasterData(
        tenant,
        orderDraftId,
        CheckoutOrderMasterDataRequestV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Update or set billing address for checkoutId / orderDraftId
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {CheckoutBillingAddressRequestV1} CheckoutBillingAddressRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bullyDraftPutBillingAddress(tenant, orderDraftId, CheckoutBillingAddressRequestV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bullyDraftPutBillingAddress(
        tenant,
        orderDraftId,
        CheckoutBillingAddressRequestV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Update or set chosen carrier for checkoutId / orderDraftId
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {CheckoutCarrierRequestBody} CheckoutCarrierRequestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bullyDraftPutCarrier(tenant, orderDraftId, CheckoutCarrierRequestBody, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bullyDraftPutCarrier(
        tenant,
        orderDraftId,
        CheckoutCarrierRequestBody,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * updates carriers (standard, market place and now) in orderDraft given orderDraftId, subOrderId and carrierList.
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {CheckoutCarrierListUpdateRequestBody} CheckoutCarrierListUpdateRequestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bullyDraftPutCarriers(tenant, orderDraftId, CheckoutCarrierListUpdateRequestBody, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bullyDraftPutCarriers(
        tenant,
        orderDraftId,
        CheckoutCarrierListUpdateRequestBody,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Update or set chosen payment for checkoutId / orderDraftId
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {CheckoutPaymentRequest} CheckoutPaymentRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bullyDraftPutPayment(tenant, orderDraftId, CheckoutPaymentRequest, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bullyDraftPutPayment(
        tenant,
        orderDraftId,
        CheckoutPaymentRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Update customer\'s phone number in checkout billing address step for billingAddressId / orderDraftId
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {CheckoutPhoneNumberRequestV1} CheckoutPhoneNumberRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bullyDraftPutPhoneNumber(tenant, orderDraftId, CheckoutPhoneNumberRequestV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bullyDraftPutPhoneNumber(
        tenant,
        orderDraftId,
        CheckoutPhoneNumberRequestV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Update or set shipping address for checkoutId / orderDraftId
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {CheckoutShippingAddressRequestV1} CheckoutShippingAddressRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bullyDraftPutShippingAddress(tenant, orderDraftId, CheckoutShippingAddressRequestV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bullyDraftPutShippingAddress(
        tenant,
        orderDraftId,
        CheckoutShippingAddressRequestV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Updates orderDraft with payment that is allowed for zero amount order
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bullyDraftPutZeroAmountPayment(tenant, orderDraftId, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bullyDraftPutZeroAmountPayment(
        tenant,
        orderDraftId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Determines price change on the fly for the given carrier (Does not persist to order draft)
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {CheckoutCarrierListCalculatePriceRequestBody} CheckoutCarrierListCalculatePriceRequestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checkoutV1TenantOrderDraftIdCarrierCalculatePricePost(
      tenant,
      orderDraftId,
      CheckoutCarrierListCalculatePriceRequestBody,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.checkoutV1TenantOrderDraftIdCarrierCalculatePricePost(
        tenant,
        orderDraftId,
        CheckoutCarrierListCalculatePriceRequestBody,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Creates order from order-draft.
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {string} Accept_Language
     * @param {CheckoutSubmitOrderRequestV1} CheckoutSubmitOrderRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checkoutV1TenantOrderDraftIdOrderPost(
      tenant,
      orderDraftId,
      Accept_Language,
      CheckoutSubmitOrderRequestV1,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.checkoutV1TenantOrderDraftIdOrderPost(
        tenant,
        orderDraftId,
        Accept_Language,
        CheckoutSubmitOrderRequestV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Create new checkout process
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {CheckoutCreateDataRequestV1} [CheckoutCreateDataRequestV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checkoutV1TenantPost(tenant, Accept_Language, CheckoutCreateDataRequestV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.checkoutV1TenantPost(
        tenant,
        Accept_Language,
        CheckoutCreateDataRequestV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Creates order from order-draft (for use with QuickCheckout non-logged-in flow). [See more](https://jira.shop-apotheke.com/browse/WSSSH-916)
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {string} Accept_Language
     * @param {QuickCheckoutSubmitOrderRequestV1} QuickCheckoutSubmitOrderRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checkoutV1TenantQuickOrderDraftIdOrderPost(
      tenant,
      orderDraftId,
      Accept_Language,
      QuickCheckoutSubmitOrderRequestV1,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.checkoutV1TenantQuickOrderDraftIdOrderPost(
        tenant,
        orderDraftId,
        Accept_Language,
        QuickCheckoutSubmitOrderRequestV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Change the orderType field in the sub-orders from Integration Quick Checkout
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {OrderTypeQuickCheckoutOrderRequestV1} OrderTypeQuickCheckoutOrderRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checkoutV1TenantQuickOrderDraftIdOrderTypePatch(
      tenant,
      orderDraftId,
      OrderTypeQuickCheckoutOrderRequestV1,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.checkoutV1TenantQuickOrderDraftIdOrderTypePatch(
        tenant,
        orderDraftId,
        OrderTypeQuickCheckoutOrderRequestV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Creates order from order-draft (for use with QuickCheckout logged-in flow). [See more](https://jira.shop-apotheke.com/browse/WSSSH-518)
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {string} Accept_Language
     * @param {PreAuthedQuickCheckoutSubmitOrderRequestV1} PreAuthedQuickCheckoutSubmitOrderRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checkoutV1TenantQuickOrderDraftIdPreAuthedOrderPost(
      tenant,
      orderDraftId,
      Accept_Language,
      PreAuthedQuickCheckoutSubmitOrderRequestV1,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.checkoutV1TenantQuickOrderDraftIdPreAuthedOrderPost(
        tenant,
        orderDraftId,
        Accept_Language,
        PreAuthedQuickCheckoutSubmitOrderRequestV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Create new quick ERX checkout process
     * @param {string} tenant
     * @param {HashedTokensPayload} HashedTokensPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checkoutV1TenantQuickPost(tenant, HashedTokensPayload, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.checkoutV1TenantQuickPost(
        tenant,
        HashedTokensPayload,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * CheckoutControllerV1Api - factory interface
 * @export
 */
export const CheckoutControllerV1ApiFactory = function (configuration, basePath, axios) {
  const localVarFp = CheckoutControllerV1ApiFp(configuration);
  return {
    /**
     * Unset chosen payment for checkoutId / orderDraftId
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyDraftDeletePayment(tenant, orderDraftId, options) {
      return localVarFp
        .bullyDraftDeletePayment(tenant, orderDraftId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get existing order draft with orderDraftId
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyDraftGetDraft(tenant, orderDraftId, options) {
      return localVarFp.bullyDraftGetDraft(tenant, orderDraftId, options).then((request) => request(axios, basePath));
    },
    /**
     * As the flag is now set while starting the checkout this endpoint is deprecated! Sets prescriptionFollows flag on draft\'s orderMasterData
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {CheckoutOrderMasterDataRequestV1} CheckoutOrderMasterDataRequestV1
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    bullyDraftPatchOrderMasterData(tenant, orderDraftId, CheckoutOrderMasterDataRequestV1, options) {
      return localVarFp
        .bullyDraftPatchOrderMasterData(tenant, orderDraftId, CheckoutOrderMasterDataRequestV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Update or set billing address for checkoutId / orderDraftId
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {CheckoutBillingAddressRequestV1} CheckoutBillingAddressRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyDraftPutBillingAddress(tenant, orderDraftId, CheckoutBillingAddressRequestV1, options) {
      return localVarFp
        .bullyDraftPutBillingAddress(tenant, orderDraftId, CheckoutBillingAddressRequestV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Update or set chosen carrier for checkoutId / orderDraftId
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {CheckoutCarrierRequestBody} CheckoutCarrierRequestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyDraftPutCarrier(tenant, orderDraftId, CheckoutCarrierRequestBody, options) {
      return localVarFp
        .bullyDraftPutCarrier(tenant, orderDraftId, CheckoutCarrierRequestBody, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * updates carriers (standard, market place and now) in orderDraft given orderDraftId, subOrderId and carrierList.
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {CheckoutCarrierListUpdateRequestBody} CheckoutCarrierListUpdateRequestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyDraftPutCarriers(tenant, orderDraftId, CheckoutCarrierListUpdateRequestBody, options) {
      return localVarFp
        .bullyDraftPutCarriers(tenant, orderDraftId, CheckoutCarrierListUpdateRequestBody, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Update or set chosen payment for checkoutId / orderDraftId
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {CheckoutPaymentRequest} CheckoutPaymentRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyDraftPutPayment(tenant, orderDraftId, CheckoutPaymentRequest, options) {
      return localVarFp
        .bullyDraftPutPayment(tenant, orderDraftId, CheckoutPaymentRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Update customer\'s phone number in checkout billing address step for billingAddressId / orderDraftId
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {CheckoutPhoneNumberRequestV1} CheckoutPhoneNumberRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyDraftPutPhoneNumber(tenant, orderDraftId, CheckoutPhoneNumberRequestV1, options) {
      return localVarFp
        .bullyDraftPutPhoneNumber(tenant, orderDraftId, CheckoutPhoneNumberRequestV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Update or set shipping address for checkoutId / orderDraftId
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {CheckoutShippingAddressRequestV1} CheckoutShippingAddressRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyDraftPutShippingAddress(tenant, orderDraftId, CheckoutShippingAddressRequestV1, options) {
      return localVarFp
        .bullyDraftPutShippingAddress(tenant, orderDraftId, CheckoutShippingAddressRequestV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Updates orderDraft with payment that is allowed for zero amount order
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyDraftPutZeroAmountPayment(tenant, orderDraftId, options) {
      return localVarFp
        .bullyDraftPutZeroAmountPayment(tenant, orderDraftId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Determines price change on the fly for the given carrier (Does not persist to order draft)
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {CheckoutCarrierListCalculatePriceRequestBody} CheckoutCarrierListCalculatePriceRequestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkoutV1TenantOrderDraftIdCarrierCalculatePricePost(
      tenant,
      orderDraftId,
      CheckoutCarrierListCalculatePriceRequestBody,
      options
    ) {
      return localVarFp
        .checkoutV1TenantOrderDraftIdCarrierCalculatePricePost(
          tenant,
          orderDraftId,
          CheckoutCarrierListCalculatePriceRequestBody,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Creates order from order-draft.
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {string} Accept_Language
     * @param {CheckoutSubmitOrderRequestV1} CheckoutSubmitOrderRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkoutV1TenantOrderDraftIdOrderPost(
      tenant,
      orderDraftId,
      Accept_Language,
      CheckoutSubmitOrderRequestV1,
      options
    ) {
      return localVarFp
        .checkoutV1TenantOrderDraftIdOrderPost(
          tenant,
          orderDraftId,
          Accept_Language,
          CheckoutSubmitOrderRequestV1,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Create new checkout process
     * @param {string} tenant
     * @param {string} Accept_Language
     * @param {CheckoutCreateDataRequestV1} [CheckoutCreateDataRequestV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkoutV1TenantPost(tenant, Accept_Language, CheckoutCreateDataRequestV1, options) {
      return localVarFp
        .checkoutV1TenantPost(tenant, Accept_Language, CheckoutCreateDataRequestV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Creates order from order-draft (for use with QuickCheckout non-logged-in flow). [See more](https://jira.shop-apotheke.com/browse/WSSSH-916)
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {string} Accept_Language
     * @param {QuickCheckoutSubmitOrderRequestV1} QuickCheckoutSubmitOrderRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkoutV1TenantQuickOrderDraftIdOrderPost(
      tenant,
      orderDraftId,
      Accept_Language,
      QuickCheckoutSubmitOrderRequestV1,
      options
    ) {
      return localVarFp
        .checkoutV1TenantQuickOrderDraftIdOrderPost(
          tenant,
          orderDraftId,
          Accept_Language,
          QuickCheckoutSubmitOrderRequestV1,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Change the orderType field in the sub-orders from Integration Quick Checkout
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {OrderTypeQuickCheckoutOrderRequestV1} OrderTypeQuickCheckoutOrderRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkoutV1TenantQuickOrderDraftIdOrderTypePatch(
      tenant,
      orderDraftId,
      OrderTypeQuickCheckoutOrderRequestV1,
      options
    ) {
      return localVarFp
        .checkoutV1TenantQuickOrderDraftIdOrderTypePatch(
          tenant,
          orderDraftId,
          OrderTypeQuickCheckoutOrderRequestV1,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Creates order from order-draft (for use with QuickCheckout logged-in flow). [See more](https://jira.shop-apotheke.com/browse/WSSSH-518)
     * @param {string} tenant
     * @param {string} orderDraftId
     * @param {string} Accept_Language
     * @param {PreAuthedQuickCheckoutSubmitOrderRequestV1} PreAuthedQuickCheckoutSubmitOrderRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkoutV1TenantQuickOrderDraftIdPreAuthedOrderPost(
      tenant,
      orderDraftId,
      Accept_Language,
      PreAuthedQuickCheckoutSubmitOrderRequestV1,
      options
    ) {
      return localVarFp
        .checkoutV1TenantQuickOrderDraftIdPreAuthedOrderPost(
          tenant,
          orderDraftId,
          Accept_Language,
          PreAuthedQuickCheckoutSubmitOrderRequestV1,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Create new quick ERX checkout process
     * @param {string} tenant
     * @param {HashedTokensPayload} HashedTokensPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkoutV1TenantQuickPost(tenant, HashedTokensPayload, options) {
      return localVarFp
        .checkoutV1TenantQuickPost(tenant, HashedTokensPayload, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * CheckoutControllerV1Api - object-oriented interface
 * @export
 * @class CheckoutControllerV1Api
 * @extends {BaseAPI}
 */
export class CheckoutControllerV1Api extends BaseAPI {
  /**
   * Unset chosen payment for checkoutId / orderDraftId
   * @param {string} tenant
   * @param {string} orderDraftId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CheckoutControllerV1Api
   */
  bullyDraftDeletePayment(tenant, orderDraftId, options) {
    return CheckoutControllerV1ApiFp(this.configuration)
      .bullyDraftDeletePayment(tenant, orderDraftId, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get existing order draft with orderDraftId
   * @param {string} tenant
   * @param {string} orderDraftId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CheckoutControllerV1Api
   */
  bullyDraftGetDraft(tenant, orderDraftId, options) {
    return CheckoutControllerV1ApiFp(this.configuration)
      .bullyDraftGetDraft(tenant, orderDraftId, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * As the flag is now set while starting the checkout this endpoint is deprecated! Sets prescriptionFollows flag on draft\'s orderMasterData
   * @param {string} tenant
   * @param {string} orderDraftId
   * @param {CheckoutOrderMasterDataRequestV1} CheckoutOrderMasterDataRequestV1
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof CheckoutControllerV1Api
   */
  bullyDraftPatchOrderMasterData(tenant, orderDraftId, CheckoutOrderMasterDataRequestV1, options) {
    return CheckoutControllerV1ApiFp(this.configuration)
      .bullyDraftPatchOrderMasterData(tenant, orderDraftId, CheckoutOrderMasterDataRequestV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update or set billing address for checkoutId / orderDraftId
   * @param {string} tenant
   * @param {string} orderDraftId
   * @param {CheckoutBillingAddressRequestV1} CheckoutBillingAddressRequestV1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CheckoutControllerV1Api
   */
  bullyDraftPutBillingAddress(tenant, orderDraftId, CheckoutBillingAddressRequestV1, options) {
    return CheckoutControllerV1ApiFp(this.configuration)
      .bullyDraftPutBillingAddress(tenant, orderDraftId, CheckoutBillingAddressRequestV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update or set chosen carrier for checkoutId / orderDraftId
   * @param {string} tenant
   * @param {string} orderDraftId
   * @param {CheckoutCarrierRequestBody} CheckoutCarrierRequestBody
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CheckoutControllerV1Api
   */
  bullyDraftPutCarrier(tenant, orderDraftId, CheckoutCarrierRequestBody, options) {
    return CheckoutControllerV1ApiFp(this.configuration)
      .bullyDraftPutCarrier(tenant, orderDraftId, CheckoutCarrierRequestBody, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * updates carriers (standard, market place and now) in orderDraft given orderDraftId, subOrderId and carrierList.
   * @param {string} tenant
   * @param {string} orderDraftId
   * @param {CheckoutCarrierListUpdateRequestBody} CheckoutCarrierListUpdateRequestBody
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CheckoutControllerV1Api
   */
  bullyDraftPutCarriers(tenant, orderDraftId, CheckoutCarrierListUpdateRequestBody, options) {
    return CheckoutControllerV1ApiFp(this.configuration)
      .bullyDraftPutCarriers(tenant, orderDraftId, CheckoutCarrierListUpdateRequestBody, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update or set chosen payment for checkoutId / orderDraftId
   * @param {string} tenant
   * @param {string} orderDraftId
   * @param {CheckoutPaymentRequest} CheckoutPaymentRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CheckoutControllerV1Api
   */
  bullyDraftPutPayment(tenant, orderDraftId, CheckoutPaymentRequest, options) {
    return CheckoutControllerV1ApiFp(this.configuration)
      .bullyDraftPutPayment(tenant, orderDraftId, CheckoutPaymentRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update customer\'s phone number in checkout billing address step for billingAddressId / orderDraftId
   * @param {string} tenant
   * @param {string} orderDraftId
   * @param {CheckoutPhoneNumberRequestV1} CheckoutPhoneNumberRequestV1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CheckoutControllerV1Api
   */
  bullyDraftPutPhoneNumber(tenant, orderDraftId, CheckoutPhoneNumberRequestV1, options) {
    return CheckoutControllerV1ApiFp(this.configuration)
      .bullyDraftPutPhoneNumber(tenant, orderDraftId, CheckoutPhoneNumberRequestV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update or set shipping address for checkoutId / orderDraftId
   * @param {string} tenant
   * @param {string} orderDraftId
   * @param {CheckoutShippingAddressRequestV1} CheckoutShippingAddressRequestV1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CheckoutControllerV1Api
   */
  bullyDraftPutShippingAddress(tenant, orderDraftId, CheckoutShippingAddressRequestV1, options) {
    return CheckoutControllerV1ApiFp(this.configuration)
      .bullyDraftPutShippingAddress(tenant, orderDraftId, CheckoutShippingAddressRequestV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Updates orderDraft with payment that is allowed for zero amount order
   * @param {string} tenant
   * @param {string} orderDraftId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CheckoutControllerV1Api
   */
  bullyDraftPutZeroAmountPayment(tenant, orderDraftId, options) {
    return CheckoutControllerV1ApiFp(this.configuration)
      .bullyDraftPutZeroAmountPayment(tenant, orderDraftId, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Determines price change on the fly for the given carrier (Does not persist to order draft)
   * @param {string} tenant
   * @param {string} orderDraftId
   * @param {CheckoutCarrierListCalculatePriceRequestBody} CheckoutCarrierListCalculatePriceRequestBody
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CheckoutControllerV1Api
   */
  checkoutV1TenantOrderDraftIdCarrierCalculatePricePost(
    tenant,
    orderDraftId,
    CheckoutCarrierListCalculatePriceRequestBody,
    options
  ) {
    return CheckoutControllerV1ApiFp(this.configuration)
      .checkoutV1TenantOrderDraftIdCarrierCalculatePricePost(
        tenant,
        orderDraftId,
        CheckoutCarrierListCalculatePriceRequestBody,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Creates order from order-draft.
   * @param {string} tenant
   * @param {string} orderDraftId
   * @param {string} Accept_Language
   * @param {CheckoutSubmitOrderRequestV1} CheckoutSubmitOrderRequestV1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CheckoutControllerV1Api
   */
  checkoutV1TenantOrderDraftIdOrderPost(tenant, orderDraftId, Accept_Language, CheckoutSubmitOrderRequestV1, options) {
    return CheckoutControllerV1ApiFp(this.configuration)
      .checkoutV1TenantOrderDraftIdOrderPost(
        tenant,
        orderDraftId,
        Accept_Language,
        CheckoutSubmitOrderRequestV1,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create new checkout process
   * @param {string} tenant
   * @param {string} Accept_Language
   * @param {CheckoutCreateDataRequestV1} [CheckoutCreateDataRequestV1]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CheckoutControllerV1Api
   */
  checkoutV1TenantPost(tenant, Accept_Language, CheckoutCreateDataRequestV1, options) {
    return CheckoutControllerV1ApiFp(this.configuration)
      .checkoutV1TenantPost(tenant, Accept_Language, CheckoutCreateDataRequestV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Creates order from order-draft (for use with QuickCheckout non-logged-in flow). [See more](https://jira.shop-apotheke.com/browse/WSSSH-916)
   * @param {string} tenant
   * @param {string} orderDraftId
   * @param {string} Accept_Language
   * @param {QuickCheckoutSubmitOrderRequestV1} QuickCheckoutSubmitOrderRequestV1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CheckoutControllerV1Api
   */
  checkoutV1TenantQuickOrderDraftIdOrderPost(
    tenant,
    orderDraftId,
    Accept_Language,
    QuickCheckoutSubmitOrderRequestV1,
    options
  ) {
    return CheckoutControllerV1ApiFp(this.configuration)
      .checkoutV1TenantQuickOrderDraftIdOrderPost(
        tenant,
        orderDraftId,
        Accept_Language,
        QuickCheckoutSubmitOrderRequestV1,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Change the orderType field in the sub-orders from Integration Quick Checkout
   * @param {string} tenant
   * @param {string} orderDraftId
   * @param {OrderTypeQuickCheckoutOrderRequestV1} OrderTypeQuickCheckoutOrderRequestV1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CheckoutControllerV1Api
   */
  checkoutV1TenantQuickOrderDraftIdOrderTypePatch(tenant, orderDraftId, OrderTypeQuickCheckoutOrderRequestV1, options) {
    return CheckoutControllerV1ApiFp(this.configuration)
      .checkoutV1TenantQuickOrderDraftIdOrderTypePatch(
        tenant,
        orderDraftId,
        OrderTypeQuickCheckoutOrderRequestV1,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Creates order from order-draft (for use with QuickCheckout logged-in flow). [See more](https://jira.shop-apotheke.com/browse/WSSSH-518)
   * @param {string} tenant
   * @param {string} orderDraftId
   * @param {string} Accept_Language
   * @param {PreAuthedQuickCheckoutSubmitOrderRequestV1} PreAuthedQuickCheckoutSubmitOrderRequestV1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CheckoutControllerV1Api
   */
  checkoutV1TenantQuickOrderDraftIdPreAuthedOrderPost(
    tenant,
    orderDraftId,
    Accept_Language,
    PreAuthedQuickCheckoutSubmitOrderRequestV1,
    options
  ) {
    return CheckoutControllerV1ApiFp(this.configuration)
      .checkoutV1TenantQuickOrderDraftIdPreAuthedOrderPost(
        tenant,
        orderDraftId,
        Accept_Language,
        PreAuthedQuickCheckoutSubmitOrderRequestV1,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create new quick ERX checkout process
   * @param {string} tenant
   * @param {HashedTokensPayload} HashedTokensPayload
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CheckoutControllerV1Api
   */
  checkoutV1TenantQuickPost(tenant, HashedTokensPayload, options) {
    return CheckoutControllerV1ApiFp(this.configuration)
      .checkoutV1TenantQuickPost(tenant, HashedTokensPayload, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * CleansiteControllerV1Api - axios parameter creator
 * @export
 */
export const CleansiteControllerV1ApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Republished all reviews results for given language-tenant combinations
     * @param {Array<RepublishAllReviewsRequestV1Inner>} RepublishAllReviewsRequestV1Inner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cleansiteV1RepublishAllReviewsPost: async (RepublishAllReviewsRequestV1Inner, options = {}) => {
      // verify required parameter 'RepublishAllReviewsRequestV1Inner' is not null or undefined
      assertParamExists(
        "cleansiteV1RepublishAllReviewsPost",
        "RepublishAllReviewsRequestV1Inner",
        RepublishAllReviewsRequestV1Inner
      );
      const localVarPath = `/cleansite/v1/republish-all-reviews`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        RepublishAllReviewsRequestV1Inner,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Returns blacklisting results for given review
     * @param {EvaluateReviewRequestV1} EvaluateReviewRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cleansiteV1ReviewPost: async (EvaluateReviewRequestV1, options = {}) => {
      // verify required parameter 'EvaluateReviewRequestV1' is not null or undefined
      assertParamExists("cleansiteV1ReviewPost", "EvaluateReviewRequestV1", EvaluateReviewRequestV1);
      const localVarPath = `/cleansite/v1/review`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        EvaluateReviewRequestV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * CleansiteControllerV1Api - functional programming interface
 * @export
 */
export const CleansiteControllerV1ApiFp = function (configuration) {
  const localVarAxiosParamCreator = CleansiteControllerV1ApiAxiosParamCreator(configuration);
  return {
    /**
     * Republished all reviews results for given language-tenant combinations
     * @param {Array<RepublishAllReviewsRequestV1Inner>} RepublishAllReviewsRequestV1Inner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cleansiteV1RepublishAllReviewsPost(RepublishAllReviewsRequestV1Inner, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cleansiteV1RepublishAllReviewsPost(
        RepublishAllReviewsRequestV1Inner,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Returns blacklisting results for given review
     * @param {EvaluateReviewRequestV1} EvaluateReviewRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cleansiteV1ReviewPost(EvaluateReviewRequestV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cleansiteV1ReviewPost(EvaluateReviewRequestV1, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * CleansiteControllerV1Api - factory interface
 * @export
 */
export const CleansiteControllerV1ApiFactory = function (configuration, basePath, axios) {
  const localVarFp = CleansiteControllerV1ApiFp(configuration);
  return {
    /**
     * Republished all reviews results for given language-tenant combinations
     * @param {Array<RepublishAllReviewsRequestV1Inner>} RepublishAllReviewsRequestV1Inner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cleansiteV1RepublishAllReviewsPost(RepublishAllReviewsRequestV1Inner, options) {
      return localVarFp
        .cleansiteV1RepublishAllReviewsPost(RepublishAllReviewsRequestV1Inner, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Returns blacklisting results for given review
     * @param {EvaluateReviewRequestV1} EvaluateReviewRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cleansiteV1ReviewPost(EvaluateReviewRequestV1, options) {
      return localVarFp
        .cleansiteV1ReviewPost(EvaluateReviewRequestV1, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * CleansiteControllerV1Api - object-oriented interface
 * @export
 * @class CleansiteControllerV1Api
 * @extends {BaseAPI}
 */
export class CleansiteControllerV1Api extends BaseAPI {
  /**
   * Republished all reviews results for given language-tenant combinations
   * @param {Array<RepublishAllReviewsRequestV1Inner>} RepublishAllReviewsRequestV1Inner
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CleansiteControllerV1Api
   */
  cleansiteV1RepublishAllReviewsPost(RepublishAllReviewsRequestV1Inner, options) {
    return CleansiteControllerV1ApiFp(this.configuration)
      .cleansiteV1RepublishAllReviewsPost(RepublishAllReviewsRequestV1Inner, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Returns blacklisting results for given review
   * @param {EvaluateReviewRequestV1} EvaluateReviewRequestV1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CleansiteControllerV1Api
   */
  cleansiteV1ReviewPost(EvaluateReviewRequestV1, options) {
    return CleansiteControllerV1ApiFp(this.configuration)
      .cleansiteV1ReviewPost(EvaluateReviewRequestV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * ClientSessionControllerV1Api - axios parameter creator
 * @export
 */
export const ClientSessionControllerV1ApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Get the customer data for a given client session. Returns empty values for Guest users
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionV1TenantCustomerGet: async (tenant, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("sessionV1TenantCustomerGet", "tenant", tenant);
      const localVarPath = `/session/v1/{tenant}/customer`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * ClientSessionControllerV1Api - functional programming interface
 * @export
 */
export const ClientSessionControllerV1ApiFp = function (configuration) {
  const localVarAxiosParamCreator = ClientSessionControllerV1ApiAxiosParamCreator(configuration);
  return {
    /**
     * Get the customer data for a given client session. Returns empty values for Guest users
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sessionV1TenantCustomerGet(tenant, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sessionV1TenantCustomerGet(tenant, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * ClientSessionControllerV1Api - factory interface
 * @export
 */
export const ClientSessionControllerV1ApiFactory = function (configuration, basePath, axios) {
  const localVarFp = ClientSessionControllerV1ApiFp(configuration);
  return {
    /**
     * Get the customer data for a given client session. Returns empty values for Guest users
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionV1TenantCustomerGet(tenant, options) {
      return localVarFp.sessionV1TenantCustomerGet(tenant, options).then((request) => request(axios, basePath));
    }
  };
};
/**
 * ClientSessionControllerV1Api - object-oriented interface
 * @export
 * @class ClientSessionControllerV1Api
 * @extends {BaseAPI}
 */
export class ClientSessionControllerV1Api extends BaseAPI {
  /**
   * Get the customer data for a given client session. Returns empty values for Guest users
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientSessionControllerV1Api
   */
  sessionV1TenantCustomerGet(tenant, options) {
    return ClientSessionControllerV1ApiFp(this.configuration)
      .sessionV1TenantCustomerGet(tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * ConfirmationPageControllerApi - axios parameter creator
 * @export
 */
export const ConfirmationPageControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @summary Returns the order by order number
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} shopOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    confirmationpageV1TenantConfirmationShopOrderIdGet: async (tenant, shopOrderId, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("confirmationpageV1TenantConfirmationShopOrderIdGet", "tenant", tenant);
      // verify required parameter 'shopOrderId' is not null or undefined
      assertParamExists("confirmationpageV1TenantConfirmationShopOrderIdGet", "shopOrderId", shopOrderId);
      const localVarPath = `/confirmationpage/v1/{tenant}/confirmation/{shopOrderId}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"shopOrderId"}}`, encodeURIComponent(String(shopOrderId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * ConfirmationPageControllerApi - functional programming interface
 * @export
 */
export const ConfirmationPageControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = ConfirmationPageControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Returns the order by order number
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} shopOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async confirmationpageV1TenantConfirmationShopOrderIdGet(tenant, shopOrderId, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.confirmationpageV1TenantConfirmationShopOrderIdGet(
        tenant,
        shopOrderId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * ConfirmationPageControllerApi - factory interface
 * @export
 */
export const ConfirmationPageControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = ConfirmationPageControllerApiFp(configuration);
  return {
    /**
     *
     * @summary Returns the order by order number
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} shopOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    confirmationpageV1TenantConfirmationShopOrderIdGet(tenant, shopOrderId, options) {
      return localVarFp
        .confirmationpageV1TenantConfirmationShopOrderIdGet(tenant, shopOrderId, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * ConfirmationPageControllerApi - object-oriented interface
 * @export
 * @class ConfirmationPageControllerApi
 * @extends {BaseAPI}
 */
export class ConfirmationPageControllerApi extends BaseAPI {
  /**
   *
   * @summary Returns the order by order number
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} shopOrderId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConfirmationPageControllerApi
   */
  confirmationpageV1TenantConfirmationShopOrderIdGet(tenant, shopOrderId, options) {
    return ConfirmationPageControllerApiFp(this.configuration)
      .confirmationpageV1TenantConfirmationShopOrderIdGet(tenant, shopOrderId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * ContactControllerApi - axios parameter creator
 * @export
 */
export const ContactControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {CallbackRequestV1} CallbackRequestV1
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    contactV1TenantLanguageCallbackPost: async (tenant, language, CallbackRequestV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("contactV1TenantLanguageCallbackPost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("contactV1TenantLanguageCallbackPost", "language", language);
      // verify required parameter 'CallbackRequestV1' is not null or undefined
      assertParamExists("contactV1TenantLanguageCallbackPost", "CallbackRequestV1", CallbackRequestV1);
      const localVarPath = `/contact/v1/{tenant}/{language}/callback`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(CallbackRequestV1, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {ContactRequestV1} ContactRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contactV1TenantLanguageContactPost: async (tenant, language, ContactRequestV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("contactV1TenantLanguageContactPost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("contactV1TenantLanguageContactPost", "language", language);
      // verify required parameter 'ContactRequestV1' is not null or undefined
      assertParamExists("contactV1TenantLanguageContactPost", "ContactRequestV1", ContactRequestV1);
      const localVarPath = `/contact/v1/{tenant}/{language}/contact`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(ContactRequestV1, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * ContactControllerApi - functional programming interface
 * @export
 */
export const ContactControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = ContactControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {CallbackRequestV1} CallbackRequestV1
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async contactV1TenantLanguageCallbackPost(tenant, language, CallbackRequestV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.contactV1TenantLanguageCallbackPost(
        tenant,
        language,
        CallbackRequestV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {ContactRequestV1} ContactRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contactV1TenantLanguageContactPost(tenant, language, ContactRequestV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.contactV1TenantLanguageContactPost(
        tenant,
        language,
        ContactRequestV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * ContactControllerApi - factory interface
 * @export
 */
export const ContactControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = ContactControllerApiFp(configuration);
  return {
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {CallbackRequestV1} CallbackRequestV1
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    contactV1TenantLanguageCallbackPost(tenant, language, CallbackRequestV1, options) {
      return localVarFp
        .contactV1TenantLanguageCallbackPost(tenant, language, CallbackRequestV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {ContactRequestV1} ContactRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contactV1TenantLanguageContactPost(tenant, language, ContactRequestV1, options) {
      return localVarFp
        .contactV1TenantLanguageContactPost(tenant, language, ContactRequestV1, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * ContactControllerApi - object-oriented interface
 * @export
 * @class ContactControllerApi
 * @extends {BaseAPI}
 */
export class ContactControllerApi extends BaseAPI {
  /**
   *
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {CallbackRequestV1} CallbackRequestV1
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof ContactControllerApi
   */
  contactV1TenantLanguageCallbackPost(tenant, language, CallbackRequestV1, options) {
    return ContactControllerApiFp(this.configuration)
      .contactV1TenantLanguageCallbackPost(tenant, language, CallbackRequestV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {ContactRequestV1} ContactRequestV1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactControllerApi
   */
  contactV1TenantLanguageContactPost(tenant, language, ContactRequestV1, options) {
    return ContactControllerApiFp(this.configuration)
      .contactV1TenantLanguageContactPost(tenant, language, ContactRequestV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * ContentControllerApi - axios parameter creator
 * @export
 */
export const ContentControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @param {'at-dev' | 'ch-dev' | 'com-dev' | 'es-dev' | 'fr-dev' | 'it-dev'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageContentV2TenantGet: async (tenant, language, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageContentV2TenantGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageContentV2TenantGet", "language", language);
      const localVarPath = `/{language}/content/v2/{tenant}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'ch-dev' | 'com-dev' | 'es-dev' | 'fr-dev' | 'it-dev'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {string} [fields] QueryParam fields
     * @param {string} [contentsFilter] QueryParam contentsFilter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageContentV2TenantIdGet: async (id, tenant, language, fields, contentsFilter, options = {}) => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("languageContentV2TenantIdGet", "id", id);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageContentV2TenantIdGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageContentV2TenantIdGet", "language", language);
      const localVarPath = `/{language}/content/v2/{tenant}/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (fields !== undefined) {
        localVarQueryParameter["fields"] = fields;
      }
      if (contentsFilter !== undefined) {
        localVarQueryParameter["contentsFilter"] = contentsFilter;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * ContentControllerApi - functional programming interface
 * @export
 */
export const ContentControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = ContentControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {'at-dev' | 'ch-dev' | 'com-dev' | 'es-dev' | 'fr-dev' | 'it-dev'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageContentV2TenantGet(tenant, language, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageContentV2TenantGet(tenant, language, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'ch-dev' | 'com-dev' | 'es-dev' | 'fr-dev' | 'it-dev'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {string} [fields] QueryParam fields
     * @param {string} [contentsFilter] QueryParam contentsFilter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageContentV2TenantIdGet(id, tenant, language, fields, contentsFilter, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageContentV2TenantIdGet(
        id,
        tenant,
        language,
        fields,
        contentsFilter,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * ContentControllerApi - factory interface
 * @export
 */
export const ContentControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = ContentControllerApiFp(configuration);
  return {
    /**
     *
     * @param {'at-dev' | 'ch-dev' | 'com-dev' | 'es-dev' | 'fr-dev' | 'it-dev'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageContentV2TenantGet(tenant, language, options) {
      return localVarFp
        .languageContentV2TenantGet(tenant, language, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'ch-dev' | 'com-dev' | 'es-dev' | 'fr-dev' | 'it-dev'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {string} [fields] QueryParam fields
     * @param {string} [contentsFilter] QueryParam contentsFilter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageContentV2TenantIdGet(id, tenant, language, fields, contentsFilter, options) {
      return localVarFp
        .languageContentV2TenantIdGet(id, tenant, language, fields, contentsFilter, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * ContentControllerApi - object-oriented interface
 * @export
 * @class ContentControllerApi
 * @extends {BaseAPI}
 */
export class ContentControllerApi extends BaseAPI {
  /**
   *
   * @param {'at-dev' | 'ch-dev' | 'com-dev' | 'es-dev' | 'fr-dev' | 'it-dev'} tenant ControllerParam tenant
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentControllerApi
   */
  languageContentV2TenantGet(tenant, language, options) {
    return ContentControllerApiFp(this.configuration)
      .languageContentV2TenantGet(tenant, language, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} id PathParam id
   * @param {'at-dev' | 'ch-dev' | 'com-dev' | 'es-dev' | 'fr-dev' | 'it-dev'} tenant ControllerParam tenant
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {string} [fields] QueryParam fields
   * @param {string} [contentsFilter] QueryParam contentsFilter
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentControllerApi
   */
  languageContentV2TenantIdGet(id, tenant, language, fields, contentsFilter, options) {
    return ContentControllerApiFp(this.configuration)
      .languageContentV2TenantIdGet(id, tenant, language, fields, contentsFilter, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * ContentControllerV3Api - axios parameter creator
 * @export
 */
export const ContentControllerV3ApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @param {string} code PathParam code
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageContentV3TenantBlocksCodeGet: async (code, tenant, language, options = {}) => {
      // verify required parameter 'code' is not null or undefined
      assertParamExists("languageContentV3TenantBlocksCodeGet", "code", code);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageContentV3TenantBlocksCodeGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageContentV3TenantBlocksCodeGet", "language", language);
      const localVarPath = `/{language}/content/v3/{tenant}/blocks/{code}`
        .replace(`{${"code"}}`, encodeURIComponent(String(code)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} categoryCode
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageContentV3TenantNodesByCodeCategoryCodeGet: async (categoryCode, tenant, language, options = {}) => {
      // verify required parameter 'categoryCode' is not null or undefined
      assertParamExists("languageContentV3TenantNodesByCodeCategoryCodeGet", "categoryCode", categoryCode);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageContentV3TenantNodesByCodeCategoryCodeGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageContentV3TenantNodesByCodeCategoryCodeGet", "language", language);
      const localVarPath = `/{language}/content/v3/{tenant}/nodes-by-code/{categoryCode}`
        .replace(`{${"categoryCode"}}`, encodeURIComponent(String(categoryCode)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} path PathParam path
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageContentV3TenantNodesPathGet: async (path, tenant, language, options = {}) => {
      // verify required parameter 'path' is not null or undefined
      assertParamExists("languageContentV3TenantNodesPathGet", "path", path);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageContentV3TenantNodesPathGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageContentV3TenantNodesPathGet", "language", language);
      const localVarPath = `/{language}/content/v3/{tenant}/nodes/{path}`
        .replace(`{${"path"}}`, encodeURIComponent(String(path)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} code PathParam code
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageContentV3TenantPageCodeGet: async (code, tenant, language, options = {}) => {
      // verify required parameter 'code' is not null or undefined
      assertParamExists("languageContentV3TenantPageCodeGet", "code", code);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageContentV3TenantPageCodeGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageContentV3TenantPageCodeGet", "language", language);
      const localVarPath = `/{language}/content/v3/{tenant}/page/{code}`
        .replace(`{${"code"}}`, encodeURIComponent(String(code)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageContentV3TenantPagesGet: async (tenant, language, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageContentV3TenantPagesGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageContentV3TenantPagesGet", "language", language);
      const localVarPath = `/{language}/content/v3/{tenant}/pages/}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} path PathParam path
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageContentV3TenantRoutePathGet: async (path, tenant, language, options = {}) => {
      // verify required parameter 'path' is not null or undefined
      assertParamExists("languageContentV3TenantRoutePathGet", "path", path);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageContentV3TenantRoutePathGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageContentV3TenantRoutePathGet", "language", language);
      const localVarPath = `/{language}/content/v3/{tenant}/route/{path}`
        .replace(`{${"path"}}`, encodeURIComponent(String(path)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * ContentControllerV3Api - functional programming interface
 * @export
 */
export const ContentControllerV3ApiFp = function (configuration) {
  const localVarAxiosParamCreator = ContentControllerV3ApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} code PathParam code
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageContentV3TenantBlocksCodeGet(code, tenant, language, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageContentV3TenantBlocksCodeGet(
        code,
        tenant,
        language,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} categoryCode
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageContentV3TenantNodesByCodeCategoryCodeGet(categoryCode, tenant, language, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageContentV3TenantNodesByCodeCategoryCodeGet(
        categoryCode,
        tenant,
        language,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} path PathParam path
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageContentV3TenantNodesPathGet(path, tenant, language, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageContentV3TenantNodesPathGet(
        path,
        tenant,
        language,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} code PathParam code
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageContentV3TenantPageCodeGet(code, tenant, language, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageContentV3TenantPageCodeGet(
        code,
        tenant,
        language,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageContentV3TenantPagesGet(tenant, language, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageContentV3TenantPagesGet(
        tenant,
        language,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} path PathParam path
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageContentV3TenantRoutePathGet(path, tenant, language, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageContentV3TenantRoutePathGet(
        path,
        tenant,
        language,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * ContentControllerV3Api - factory interface
 * @export
 */
export const ContentControllerV3ApiFactory = function (configuration, basePath, axios) {
  const localVarFp = ContentControllerV3ApiFp(configuration);
  return {
    /**
     *
     * @param {string} code PathParam code
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageContentV3TenantBlocksCodeGet(code, tenant, language, options) {
      return localVarFp
        .languageContentV3TenantBlocksCodeGet(code, tenant, language, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} categoryCode
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageContentV3TenantNodesByCodeCategoryCodeGet(categoryCode, tenant, language, options) {
      return localVarFp
        .languageContentV3TenantNodesByCodeCategoryCodeGet(categoryCode, tenant, language, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} path PathParam path
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageContentV3TenantNodesPathGet(path, tenant, language, options) {
      return localVarFp
        .languageContentV3TenantNodesPathGet(path, tenant, language, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} code PathParam code
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageContentV3TenantPageCodeGet(code, tenant, language, options) {
      return localVarFp
        .languageContentV3TenantPageCodeGet(code, tenant, language, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageContentV3TenantPagesGet(tenant, language, options) {
      return localVarFp
        .languageContentV3TenantPagesGet(tenant, language, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} path PathParam path
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageContentV3TenantRoutePathGet(path, tenant, language, options) {
      return localVarFp
        .languageContentV3TenantRoutePathGet(path, tenant, language, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * ContentControllerV3Api - object-oriented interface
 * @export
 * @class ContentControllerV3Api
 * @extends {BaseAPI}
 */
export class ContentControllerV3Api extends BaseAPI {
  /**
   *
   * @param {string} code PathParam code
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentControllerV3Api
   */
  languageContentV3TenantBlocksCodeGet(code, tenant, language, options) {
    return ContentControllerV3ApiFp(this.configuration)
      .languageContentV3TenantBlocksCodeGet(code, tenant, language, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} categoryCode
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentControllerV3Api
   */
  languageContentV3TenantNodesByCodeCategoryCodeGet(categoryCode, tenant, language, options) {
    return ContentControllerV3ApiFp(this.configuration)
      .languageContentV3TenantNodesByCodeCategoryCodeGet(categoryCode, tenant, language, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} path PathParam path
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentControllerV3Api
   */
  languageContentV3TenantNodesPathGet(path, tenant, language, options) {
    return ContentControllerV3ApiFp(this.configuration)
      .languageContentV3TenantNodesPathGet(path, tenant, language, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} code PathParam code
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentControllerV3Api
   */
  languageContentV3TenantPageCodeGet(code, tenant, language, options) {
    return ContentControllerV3ApiFp(this.configuration)
      .languageContentV3TenantPageCodeGet(code, tenant, language, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentControllerV3Api
   */
  languageContentV3TenantPagesGet(tenant, language, options) {
    return ContentControllerV3ApiFp(this.configuration)
      .languageContentV3TenantPagesGet(tenant, language, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} path PathParam path
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentControllerV3Api
   */
  languageContentV3TenantRoutePathGet(path, tenant, language, options) {
    return ContentControllerV3ApiFp(this.configuration)
      .languageContentV3TenantRoutePathGet(path, tenant, language, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * CreditBalanceControllerV1Api - axios parameter creator
 * @export
 */
export const CreditBalanceControllerV1ApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Gets eligible credit for currently logged in user
     * @param {string} tenant
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creditBalanceV1TenantLanguageGetEligibleCreditForCurrentUserGet: async (tenant, language, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("creditBalanceV1TenantLanguageGetEligibleCreditForCurrentUserGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("creditBalanceV1TenantLanguageGetEligibleCreditForCurrentUserGet", "language", language);
      const localVarPath = `/creditBalance/v1/{tenant}/{language}/getEligibleCreditForCurrentUser`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * CreditBalanceControllerV1Api - functional programming interface
 * @export
 */
export const CreditBalanceControllerV1ApiFp = function (configuration) {
  const localVarAxiosParamCreator = CreditBalanceControllerV1ApiAxiosParamCreator(configuration);
  return {
    /**
     * Gets eligible credit for currently logged in user
     * @param {string} tenant
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async creditBalanceV1TenantLanguageGetEligibleCreditForCurrentUserGet(tenant, language, options) {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.creditBalanceV1TenantLanguageGetEligibleCreditForCurrentUserGet(
          tenant,
          language,
          options
        );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * CreditBalanceControllerV1Api - factory interface
 * @export
 */
export const CreditBalanceControllerV1ApiFactory = function (configuration, basePath, axios) {
  const localVarFp = CreditBalanceControllerV1ApiFp(configuration);
  return {
    /**
     * Gets eligible credit for currently logged in user
     * @param {string} tenant
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creditBalanceV1TenantLanguageGetEligibleCreditForCurrentUserGet(tenant, language, options) {
      return localVarFp
        .creditBalanceV1TenantLanguageGetEligibleCreditForCurrentUserGet(tenant, language, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * CreditBalanceControllerV1Api - object-oriented interface
 * @export
 * @class CreditBalanceControllerV1Api
 * @extends {BaseAPI}
 */
export class CreditBalanceControllerV1Api extends BaseAPI {
  /**
   * Gets eligible credit for currently logged in user
   * @param {string} tenant
   * @param {string} language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreditBalanceControllerV1Api
   */
  creditBalanceV1TenantLanguageGetEligibleCreditForCurrentUserGet(tenant, language, options) {
    return CreditBalanceControllerV1ApiFp(this.configuration)
      .creditBalanceV1TenantLanguageGetEligibleCreditForCurrentUserGet(tenant, language, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * CrosssellersControllerV1Api - axios parameter creator
 * @export
 */
export const CrosssellersControllerV1ApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Get data about crossselers
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crosssellersV1TenantLanguageGet: async (tenant, language, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("crosssellersV1TenantLanguageGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("crosssellersV1TenantLanguageGet", "language", language);
      const localVarPath = `/crosssellers/v1/{tenant}/{language}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * CrosssellersControllerV1Api - functional programming interface
 * @export
 */
export const CrosssellersControllerV1ApiFp = function (configuration) {
  const localVarAxiosParamCreator = CrosssellersControllerV1ApiAxiosParamCreator(configuration);
  return {
    /**
     * Get data about crossselers
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async crosssellersV1TenantLanguageGet(tenant, language, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.crosssellersV1TenantLanguageGet(
        tenant,
        language,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * CrosssellersControllerV1Api - factory interface
 * @export
 */
export const CrosssellersControllerV1ApiFactory = function (configuration, basePath, axios) {
  const localVarFp = CrosssellersControllerV1ApiFp(configuration);
  return {
    /**
     * Get data about crossselers
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    crosssellersV1TenantLanguageGet(tenant, language, options) {
      return localVarFp
        .crosssellersV1TenantLanguageGet(tenant, language, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * CrosssellersControllerV1Api - object-oriented interface
 * @export
 * @class CrosssellersControllerV1Api
 * @extends {BaseAPI}
 */
export class CrosssellersControllerV1Api extends BaseAPI {
  /**
   * Get data about crossselers
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CrosssellersControllerV1Api
   */
  crosssellersV1TenantLanguageGet(tenant, language, options) {
    return CrosssellersControllerV1ApiFp(this.configuration)
      .crosssellersV1TenantLanguageGet(tenant, language, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * CustomerDataControllerApi - axios parameter creator
 * @export
 */
export const CustomerDataControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * This endpoint allows to import a JSON String representation of customer data from LMS based systems. Use only with service token.
     * @param {CustomerDataSyncBlob} [CustomerDataSyncBlob]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerV1SyncLmsPost: async (CustomerDataSyncBlob, options = {}) => {
      const localVarPath = `/customer/v1/sync/lms`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(CustomerDataSyncBlob, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Initiate email change. Validates the email, password and sends link for verification .
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {CustomerDataChangeEmail} [CustomerDataChangeEmail]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerV1TenantChangeEmailPost: async (tenant, CustomerDataChangeEmail, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("customerV1TenantChangeEmailPost", "tenant", tenant);
      const localVarPath = `/customer/v1/{tenant}/changeEmail`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        CustomerDataChangeEmail,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * This endpoint allows to change the user\'s birthday for use in e.g. change birthday page in account area. User should be minimum 18 years old.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {CustomerDataChangeDateOfBirth} [CustomerDataChangeDateOfBirth]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerV1TenantDateOfBirthPatch: async (tenant, CustomerDataChangeDateOfBirth, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("customerV1TenantDateOfBirthPatch", "tenant", tenant);
      const localVarPath = `/customer/v1/{tenant}/dateOfBirth`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "PATCH", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        CustomerDataChangeDateOfBirth,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * On user confirmation this API endpoint will update the email for the customer and send out confirmation mails.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} emailToken Token issued by CDS or LMS to update customers email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerV1TenantEmailEmailTokenPatch: async (tenant, emailToken, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("customerV1TenantEmailEmailTokenPatch", "tenant", tenant);
      // verify required parameter 'emailToken' is not null or undefined
      assertParamExists("customerV1TenantEmailEmailTokenPatch", "emailToken", emailToken);
      const localVarPath = `/customer/v1/{tenant}/email/{emailToken}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"emailToken"}}`, encodeURIComponent(String(emailToken)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "PATCH", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * This endpoint allows to change the user\'s preferred language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {CustomerDataChangePreferredLanguage} [CustomerDataChangePreferredLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerV1TenantPreferredLanguagePatch: async (tenant, CustomerDataChangePreferredLanguage, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("customerV1TenantPreferredLanguagePatch", "tenant", tenant);
      const localVarPath = `/customer/v1/{tenant}/preferredLanguage`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "PATCH", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        CustomerDataChangePreferredLanguage,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * CustomerDataControllerApi - functional programming interface
 * @export
 */
export const CustomerDataControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = CustomerDataControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * This endpoint allows to import a JSON String representation of customer data from LMS based systems. Use only with service token.
     * @param {CustomerDataSyncBlob} [CustomerDataSyncBlob]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async customerV1SyncLmsPost(CustomerDataSyncBlob, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.customerV1SyncLmsPost(CustomerDataSyncBlob, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Initiate email change. Validates the email, password and sends link for verification .
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {CustomerDataChangeEmail} [CustomerDataChangeEmail]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async customerV1TenantChangeEmailPost(tenant, CustomerDataChangeEmail, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.customerV1TenantChangeEmailPost(
        tenant,
        CustomerDataChangeEmail,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * This endpoint allows to change the user\'s birthday for use in e.g. change birthday page in account area. User should be minimum 18 years old.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {CustomerDataChangeDateOfBirth} [CustomerDataChangeDateOfBirth]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async customerV1TenantDateOfBirthPatch(tenant, CustomerDataChangeDateOfBirth, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.customerV1TenantDateOfBirthPatch(
        tenant,
        CustomerDataChangeDateOfBirth,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * On user confirmation this API endpoint will update the email for the customer and send out confirmation mails.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} emailToken Token issued by CDS or LMS to update customers email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async customerV1TenantEmailEmailTokenPatch(tenant, emailToken, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.customerV1TenantEmailEmailTokenPatch(
        tenant,
        emailToken,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * This endpoint allows to change the user\'s preferred language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {CustomerDataChangePreferredLanguage} [CustomerDataChangePreferredLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async customerV1TenantPreferredLanguagePatch(tenant, CustomerDataChangePreferredLanguage, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.customerV1TenantPreferredLanguagePatch(
        tenant,
        CustomerDataChangePreferredLanguage,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * CustomerDataControllerApi - factory interface
 * @export
 */
export const CustomerDataControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = CustomerDataControllerApiFp(configuration);
  return {
    /**
     * This endpoint allows to import a JSON String representation of customer data from LMS based systems. Use only with service token.
     * @param {CustomerDataSyncBlob} [CustomerDataSyncBlob]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerV1SyncLmsPost(CustomerDataSyncBlob, options) {
      return localVarFp
        .customerV1SyncLmsPost(CustomerDataSyncBlob, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Initiate email change. Validates the email, password and sends link for verification .
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {CustomerDataChangeEmail} [CustomerDataChangeEmail]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerV1TenantChangeEmailPost(tenant, CustomerDataChangeEmail, options) {
      return localVarFp
        .customerV1TenantChangeEmailPost(tenant, CustomerDataChangeEmail, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * This endpoint allows to change the user\'s birthday for use in e.g. change birthday page in account area. User should be minimum 18 years old.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {CustomerDataChangeDateOfBirth} [CustomerDataChangeDateOfBirth]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerV1TenantDateOfBirthPatch(tenant, CustomerDataChangeDateOfBirth, options) {
      return localVarFp
        .customerV1TenantDateOfBirthPatch(tenant, CustomerDataChangeDateOfBirth, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * On user confirmation this API endpoint will update the email for the customer and send out confirmation mails.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} emailToken Token issued by CDS or LMS to update customers email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerV1TenantEmailEmailTokenPatch(tenant, emailToken, options) {
      return localVarFp
        .customerV1TenantEmailEmailTokenPatch(tenant, emailToken, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * This endpoint allows to change the user\'s preferred language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {CustomerDataChangePreferredLanguage} [CustomerDataChangePreferredLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerV1TenantPreferredLanguagePatch(tenant, CustomerDataChangePreferredLanguage, options) {
      return localVarFp
        .customerV1TenantPreferredLanguagePatch(tenant, CustomerDataChangePreferredLanguage, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * CustomerDataControllerApi - object-oriented interface
 * @export
 * @class CustomerDataControllerApi
 * @extends {BaseAPI}
 */
export class CustomerDataControllerApi extends BaseAPI {
  /**
   * This endpoint allows to import a JSON String representation of customer data from LMS based systems. Use only with service token.
   * @param {CustomerDataSyncBlob} [CustomerDataSyncBlob]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerDataControllerApi
   */
  customerV1SyncLmsPost(CustomerDataSyncBlob, options) {
    return CustomerDataControllerApiFp(this.configuration)
      .customerV1SyncLmsPost(CustomerDataSyncBlob, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Initiate email change. Validates the email, password and sends link for verification .
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {CustomerDataChangeEmail} [CustomerDataChangeEmail]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerDataControllerApi
   */
  customerV1TenantChangeEmailPost(tenant, CustomerDataChangeEmail, options) {
    return CustomerDataControllerApiFp(this.configuration)
      .customerV1TenantChangeEmailPost(tenant, CustomerDataChangeEmail, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * This endpoint allows to change the user\'s birthday for use in e.g. change birthday page in account area. User should be minimum 18 years old.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {CustomerDataChangeDateOfBirth} [CustomerDataChangeDateOfBirth]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerDataControllerApi
   */
  customerV1TenantDateOfBirthPatch(tenant, CustomerDataChangeDateOfBirth, options) {
    return CustomerDataControllerApiFp(this.configuration)
      .customerV1TenantDateOfBirthPatch(tenant, CustomerDataChangeDateOfBirth, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * On user confirmation this API endpoint will update the email for the customer and send out confirmation mails.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} emailToken Token issued by CDS or LMS to update customers email
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerDataControllerApi
   */
  customerV1TenantEmailEmailTokenPatch(tenant, emailToken, options) {
    return CustomerDataControllerApiFp(this.configuration)
      .customerV1TenantEmailEmailTokenPatch(tenant, emailToken, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * This endpoint allows to change the user\'s preferred language
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {CustomerDataChangePreferredLanguage} [CustomerDataChangePreferredLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerDataControllerApi
   */
  customerV1TenantPreferredLanguagePatch(tenant, CustomerDataChangePreferredLanguage, options) {
    return CustomerDataControllerApiFp(this.configuration)
      .customerV1TenantPreferredLanguagePatch(tenant, CustomerDataChangePreferredLanguage, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * EmailVerificationControllerApi - axios parameter creator
 * @export
 */
export const EmailVerificationControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @param {string} email PathParam email
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageEmailverificationV1TenantEmailGet: async (email, tenant, language, options = {}) => {
      // verify required parameter 'email' is not null or undefined
      assertParamExists("languageEmailverificationV1TenantEmailGet", "email", email);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageEmailverificationV1TenantEmailGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageEmailverificationV1TenantEmailGet", "language", language);
      const localVarPath = `/{language}/emailverification/v1/{tenant}/{email}`
        .replace(`{${"email"}}`, encodeURIComponent(String(email)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * EmailVerificationControllerApi - functional programming interface
 * @export
 */
export const EmailVerificationControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = EmailVerificationControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} email PathParam email
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageEmailverificationV1TenantEmailGet(email, tenant, language, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageEmailverificationV1TenantEmailGet(
        email,
        tenant,
        language,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * EmailVerificationControllerApi - factory interface
 * @export
 */
export const EmailVerificationControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = EmailVerificationControllerApiFp(configuration);
  return {
    /**
     *
     * @param {string} email PathParam email
     * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageEmailverificationV1TenantEmailGet(email, tenant, language, options) {
      return localVarFp
        .languageEmailverificationV1TenantEmailGet(email, tenant, language, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * EmailVerificationControllerApi - object-oriented interface
 * @export
 * @class EmailVerificationControllerApi
 * @extends {BaseAPI}
 */
export class EmailVerificationControllerApi extends BaseAPI {
  /**
   *
   * @param {string} email PathParam email
   * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EmailVerificationControllerApi
   */
  languageEmailverificationV1TenantEmailGet(email, tenant, language, options) {
    return EmailVerificationControllerApiFp(this.configuration)
      .languageEmailverificationV1TenantEmailGet(email, tenant, language, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * FaqControllerApi - axios parameter creator
 * @export
 */
export const FaqControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @param {string} famId PathParam famId
     * @param {'com'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageFaqV2TenantFamIdGet: async (famId, tenant, language, options = {}) => {
      // verify required parameter 'famId' is not null or undefined
      assertParamExists("languageFaqV2TenantFamIdGet", "famId", famId);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageFaqV2TenantFamIdGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageFaqV2TenantFamIdGet", "language", language);
      const localVarPath = `/{language}/faq/v2/{tenant}/{famId}`
        .replace(`{${"famId"}}`, encodeURIComponent(String(famId)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} pzn PathParam pzn
     * @param {'com'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageFaqV2TenantPznPznGet: async (pzn, tenant, language, options = {}) => {
      // verify required parameter 'pzn' is not null or undefined
      assertParamExists("languageFaqV2TenantPznPznGet", "pzn", pzn);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageFaqV2TenantPznPznGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageFaqV2TenantPznPznGet", "language", language);
      const localVarPath = `/{language}/faq/v2/{tenant}/pzn/{pzn}`
        .replace(`{${"pzn"}}`, encodeURIComponent(String(pzn)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * FaqControllerApi - functional programming interface
 * @export
 */
export const FaqControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = FaqControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} famId PathParam famId
     * @param {'com'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageFaqV2TenantFamIdGet(famId, tenant, language, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageFaqV2TenantFamIdGet(
        famId,
        tenant,
        language,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} pzn PathParam pzn
     * @param {'com'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageFaqV2TenantPznPznGet(pzn, tenant, language, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageFaqV2TenantPznPznGet(
        pzn,
        tenant,
        language,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * FaqControllerApi - factory interface
 * @export
 */
export const FaqControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = FaqControllerApiFp(configuration);
  return {
    /**
     *
     * @param {string} famId PathParam famId
     * @param {'com'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageFaqV2TenantFamIdGet(famId, tenant, language, options) {
      return localVarFp
        .languageFaqV2TenantFamIdGet(famId, tenant, language, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} pzn PathParam pzn
     * @param {'com'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageFaqV2TenantPznPznGet(pzn, tenant, language, options) {
      return localVarFp
        .languageFaqV2TenantPznPznGet(pzn, tenant, language, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * FaqControllerApi - object-oriented interface
 * @export
 * @class FaqControllerApi
 * @extends {BaseAPI}
 */
export class FaqControllerApi extends BaseAPI {
  /**
   *
   * @param {string} famId PathParam famId
   * @param {'com'} tenant ControllerParam tenant
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FaqControllerApi
   */
  languageFaqV2TenantFamIdGet(famId, tenant, language, options) {
    return FaqControllerApiFp(this.configuration)
      .languageFaqV2TenantFamIdGet(famId, tenant, language, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} pzn PathParam pzn
   * @param {'com'} tenant ControllerParam tenant
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FaqControllerApi
   */
  languageFaqV2TenantPznPznGet(pzn, tenant, language, options) {
    return FaqControllerApiFp(this.configuration)
      .languageFaqV2TenantPznPznGet(pzn, tenant, language, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * GtmControllerApi - axios parameter creator
 * @export
 */
export const GtmControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'login' | 'registration'} [after] origin page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageGtmDataLayerV1TenantEventsAccountOverviewGet: async (language, tenant, after, options = {}) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageGtmDataLayerV1TenantEventsAccountOverviewGet", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageGtmDataLayerV1TenantEventsAccountOverviewGet", "tenant", tenant);
      const localVarPath = `/{language}/gtmDataLayer/v1/{tenant}/events/account_overview`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (after !== undefined) {
        localVarQueryParameter["after"] = after;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageGtmDataLayerV1TenantEventsCartGet: async (language, tenant, options = {}) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageGtmDataLayerV1TenantEventsCartGet", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageGtmDataLayerV1TenantEventsCartGet", "tenant", tenant);
      const localVarPath = `/{language}/gtmDataLayer/v1/{tenant}/events/cart`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {string} [prescriptionType] QueryParam prescriptionType
     * @param {string} [upid] QueryParam upid
     * @param {string} [hashedTokens] QueryParam hashedTokens
     * @param {number} [quantity] QueryParam quantity
     * @param {string} [channel] Channel based pricing for the product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageGtmDataLayerV1TenantEventsCartintermediateGet: async (
      language,
      tenant,
      prescriptionType,
      upid,
      hashedTokens,
      quantity,
      channel,
      options = {}
    ) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageGtmDataLayerV1TenantEventsCartintermediateGet", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageGtmDataLayerV1TenantEventsCartintermediateGet", "tenant", tenant);
      const localVarPath = `/{language}/gtmDataLayer/v1/{tenant}/events/cartintermediate`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (prescriptionType !== undefined) {
        localVarQueryParameter["prescriptionType"] = prescriptionType;
      }
      if (upid !== undefined) {
        localVarQueryParameter["upid"] = upid;
      }
      if (hashedTokens !== undefined) {
        localVarQueryParameter["hashedTokens"] = hashedTokens;
      }
      if (quantity !== undefined) {
        localVarQueryParameter["quantity"] = quantity;
      }
      if (channel !== undefined) {
        localVarQueryParameter["channel"] = channel;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageGtmDataLayerV1TenantEventsCheckoutConfirmationGet: async (language, tenant, options = {}) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageGtmDataLayerV1TenantEventsCheckoutConfirmationGet", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageGtmDataLayerV1TenantEventsCheckoutConfirmationGet", "tenant", tenant);
      const localVarPath = `/{language}/gtmDataLayer/v1/{tenant}/events/checkout_confirmation`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} orderDraftId origin page
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'login' | 'registration'} [after] origin page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageGtmDataLayerV1TenantEventsCheckoutGet: async (orderDraftId, language, tenant, after, options = {}) => {
      // verify required parameter 'orderDraftId' is not null or undefined
      assertParamExists("languageGtmDataLayerV1TenantEventsCheckoutGet", "orderDraftId", orderDraftId);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageGtmDataLayerV1TenantEventsCheckoutGet", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageGtmDataLayerV1TenantEventsCheckoutGet", "tenant", tenant);
      const localVarPath = `/{language}/gtmDataLayer/v1/{tenant}/events/checkout`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (orderDraftId !== undefined) {
        localVarQueryParameter["orderDraftId"] = orderDraftId;
      }
      if (after !== undefined) {
        localVarQueryParameter["after"] = after;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {Array<string>} upids origin page
     * @param {Array<string>} offerIds origin page
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {string} [channel] Channel based pricing for the product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageGtmDataLayerV1TenantEventsOfferGet: async (upids, offerIds, language, tenant, channel, options = {}) => {
      // verify required parameter 'upids' is not null or undefined
      assertParamExists("languageGtmDataLayerV1TenantEventsOfferGet", "upids", upids);
      // verify required parameter 'offerIds' is not null or undefined
      assertParamExists("languageGtmDataLayerV1TenantEventsOfferGet", "offerIds", offerIds);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageGtmDataLayerV1TenantEventsOfferGet", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageGtmDataLayerV1TenantEventsOfferGet", "tenant", tenant);
      const localVarPath = `/{language}/gtmDataLayer/v1/{tenant}/events/offer`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (upids) {
        localVarQueryParameter["upids"] = upids;
      }
      if (offerIds) {
        localVarQueryParameter["offerIds"] = offerIds;
      }
      if (channel !== undefined) {
        localVarQueryParameter["channel"] = channel;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {Array<string>} upids origin page
     * @param {Array<string>} offerIds origin page
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'login' | 'registration'} [after] origin page
     * @param {string} [channel] Channel based pricing for the product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageGtmDataLayerV1TenantEventsProductGet: async (
      upids,
      offerIds,
      language,
      tenant,
      after,
      channel,
      options = {}
    ) => {
      // verify required parameter 'upids' is not null or undefined
      assertParamExists("languageGtmDataLayerV1TenantEventsProductGet", "upids", upids);
      // verify required parameter 'offerIds' is not null or undefined
      assertParamExists("languageGtmDataLayerV1TenantEventsProductGet", "offerIds", offerIds);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageGtmDataLayerV1TenantEventsProductGet", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageGtmDataLayerV1TenantEventsProductGet", "tenant", tenant);
      const localVarPath = `/{language}/gtmDataLayer/v1/{tenant}/events/product`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (upids) {
        localVarQueryParameter["upids"] = upids;
      }
      if (offerIds) {
        localVarQueryParameter["offerIds"] = offerIds;
      }
      if (after !== undefined) {
        localVarQueryParameter["after"] = after;
      }
      if (channel !== undefined) {
        localVarQueryParameter["channel"] = channel;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageGtmDataLayerV1TenantGet: async (language, tenant, options = {}) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageGtmDataLayerV1TenantGet", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageGtmDataLayerV1TenantGet", "tenant", tenant);
      const localVarPath = `/{language}/gtmDataLayer/v1/{tenant}`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * GtmControllerApi - functional programming interface
 * @export
 */
export const GtmControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = GtmControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'login' | 'registration'} [after] origin page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageGtmDataLayerV1TenantEventsAccountOverviewGet(language, tenant, after, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageGtmDataLayerV1TenantEventsAccountOverviewGet(
        language,
        tenant,
        after,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageGtmDataLayerV1TenantEventsCartGet(language, tenant, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageGtmDataLayerV1TenantEventsCartGet(
        language,
        tenant,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {string} [prescriptionType] QueryParam prescriptionType
     * @param {string} [upid] QueryParam upid
     * @param {string} [hashedTokens] QueryParam hashedTokens
     * @param {number} [quantity] QueryParam quantity
     * @param {string} [channel] Channel based pricing for the product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageGtmDataLayerV1TenantEventsCartintermediateGet(
      language,
      tenant,
      prescriptionType,
      upid,
      hashedTokens,
      quantity,
      channel,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageGtmDataLayerV1TenantEventsCartintermediateGet(
        language,
        tenant,
        prescriptionType,
        upid,
        hashedTokens,
        quantity,
        channel,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageGtmDataLayerV1TenantEventsCheckoutConfirmationGet(language, tenant, options) {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.languageGtmDataLayerV1TenantEventsCheckoutConfirmationGet(
          language,
          tenant,
          options
        );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orderDraftId origin page
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'login' | 'registration'} [after] origin page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageGtmDataLayerV1TenantEventsCheckoutGet(orderDraftId, language, tenant, after, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageGtmDataLayerV1TenantEventsCheckoutGet(
        orderDraftId,
        language,
        tenant,
        after,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {Array<string>} upids origin page
     * @param {Array<string>} offerIds origin page
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {string} [channel] Channel based pricing for the product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageGtmDataLayerV1TenantEventsOfferGet(upids, offerIds, language, tenant, channel, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageGtmDataLayerV1TenantEventsOfferGet(
        upids,
        offerIds,
        language,
        tenant,
        channel,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {Array<string>} upids origin page
     * @param {Array<string>} offerIds origin page
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'login' | 'registration'} [after] origin page
     * @param {string} [channel] Channel based pricing for the product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageGtmDataLayerV1TenantEventsProductGet(upids, offerIds, language, tenant, after, channel, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageGtmDataLayerV1TenantEventsProductGet(
        upids,
        offerIds,
        language,
        tenant,
        after,
        channel,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageGtmDataLayerV1TenantGet(language, tenant, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageGtmDataLayerV1TenantGet(
        language,
        tenant,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * GtmControllerApi - factory interface
 * @export
 */
export const GtmControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = GtmControllerApiFp(configuration);
  return {
    /**
     *
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'login' | 'registration'} [after] origin page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageGtmDataLayerV1TenantEventsAccountOverviewGet(language, tenant, after, options) {
      return localVarFp
        .languageGtmDataLayerV1TenantEventsAccountOverviewGet(language, tenant, after, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageGtmDataLayerV1TenantEventsCartGet(language, tenant, options) {
      return localVarFp
        .languageGtmDataLayerV1TenantEventsCartGet(language, tenant, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {string} [prescriptionType] QueryParam prescriptionType
     * @param {string} [upid] QueryParam upid
     * @param {string} [hashedTokens] QueryParam hashedTokens
     * @param {number} [quantity] QueryParam quantity
     * @param {string} [channel] Channel based pricing for the product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageGtmDataLayerV1TenantEventsCartintermediateGet(
      language,
      tenant,
      prescriptionType,
      upid,
      hashedTokens,
      quantity,
      channel,
      options
    ) {
      return localVarFp
        .languageGtmDataLayerV1TenantEventsCartintermediateGet(
          language,
          tenant,
          prescriptionType,
          upid,
          hashedTokens,
          quantity,
          channel,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageGtmDataLayerV1TenantEventsCheckoutConfirmationGet(language, tenant, options) {
      return localVarFp
        .languageGtmDataLayerV1TenantEventsCheckoutConfirmationGet(language, tenant, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orderDraftId origin page
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'login' | 'registration'} [after] origin page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageGtmDataLayerV1TenantEventsCheckoutGet(orderDraftId, language, tenant, after, options) {
      return localVarFp
        .languageGtmDataLayerV1TenantEventsCheckoutGet(orderDraftId, language, tenant, after, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {Array<string>} upids origin page
     * @param {Array<string>} offerIds origin page
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {string} [channel] Channel based pricing for the product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageGtmDataLayerV1TenantEventsOfferGet(upids, offerIds, language, tenant, channel, options) {
      return localVarFp
        .languageGtmDataLayerV1TenantEventsOfferGet(upids, offerIds, language, tenant, channel, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {Array<string>} upids origin page
     * @param {Array<string>} offerIds origin page
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'login' | 'registration'} [after] origin page
     * @param {string} [channel] Channel based pricing for the product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageGtmDataLayerV1TenantEventsProductGet(upids, offerIds, language, tenant, after, channel, options) {
      return localVarFp
        .languageGtmDataLayerV1TenantEventsProductGet(upids, offerIds, language, tenant, after, channel, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageGtmDataLayerV1TenantGet(language, tenant, options) {
      return localVarFp
        .languageGtmDataLayerV1TenantGet(language, tenant, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * GtmControllerApi - object-oriented interface
 * @export
 * @class GtmControllerApi
 * @extends {BaseAPI}
 */
export class GtmControllerApi extends BaseAPI {
  /**
   *
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
   * @param {'login' | 'registration'} [after] origin page
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GtmControllerApi
   */
  languageGtmDataLayerV1TenantEventsAccountOverviewGet(language, tenant, after, options) {
    return GtmControllerApiFp(this.configuration)
      .languageGtmDataLayerV1TenantEventsAccountOverviewGet(language, tenant, after, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GtmControllerApi
   */
  languageGtmDataLayerV1TenantEventsCartGet(language, tenant, options) {
    return GtmControllerApiFp(this.configuration)
      .languageGtmDataLayerV1TenantEventsCartGet(language, tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
   * @param {string} [prescriptionType] QueryParam prescriptionType
   * @param {string} [upid] QueryParam upid
   * @param {string} [hashedTokens] QueryParam hashedTokens
   * @param {number} [quantity] QueryParam quantity
   * @param {string} [channel] Channel based pricing for the product
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GtmControllerApi
   */
  languageGtmDataLayerV1TenantEventsCartintermediateGet(
    language,
    tenant,
    prescriptionType,
    upid,
    hashedTokens,
    quantity,
    channel,
    options
  ) {
    return GtmControllerApiFp(this.configuration)
      .languageGtmDataLayerV1TenantEventsCartintermediateGet(
        language,
        tenant,
        prescriptionType,
        upid,
        hashedTokens,
        quantity,
        channel,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GtmControllerApi
   */
  languageGtmDataLayerV1TenantEventsCheckoutConfirmationGet(language, tenant, options) {
    return GtmControllerApiFp(this.configuration)
      .languageGtmDataLayerV1TenantEventsCheckoutConfirmationGet(language, tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} orderDraftId origin page
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
   * @param {'login' | 'registration'} [after] origin page
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GtmControllerApi
   */
  languageGtmDataLayerV1TenantEventsCheckoutGet(orderDraftId, language, tenant, after, options) {
    return GtmControllerApiFp(this.configuration)
      .languageGtmDataLayerV1TenantEventsCheckoutGet(orderDraftId, language, tenant, after, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {Array<string>} upids origin page
   * @param {Array<string>} offerIds origin page
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
   * @param {string} [channel] Channel based pricing for the product
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GtmControllerApi
   */
  languageGtmDataLayerV1TenantEventsOfferGet(upids, offerIds, language, tenant, channel, options) {
    return GtmControllerApiFp(this.configuration)
      .languageGtmDataLayerV1TenantEventsOfferGet(upids, offerIds, language, tenant, channel, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {Array<string>} upids origin page
   * @param {Array<string>} offerIds origin page
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
   * @param {'login' | 'registration'} [after] origin page
   * @param {string} [channel] Channel based pricing for the product
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GtmControllerApi
   */
  languageGtmDataLayerV1TenantEventsProductGet(upids, offerIds, language, tenant, after, channel, options) {
    return GtmControllerApiFp(this.configuration)
      .languageGtmDataLayerV1TenantEventsProductGet(upids, offerIds, language, tenant, after, channel, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GtmControllerApi
   */
  languageGtmDataLayerV1TenantGet(language, tenant, options) {
    return GtmControllerApiFp(this.configuration)
      .languageGtmDataLayerV1TenantGet(language, tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * KlarnaDataControllerApi - axios parameter creator
 * @export
 */
export const KlarnaDataControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * transform and anonymize order
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {KlarnaDataOrderDraft} KlarnaDataOrderDraft
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    klarnaDataV1TenantTransformPost: async (tenant, KlarnaDataOrderDraft, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("klarnaDataV1TenantTransformPost", "tenant", tenant);
      // verify required parameter 'KlarnaDataOrderDraft' is not null or undefined
      assertParamExists("klarnaDataV1TenantTransformPost", "KlarnaDataOrderDraft", KlarnaDataOrderDraft);
      const localVarPath = `/klarna-data/v1/{tenant}/transform`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(KlarnaDataOrderDraft, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * KlarnaDataControllerApi - functional programming interface
 * @export
 */
export const KlarnaDataControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = KlarnaDataControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * transform and anonymize order
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {KlarnaDataOrderDraft} KlarnaDataOrderDraft
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async klarnaDataV1TenantTransformPost(tenant, KlarnaDataOrderDraft, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.klarnaDataV1TenantTransformPost(
        tenant,
        KlarnaDataOrderDraft,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * KlarnaDataControllerApi - factory interface
 * @export
 */
export const KlarnaDataControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = KlarnaDataControllerApiFp(configuration);
  return {
    /**
     * transform and anonymize order
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {KlarnaDataOrderDraft} KlarnaDataOrderDraft
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    klarnaDataV1TenantTransformPost(tenant, KlarnaDataOrderDraft, options) {
      return localVarFp
        .klarnaDataV1TenantTransformPost(tenant, KlarnaDataOrderDraft, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * KlarnaDataControllerApi - object-oriented interface
 * @export
 * @class KlarnaDataControllerApi
 * @extends {BaseAPI}
 */
export class KlarnaDataControllerApi extends BaseAPI {
  /**
   * transform and anonymize order
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {KlarnaDataOrderDraft} KlarnaDataOrderDraft
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KlarnaDataControllerApi
   */
  klarnaDataV1TenantTransformPost(tenant, KlarnaDataOrderDraft, options) {
    return KlarnaDataControllerApiFp(this.configuration)
      .klarnaDataV1TenantTransformPost(tenant, KlarnaDataOrderDraft, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * LeafletsControllerApi - axios parameter creator
 * @export
 */
export const LeafletsControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
     * @param {string} id PathParam id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    leafletsV1TenantBiozidIdGet: async (tenant, id, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("leafletsV1TenantBiozidIdGet", "tenant", tenant);
      // verify required parameter 'id' is not null or undefined
      assertParamExists("leafletsV1TenantBiozidIdGet", "id", id);
      const localVarPath = `/leaflets/v1/{tenant}/biozid/{id}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
     * @param {string} id PathParam id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    leafletsV1TenantLeafletsIdGet: async (tenant, id, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("leafletsV1TenantLeafletsIdGet", "tenant", tenant);
      // verify required parameter 'id' is not null or undefined
      assertParamExists("leafletsV1TenantLeafletsIdGet", "id", id);
      const localVarPath = `/leaflets/v1/{tenant}/leaflets/{id}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
     * @param {string} id PathParam id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    leafletsV1TenantLmivIdGet: async (tenant, id, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("leafletsV1TenantLmivIdGet", "tenant", tenant);
      // verify required parameter 'id' is not null or undefined
      assertParamExists("leafletsV1TenantLmivIdGet", "id", id);
      const localVarPath = `/leaflets/v1/{tenant}/lmiv/{id}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {'leaflet' | 'lmiv'} kind PathParam kind
     * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    leafletsV1TenantPznsKindGet: async (kind, tenant, options = {}) => {
      // verify required parameter 'kind' is not null or undefined
      assertParamExists("leafletsV1TenantPznsKindGet", "kind", kind);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("leafletsV1TenantPznsKindGet", "tenant", tenant);
      const localVarPath = `/leaflets/v1/{tenant}/pzns/{kind}`
        .replace(`{${"kind"}}`, encodeURIComponent(String(kind)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
     * @param {string} id PathParam id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    leafletsV1TenantRxIdGet: async (tenant, id, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("leafletsV1TenantRxIdGet", "tenant", tenant);
      // verify required parameter 'id' is not null or undefined
      assertParamExists("leafletsV1TenantRxIdGet", "id", id);
      const localVarPath = `/leaflets/v1/{tenant}/rx/{id}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * LeafletsControllerApi - functional programming interface
 * @export
 */
export const LeafletsControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = LeafletsControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
     * @param {string} id PathParam id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async leafletsV1TenantBiozidIdGet(tenant, id, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.leafletsV1TenantBiozidIdGet(tenant, id, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
     * @param {string} id PathParam id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async leafletsV1TenantLeafletsIdGet(tenant, id, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.leafletsV1TenantLeafletsIdGet(tenant, id, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
     * @param {string} id PathParam id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async leafletsV1TenantLmivIdGet(tenant, id, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.leafletsV1TenantLmivIdGet(tenant, id, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {'leaflet' | 'lmiv'} kind PathParam kind
     * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async leafletsV1TenantPznsKindGet(kind, tenant, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.leafletsV1TenantPznsKindGet(kind, tenant, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
     * @param {string} id PathParam id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async leafletsV1TenantRxIdGet(tenant, id, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.leafletsV1TenantRxIdGet(tenant, id, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * LeafletsControllerApi - factory interface
 * @export
 */
export const LeafletsControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = LeafletsControllerApiFp(configuration);
  return {
    /**
     *
     * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
     * @param {string} id PathParam id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    leafletsV1TenantBiozidIdGet(tenant, id, options) {
      return localVarFp.leafletsV1TenantBiozidIdGet(tenant, id, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
     * @param {string} id PathParam id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    leafletsV1TenantLeafletsIdGet(tenant, id, options) {
      return localVarFp.leafletsV1TenantLeafletsIdGet(tenant, id, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
     * @param {string} id PathParam id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    leafletsV1TenantLmivIdGet(tenant, id, options) {
      return localVarFp.leafletsV1TenantLmivIdGet(tenant, id, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {'leaflet' | 'lmiv'} kind PathParam kind
     * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    leafletsV1TenantPznsKindGet(kind, tenant, options) {
      return localVarFp.leafletsV1TenantPznsKindGet(kind, tenant, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
     * @param {string} id PathParam id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    leafletsV1TenantRxIdGet(tenant, id, options) {
      return localVarFp.leafletsV1TenantRxIdGet(tenant, id, options).then((request) => request(axios, basePath));
    }
  };
};
/**
 * LeafletsControllerApi - object-oriented interface
 * @export
 * @class LeafletsControllerApi
 * @extends {BaseAPI}
 */
export class LeafletsControllerApi extends BaseAPI {
  /**
   *
   * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
   * @param {string} id PathParam id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LeafletsControllerApi
   */
  leafletsV1TenantBiozidIdGet(tenant, id, options) {
    return LeafletsControllerApiFp(this.configuration)
      .leafletsV1TenantBiozidIdGet(tenant, id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
   * @param {string} id PathParam id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LeafletsControllerApi
   */
  leafletsV1TenantLeafletsIdGet(tenant, id, options) {
    return LeafletsControllerApiFp(this.configuration)
      .leafletsV1TenantLeafletsIdGet(tenant, id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
   * @param {string} id PathParam id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LeafletsControllerApi
   */
  leafletsV1TenantLmivIdGet(tenant, id, options) {
    return LeafletsControllerApiFp(this.configuration)
      .leafletsV1TenantLmivIdGet(tenant, id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {'leaflet' | 'lmiv'} kind PathParam kind
   * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LeafletsControllerApi
   */
  leafletsV1TenantPznsKindGet(kind, tenant, options) {
    return LeafletsControllerApiFp(this.configuration)
      .leafletsV1TenantPznsKindGet(kind, tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
   * @param {string} id PathParam id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LeafletsControllerApi
   */
  leafletsV1TenantRxIdGet(tenant, id, options) {
    return LeafletsControllerApiFp(this.configuration)
      .leafletsV1TenantRxIdGet(tenant, id, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * LetterboxControllerApi - axios parameter creator
 * @export
 */
export const LetterboxControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * List all documents for the given order id. Note that if no documents can be found for the given parameters, an empty array will be returned (no 404).
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageLetterboxV1TenantDocumentsOrderNumberGet: async (language, tenant, orderNumber, options = {}) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageLetterboxV1TenantDocumentsOrderNumberGet", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageLetterboxV1TenantDocumentsOrderNumberGet", "tenant", tenant);
      // verify required parameter 'orderNumber' is not null or undefined
      assertParamExists("languageLetterboxV1TenantDocumentsOrderNumberGet", "orderNumber", orderNumber);
      const localVarPath = `/{language}/letterbox/v1/{tenant}/documents/{orderNumber}`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"orderNumber"}}`, encodeURIComponent(String(orderNumber)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Download the binary content of a single document for SAE seller
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} orderNumber
     * @param {string} document_type
     * @param {string} hash A secure hash of the binary content to be retrieved.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    letterboxApiGetOrderDocument: async (tenant, language, orderNumber, document_type, hash, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("letterboxApiGetOrderDocument", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("letterboxApiGetOrderDocument", "language", language);
      // verify required parameter 'orderNumber' is not null or undefined
      assertParamExists("letterboxApiGetOrderDocument", "orderNumber", orderNumber);
      // verify required parameter 'document_type' is not null or undefined
      assertParamExists("letterboxApiGetOrderDocument", "document_type", document_type);
      // verify required parameter 'hash' is not null or undefined
      assertParamExists("letterboxApiGetOrderDocument", "hash", hash);
      const localVarPath = `/{language}/letterbox/v1/{tenant}/document/{orderNumber}/{document-type}/{hash}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"orderNumber"}}`, encodeURIComponent(String(orderNumber)))
        .replace(`{${"document-type"}}`, encodeURIComponent(String(document_type)))
        .replace(`{${"hash"}}`, encodeURIComponent(String(hash)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Download the binary content of a single document for SAE seller
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} subOrderId
     * @param {string} document_type
     * @param {string} hash A secure hash of the binary content to be retrieved.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    letterboxApiGetSuborderDocument: async (tenant, language, subOrderId, document_type, hash, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("letterboxApiGetSuborderDocument", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("letterboxApiGetSuborderDocument", "language", language);
      // verify required parameter 'subOrderId' is not null or undefined
      assertParamExists("letterboxApiGetSuborderDocument", "subOrderId", subOrderId);
      // verify required parameter 'document_type' is not null or undefined
      assertParamExists("letterboxApiGetSuborderDocument", "document_type", document_type);
      // verify required parameter 'hash' is not null or undefined
      assertParamExists("letterboxApiGetSuborderDocument", "hash", hash);
      const localVarPath = `/{language}/letterbox/v1/{tenant}/document/sae/{subOrderId}/{document-type}/{hash}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"subOrderId"}}`, encodeURIComponent(String(subOrderId)))
        .replace(`{${"document-type"}}`, encodeURIComponent(String(document_type)))
        .replace(`{${"hash"}}`, encodeURIComponent(String(hash)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Download the binary content of a single document for marketplace seller
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} subOrderId
     * @param {string} documentId Unique document id of marketplace document to fetch.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    letterboxApiGetSuborderMpDocument: async (tenant, language, subOrderId, documentId, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("letterboxApiGetSuborderMpDocument", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("letterboxApiGetSuborderMpDocument", "language", language);
      // verify required parameter 'subOrderId' is not null or undefined
      assertParamExists("letterboxApiGetSuborderMpDocument", "subOrderId", subOrderId);
      // verify required parameter 'documentId' is not null or undefined
      assertParamExists("letterboxApiGetSuborderMpDocument", "documentId", documentId);
      const localVarPath = `/{language}/letterbox/v1/{tenant}/document/marketplace/{subOrderId}/{documentId}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"subOrderId"}}`, encodeURIComponent(String(subOrderId)))
        .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * LetterboxControllerApi - functional programming interface
 * @export
 */
export const LetterboxControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = LetterboxControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * List all documents for the given order id. Note that if no documents can be found for the given parameters, an empty array will be returned (no 404).
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageLetterboxV1TenantDocumentsOrderNumberGet(language, tenant, orderNumber, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageLetterboxV1TenantDocumentsOrderNumberGet(
        language,
        tenant,
        orderNumber,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Download the binary content of a single document for SAE seller
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} orderNumber
     * @param {string} document_type
     * @param {string} hash A secure hash of the binary content to be retrieved.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async letterboxApiGetOrderDocument(tenant, language, orderNumber, document_type, hash, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.letterboxApiGetOrderDocument(
        tenant,
        language,
        orderNumber,
        document_type,
        hash,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Download the binary content of a single document for SAE seller
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} subOrderId
     * @param {string} document_type
     * @param {string} hash A secure hash of the binary content to be retrieved.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async letterboxApiGetSuborderDocument(tenant, language, subOrderId, document_type, hash, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.letterboxApiGetSuborderDocument(
        tenant,
        language,
        subOrderId,
        document_type,
        hash,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Download the binary content of a single document for marketplace seller
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} subOrderId
     * @param {string} documentId Unique document id of marketplace document to fetch.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async letterboxApiGetSuborderMpDocument(tenant, language, subOrderId, documentId, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.letterboxApiGetSuborderMpDocument(
        tenant,
        language,
        subOrderId,
        documentId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * LetterboxControllerApi - factory interface
 * @export
 */
export const LetterboxControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = LetterboxControllerApiFp(configuration);
  return {
    /**
     * List all documents for the given order id. Note that if no documents can be found for the given parameters, an empty array will be returned (no 404).
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageLetterboxV1TenantDocumentsOrderNumberGet(language, tenant, orderNumber, options) {
      return localVarFp
        .languageLetterboxV1TenantDocumentsOrderNumberGet(language, tenant, orderNumber, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Download the binary content of a single document for SAE seller
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} orderNumber
     * @param {string} document_type
     * @param {string} hash A secure hash of the binary content to be retrieved.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    letterboxApiGetOrderDocument(tenant, language, orderNumber, document_type, hash, options) {
      return localVarFp
        .letterboxApiGetOrderDocument(tenant, language, orderNumber, document_type, hash, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Download the binary content of a single document for SAE seller
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} subOrderId
     * @param {string} document_type
     * @param {string} hash A secure hash of the binary content to be retrieved.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    letterboxApiGetSuborderDocument(tenant, language, subOrderId, document_type, hash, options) {
      return localVarFp
        .letterboxApiGetSuborderDocument(tenant, language, subOrderId, document_type, hash, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Download the binary content of a single document for marketplace seller
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} subOrderId
     * @param {string} documentId Unique document id of marketplace document to fetch.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    letterboxApiGetSuborderMpDocument(tenant, language, subOrderId, documentId, options) {
      return localVarFp
        .letterboxApiGetSuborderMpDocument(tenant, language, subOrderId, documentId, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * LetterboxControllerApi - object-oriented interface
 * @export
 * @class LetterboxControllerApi
 * @extends {BaseAPI}
 */
export class LetterboxControllerApi extends BaseAPI {
  /**
   * List all documents for the given order id. Note that if no documents can be found for the given parameters, an empty array will be returned (no 404).
   * @param {string} language
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} orderNumber
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LetterboxControllerApi
   */
  languageLetterboxV1TenantDocumentsOrderNumberGet(language, tenant, orderNumber, options) {
    return LetterboxControllerApiFp(this.configuration)
      .languageLetterboxV1TenantDocumentsOrderNumberGet(language, tenant, orderNumber, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Download the binary content of a single document for SAE seller
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {string} orderNumber
   * @param {string} document_type
   * @param {string} hash A secure hash of the binary content to be retrieved.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof LetterboxControllerApi
   */
  letterboxApiGetOrderDocument(tenant, language, orderNumber, document_type, hash, options) {
    return LetterboxControllerApiFp(this.configuration)
      .letterboxApiGetOrderDocument(tenant, language, orderNumber, document_type, hash, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Download the binary content of a single document for SAE seller
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {string} subOrderId
   * @param {string} document_type
   * @param {string} hash A secure hash of the binary content to be retrieved.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LetterboxControllerApi
   */
  letterboxApiGetSuborderDocument(tenant, language, subOrderId, document_type, hash, options) {
    return LetterboxControllerApiFp(this.configuration)
      .letterboxApiGetSuborderDocument(tenant, language, subOrderId, document_type, hash, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Download the binary content of a single document for marketplace seller
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {string} subOrderId
   * @param {string} documentId Unique document id of marketplace document to fetch.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LetterboxControllerApi
   */
  letterboxApiGetSuborderMpDocument(tenant, language, subOrderId, documentId, options) {
    return LetterboxControllerApiFp(this.configuration)
      .letterboxApiGetSuborderMpDocument(tenant, language, subOrderId, documentId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * MPSControllerApi - axios parameter creator
 * @export
 */
export const MPSControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {MpCreateMedicationDtoV1} MpCreateMedicationDtoV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    medicationControllerCreate: async (tenant, MpCreateMedicationDtoV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("medicationControllerCreate", "tenant", tenant);
      // verify required parameter 'MpCreateMedicationDtoV1' is not null or undefined
      assertParamExists("medicationControllerCreate", "MpCreateMedicationDtoV1", MpCreateMedicationDtoV1);
      const localVarPath = `/medicationplan/v1/{tenant}/medication`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        MpCreateMedicationDtoV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    medicationControllerFindAll: async (tenant, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("medicationControllerFindAll", "tenant", tenant);
      const localVarPath = `/medicationplan/v1/{tenant}/medication`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} id
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    medicationControllerFindOne: async (id, tenant, options = {}) => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("medicationControllerFindOne", "id", id);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("medicationControllerFindOne", "tenant", tenant);
      const localVarPath = `/medicationplan/v1/{tenant}/medication/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} id
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    medicationControllerRemove: async (id, tenant, options = {}) => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("medicationControllerRemove", "id", id);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("medicationControllerRemove", "tenant", tenant);
      const localVarPath = `/medicationplan/v1/{tenant}/medication/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "DELETE", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {MpCheckMedicationDtoV1} MpCheckMedicationDtoV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    medicationControllerRequestCheck: async (tenant, MpCheckMedicationDtoV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("medicationControllerRequestCheck", "tenant", tenant);
      // verify required parameter 'MpCheckMedicationDtoV1' is not null or undefined
      assertParamExists("medicationControllerRequestCheck", "MpCheckMedicationDtoV1", MpCheckMedicationDtoV1);
      const localVarPath = `/medicationplan/v1/{tenant}/medication/requestCheck`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        MpCheckMedicationDtoV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} id
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {MpUpdateMedicationDtoV1} MpUpdateMedicationDtoV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    medicationControllerUpdate: async (id, tenant, MpUpdateMedicationDtoV1, options = {}) => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("medicationControllerUpdate", "id", id);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("medicationControllerUpdate", "tenant", tenant);
      // verify required parameter 'MpUpdateMedicationDtoV1' is not null or undefined
      assertParamExists("medicationControllerUpdate", "MpUpdateMedicationDtoV1", MpUpdateMedicationDtoV1);
      const localVarPath = `/medicationplan/v1/{tenant}/medication/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "PATCH", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        MpUpdateMedicationDtoV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * MPSControllerApi - functional programming interface
 * @export
 */
export const MPSControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = MPSControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {MpCreateMedicationDtoV1} MpCreateMedicationDtoV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async medicationControllerCreate(tenant, MpCreateMedicationDtoV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.medicationControllerCreate(
        tenant,
        MpCreateMedicationDtoV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async medicationControllerFindAll(tenant, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.medicationControllerFindAll(tenant, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} id
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async medicationControllerFindOne(id, tenant, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.medicationControllerFindOne(id, tenant, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} id
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async medicationControllerRemove(id, tenant, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.medicationControllerRemove(id, tenant, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {MpCheckMedicationDtoV1} MpCheckMedicationDtoV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async medicationControllerRequestCheck(tenant, MpCheckMedicationDtoV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.medicationControllerRequestCheck(
        tenant,
        MpCheckMedicationDtoV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} id
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {MpUpdateMedicationDtoV1} MpUpdateMedicationDtoV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async medicationControllerUpdate(id, tenant, MpUpdateMedicationDtoV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.medicationControllerUpdate(
        id,
        tenant,
        MpUpdateMedicationDtoV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * MPSControllerApi - factory interface
 * @export
 */
export const MPSControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = MPSControllerApiFp(configuration);
  return {
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {MpCreateMedicationDtoV1} MpCreateMedicationDtoV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    medicationControllerCreate(tenant, MpCreateMedicationDtoV1, options) {
      return localVarFp
        .medicationControllerCreate(tenant, MpCreateMedicationDtoV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    medicationControllerFindAll(tenant, options) {
      return localVarFp.medicationControllerFindAll(tenant, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    medicationControllerFindOne(id, tenant, options) {
      return localVarFp.medicationControllerFindOne(id, tenant, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    medicationControllerRemove(id, tenant, options) {
      return localVarFp.medicationControllerRemove(id, tenant, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {MpCheckMedicationDtoV1} MpCheckMedicationDtoV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    medicationControllerRequestCheck(tenant, MpCheckMedicationDtoV1, options) {
      return localVarFp
        .medicationControllerRequestCheck(tenant, MpCheckMedicationDtoV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {MpUpdateMedicationDtoV1} MpUpdateMedicationDtoV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    medicationControllerUpdate(id, tenant, MpUpdateMedicationDtoV1, options) {
      return localVarFp
        .medicationControllerUpdate(id, tenant, MpUpdateMedicationDtoV1, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * MPSControllerApi - object-oriented interface
 * @export
 * @class MPSControllerApi
 * @extends {BaseAPI}
 */
export class MPSControllerApi extends BaseAPI {
  /**
   *
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {MpCreateMedicationDtoV1} MpCreateMedicationDtoV1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MPSControllerApi
   */
  medicationControllerCreate(tenant, MpCreateMedicationDtoV1, options) {
    return MPSControllerApiFp(this.configuration)
      .medicationControllerCreate(tenant, MpCreateMedicationDtoV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MPSControllerApi
   */
  medicationControllerFindAll(tenant, options) {
    return MPSControllerApiFp(this.configuration)
      .medicationControllerFindAll(tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} id
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MPSControllerApi
   */
  medicationControllerFindOne(id, tenant, options) {
    return MPSControllerApiFp(this.configuration)
      .medicationControllerFindOne(id, tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} id
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MPSControllerApi
   */
  medicationControllerRemove(id, tenant, options) {
    return MPSControllerApiFp(this.configuration)
      .medicationControllerRemove(id, tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {MpCheckMedicationDtoV1} MpCheckMedicationDtoV1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MPSControllerApi
   */
  medicationControllerRequestCheck(tenant, MpCheckMedicationDtoV1, options) {
    return MPSControllerApiFp(this.configuration)
      .medicationControllerRequestCheck(tenant, MpCheckMedicationDtoV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} id
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {MpUpdateMedicationDtoV1} MpUpdateMedicationDtoV1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MPSControllerApi
   */
  medicationControllerUpdate(id, tenant, MpUpdateMedicationDtoV1, options) {
    return MPSControllerApiFp(this.configuration)
      .medicationControllerUpdate(id, tenant, MpUpdateMedicationDtoV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * MailingSubscriptionControllerApi - axios parameter creator
 * @export
 */
export const MailingSubscriptionControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Activate the subscription with a given token
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} subscription_token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mailingSubscriptionV1TenantActivateSubscriptionsSubscriptionTokenPut: async (
      tenant,
      subscription_token,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("mailingSubscriptionV1TenantActivateSubscriptionsSubscriptionTokenPut", "tenant", tenant);
      // verify required parameter 'subscription_token' is not null or undefined
      assertParamExists(
        "mailingSubscriptionV1TenantActivateSubscriptionsSubscriptionTokenPut",
        "subscription_token",
        subscription_token
      );
      const localVarPath = `/mailing-subscription/v1/{tenant}/activate/subscriptions/{subscription-token}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"subscription-token"}}`, encodeURIComponent(String(subscription_token)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "PUT", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * This endpoint allows a customer to retrieve its own subscriptions only.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} customerNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mailingSubscriptionV1TenantSubscriptionsGet: async (tenant, customerNumber, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("mailingSubscriptionV1TenantSubscriptionsGet", "tenant", tenant);
      // verify required parameter 'customerNumber' is not null or undefined
      assertParamExists("mailingSubscriptionV1TenantSubscriptionsGet", "customerNumber", customerNumber);
      const localVarPath = `/mailing-subscription/v1/{tenant}/subscriptions`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (customerNumber !== undefined) {
        localVarQueryParameter["customerNumber"] = customerNumber;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Update a specific subscription
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {UnsubscribeSubscriptionRequestV1} [UnsubscribeSubscriptionRequestV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mailingSubscriptionV1TenantSubscriptionsPatch: async (tenant, UnsubscribeSubscriptionRequestV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("mailingSubscriptionV1TenantSubscriptionsPatch", "tenant", tenant);
      const localVarPath = `/mailing-subscription/v1/{tenant}/subscriptions`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "PATCH", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        UnsubscribeSubscriptionRequestV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {MailingSubscriptionRequestV1} [MailingSubscriptionRequestV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mailingSubscriptionV1TenantSubscriptionsPost: async (tenant, MailingSubscriptionRequestV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("mailingSubscriptionV1TenantSubscriptionsPost", "tenant", tenant);
      const localVarPath = `/mailing-subscription/v1/{tenant}/subscriptions`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        MailingSubscriptionRequestV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * MailingSubscriptionControllerApi - functional programming interface
 * @export
 */
export const MailingSubscriptionControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = MailingSubscriptionControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * Activate the subscription with a given token
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} subscription_token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mailingSubscriptionV1TenantActivateSubscriptionsSubscriptionTokenPut(tenant, subscription_token, options) {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.mailingSubscriptionV1TenantActivateSubscriptionsSubscriptionTokenPut(
          tenant,
          subscription_token,
          options
        );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * This endpoint allows a customer to retrieve its own subscriptions only.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} customerNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mailingSubscriptionV1TenantSubscriptionsGet(tenant, customerNumber, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.mailingSubscriptionV1TenantSubscriptionsGet(
        tenant,
        customerNumber,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Update a specific subscription
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {UnsubscribeSubscriptionRequestV1} [UnsubscribeSubscriptionRequestV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mailingSubscriptionV1TenantSubscriptionsPatch(tenant, UnsubscribeSubscriptionRequestV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.mailingSubscriptionV1TenantSubscriptionsPatch(
        tenant,
        UnsubscribeSubscriptionRequestV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {MailingSubscriptionRequestV1} [MailingSubscriptionRequestV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mailingSubscriptionV1TenantSubscriptionsPost(tenant, MailingSubscriptionRequestV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.mailingSubscriptionV1TenantSubscriptionsPost(
        tenant,
        MailingSubscriptionRequestV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * MailingSubscriptionControllerApi - factory interface
 * @export
 */
export const MailingSubscriptionControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = MailingSubscriptionControllerApiFp(configuration);
  return {
    /**
     * Activate the subscription with a given token
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} subscription_token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mailingSubscriptionV1TenantActivateSubscriptionsSubscriptionTokenPut(tenant, subscription_token, options) {
      return localVarFp
        .mailingSubscriptionV1TenantActivateSubscriptionsSubscriptionTokenPut(tenant, subscription_token, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * This endpoint allows a customer to retrieve its own subscriptions only.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} customerNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mailingSubscriptionV1TenantSubscriptionsGet(tenant, customerNumber, options) {
      return localVarFp
        .mailingSubscriptionV1TenantSubscriptionsGet(tenant, customerNumber, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Update a specific subscription
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {UnsubscribeSubscriptionRequestV1} [UnsubscribeSubscriptionRequestV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mailingSubscriptionV1TenantSubscriptionsPatch(tenant, UnsubscribeSubscriptionRequestV1, options) {
      return localVarFp
        .mailingSubscriptionV1TenantSubscriptionsPatch(tenant, UnsubscribeSubscriptionRequestV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {MailingSubscriptionRequestV1} [MailingSubscriptionRequestV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mailingSubscriptionV1TenantSubscriptionsPost(tenant, MailingSubscriptionRequestV1, options) {
      return localVarFp
        .mailingSubscriptionV1TenantSubscriptionsPost(tenant, MailingSubscriptionRequestV1, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * MailingSubscriptionControllerApi - object-oriented interface
 * @export
 * @class MailingSubscriptionControllerApi
 * @extends {BaseAPI}
 */
export class MailingSubscriptionControllerApi extends BaseAPI {
  /**
   * Activate the subscription with a given token
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} subscription_token
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MailingSubscriptionControllerApi
   */
  mailingSubscriptionV1TenantActivateSubscriptionsSubscriptionTokenPut(tenant, subscription_token, options) {
    return MailingSubscriptionControllerApiFp(this.configuration)
      .mailingSubscriptionV1TenantActivateSubscriptionsSubscriptionTokenPut(tenant, subscription_token, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * This endpoint allows a customer to retrieve its own subscriptions only.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} customerNumber
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MailingSubscriptionControllerApi
   */
  mailingSubscriptionV1TenantSubscriptionsGet(tenant, customerNumber, options) {
    return MailingSubscriptionControllerApiFp(this.configuration)
      .mailingSubscriptionV1TenantSubscriptionsGet(tenant, customerNumber, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update a specific subscription
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {UnsubscribeSubscriptionRequestV1} [UnsubscribeSubscriptionRequestV1]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MailingSubscriptionControllerApi
   */
  mailingSubscriptionV1TenantSubscriptionsPatch(tenant, UnsubscribeSubscriptionRequestV1, options) {
    return MailingSubscriptionControllerApiFp(this.configuration)
      .mailingSubscriptionV1TenantSubscriptionsPatch(tenant, UnsubscribeSubscriptionRequestV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {MailingSubscriptionRequestV1} [MailingSubscriptionRequestV1]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MailingSubscriptionControllerApi
   */
  mailingSubscriptionV1TenantSubscriptionsPost(tenant, MailingSubscriptionRequestV1, options) {
    return MailingSubscriptionControllerApiFp(this.configuration)
      .mailingSubscriptionV1TenantSubscriptionsPost(tenant, MailingSubscriptionRequestV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * MaxDosageServiceV1Api - axios parameter creator
 * @export
 */
export const MaxDosageServiceV1ApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Calculates possible overdrafts against maximum dosage groups for the provided cart items.
     * @summary Returns a list of overdrafts including the affected products
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {MaxDosageRequestV1} MaxDosageRequestV1 Current cart contents
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyMaxdosageGetOverdrafts: async (tenant, MaxDosageRequestV1, X_Request_ID, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("bullyMaxdosageGetOverdrafts", "tenant", tenant);
      // verify required parameter 'MaxDosageRequestV1' is not null or undefined
      assertParamExists("bullyMaxdosageGetOverdrafts", "MaxDosageRequestV1", MaxDosageRequestV1);
      const localVarPath = `/maxdosage/v1/{tenant}/overdrafts`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (X_Request_ID != null) {
        localVarHeaderParameter["X-Request-ID"] = String(X_Request_ID);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(MaxDosageRequestV1, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Get the health status of MaxDosage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    maxdosageApiGetMaxDosageHealth: async (options = {}) => {
      const localVarPath = `/maxdosage/health`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Calculates possible overdrafts against maximum dosage groups
     * @summary Returns a list of overdrafts including the affected products for PDP
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {MaxDosageRequestV2} MaxDosageRequestV2 overdrafts for PDP
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    maxdosageV1TenantProductPageLimitPost: async (tenant, MaxDosageRequestV2, X_Request_ID, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("maxdosageV1TenantProductPageLimitPost", "tenant", tenant);
      // verify required parameter 'MaxDosageRequestV2' is not null or undefined
      assertParamExists("maxdosageV1TenantProductPageLimitPost", "MaxDosageRequestV2", MaxDosageRequestV2);
      const localVarPath = `/maxdosage/v1/{tenant}/product-page-limit`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (X_Request_ID != null) {
        localVarHeaderParameter["X-Request-ID"] = String(X_Request_ID);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(MaxDosageRequestV2, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * MaxDosageServiceV1Api - functional programming interface
 * @export
 */
export const MaxDosageServiceV1ApiFp = function (configuration) {
  const localVarAxiosParamCreator = MaxDosageServiceV1ApiAxiosParamCreator(configuration);
  return {
    /**
     * Calculates possible overdrafts against maximum dosage groups for the provided cart items.
     * @summary Returns a list of overdrafts including the affected products
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {MaxDosageRequestV1} MaxDosageRequestV1 Current cart contents
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bullyMaxdosageGetOverdrafts(tenant, MaxDosageRequestV1, X_Request_ID, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bullyMaxdosageGetOverdrafts(
        tenant,
        MaxDosageRequestV1,
        X_Request_ID,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Get the health status of MaxDosage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maxdosageApiGetMaxDosageHealth(options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.maxdosageApiGetMaxDosageHealth(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Calculates possible overdrafts against maximum dosage groups
     * @summary Returns a list of overdrafts including the affected products for PDP
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {MaxDosageRequestV2} MaxDosageRequestV2 overdrafts for PDP
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maxdosageV1TenantProductPageLimitPost(tenant, MaxDosageRequestV2, X_Request_ID, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.maxdosageV1TenantProductPageLimitPost(
        tenant,
        MaxDosageRequestV2,
        X_Request_ID,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * MaxDosageServiceV1Api - factory interface
 * @export
 */
export const MaxDosageServiceV1ApiFactory = function (configuration, basePath, axios) {
  const localVarFp = MaxDosageServiceV1ApiFp(configuration);
  return {
    /**
     * Calculates possible overdrafts against maximum dosage groups for the provided cart items.
     * @summary Returns a list of overdrafts including the affected products
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {MaxDosageRequestV1} MaxDosageRequestV1 Current cart contents
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyMaxdosageGetOverdrafts(tenant, MaxDosageRequestV1, X_Request_ID, options) {
      return localVarFp
        .bullyMaxdosageGetOverdrafts(tenant, MaxDosageRequestV1, X_Request_ID, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get the health status of MaxDosage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    maxdosageApiGetMaxDosageHealth(options) {
      return localVarFp.maxdosageApiGetMaxDosageHealth(options).then((request) => request(axios, basePath));
    },
    /**
     * Calculates possible overdrafts against maximum dosage groups
     * @summary Returns a list of overdrafts including the affected products for PDP
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {MaxDosageRequestV2} MaxDosageRequestV2 overdrafts for PDP
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    maxdosageV1TenantProductPageLimitPost(tenant, MaxDosageRequestV2, X_Request_ID, options) {
      return localVarFp
        .maxdosageV1TenantProductPageLimitPost(tenant, MaxDosageRequestV2, X_Request_ID, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * MaxDosageServiceV1Api - object-oriented interface
 * @export
 * @class MaxDosageServiceV1Api
 * @extends {BaseAPI}
 */
export class MaxDosageServiceV1Api extends BaseAPI {
  /**
   * Calculates possible overdrafts against maximum dosage groups for the provided cart items.
   * @summary Returns a list of overdrafts including the affected products
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {MaxDosageRequestV1} MaxDosageRequestV1 Current cart contents
   * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MaxDosageServiceV1Api
   */
  bullyMaxdosageGetOverdrafts(tenant, MaxDosageRequestV1, X_Request_ID, options) {
    return MaxDosageServiceV1ApiFp(this.configuration)
      .bullyMaxdosageGetOverdrafts(tenant, MaxDosageRequestV1, X_Request_ID, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get the health status of MaxDosage
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MaxDosageServiceV1Api
   */
  maxdosageApiGetMaxDosageHealth(options) {
    return MaxDosageServiceV1ApiFp(this.configuration)
      .maxdosageApiGetMaxDosageHealth(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Calculates possible overdrafts against maximum dosage groups
   * @summary Returns a list of overdrafts including the affected products for PDP
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {MaxDosageRequestV2} MaxDosageRequestV2 overdrafts for PDP
   * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MaxDosageServiceV1Api
   */
  maxdosageV1TenantProductPageLimitPost(tenant, MaxDosageRequestV2, X_Request_ID, options) {
    return MaxDosageServiceV1ApiFp(this.configuration)
      .maxdosageV1TenantProductPageLimitPost(tenant, MaxDosageRequestV2, X_Request_ID, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * MiraklControllerV1Api - axios parameter creator
 * @export
 */
export const MiraklControllerV1ApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Returns the order split from mirakl
     * @summary Request order split
     * @param {string} offers QueryParam offers
     * @param {string} shippingZoneCode QueryParam shippingZoneCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyMiraklOrderSplit: async (offers, shippingZoneCode, options = {}) => {
      // verify required parameter 'offers' is not null or undefined
      assertParamExists("bullyMiraklOrderSplit", "offers", offers);
      // verify required parameter 'shippingZoneCode' is not null or undefined
      assertParamExists("bullyMiraklOrderSplit", "shippingZoneCode", shippingZoneCode);
      const localVarPath = `/mirakl/v1/order/split`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (offers !== undefined) {
        localVarQueryParameter["offers"] = offers;
      }
      if (shippingZoneCode !== undefined) {
        localVarQueryParameter["shippingZoneCode"] = shippingZoneCode;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    miraklV1ReasonsGet: async (options = {}) => {
      const localVarPath = `/mirakl/v1/reasons`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} type PathParam type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    miraklV1ReasonsTypeGet: async (type, options = {}) => {
      // verify required parameter 'type' is not null or undefined
      assertParamExists("miraklV1ReasonsTypeGet", "type", type);
      const localVarPath = `/mirakl/v1/reasons/{type}`.replace(`{${"type"}}`, encodeURIComponent(String(type)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} entityType QueryParam entityType
     * @param {string} [limit] QueryParam limit
     * @param {string} [pageToken] QueryParam pageToken
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    miraklV1ThreadsGet: async (entityType, limit, pageToken, options = {}) => {
      // verify required parameter 'entityType' is not null or undefined
      assertParamExists("miraklV1ThreadsGet", "entityType", entityType);
      const localVarPath = `/mirakl/v1/threads`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (entityType !== undefined) {
        localVarQueryParameter["entityType"] = entityType;
      }
      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }
      if (pageToken !== undefined) {
        localVarQueryParameter["pageToken"] = pageToken;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} threadId PathParam threadId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    miraklV1ThreadsThreadIdGet: async (threadId, options = {}) => {
      // verify required parameter 'threadId' is not null or undefined
      assertParamExists("miraklV1ThreadsThreadIdGet", "threadId", threadId);
      const localVarPath = `/mirakl/v1/threads/{threadId}`.replace(
        `{${"threadId"}}`,
        encodeURIComponent(String(threadId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} threadId PathParam threadId
     * @param {MiraklThreadMessageBodyV1V1} MiraklThreadMessageBodyV1V1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    miraklV1ThreadsThreadIdPost: async (threadId, MiraklThreadMessageBodyV1V1, options = {}) => {
      // verify required parameter 'threadId' is not null or undefined
      assertParamExists("miraklV1ThreadsThreadIdPost", "threadId", threadId);
      // verify required parameter 'MiraklThreadMessageBodyV1V1' is not null or undefined
      assertParamExists("miraklV1ThreadsThreadIdPost", "MiraklThreadMessageBodyV1V1", MiraklThreadMessageBodyV1V1);
      const localVarPath = `/mirakl/v1/threads/{threadId}`.replace(
        `{${"threadId"}}`,
        encodeURIComponent(String(threadId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        MiraklThreadMessageBodyV1V1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * MiraklControllerV1Api - functional programming interface
 * @export
 */
export const MiraklControllerV1ApiFp = function (configuration) {
  const localVarAxiosParamCreator = MiraklControllerV1ApiAxiosParamCreator(configuration);
  return {
    /**
     * Returns the order split from mirakl
     * @summary Request order split
     * @param {string} offers QueryParam offers
     * @param {string} shippingZoneCode QueryParam shippingZoneCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bullyMiraklOrderSplit(offers, shippingZoneCode, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bullyMiraklOrderSplit(
        offers,
        shippingZoneCode,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async miraklV1ReasonsGet(options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.miraklV1ReasonsGet(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} type PathParam type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async miraklV1ReasonsTypeGet(type, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.miraklV1ReasonsTypeGet(type, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} entityType QueryParam entityType
     * @param {string} [limit] QueryParam limit
     * @param {string} [pageToken] QueryParam pageToken
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async miraklV1ThreadsGet(entityType, limit, pageToken, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.miraklV1ThreadsGet(
        entityType,
        limit,
        pageToken,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} threadId PathParam threadId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async miraklV1ThreadsThreadIdGet(threadId, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.miraklV1ThreadsThreadIdGet(threadId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} threadId PathParam threadId
     * @param {MiraklThreadMessageBodyV1V1} MiraklThreadMessageBodyV1V1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async miraklV1ThreadsThreadIdPost(threadId, MiraklThreadMessageBodyV1V1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.miraklV1ThreadsThreadIdPost(
        threadId,
        MiraklThreadMessageBodyV1V1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * MiraklControllerV1Api - factory interface
 * @export
 */
export const MiraklControllerV1ApiFactory = function (configuration, basePath, axios) {
  const localVarFp = MiraklControllerV1ApiFp(configuration);
  return {
    /**
     * Returns the order split from mirakl
     * @summary Request order split
     * @param {string} offers QueryParam offers
     * @param {string} shippingZoneCode QueryParam shippingZoneCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyMiraklOrderSplit(offers, shippingZoneCode, options) {
      return localVarFp
        .bullyMiraklOrderSplit(offers, shippingZoneCode, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    miraklV1ReasonsGet(options) {
      return localVarFp.miraklV1ReasonsGet(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} type PathParam type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    miraklV1ReasonsTypeGet(type, options) {
      return localVarFp.miraklV1ReasonsTypeGet(type, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} entityType QueryParam entityType
     * @param {string} [limit] QueryParam limit
     * @param {string} [pageToken] QueryParam pageToken
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    miraklV1ThreadsGet(entityType, limit, pageToken, options) {
      return localVarFp
        .miraklV1ThreadsGet(entityType, limit, pageToken, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} threadId PathParam threadId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    miraklV1ThreadsThreadIdGet(threadId, options) {
      return localVarFp.miraklV1ThreadsThreadIdGet(threadId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} threadId PathParam threadId
     * @param {MiraklThreadMessageBodyV1V1} MiraklThreadMessageBodyV1V1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    miraklV1ThreadsThreadIdPost(threadId, MiraklThreadMessageBodyV1V1, options) {
      return localVarFp
        .miraklV1ThreadsThreadIdPost(threadId, MiraklThreadMessageBodyV1V1, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * MiraklControllerV1Api - object-oriented interface
 * @export
 * @class MiraklControllerV1Api
 * @extends {BaseAPI}
 */
export class MiraklControllerV1Api extends BaseAPI {
  /**
   * Returns the order split from mirakl
   * @summary Request order split
   * @param {string} offers QueryParam offers
   * @param {string} shippingZoneCode QueryParam shippingZoneCode
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MiraklControllerV1Api
   */
  bullyMiraklOrderSplit(offers, shippingZoneCode, options) {
    return MiraklControllerV1ApiFp(this.configuration)
      .bullyMiraklOrderSplit(offers, shippingZoneCode, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MiraklControllerV1Api
   */
  miraklV1ReasonsGet(options) {
    return MiraklControllerV1ApiFp(this.configuration)
      .miraklV1ReasonsGet(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} type PathParam type
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MiraklControllerV1Api
   */
  miraklV1ReasonsTypeGet(type, options) {
    return MiraklControllerV1ApiFp(this.configuration)
      .miraklV1ReasonsTypeGet(type, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} entityType QueryParam entityType
   * @param {string} [limit] QueryParam limit
   * @param {string} [pageToken] QueryParam pageToken
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MiraklControllerV1Api
   */
  miraklV1ThreadsGet(entityType, limit, pageToken, options) {
    return MiraklControllerV1ApiFp(this.configuration)
      .miraklV1ThreadsGet(entityType, limit, pageToken, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} threadId PathParam threadId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MiraklControllerV1Api
   */
  miraklV1ThreadsThreadIdGet(threadId, options) {
    return MiraklControllerV1ApiFp(this.configuration)
      .miraklV1ThreadsThreadIdGet(threadId, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} threadId PathParam threadId
   * @param {MiraklThreadMessageBodyV1V1} MiraklThreadMessageBodyV1V1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MiraklControllerV1Api
   */
  miraklV1ThreadsThreadIdPost(threadId, MiraklThreadMessageBodyV1V1, options) {
    return MiraklControllerV1ApiFp(this.configuration)
      .miraklV1ThreadsThreadIdPost(threadId, MiraklThreadMessageBodyV1V1, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * MiraklControllerV2Api - axios parameter creator
 * @export
 */
export const MiraklControllerV2ApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    miraklV2TenantReasonsGet: async (tenant, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("miraklV2TenantReasonsGet", "tenant", tenant);
      const localVarPath = `/mirakl/v2/{tenant}/reasons`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} subOrderid the seller\&#39;s suborder id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    miraklV2TenantSubOrderidGet: async (tenant, subOrderid, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("miraklV2TenantSubOrderidGet", "tenant", tenant);
      // verify required parameter 'subOrderid' is not null or undefined
      assertParamExists("miraklV2TenantSubOrderidGet", "subOrderid", subOrderid);
      const localVarPath = `/mirakl/v2/{tenant}/{subOrderid}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"subOrderid"}}`, encodeURIComponent(String(subOrderid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} subOrderid the seller\&#39;s suborder id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    miraklV2TenantSubOrderidThreadsGet: async (tenant, subOrderid, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("miraklV2TenantSubOrderidThreadsGet", "tenant", tenant);
      // verify required parameter 'subOrderid' is not null or undefined
      assertParamExists("miraklV2TenantSubOrderidThreadsGet", "subOrderid", subOrderid);
      const localVarPath = `/mirakl/v2/{tenant}/{subOrderid}/threads`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"subOrderid"}}`, encodeURIComponent(String(subOrderid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} subOrderid the seller\&#39;s suborder id
     * @param {MiraklCreateThreadRequestBodyV2} MiraklCreateThreadRequestBodyV2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    miraklV2TenantSubOrderidThreadsPost: async (tenant, subOrderid, MiraklCreateThreadRequestBodyV2, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("miraklV2TenantSubOrderidThreadsPost", "tenant", tenant);
      // verify required parameter 'subOrderid' is not null or undefined
      assertParamExists("miraklV2TenantSubOrderidThreadsPost", "subOrderid", subOrderid);
      // verify required parameter 'MiraklCreateThreadRequestBodyV2' is not null or undefined
      assertParamExists(
        "miraklV2TenantSubOrderidThreadsPost",
        "MiraklCreateThreadRequestBodyV2",
        MiraklCreateThreadRequestBodyV2
      );
      const localVarPath = `/mirakl/v2/{tenant}/{subOrderid}/threads`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"subOrderid"}}`, encodeURIComponent(String(subOrderid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        MiraklCreateThreadRequestBodyV2,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} subOrderid the seller\&#39;s suborder id
     * @param {string} threadId the thread\&#39;s id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    miraklV2TenantSubOrderidThreadsThreadIdGet: async (tenant, subOrderid, threadId, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("miraklV2TenantSubOrderidThreadsThreadIdGet", "tenant", tenant);
      // verify required parameter 'subOrderid' is not null or undefined
      assertParamExists("miraklV2TenantSubOrderidThreadsThreadIdGet", "subOrderid", subOrderid);
      // verify required parameter 'threadId' is not null or undefined
      assertParamExists("miraklV2TenantSubOrderidThreadsThreadIdGet", "threadId", threadId);
      const localVarPath = `/mirakl/v2/{tenant}/{subOrderid}/threads/{threadId}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"subOrderid"}}`, encodeURIComponent(String(subOrderid)))
        .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * dowload attachment with id
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} subOrderid the seller\&#39;s suborder id
     * @param {string} threadId the thread\&#39;s id
     * @param {string} attachmentId the attachment\&#39;s id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    miraklV2TenantSubOrderidThreadsThreadIdMessageAttachmentsAttachmentIdGet: async (
      tenant,
      subOrderid,
      threadId,
      attachmentId,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("miraklV2TenantSubOrderidThreadsThreadIdMessageAttachmentsAttachmentIdGet", "tenant", tenant);
      // verify required parameter 'subOrderid' is not null or undefined
      assertParamExists(
        "miraklV2TenantSubOrderidThreadsThreadIdMessageAttachmentsAttachmentIdGet",
        "subOrderid",
        subOrderid
      );
      // verify required parameter 'threadId' is not null or undefined
      assertParamExists(
        "miraklV2TenantSubOrderidThreadsThreadIdMessageAttachmentsAttachmentIdGet",
        "threadId",
        threadId
      );
      // verify required parameter 'attachmentId' is not null or undefined
      assertParamExists(
        "miraklV2TenantSubOrderidThreadsThreadIdMessageAttachmentsAttachmentIdGet",
        "attachmentId",
        attachmentId
      );
      const localVarPath = `/mirakl/v2/{tenant}/{subOrderid}/threads/{threadId}/message/attachments/{attachmentId}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"subOrderid"}}`, encodeURIComponent(String(subOrderid)))
        .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)))
        .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} subOrderid the seller\&#39;s suborder id
     * @param {string} threadId the thread\&#39;s id
     * @param {MiraklAddMessageRequestBodyV2} MiraklAddMessageRequestBodyV2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    miraklV2TenantSubOrderidThreadsThreadIdMessagePost: async (
      tenant,
      subOrderid,
      threadId,
      MiraklAddMessageRequestBodyV2,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("miraklV2TenantSubOrderidThreadsThreadIdMessagePost", "tenant", tenant);
      // verify required parameter 'subOrderid' is not null or undefined
      assertParamExists("miraklV2TenantSubOrderidThreadsThreadIdMessagePost", "subOrderid", subOrderid);
      // verify required parameter 'threadId' is not null or undefined
      assertParamExists("miraklV2TenantSubOrderidThreadsThreadIdMessagePost", "threadId", threadId);
      // verify required parameter 'MiraklAddMessageRequestBodyV2' is not null or undefined
      assertParamExists(
        "miraklV2TenantSubOrderidThreadsThreadIdMessagePost",
        "MiraklAddMessageRequestBodyV2",
        MiraklAddMessageRequestBodyV2
      );
      const localVarPath = `/mirakl/v2/{tenant}/{subOrderid}/threads/{threadId}/message`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"subOrderid"}}`, encodeURIComponent(String(subOrderid)))
        .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        MiraklAddMessageRequestBodyV2,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * MiraklControllerV2Api - functional programming interface
 * @export
 */
export const MiraklControllerV2ApiFp = function (configuration) {
  const localVarAxiosParamCreator = MiraklControllerV2ApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async miraklV2TenantReasonsGet(tenant, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.miraklV2TenantReasonsGet(tenant, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} subOrderid the seller\&#39;s suborder id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async miraklV2TenantSubOrderidGet(tenant, subOrderid, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.miraklV2TenantSubOrderidGet(
        tenant,
        subOrderid,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} subOrderid the seller\&#39;s suborder id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async miraklV2TenantSubOrderidThreadsGet(tenant, subOrderid, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.miraklV2TenantSubOrderidThreadsGet(
        tenant,
        subOrderid,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} subOrderid the seller\&#39;s suborder id
     * @param {MiraklCreateThreadRequestBodyV2} MiraklCreateThreadRequestBodyV2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async miraklV2TenantSubOrderidThreadsPost(tenant, subOrderid, MiraklCreateThreadRequestBodyV2, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.miraklV2TenantSubOrderidThreadsPost(
        tenant,
        subOrderid,
        MiraklCreateThreadRequestBodyV2,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} subOrderid the seller\&#39;s suborder id
     * @param {string} threadId the thread\&#39;s id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async miraklV2TenantSubOrderidThreadsThreadIdGet(tenant, subOrderid, threadId, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.miraklV2TenantSubOrderidThreadsThreadIdGet(
        tenant,
        subOrderid,
        threadId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * dowload attachment with id
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} subOrderid the seller\&#39;s suborder id
     * @param {string} threadId the thread\&#39;s id
     * @param {string} attachmentId the attachment\&#39;s id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async miraklV2TenantSubOrderidThreadsThreadIdMessageAttachmentsAttachmentIdGet(
      tenant,
      subOrderid,
      threadId,
      attachmentId,
      options
    ) {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.miraklV2TenantSubOrderidThreadsThreadIdMessageAttachmentsAttachmentIdGet(
          tenant,
          subOrderid,
          threadId,
          attachmentId,
          options
        );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} subOrderid the seller\&#39;s suborder id
     * @param {string} threadId the thread\&#39;s id
     * @param {MiraklAddMessageRequestBodyV2} MiraklAddMessageRequestBodyV2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async miraklV2TenantSubOrderidThreadsThreadIdMessagePost(
      tenant,
      subOrderid,
      threadId,
      MiraklAddMessageRequestBodyV2,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.miraklV2TenantSubOrderidThreadsThreadIdMessagePost(
        tenant,
        subOrderid,
        threadId,
        MiraklAddMessageRequestBodyV2,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * MiraklControllerV2Api - factory interface
 * @export
 */
export const MiraklControllerV2ApiFactory = function (configuration, basePath, axios) {
  const localVarFp = MiraklControllerV2ApiFp(configuration);
  return {
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    miraklV2TenantReasonsGet(tenant, options) {
      return localVarFp.miraklV2TenantReasonsGet(tenant, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} subOrderid the seller\&#39;s suborder id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    miraklV2TenantSubOrderidGet(tenant, subOrderid, options) {
      return localVarFp
        .miraklV2TenantSubOrderidGet(tenant, subOrderid, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} subOrderid the seller\&#39;s suborder id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    miraklV2TenantSubOrderidThreadsGet(tenant, subOrderid, options) {
      return localVarFp
        .miraklV2TenantSubOrderidThreadsGet(tenant, subOrderid, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} subOrderid the seller\&#39;s suborder id
     * @param {MiraklCreateThreadRequestBodyV2} MiraklCreateThreadRequestBodyV2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    miraklV2TenantSubOrderidThreadsPost(tenant, subOrderid, MiraklCreateThreadRequestBodyV2, options) {
      return localVarFp
        .miraklV2TenantSubOrderidThreadsPost(tenant, subOrderid, MiraklCreateThreadRequestBodyV2, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} subOrderid the seller\&#39;s suborder id
     * @param {string} threadId the thread\&#39;s id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    miraklV2TenantSubOrderidThreadsThreadIdGet(tenant, subOrderid, threadId, options) {
      return localVarFp
        .miraklV2TenantSubOrderidThreadsThreadIdGet(tenant, subOrderid, threadId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * dowload attachment with id
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} subOrderid the seller\&#39;s suborder id
     * @param {string} threadId the thread\&#39;s id
     * @param {string} attachmentId the attachment\&#39;s id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    miraklV2TenantSubOrderidThreadsThreadIdMessageAttachmentsAttachmentIdGet(
      tenant,
      subOrderid,
      threadId,
      attachmentId,
      options
    ) {
      return localVarFp
        .miraklV2TenantSubOrderidThreadsThreadIdMessageAttachmentsAttachmentIdGet(
          tenant,
          subOrderid,
          threadId,
          attachmentId,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} subOrderid the seller\&#39;s suborder id
     * @param {string} threadId the thread\&#39;s id
     * @param {MiraklAddMessageRequestBodyV2} MiraklAddMessageRequestBodyV2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    miraklV2TenantSubOrderidThreadsThreadIdMessagePost(
      tenant,
      subOrderid,
      threadId,
      MiraklAddMessageRequestBodyV2,
      options
    ) {
      return localVarFp
        .miraklV2TenantSubOrderidThreadsThreadIdMessagePost(
          tenant,
          subOrderid,
          threadId,
          MiraklAddMessageRequestBodyV2,
          options
        )
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * MiraklControllerV2Api - object-oriented interface
 * @export
 * @class MiraklControllerV2Api
 * @extends {BaseAPI}
 */
export class MiraklControllerV2Api extends BaseAPI {
  /**
   *
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MiraklControllerV2Api
   */
  miraklV2TenantReasonsGet(tenant, options) {
    return MiraklControllerV2ApiFp(this.configuration)
      .miraklV2TenantReasonsGet(tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} subOrderid the seller\&#39;s suborder id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MiraklControllerV2Api
   */
  miraklV2TenantSubOrderidGet(tenant, subOrderid, options) {
    return MiraklControllerV2ApiFp(this.configuration)
      .miraklV2TenantSubOrderidGet(tenant, subOrderid, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} subOrderid the seller\&#39;s suborder id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MiraklControllerV2Api
   */
  miraklV2TenantSubOrderidThreadsGet(tenant, subOrderid, options) {
    return MiraklControllerV2ApiFp(this.configuration)
      .miraklV2TenantSubOrderidThreadsGet(tenant, subOrderid, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} subOrderid the seller\&#39;s suborder id
   * @param {MiraklCreateThreadRequestBodyV2} MiraklCreateThreadRequestBodyV2
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MiraklControllerV2Api
   */
  miraklV2TenantSubOrderidThreadsPost(tenant, subOrderid, MiraklCreateThreadRequestBodyV2, options) {
    return MiraklControllerV2ApiFp(this.configuration)
      .miraklV2TenantSubOrderidThreadsPost(tenant, subOrderid, MiraklCreateThreadRequestBodyV2, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} subOrderid the seller\&#39;s suborder id
   * @param {string} threadId the thread\&#39;s id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MiraklControllerV2Api
   */
  miraklV2TenantSubOrderidThreadsThreadIdGet(tenant, subOrderid, threadId, options) {
    return MiraklControllerV2ApiFp(this.configuration)
      .miraklV2TenantSubOrderidThreadsThreadIdGet(tenant, subOrderid, threadId, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * dowload attachment with id
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} subOrderid the seller\&#39;s suborder id
   * @param {string} threadId the thread\&#39;s id
   * @param {string} attachmentId the attachment\&#39;s id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MiraklControllerV2Api
   */
  miraklV2TenantSubOrderidThreadsThreadIdMessageAttachmentsAttachmentIdGet(
    tenant,
    subOrderid,
    threadId,
    attachmentId,
    options
  ) {
    return MiraklControllerV2ApiFp(this.configuration)
      .miraklV2TenantSubOrderidThreadsThreadIdMessageAttachmentsAttachmentIdGet(
        tenant,
        subOrderid,
        threadId,
        attachmentId,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} subOrderid the seller\&#39;s suborder id
   * @param {string} threadId the thread\&#39;s id
   * @param {MiraklAddMessageRequestBodyV2} MiraklAddMessageRequestBodyV2
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MiraklControllerV2Api
   */
  miraklV2TenantSubOrderidThreadsThreadIdMessagePost(
    tenant,
    subOrderid,
    threadId,
    MiraklAddMessageRequestBodyV2,
    options
  ) {
    return MiraklControllerV2ApiFp(this.configuration)
      .miraklV2TenantSubOrderidThreadsThreadIdMessagePost(
        tenant,
        subOrderid,
        threadId,
        MiraklAddMessageRequestBodyV2,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * MobileAccountControllerV1Api - axios parameter creator
 * @export
 */
export const MobileAccountControllerV1ApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Used by a customer to retrieve a push notifications configuration
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} leanPlumUserId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdGet: async (
      tenant,
      leanPlumUserId,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdGet", "tenant", tenant);
      // verify required parameter 'leanPlumUserId' is not null or undefined
      assertParamExists(
        "mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdGet",
        "leanPlumUserId",
        leanPlumUserId
      );
      const localVarPath = `/mobileaccount/v1/{tenant}/pushNotificationsConfiguration/{leanPlumUserId}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"leanPlumUserId"}}`, encodeURIComponent(String(leanPlumUserId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Used by a customer to set a push notifications toggles
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} leanPlumUserId
     * @param {PushNotificationsTogglesDto} PushNotificationsTogglesDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesPost: async (
      tenant,
      leanPlumUserId,
      PushNotificationsTogglesDto,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists(
        "mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesPost",
        "tenant",
        tenant
      );
      // verify required parameter 'leanPlumUserId' is not null or undefined
      assertParamExists(
        "mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesPost",
        "leanPlumUserId",
        leanPlumUserId
      );
      // verify required parameter 'PushNotificationsTogglesDto' is not null or undefined
      assertParamExists(
        "mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesPost",
        "PushNotificationsTogglesDto",
        PushNotificationsTogglesDto
      );
      const localVarPath = `/mobileaccount/v1/{tenant}/pushNotificationsConfiguration/{leanPlumUserId}/toggles`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"leanPlumUserId"}}`, encodeURIComponent(String(leanPlumUserId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        PushNotificationsTogglesDto,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Used by a customer to set a push notifications toggles
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} leanPlumUserId
     * @param {string} toggleName
     * @param {MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest} MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePost: async (
      tenant,
      leanPlumUserId,
      toggleName,
      MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists(
        "mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePost",
        "tenant",
        tenant
      );
      // verify required parameter 'leanPlumUserId' is not null or undefined
      assertParamExists(
        "mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePost",
        "leanPlumUserId",
        leanPlumUserId
      );
      // verify required parameter 'toggleName' is not null or undefined
      assertParamExists(
        "mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePost",
        "toggleName",
        toggleName
      );
      // verify required parameter 'MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest' is not null or undefined
      assertParamExists(
        "mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePost",
        "MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest",
        MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest
      );
      const localVarPath =
        `/mobileaccount/v1/{tenant}/pushNotificationsConfiguration/{leanPlumUserId}/toggles/{toggleName}`
          .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
          .replace(`{${"leanPlumUserId"}}`, encodeURIComponent(String(leanPlumUserId)))
          .replace(`{${"toggleName"}}`, encodeURIComponent(String(toggleName)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * MobileAccountControllerV1Api - functional programming interface
 * @export
 */
export const MobileAccountControllerV1ApiFp = function (configuration) {
  const localVarAxiosParamCreator = MobileAccountControllerV1ApiAxiosParamCreator(configuration);
  return {
    /**
     * Used by a customer to retrieve a push notifications configuration
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} leanPlumUserId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdGet(tenant, leanPlumUserId, options) {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdGet(
          tenant,
          leanPlumUserId,
          options
        );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Used by a customer to set a push notifications toggles
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} leanPlumUserId
     * @param {PushNotificationsTogglesDto} PushNotificationsTogglesDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesPost(
      tenant,
      leanPlumUserId,
      PushNotificationsTogglesDto,
      options
    ) {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesPost(
          tenant,
          leanPlumUserId,
          PushNotificationsTogglesDto,
          options
        );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Used by a customer to set a push notifications toggles
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} leanPlumUserId
     * @param {string} toggleName
     * @param {MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest} MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePost(
      tenant,
      leanPlumUserId,
      toggleName,
      MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest,
      options
    ) {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePost(
          tenant,
          leanPlumUserId,
          toggleName,
          MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest,
          options
        );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * MobileAccountControllerV1Api - factory interface
 * @export
 */
export const MobileAccountControllerV1ApiFactory = function (configuration, basePath, axios) {
  const localVarFp = MobileAccountControllerV1ApiFp(configuration);
  return {
    /**
     * Used by a customer to retrieve a push notifications configuration
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} leanPlumUserId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdGet(tenant, leanPlumUserId, options) {
      return localVarFp
        .mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdGet(tenant, leanPlumUserId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Used by a customer to set a push notifications toggles
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} leanPlumUserId
     * @param {PushNotificationsTogglesDto} PushNotificationsTogglesDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesPost(
      tenant,
      leanPlumUserId,
      PushNotificationsTogglesDto,
      options
    ) {
      return localVarFp
        .mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesPost(
          tenant,
          leanPlumUserId,
          PushNotificationsTogglesDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Used by a customer to set a push notifications toggles
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} leanPlumUserId
     * @param {string} toggleName
     * @param {MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest} MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePost(
      tenant,
      leanPlumUserId,
      toggleName,
      MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest,
      options
    ) {
      return localVarFp
        .mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePost(
          tenant,
          leanPlumUserId,
          toggleName,
          MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest,
          options
        )
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * MobileAccountControllerV1Api - object-oriented interface
 * @export
 * @class MobileAccountControllerV1Api
 * @extends {BaseAPI}
 */
export class MobileAccountControllerV1Api extends BaseAPI {
  /**
   * Used by a customer to retrieve a push notifications configuration
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} leanPlumUserId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MobileAccountControllerV1Api
   */
  mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdGet(tenant, leanPlumUserId, options) {
    return MobileAccountControllerV1ApiFp(this.configuration)
      .mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdGet(tenant, leanPlumUserId, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Used by a customer to set a push notifications toggles
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} leanPlumUserId
   * @param {PushNotificationsTogglesDto} PushNotificationsTogglesDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MobileAccountControllerV1Api
   */
  mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesPost(
    tenant,
    leanPlumUserId,
    PushNotificationsTogglesDto,
    options
  ) {
    return MobileAccountControllerV1ApiFp(this.configuration)
      .mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesPost(
        tenant,
        leanPlumUserId,
        PushNotificationsTogglesDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Used by a customer to set a push notifications toggles
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} leanPlumUserId
   * @param {string} toggleName
   * @param {MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest} MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MobileAccountControllerV1Api
   */
  mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePost(
    tenant,
    leanPlumUserId,
    toggleName,
    MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest,
    options
  ) {
    return MobileAccountControllerV1ApiFp(this.configuration)
      .mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePost(
        tenant,
        leanPlumUserId,
        toggleName,
        MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * MyTherapyControllerV1Api - axios parameter creator
 * @export
 */
export const MyTherapyControllerV1ApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Used by a customer to retrieve a MyTherapy activation link
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderNumber
     * @param {'SAE App' | 'Email' | 'Webshop' | 'Package Insert'} [attributionChannel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mytherapyV1TenantOrdersOrderNumberActivationLinkGet: async (
      tenant,
      orderNumber,
      attributionChannel,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("mytherapyV1TenantOrdersOrderNumberActivationLinkGet", "tenant", tenant);
      // verify required parameter 'orderNumber' is not null or undefined
      assertParamExists("mytherapyV1TenantOrdersOrderNumberActivationLinkGet", "orderNumber", orderNumber);
      const localVarPath = `/mytherapy/v1/{tenant}/orders/{orderNumber}/activationLink`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"orderNumber"}}`, encodeURIComponent(String(orderNumber)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (attributionChannel !== undefined) {
        localVarQueryParameter["attributionChannel"] = attributionChannel;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * MyTherapyControllerV1Api - functional programming interface
 * @export
 */
export const MyTherapyControllerV1ApiFp = function (configuration) {
  const localVarAxiosParamCreator = MyTherapyControllerV1ApiAxiosParamCreator(configuration);
  return {
    /**
     * Used by a customer to retrieve a MyTherapy activation link
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderNumber
     * @param {'SAE App' | 'Email' | 'Webshop' | 'Package Insert'} [attributionChannel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mytherapyV1TenantOrdersOrderNumberActivationLinkGet(tenant, orderNumber, attributionChannel, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.mytherapyV1TenantOrdersOrderNumberActivationLinkGet(
        tenant,
        orderNumber,
        attributionChannel,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * MyTherapyControllerV1Api - factory interface
 * @export
 */
export const MyTherapyControllerV1ApiFactory = function (configuration, basePath, axios) {
  const localVarFp = MyTherapyControllerV1ApiFp(configuration);
  return {
    /**
     * Used by a customer to retrieve a MyTherapy activation link
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderNumber
     * @param {'SAE App' | 'Email' | 'Webshop' | 'Package Insert'} [attributionChannel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mytherapyV1TenantOrdersOrderNumberActivationLinkGet(tenant, orderNumber, attributionChannel, options) {
      return localVarFp
        .mytherapyV1TenantOrdersOrderNumberActivationLinkGet(tenant, orderNumber, attributionChannel, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * MyTherapyControllerV1Api - object-oriented interface
 * @export
 * @class MyTherapyControllerV1Api
 * @extends {BaseAPI}
 */
export class MyTherapyControllerV1Api extends BaseAPI {
  /**
   * Used by a customer to retrieve a MyTherapy activation link
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} orderNumber
   * @param {'SAE App' | 'Email' | 'Webshop' | 'Package Insert'} [attributionChannel]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MyTherapyControllerV1Api
   */
  mytherapyV1TenantOrdersOrderNumberActivationLinkGet(tenant, orderNumber, attributionChannel, options) {
    return MyTherapyControllerV1ApiFp(this.configuration)
      .mytherapyV1TenantOrdersOrderNumberActivationLinkGet(tenant, orderNumber, attributionChannel, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * NewsletterControllerApi - axios parameter creator
 * @export
 */
export const NewsletterControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageNewsletterV1TenantEmailDelete: async (tenant, language, email, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageNewsletterV1TenantEmailDelete", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageNewsletterV1TenantEmailDelete", "language", language);
      // verify required parameter 'email' is not null or undefined
      assertParamExists("languageNewsletterV1TenantEmailDelete", "email", email);
      const localVarPath = `/{language}/newsletter/v1/{tenant}/{email}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"email"}}`, encodeURIComponent(String(email)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "DELETE", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} token
     * @param {string} email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageNewsletterV1TenantEmailOptinTokenGet: async (tenant, language, token, email, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageNewsletterV1TenantEmailOptinTokenGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageNewsletterV1TenantEmailOptinTokenGet", "language", language);
      // verify required parameter 'token' is not null or undefined
      assertParamExists("languageNewsletterV1TenantEmailOptinTokenGet", "token", token);
      // verify required parameter 'email' is not null or undefined
      assertParamExists("languageNewsletterV1TenantEmailOptinTokenGet", "email", email);
      const localVarPath = `/{language}/newsletter/v1/{tenant}/{email}/optin/{token}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"token"}}`, encodeURIComponent(String(token)))
        .replace(`{${"email"}}`, encodeURIComponent(String(email)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {NewsletterRequestV1} NewsletterRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageNewsletterV1TenantPost: async (tenant, language, NewsletterRequestV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageNewsletterV1TenantPost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageNewsletterV1TenantPost", "language", language);
      // verify required parameter 'NewsletterRequestV1' is not null or undefined
      assertParamExists("languageNewsletterV1TenantPost", "NewsletterRequestV1", NewsletterRequestV1);
      const localVarPath = `/{language}/newsletter/v1/{tenant}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(NewsletterRequestV1, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * NewsletterControllerApi - functional programming interface
 * @export
 */
export const NewsletterControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = NewsletterControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageNewsletterV1TenantEmailDelete(tenant, language, email, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageNewsletterV1TenantEmailDelete(
        tenant,
        language,
        email,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} token
     * @param {string} email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageNewsletterV1TenantEmailOptinTokenGet(tenant, language, token, email, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageNewsletterV1TenantEmailOptinTokenGet(
        tenant,
        language,
        token,
        email,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {NewsletterRequestV1} NewsletterRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageNewsletterV1TenantPost(tenant, language, NewsletterRequestV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageNewsletterV1TenantPost(
        tenant,
        language,
        NewsletterRequestV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * NewsletterControllerApi - factory interface
 * @export
 */
export const NewsletterControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = NewsletterControllerApiFp(configuration);
  return {
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageNewsletterV1TenantEmailDelete(tenant, language, email, options) {
      return localVarFp
        .languageNewsletterV1TenantEmailDelete(tenant, language, email, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} token
     * @param {string} email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageNewsletterV1TenantEmailOptinTokenGet(tenant, language, token, email, options) {
      return localVarFp
        .languageNewsletterV1TenantEmailOptinTokenGet(tenant, language, token, email, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {NewsletterRequestV1} NewsletterRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageNewsletterV1TenantPost(tenant, language, NewsletterRequestV1, options) {
      return localVarFp
        .languageNewsletterV1TenantPost(tenant, language, NewsletterRequestV1, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * NewsletterControllerApi - object-oriented interface
 * @export
 * @class NewsletterControllerApi
 * @extends {BaseAPI}
 */
export class NewsletterControllerApi extends BaseAPI {
  /**
   *
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {string} email
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NewsletterControllerApi
   */
  languageNewsletterV1TenantEmailDelete(tenant, language, email, options) {
    return NewsletterControllerApiFp(this.configuration)
      .languageNewsletterV1TenantEmailDelete(tenant, language, email, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {string} token
   * @param {string} email
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NewsletterControllerApi
   */
  languageNewsletterV1TenantEmailOptinTokenGet(tenant, language, token, email, options) {
    return NewsletterControllerApiFp(this.configuration)
      .languageNewsletterV1TenantEmailOptinTokenGet(tenant, language, token, email, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {NewsletterRequestV1} NewsletterRequestV1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NewsletterControllerApi
   */
  languageNewsletterV1TenantPost(tenant, language, NewsletterRequestV1, options) {
    return NewsletterControllerApiFp(this.configuration)
      .languageNewsletterV1TenantPost(tenant, language, NewsletterRequestV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * NotepadControllerV2Api - axios parameter creator
 * @export
 */
export const NotepadControllerV2ApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Gets list of notepad entries accumulated with pim products and offers.
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {number} [limit] The limit specifies the maximum number of documents the endpoint will return. A limit value of 0 is equivalent to setting no limit.
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageNotepadV2TenantGet: async (language, tenant, limit, page, options = {}) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageNotepadV2TenantGet", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageNotepadV2TenantGet", "tenant", tenant);
      const localVarPath = `/{language}/notepad/v2/{tenant}`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }
      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Deletes single notepad entry
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upid Unique product identifiers as comma separated list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageNotepadV2TenantUpidDelete: async (language, tenant, upid, options = {}) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageNotepadV2TenantUpidDelete", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageNotepadV2TenantUpidDelete", "tenant", tenant);
      // verify required parameter 'upid' is not null or undefined
      assertParamExists("languageNotepadV2TenantUpidDelete", "upid", upid);
      const localVarPath = `/{language}/notepad/v2/{tenant}/{upid}`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"upid"}}`, encodeURIComponent(String(upid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "DELETE", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Gets single notepad entry
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upid Unique product identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageNotepadV2TenantUpidGet: async (language, tenant, upid, options = {}) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageNotepadV2TenantUpidGet", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageNotepadV2TenantUpidGet", "tenant", tenant);
      // verify required parameter 'upid' is not null or undefined
      assertParamExists("languageNotepadV2TenantUpidGet", "upid", upid);
      const localVarPath = `/{language}/notepad/v2/{tenant}/{upid}`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"upid"}}`, encodeURIComponent(String(upid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Adds single notepad entry
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upid Unique product identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageNotepadV2TenantUpidPut: async (language, tenant, upid, options = {}) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageNotepadV2TenantUpidPut", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageNotepadV2TenantUpidPut", "tenant", tenant);
      // verify required parameter 'upid' is not null or undefined
      assertParamExists("languageNotepadV2TenantUpidPut", "upid", upid);
      const localVarPath = `/{language}/notepad/v2/{tenant}/{upid}`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"upid"}}`, encodeURIComponent(String(upid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "PUT", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Gets list of upids for notepad entries.
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageNotepadV2TenantUpidsGet: async (language, tenant, options = {}) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageNotepadV2TenantUpidsGet", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageNotepadV2TenantUpidsGet", "tenant", tenant);
      const localVarPath = `/{language}/notepad/v2/{tenant}/upids`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * NotepadControllerV2Api - functional programming interface
 * @export
 */
export const NotepadControllerV2ApiFp = function (configuration) {
  const localVarAxiosParamCreator = NotepadControllerV2ApiAxiosParamCreator(configuration);
  return {
    /**
     * Gets list of notepad entries accumulated with pim products and offers.
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {number} [limit] The limit specifies the maximum number of documents the endpoint will return. A limit value of 0 is equivalent to setting no limit.
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageNotepadV2TenantGet(language, tenant, limit, page, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageNotepadV2TenantGet(
        language,
        tenant,
        limit,
        page,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Deletes single notepad entry
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upid Unique product identifiers as comma separated list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageNotepadV2TenantUpidDelete(language, tenant, upid, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageNotepadV2TenantUpidDelete(
        language,
        tenant,
        upid,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Gets single notepad entry
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upid Unique product identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageNotepadV2TenantUpidGet(language, tenant, upid, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageNotepadV2TenantUpidGet(
        language,
        tenant,
        upid,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Adds single notepad entry
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upid Unique product identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageNotepadV2TenantUpidPut(language, tenant, upid, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageNotepadV2TenantUpidPut(
        language,
        tenant,
        upid,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Gets list of upids for notepad entries.
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageNotepadV2TenantUpidsGet(language, tenant, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageNotepadV2TenantUpidsGet(
        language,
        tenant,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * NotepadControllerV2Api - factory interface
 * @export
 */
export const NotepadControllerV2ApiFactory = function (configuration, basePath, axios) {
  const localVarFp = NotepadControllerV2ApiFp(configuration);
  return {
    /**
     * Gets list of notepad entries accumulated with pim products and offers.
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {number} [limit] The limit specifies the maximum number of documents the endpoint will return. A limit value of 0 is equivalent to setting no limit.
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageNotepadV2TenantGet(language, tenant, limit, page, options) {
      return localVarFp
        .languageNotepadV2TenantGet(language, tenant, limit, page, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Deletes single notepad entry
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upid Unique product identifiers as comma separated list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageNotepadV2TenantUpidDelete(language, tenant, upid, options) {
      return localVarFp
        .languageNotepadV2TenantUpidDelete(language, tenant, upid, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Gets single notepad entry
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upid Unique product identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageNotepadV2TenantUpidGet(language, tenant, upid, options) {
      return localVarFp
        .languageNotepadV2TenantUpidGet(language, tenant, upid, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Adds single notepad entry
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upid Unique product identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageNotepadV2TenantUpidPut(language, tenant, upid, options) {
      return localVarFp
        .languageNotepadV2TenantUpidPut(language, tenant, upid, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Gets list of upids for notepad entries.
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageNotepadV2TenantUpidsGet(language, tenant, options) {
      return localVarFp
        .languageNotepadV2TenantUpidsGet(language, tenant, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * NotepadControllerV2Api - object-oriented interface
 * @export
 * @class NotepadControllerV2Api
 * @extends {BaseAPI}
 */
export class NotepadControllerV2Api extends BaseAPI {
  /**
   * Gets list of notepad entries accumulated with pim products and offers.
   * @param {string} language
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {number} [limit] The limit specifies the maximum number of documents the endpoint will return. A limit value of 0 is equivalent to setting no limit.
   * @param {number} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotepadControllerV2Api
   */
  languageNotepadV2TenantGet(language, tenant, limit, page, options) {
    return NotepadControllerV2ApiFp(this.configuration)
      .languageNotepadV2TenantGet(language, tenant, limit, page, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Deletes single notepad entry
   * @param {string} language
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} upid Unique product identifiers as comma separated list
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotepadControllerV2Api
   */
  languageNotepadV2TenantUpidDelete(language, tenant, upid, options) {
    return NotepadControllerV2ApiFp(this.configuration)
      .languageNotepadV2TenantUpidDelete(language, tenant, upid, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Gets single notepad entry
   * @param {string} language
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} upid Unique product identifier
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotepadControllerV2Api
   */
  languageNotepadV2TenantUpidGet(language, tenant, upid, options) {
    return NotepadControllerV2ApiFp(this.configuration)
      .languageNotepadV2TenantUpidGet(language, tenant, upid, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Adds single notepad entry
   * @param {string} language
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} upid Unique product identifier
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotepadControllerV2Api
   */
  languageNotepadV2TenantUpidPut(language, tenant, upid, options) {
    return NotepadControllerV2ApiFp(this.configuration)
      .languageNotepadV2TenantUpidPut(language, tenant, upid, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Gets list of upids for notepad entries.
   * @param {string} language
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotepadControllerV2Api
   */
  languageNotepadV2TenantUpidsGet(language, tenant, options) {
    return NotepadControllerV2ApiFp(this.configuration)
      .languageNotepadV2TenantUpidsGet(language, tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * NowControllerApi - axios parameter creator
 * @export
 */
export const NowControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Wraps now-service\'s init checkout call for cart data using customer\'s billing address
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
     * @param {NowV1TenantInitCartPostRequest} [NowV1TenantInitCartPostRequest] Current cart contents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nowV1TenantInitCartPost: async (tenant, Sae_Device_Type, NowV1TenantInitCartPostRequest, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("nowV1TenantInitCartPost", "tenant", tenant);
      const localVarPath = `/now/v1/{tenant}/init/cart`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (Sae_Device_Type != null) {
        localVarHeaderParameter["Sae-Device-Type"] = String(Sae_Device_Type);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        NowV1TenantInitCartPostRequest,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * NowControllerApi - functional programming interface
 * @export
 */
export const NowControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = NowControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * Wraps now-service\'s init checkout call for cart data using customer\'s billing address
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
     * @param {NowV1TenantInitCartPostRequest} [NowV1TenantInitCartPostRequest] Current cart contents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async nowV1TenantInitCartPost(tenant, Sae_Device_Type, NowV1TenantInitCartPostRequest, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.nowV1TenantInitCartPost(
        tenant,
        Sae_Device_Type,
        NowV1TenantInitCartPostRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * NowControllerApi - factory interface
 * @export
 */
export const NowControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = NowControllerApiFp(configuration);
  return {
    /**
     * Wraps now-service\'s init checkout call for cart data using customer\'s billing address
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
     * @param {NowV1TenantInitCartPostRequest} [NowV1TenantInitCartPostRequest] Current cart contents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nowV1TenantInitCartPost(tenant, Sae_Device_Type, NowV1TenantInitCartPostRequest, options) {
      return localVarFp
        .nowV1TenantInitCartPost(tenant, Sae_Device_Type, NowV1TenantInitCartPostRequest, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * NowControllerApi - object-oriented interface
 * @export
 * @class NowControllerApi
 * @extends {BaseAPI}
 */
export class NowControllerApi extends BaseAPI {
  /**
   * Wraps now-service\'s init checkout call for cart data using customer\'s billing address
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
   * @param {NowV1TenantInitCartPostRequest} [NowV1TenantInitCartPostRequest] Current cart contents
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NowControllerApi
   */
  nowV1TenantInitCartPost(tenant, Sae_Device_Type, NowV1TenantInitCartPostRequest, options) {
    return NowControllerApiFp(this.configuration)
      .nowV1TenantInitCartPost(tenant, Sae_Device_Type, NowV1TenantInitCartPostRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * NowControllerV3Api - axios parameter creator
 * @export
 */
export const NowControllerV3ApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {BasicCheckObject} [BasicCheckObject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nowV3TenantBasicCheckPost: async (tenant, BasicCheckObject, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("nowV3TenantBasicCheckPost", "tenant", tenant);
      const localVarPath = `/now/v3/{tenant}/basicCheck`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(BasicCheckObject, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Wraps now merchant center services
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} sellerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nowV3TenantNowMerchantSellerIdGet: async (tenant, sellerId, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("nowV3TenantNowMerchantSellerIdGet", "tenant", tenant);
      // verify required parameter 'sellerId' is not null or undefined
      assertParamExists("nowV3TenantNowMerchantSellerIdGet", "sellerId", sellerId);
      const localVarPath = `/now/v3/{tenant}/nowMerchant/{sellerId}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Get Now related invoices and other documents
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderNumber
     * @param {string} subOrderId
     * @param {string} documentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nowV3TenantOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet: async (
      tenant,
      orderNumber,
      subOrderId,
      documentId,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("nowV3TenantOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet", "tenant", tenant);
      // verify required parameter 'orderNumber' is not null or undefined
      assertParamExists("nowV3TenantOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet", "orderNumber", orderNumber);
      // verify required parameter 'subOrderId' is not null or undefined
      assertParamExists("nowV3TenantOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet", "subOrderId", subOrderId);
      // verify required parameter 'documentId' is not null or undefined
      assertParamExists("nowV3TenantOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet", "documentId", documentId);
      const localVarPath = `/now/v3/{tenant}/orders/{orderNumber}/{subOrderId}/documents/{documentId}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"orderNumber"}}`, encodeURIComponent(String(orderNumber)))
        .replace(`{${"subOrderId"}}`, encodeURIComponent(String(subOrderId)))
        .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * NowControllerV3Api - functional programming interface
 * @export
 */
export const NowControllerV3ApiFp = function (configuration) {
  const localVarAxiosParamCreator = NowControllerV3ApiAxiosParamCreator(configuration);
  return {
    /**
     * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {BasicCheckObject} [BasicCheckObject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async nowV3TenantBasicCheckPost(tenant, BasicCheckObject, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.nowV3TenantBasicCheckPost(
        tenant,
        BasicCheckObject,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Wraps now merchant center services
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} sellerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async nowV3TenantNowMerchantSellerIdGet(tenant, sellerId, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.nowV3TenantNowMerchantSellerIdGet(
        tenant,
        sellerId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Get Now related invoices and other documents
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderNumber
     * @param {string} subOrderId
     * @param {string} documentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async nowV3TenantOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet(
      tenant,
      orderNumber,
      subOrderId,
      documentId,
      options
    ) {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.nowV3TenantOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet(
          tenant,
          orderNumber,
          subOrderId,
          documentId,
          options
        );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * NowControllerV3Api - factory interface
 * @export
 */
export const NowControllerV3ApiFactory = function (configuration, basePath, axios) {
  const localVarFp = NowControllerV3ApiFp(configuration);
  return {
    /**
     * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {BasicCheckObject} [BasicCheckObject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nowV3TenantBasicCheckPost(tenant, BasicCheckObject, options) {
      return localVarFp
        .nowV3TenantBasicCheckPost(tenant, BasicCheckObject, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Wraps now merchant center services
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} sellerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nowV3TenantNowMerchantSellerIdGet(tenant, sellerId, options) {
      return localVarFp
        .nowV3TenantNowMerchantSellerIdGet(tenant, sellerId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get Now related invoices and other documents
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderNumber
     * @param {string} subOrderId
     * @param {string} documentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nowV3TenantOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet(tenant, orderNumber, subOrderId, documentId, options) {
      return localVarFp
        .nowV3TenantOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet(
          tenant,
          orderNumber,
          subOrderId,
          documentId,
          options
        )
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * NowControllerV3Api - object-oriented interface
 * @export
 * @class NowControllerV3Api
 * @extends {BaseAPI}
 */
export class NowControllerV3Api extends BaseAPI {
  /**
   * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {BasicCheckObject} [BasicCheckObject]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NowControllerV3Api
   */
  nowV3TenantBasicCheckPost(tenant, BasicCheckObject, options) {
    return NowControllerV3ApiFp(this.configuration)
      .nowV3TenantBasicCheckPost(tenant, BasicCheckObject, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Wraps now merchant center services
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} sellerId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NowControllerV3Api
   */
  nowV3TenantNowMerchantSellerIdGet(tenant, sellerId, options) {
    return NowControllerV3ApiFp(this.configuration)
      .nowV3TenantNowMerchantSellerIdGet(tenant, sellerId, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get Now related invoices and other documents
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} orderNumber
   * @param {string} subOrderId
   * @param {string} documentId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NowControllerV3Api
   */
  nowV3TenantOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet(tenant, orderNumber, subOrderId, documentId, options) {
    return NowControllerV3ApiFp(this.configuration)
      .nowV3TenantOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet(
        tenant,
        orderNumber,
        subOrderId,
        documentId,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * OdsServiceControllerApi - axios parameter creator
 * @export
 */
export const OdsServiceControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @summary Adds ods product and consultation to cart
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {OdsPatchCartRequestV1} OdsPatchCartRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    odsApiPatchCart: async (tenant, OdsPatchCartRequestV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("odsApiPatchCart", "tenant", tenant);
      // verify required parameter 'OdsPatchCartRequestV1' is not null or undefined
      assertParamExists("odsApiPatchCart", "OdsPatchCartRequestV1", OdsPatchCartRequestV1);
      const localVarPath = `/ods/v1/{tenant}/cart`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "PATCH", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(OdsPatchCartRequestV1, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Get treatments by icd10 of product
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {OdsRequestBodyV1} OdsRequestBodyV1 Treatments request body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    odsV1TenantTreatmentsPost: async (tenant, OdsRequestBodyV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("odsV1TenantTreatmentsPost", "tenant", tenant);
      // verify required parameter 'OdsRequestBodyV1' is not null or undefined
      assertParamExists("odsV1TenantTreatmentsPost", "OdsRequestBodyV1", OdsRequestBodyV1);
      const localVarPath = `/ods/v1/{tenant}/treatments`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(OdsRequestBodyV1, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Get all timeslots
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} providerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    odsV2TenantProvidersProviderIdTimeslotsGet: async (tenant, providerId, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("odsV2TenantProvidersProviderIdTimeslotsGet", "tenant", tenant);
      // verify required parameter 'providerId' is not null or undefined
      assertParamExists("odsV2TenantProvidersProviderIdTimeslotsGet", "providerId", providerId);
      const localVarPath = `/ods/v2/{tenant}/providers/{providerId}/timeslots`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"providerId"}}`, encodeURIComponent(String(providerId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Get all treatments by icd10 of product
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {'icd10'} [orderBy] orders the treatments by their id in ascending order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    odsV2TenantTreatmentsGet: async (tenant, orderBy, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("odsV2TenantTreatmentsGet", "tenant", tenant);
      const localVarPath = `/ods/v2/{tenant}/treatments`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (orderBy !== undefined) {
        localVarQueryParameter["orderBy"] = orderBy;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Get treatments by icd10 of product
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {OdsRequestBodyV1} OdsRequestBodyV1 Treatments request body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    odsV2TenantTreatmentsPost: async (tenant, OdsRequestBodyV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("odsV2TenantTreatmentsPost", "tenant", tenant);
      // verify required parameter 'OdsRequestBodyV1' is not null or undefined
      assertParamExists("odsV2TenantTreatmentsPost", "OdsRequestBodyV1", OdsRequestBodyV1);
      const localVarPath = `/ods/v2/{tenant}/treatments`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(OdsRequestBodyV1, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Get a treatment by it\'s exact service id
     * @param {string} serviceId The service id for the treatment
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    odsV2TenantTreatmentsServiceServiceIdGet: async (serviceId, tenant, options = {}) => {
      // verify required parameter 'serviceId' is not null or undefined
      assertParamExists("odsV2TenantTreatmentsServiceServiceIdGet", "serviceId", serviceId);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("odsV2TenantTreatmentsServiceServiceIdGet", "tenant", tenant);
      const localVarPath = `/ods/v2/{tenant}/treatments/service/{serviceId}`
        .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Get all providers of a certain treatment
     * @param {string} treatmentId
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    odsV2TenantTreatmentsTreatmentIdProvidersGet: async (treatmentId, tenant, options = {}) => {
      // verify required parameter 'treatmentId' is not null or undefined
      assertParamExists("odsV2TenantTreatmentsTreatmentIdProvidersGet", "treatmentId", treatmentId);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("odsV2TenantTreatmentsTreatmentIdProvidersGet", "tenant", tenant);
      const localVarPath = `/ods/v2/{tenant}/treatments/{treatmentId}/providers`
        .replace(`{${"treatmentId"}}`, encodeURIComponent(String(treatmentId)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Get a treatment by icd10 of product
     * @param {string} treatmentId
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    odsV2TenantTreatmentsTreatmentTreatmentIdGet: async (treatmentId, tenant, options = {}) => {
      // verify required parameter 'treatmentId' is not null or undefined
      assertParamExists("odsV2TenantTreatmentsTreatmentTreatmentIdGet", "treatmentId", treatmentId);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("odsV2TenantTreatmentsTreatmentTreatmentIdGet", "tenant", tenant);
      const localVarPath = `/ods/v2/{tenant}/treatments/treatment/{treatmentId}`
        .replace(`{${"treatmentId"}}`, encodeURIComponent(String(treatmentId)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * OdsServiceControllerApi - functional programming interface
 * @export
 */
export const OdsServiceControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = OdsServiceControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Adds ods product and consultation to cart
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {OdsPatchCartRequestV1} OdsPatchCartRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async odsApiPatchCart(tenant, OdsPatchCartRequestV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.odsApiPatchCart(tenant, OdsPatchCartRequestV1, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Get treatments by icd10 of product
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {OdsRequestBodyV1} OdsRequestBodyV1 Treatments request body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async odsV1TenantTreatmentsPost(tenant, OdsRequestBodyV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.odsV1TenantTreatmentsPost(
        tenant,
        OdsRequestBodyV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Get all timeslots
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} providerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async odsV2TenantProvidersProviderIdTimeslotsGet(tenant, providerId, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.odsV2TenantProvidersProviderIdTimeslotsGet(
        tenant,
        providerId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Get all treatments by icd10 of product
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {'icd10'} [orderBy] orders the treatments by their id in ascending order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async odsV2TenantTreatmentsGet(tenant, orderBy, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.odsV2TenantTreatmentsGet(tenant, orderBy, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Get treatments by icd10 of product
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {OdsRequestBodyV1} OdsRequestBodyV1 Treatments request body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async odsV2TenantTreatmentsPost(tenant, OdsRequestBodyV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.odsV2TenantTreatmentsPost(
        tenant,
        OdsRequestBodyV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Get a treatment by it\'s exact service id
     * @param {string} serviceId The service id for the treatment
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async odsV2TenantTreatmentsServiceServiceIdGet(serviceId, tenant, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.odsV2TenantTreatmentsServiceServiceIdGet(
        serviceId,
        tenant,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Get all providers of a certain treatment
     * @param {string} treatmentId
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async odsV2TenantTreatmentsTreatmentIdProvidersGet(treatmentId, tenant, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.odsV2TenantTreatmentsTreatmentIdProvidersGet(
        treatmentId,
        tenant,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Get a treatment by icd10 of product
     * @param {string} treatmentId
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async odsV2TenantTreatmentsTreatmentTreatmentIdGet(treatmentId, tenant, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.odsV2TenantTreatmentsTreatmentTreatmentIdGet(
        treatmentId,
        tenant,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * OdsServiceControllerApi - factory interface
 * @export
 */
export const OdsServiceControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = OdsServiceControllerApiFp(configuration);
  return {
    /**
     *
     * @summary Adds ods product and consultation to cart
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {OdsPatchCartRequestV1} OdsPatchCartRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    odsApiPatchCart(tenant, OdsPatchCartRequestV1, options) {
      return localVarFp
        .odsApiPatchCart(tenant, OdsPatchCartRequestV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get treatments by icd10 of product
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {OdsRequestBodyV1} OdsRequestBodyV1 Treatments request body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    odsV1TenantTreatmentsPost(tenant, OdsRequestBodyV1, options) {
      return localVarFp
        .odsV1TenantTreatmentsPost(tenant, OdsRequestBodyV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all timeslots
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} providerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    odsV2TenantProvidersProviderIdTimeslotsGet(tenant, providerId, options) {
      return localVarFp
        .odsV2TenantProvidersProviderIdTimeslotsGet(tenant, providerId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all treatments by icd10 of product
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {'icd10'} [orderBy] orders the treatments by their id in ascending order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    odsV2TenantTreatmentsGet(tenant, orderBy, options) {
      return localVarFp.odsV2TenantTreatmentsGet(tenant, orderBy, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get treatments by icd10 of product
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {OdsRequestBodyV1} OdsRequestBodyV1 Treatments request body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    odsV2TenantTreatmentsPost(tenant, OdsRequestBodyV1, options) {
      return localVarFp
        .odsV2TenantTreatmentsPost(tenant, OdsRequestBodyV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a treatment by it\'s exact service id
     * @param {string} serviceId The service id for the treatment
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    odsV2TenantTreatmentsServiceServiceIdGet(serviceId, tenant, options) {
      return localVarFp
        .odsV2TenantTreatmentsServiceServiceIdGet(serviceId, tenant, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all providers of a certain treatment
     * @param {string} treatmentId
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    odsV2TenantTreatmentsTreatmentIdProvidersGet(treatmentId, tenant, options) {
      return localVarFp
        .odsV2TenantTreatmentsTreatmentIdProvidersGet(treatmentId, tenant, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a treatment by icd10 of product
     * @param {string} treatmentId
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    odsV2TenantTreatmentsTreatmentTreatmentIdGet(treatmentId, tenant, options) {
      return localVarFp
        .odsV2TenantTreatmentsTreatmentTreatmentIdGet(treatmentId, tenant, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * OdsServiceControllerApi - object-oriented interface
 * @export
 * @class OdsServiceControllerApi
 * @extends {BaseAPI}
 */
export class OdsServiceControllerApi extends BaseAPI {
  /**
   *
   * @summary Adds ods product and consultation to cart
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {OdsPatchCartRequestV1} OdsPatchCartRequestV1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OdsServiceControllerApi
   */
  odsApiPatchCart(tenant, OdsPatchCartRequestV1, options) {
    return OdsServiceControllerApiFp(this.configuration)
      .odsApiPatchCart(tenant, OdsPatchCartRequestV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get treatments by icd10 of product
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {OdsRequestBodyV1} OdsRequestBodyV1 Treatments request body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OdsServiceControllerApi
   */
  odsV1TenantTreatmentsPost(tenant, OdsRequestBodyV1, options) {
    return OdsServiceControllerApiFp(this.configuration)
      .odsV1TenantTreatmentsPost(tenant, OdsRequestBodyV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get all timeslots
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} providerId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OdsServiceControllerApi
   */
  odsV2TenantProvidersProviderIdTimeslotsGet(tenant, providerId, options) {
    return OdsServiceControllerApiFp(this.configuration)
      .odsV2TenantProvidersProviderIdTimeslotsGet(tenant, providerId, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get all treatments by icd10 of product
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {'icd10'} [orderBy] orders the treatments by their id in ascending order
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OdsServiceControllerApi
   */
  odsV2TenantTreatmentsGet(tenant, orderBy, options) {
    return OdsServiceControllerApiFp(this.configuration)
      .odsV2TenantTreatmentsGet(tenant, orderBy, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get treatments by icd10 of product
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {OdsRequestBodyV1} OdsRequestBodyV1 Treatments request body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OdsServiceControllerApi
   */
  odsV2TenantTreatmentsPost(tenant, OdsRequestBodyV1, options) {
    return OdsServiceControllerApiFp(this.configuration)
      .odsV2TenantTreatmentsPost(tenant, OdsRequestBodyV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get a treatment by it\'s exact service id
   * @param {string} serviceId The service id for the treatment
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OdsServiceControllerApi
   */
  odsV2TenantTreatmentsServiceServiceIdGet(serviceId, tenant, options) {
    return OdsServiceControllerApiFp(this.configuration)
      .odsV2TenantTreatmentsServiceServiceIdGet(serviceId, tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get all providers of a certain treatment
   * @param {string} treatmentId
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OdsServiceControllerApi
   */
  odsV2TenantTreatmentsTreatmentIdProvidersGet(treatmentId, tenant, options) {
    return OdsServiceControllerApiFp(this.configuration)
      .odsV2TenantTreatmentsTreatmentIdProvidersGet(treatmentId, tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get a treatment by icd10 of product
   * @param {string} treatmentId
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OdsServiceControllerApi
   */
  odsV2TenantTreatmentsTreatmentTreatmentIdGet(treatmentId, tenant, options) {
    return OdsServiceControllerApiFp(this.configuration)
      .odsV2TenantTreatmentsTreatmentTreatmentIdGet(treatmentId, tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * OffersControllerApi - axios parameter creator
 * @export
 */
export const OffersControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Used to get up-to-date offer details.
     * @summary Request multiple offer details by providing a list of {offerId + prescriptionType + channel}
     * @param {string} tenant
     * @param {OffersRequestV1} OffersRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyOffersMultipleOffers: async (tenant, OffersRequestV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("bullyOffersMultipleOffers", "tenant", tenant);
      // verify required parameter 'OffersRequestV1' is not null or undefined
      assertParamExists("bullyOffersMultipleOffers", "OffersRequestV1", OffersRequestV1);
      const localVarPath = `/offers/v1/{tenant}`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(OffersRequestV1, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Returns the offer details for a provided offerId
     * @summary Request offer details for a single offer id
     * @param {string} tenant
     * @param {string} offerId Unique identifier of an offer
     * @param {string} [channel] The channel might adjust the returned price
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyOffersSingleOffer: async (tenant, offerId, channel, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("bullyOffersSingleOffer", "tenant", tenant);
      // verify required parameter 'offerId' is not null or undefined
      assertParamExists("bullyOffersSingleOffer", "offerId", offerId);
      const localVarPath = `/offers/v1/{tenant}/offer/{offerId}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"offerId"}}`, encodeURIComponent(String(offerId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (channel !== undefined) {
        localVarQueryParameter["channel"] = channel;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Returns the offer details for a provided offerId
     * @summary Request offer delivery costs for shipping methods
     * @param {string} tenant
     * @param {string} offerId Unique identifier of an offer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    offersV1TenantOfferDeliveryCostsOfferIdGet: async (tenant, offerId, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("offersV1TenantOfferDeliveryCostsOfferIdGet", "tenant", tenant);
      // verify required parameter 'offerId' is not null or undefined
      assertParamExists("offersV1TenantOfferDeliveryCostsOfferIdGet", "offerId", offerId);
      const localVarPath = `/offers/v1/{tenant}/offer/delivery-costs/{offerId}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"offerId"}}`, encodeURIComponent(String(offerId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Get all active offers for a specific product by uPid
     * @param {string} tenant
     * @param {string} uPid Unique identifier of product
     * @param {string} [channel] The channel might adjust the returned price
     * @param {string} [language] for non german speaking countries the language is needed to get information from pim to enrich data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    offersV1TenantUPidGet: async (tenant, uPid, channel, language, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("offersV1TenantUPidGet", "tenant", tenant);
      // verify required parameter 'uPid' is not null or undefined
      assertParamExists("offersV1TenantUPidGet", "uPid", uPid);
      const localVarPath = `/offers/v1/{tenant}/{uPid}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"uPid"}}`, encodeURIComponent(String(uPid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (channel !== undefined) {
        localVarQueryParameter["channel"] = channel;
      }
      if (language !== undefined) {
        localVarQueryParameter["language"] = language;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * OffersControllerApi - functional programming interface
 * @export
 */
export const OffersControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = OffersControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * Used to get up-to-date offer details.
     * @summary Request multiple offer details by providing a list of {offerId + prescriptionType + channel}
     * @param {string} tenant
     * @param {OffersRequestV1} OffersRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bullyOffersMultipleOffers(tenant, OffersRequestV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bullyOffersMultipleOffers(
        tenant,
        OffersRequestV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Returns the offer details for a provided offerId
     * @summary Request offer details for a single offer id
     * @param {string} tenant
     * @param {string} offerId Unique identifier of an offer
     * @param {string} [channel] The channel might adjust the returned price
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bullyOffersSingleOffer(tenant, offerId, channel, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bullyOffersSingleOffer(
        tenant,
        offerId,
        channel,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Returns the offer details for a provided offerId
     * @summary Request offer delivery costs for shipping methods
     * @param {string} tenant
     * @param {string} offerId Unique identifier of an offer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async offersV1TenantOfferDeliveryCostsOfferIdGet(tenant, offerId, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.offersV1TenantOfferDeliveryCostsOfferIdGet(
        tenant,
        offerId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Get all active offers for a specific product by uPid
     * @param {string} tenant
     * @param {string} uPid Unique identifier of product
     * @param {string} [channel] The channel might adjust the returned price
     * @param {string} [language] for non german speaking countries the language is needed to get information from pim to enrich data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async offersV1TenantUPidGet(tenant, uPid, channel, language, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.offersV1TenantUPidGet(
        tenant,
        uPid,
        channel,
        language,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * OffersControllerApi - factory interface
 * @export
 */
export const OffersControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = OffersControllerApiFp(configuration);
  return {
    /**
     * Used to get up-to-date offer details.
     * @summary Request multiple offer details by providing a list of {offerId + prescriptionType + channel}
     * @param {string} tenant
     * @param {OffersRequestV1} OffersRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyOffersMultipleOffers(tenant, OffersRequestV1, options) {
      return localVarFp
        .bullyOffersMultipleOffers(tenant, OffersRequestV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Returns the offer details for a provided offerId
     * @summary Request offer details for a single offer id
     * @param {string} tenant
     * @param {string} offerId Unique identifier of an offer
     * @param {string} [channel] The channel might adjust the returned price
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyOffersSingleOffer(tenant, offerId, channel, options) {
      return localVarFp
        .bullyOffersSingleOffer(tenant, offerId, channel, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Returns the offer details for a provided offerId
     * @summary Request offer delivery costs for shipping methods
     * @param {string} tenant
     * @param {string} offerId Unique identifier of an offer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    offersV1TenantOfferDeliveryCostsOfferIdGet(tenant, offerId, options) {
      return localVarFp
        .offersV1TenantOfferDeliveryCostsOfferIdGet(tenant, offerId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all active offers for a specific product by uPid
     * @param {string} tenant
     * @param {string} uPid Unique identifier of product
     * @param {string} [channel] The channel might adjust the returned price
     * @param {string} [language] for non german speaking countries the language is needed to get information from pim to enrich data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    offersV1TenantUPidGet(tenant, uPid, channel, language, options) {
      return localVarFp
        .offersV1TenantUPidGet(tenant, uPid, channel, language, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * OffersControllerApi - object-oriented interface
 * @export
 * @class OffersControllerApi
 * @extends {BaseAPI}
 */
export class OffersControllerApi extends BaseAPI {
  /**
   * Used to get up-to-date offer details.
   * @summary Request multiple offer details by providing a list of {offerId + prescriptionType + channel}
   * @param {string} tenant
   * @param {OffersRequestV1} OffersRequestV1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OffersControllerApi
   */
  bullyOffersMultipleOffers(tenant, OffersRequestV1, options) {
    return OffersControllerApiFp(this.configuration)
      .bullyOffersMultipleOffers(tenant, OffersRequestV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Returns the offer details for a provided offerId
   * @summary Request offer details for a single offer id
   * @param {string} tenant
   * @param {string} offerId Unique identifier of an offer
   * @param {string} [channel] The channel might adjust the returned price
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OffersControllerApi
   */
  bullyOffersSingleOffer(tenant, offerId, channel, options) {
    return OffersControllerApiFp(this.configuration)
      .bullyOffersSingleOffer(tenant, offerId, channel, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Returns the offer details for a provided offerId
   * @summary Request offer delivery costs for shipping methods
   * @param {string} tenant
   * @param {string} offerId Unique identifier of an offer
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OffersControllerApi
   */
  offersV1TenantOfferDeliveryCostsOfferIdGet(tenant, offerId, options) {
    return OffersControllerApiFp(this.configuration)
      .offersV1TenantOfferDeliveryCostsOfferIdGet(tenant, offerId, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get all active offers for a specific product by uPid
   * @param {string} tenant
   * @param {string} uPid Unique identifier of product
   * @param {string} [channel] The channel might adjust the returned price
   * @param {string} [language] for non german speaking countries the language is needed to get information from pim to enrich data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OffersControllerApi
   */
  offersV1TenantUPidGet(tenant, uPid, channel, language, options) {
    return OffersControllerApiFp(this.configuration)
      .offersV1TenantUPidGet(tenant, uPid, channel, language, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * OptimizelyControllerApi - axios parameter creator
 * @export
 */
export const OptimizelyControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Returns Optimizely\'s decision about which features and experiments a given user is exposed to. Optionally sends an impression event to the Optimizely analytics backend for any decision made for an experiment. This endpoint consolidates key functionality from the Full Stack SDKs into one convenient call.
     * @summary Activate selected features and experiments for the given user.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {OptimizelyActivateContextV1} OptimizelyActivateContextV1
     * @param {Array<string>} [featureKey] Key for the Optimizely Feature
     * @param {Array<string>} [experimentKey] Key for the Optimizely Experiment
     * @param {boolean} [disableTracking] Setting to true will disable impression tracking for experiments.
     * @param {'feature' | 'experiment'} [type] Limit the decisions to either experiment or features
     * @param {boolean} [enabled] Filter the activation response to return only enabled descisions.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizelyV1TenantActivatePost: async (
      tenant,
      OptimizelyActivateContextV1,
      featureKey,
      experimentKey,
      disableTracking,
      type,
      enabled,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("optimizelyV1TenantActivatePost", "tenant", tenant);
      // verify required parameter 'OptimizelyActivateContextV1' is not null or undefined
      assertParamExists("optimizelyV1TenantActivatePost", "OptimizelyActivateContextV1", OptimizelyActivateContextV1);
      const localVarPath = `/optimizely/v1/{tenant}/activate`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (featureKey) {
        localVarQueryParameter["featureKey"] = featureKey;
      }
      if (experimentKey) {
        localVarQueryParameter["experimentKey"] = experimentKey;
      }
      if (disableTracking !== undefined) {
        localVarQueryParameter["disableTracking"] = disableTracking;
      }
      if (type !== undefined) {
        localVarQueryParameter["type"] = type;
      }
      if (enabled !== undefined) {
        localVarQueryParameter["enabled"] = enabled;
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        OptimizelyActivateContextV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * For debugging or testing. Overrides an experiment and variation decision for a given user, in local memory only. Do not use this endpoint for production overrides.
     * @summary Override an experiment decision for a user
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {Array<OptimizelyOverrideContextInner>} OptimizelyOverrideContextInner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizelyV1TenantOverridePost: async (tenant, OptimizelyOverrideContextInner, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("optimizelyV1TenantOverridePost", "tenant", tenant);
      // verify required parameter 'OptimizelyOverrideContextInner' is not null or undefined
      assertParamExists(
        "optimizelyV1TenantOverridePost",
        "OptimizelyOverrideContextInner",
        OptimizelyOverrideContextInner
      );
      const localVarPath = `/optimizely/v1/{tenant}/override`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        OptimizelyOverrideContextInner,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Send event and user details to Optimizely analytics backend, so you can see metrics for an experiment. You can view metrics either on your Results page or as a data export.
     * @summary Track event
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} eventKey Key of the event we\&#39;re tracking
     * @param {OptimizelyTrackContextV1} OptimizelyTrackContextV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizelyV1TenantTrackPost: async (tenant, eventKey, OptimizelyTrackContextV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("optimizelyV1TenantTrackPost", "tenant", tenant);
      // verify required parameter 'eventKey' is not null or undefined
      assertParamExists("optimizelyV1TenantTrackPost", "eventKey", eventKey);
      // verify required parameter 'OptimizelyTrackContextV1' is not null or undefined
      assertParamExists("optimizelyV1TenantTrackPost", "OptimizelyTrackContextV1", OptimizelyTrackContextV1);
      const localVarPath = `/optimizely/v1/{tenant}/track`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (eventKey !== undefined) {
        localVarQueryParameter["eventKey"] = eventKey;
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        OptimizelyTrackContextV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} [browserFamily]
     * @param {string} [browserVersion]
     * @param {string} [deviceClass]
     * @param {string} [ipAddress]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    optimizelyV1TenantUserinfoGet: async (
      tenant,
      browserFamily,
      browserVersion,
      deviceClass,
      ipAddress,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("optimizelyV1TenantUserinfoGet", "tenant", tenant);
      const localVarPath = `/optimizely/v1/{tenant}/userinfo`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (browserFamily !== undefined) {
        localVarQueryParameter["browserFamily"] = browserFamily;
      }
      if (browserVersion !== undefined) {
        localVarQueryParameter["browserVersion"] = browserVersion;
      }
      if (deviceClass !== undefined) {
        localVarQueryParameter["deviceClass"] = deviceClass;
      }
      if (ipAddress !== undefined) {
        localVarQueryParameter["ipAddress"] = ipAddress;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} optimizelyFeatureKey
     * @param {string} [browserFamily]
     * @param {string} [browserVersion]
     * @param {string} [deviceClass]
     * @param {string} [ipAddress]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    optimizelyV1TenantUserinfoOptimizelyFeatureKeyGet: async (
      tenant,
      optimizelyFeatureKey,
      browserFamily,
      browserVersion,
      deviceClass,
      ipAddress,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("optimizelyV1TenantUserinfoOptimizelyFeatureKeyGet", "tenant", tenant);
      // verify required parameter 'optimizelyFeatureKey' is not null or undefined
      assertParamExists(
        "optimizelyV1TenantUserinfoOptimizelyFeatureKeyGet",
        "optimizelyFeatureKey",
        optimizelyFeatureKey
      );
      const localVarPath = `/optimizely/v1/{tenant}/userinfo/{optimizelyFeatureKey}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"optimizelyFeatureKey"}}`, encodeURIComponent(String(optimizelyFeatureKey)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (browserFamily !== undefined) {
        localVarQueryParameter["browserFamily"] = browserFamily;
      }
      if (browserVersion !== undefined) {
        localVarQueryParameter["browserVersion"] = browserVersion;
      }
      if (deviceClass !== undefined) {
        localVarQueryParameter["deviceClass"] = deviceClass;
      }
      if (ipAddress !== undefined) {
        localVarQueryParameter["ipAddress"] = ipAddress;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Returns Optimizely\'s decision about which features and experiments a given user is exposed to. Optionally sends an impression event to the Optimizely analytics backend for any decision made for an experiment. This endpoint consolidates key functionality from the Full Stack SDKs into one convenient call.
     * @summary Activate selected features and experiments for the given user.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {OptimizelyActivateContextV2} OptimizelyActivateContextV2
     * @param {Array<string>} [featureKey] Key for the Optimizely Feature
     * @param {Array<string>} [experimentKey] Key for the Optimizely Experiment
     * @param {boolean} [disableTracking] Setting to true will disable impression tracking for experiments.
     * @param {'feature' | 'experiment'} [type] Limit the decisions to either experiment or features
     * @param {boolean} [enabled] Filter the activation response to return only enabled descisions.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizelyV2TenantActivatePost: async (
      tenant,
      OptimizelyActivateContextV2,
      featureKey,
      experimentKey,
      disableTracking,
      type,
      enabled,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("optimizelyV2TenantActivatePost", "tenant", tenant);
      // verify required parameter 'OptimizelyActivateContextV2' is not null or undefined
      assertParamExists("optimizelyV2TenantActivatePost", "OptimizelyActivateContextV2", OptimizelyActivateContextV2);
      const localVarPath = `/optimizely/v2/{tenant}/activate`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (featureKey) {
        localVarQueryParameter["featureKey"] = featureKey;
      }
      if (experimentKey) {
        localVarQueryParameter["experimentKey"] = experimentKey;
      }
      if (disableTracking !== undefined) {
        localVarQueryParameter["disableTracking"] = disableTracking;
      }
      if (type !== undefined) {
        localVarQueryParameter["type"] = type;
      }
      if (enabled !== undefined) {
        localVarQueryParameter["enabled"] = enabled;
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        OptimizelyActivateContextV2,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * For debugging or testing. Overrides an experiment and variation decision for a given user, in local memory only. Do not use this endpoint for production overrides.
     * @summary Override an experiment decision for a user
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {Array<OptimizelyOverrideContextV2Inner>} OptimizelyOverrideContextV2Inner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizelyV2TenantOverridePost: async (tenant, OptimizelyOverrideContextV2Inner, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("optimizelyV2TenantOverridePost", "tenant", tenant);
      // verify required parameter 'OptimizelyOverrideContextV2Inner' is not null or undefined
      assertParamExists(
        "optimizelyV2TenantOverridePost",
        "OptimizelyOverrideContextV2Inner",
        OptimizelyOverrideContextV2Inner
      );
      const localVarPath = `/optimizely/v2/{tenant}/override`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        OptimizelyOverrideContextV2Inner,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Send event and user details to Optimizely analytics backend, so you can see metrics for an experiment. You can view metrics either on your Results page or as a data export.
     * @summary Track event
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} eventKey Key of the event we\&#39;re tracking
     * @param {OptimizelyTrackContextV2} OptimizelyTrackContextV2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizelyV2TenantTrackPost: async (tenant, eventKey, OptimizelyTrackContextV2, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("optimizelyV2TenantTrackPost", "tenant", tenant);
      // verify required parameter 'eventKey' is not null or undefined
      assertParamExists("optimizelyV2TenantTrackPost", "eventKey", eventKey);
      // verify required parameter 'OptimizelyTrackContextV2' is not null or undefined
      assertParamExists("optimizelyV2TenantTrackPost", "OptimizelyTrackContextV2", OptimizelyTrackContextV2);
      const localVarPath = `/optimizely/v2/{tenant}/track`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (eventKey !== undefined) {
        localVarQueryParameter["eventKey"] = eventKey;
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        OptimizelyTrackContextV2,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * OptimizelyControllerApi - functional programming interface
 * @export
 */
export const OptimizelyControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = OptimizelyControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * Returns Optimizely\'s decision about which features and experiments a given user is exposed to. Optionally sends an impression event to the Optimizely analytics backend for any decision made for an experiment. This endpoint consolidates key functionality from the Full Stack SDKs into one convenient call.
     * @summary Activate selected features and experiments for the given user.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {OptimizelyActivateContextV1} OptimizelyActivateContextV1
     * @param {Array<string>} [featureKey] Key for the Optimizely Feature
     * @param {Array<string>} [experimentKey] Key for the Optimizely Experiment
     * @param {boolean} [disableTracking] Setting to true will disable impression tracking for experiments.
     * @param {'feature' | 'experiment'} [type] Limit the decisions to either experiment or features
     * @param {boolean} [enabled] Filter the activation response to return only enabled descisions.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async optimizelyV1TenantActivatePost(
      tenant,
      OptimizelyActivateContextV1,
      featureKey,
      experimentKey,
      disableTracking,
      type,
      enabled,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.optimizelyV1TenantActivatePost(
        tenant,
        OptimizelyActivateContextV1,
        featureKey,
        experimentKey,
        disableTracking,
        type,
        enabled,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * For debugging or testing. Overrides an experiment and variation decision for a given user, in local memory only. Do not use this endpoint for production overrides.
     * @summary Override an experiment decision for a user
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {Array<OptimizelyOverrideContextInner>} OptimizelyOverrideContextInner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async optimizelyV1TenantOverridePost(tenant, OptimizelyOverrideContextInner, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.optimizelyV1TenantOverridePost(
        tenant,
        OptimizelyOverrideContextInner,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Send event and user details to Optimizely analytics backend, so you can see metrics for an experiment. You can view metrics either on your Results page or as a data export.
     * @summary Track event
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} eventKey Key of the event we\&#39;re tracking
     * @param {OptimizelyTrackContextV1} OptimizelyTrackContextV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async optimizelyV1TenantTrackPost(tenant, eventKey, OptimizelyTrackContextV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.optimizelyV1TenantTrackPost(
        tenant,
        eventKey,
        OptimizelyTrackContextV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} [browserFamily]
     * @param {string} [browserVersion]
     * @param {string} [deviceClass]
     * @param {string} [ipAddress]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async optimizelyV1TenantUserinfoGet(tenant, browserFamily, browserVersion, deviceClass, ipAddress, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.optimizelyV1TenantUserinfoGet(
        tenant,
        browserFamily,
        browserVersion,
        deviceClass,
        ipAddress,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} optimizelyFeatureKey
     * @param {string} [browserFamily]
     * @param {string} [browserVersion]
     * @param {string} [deviceClass]
     * @param {string} [ipAddress]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async optimizelyV1TenantUserinfoOptimizelyFeatureKeyGet(
      tenant,
      optimizelyFeatureKey,
      browserFamily,
      browserVersion,
      deviceClass,
      ipAddress,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.optimizelyV1TenantUserinfoOptimizelyFeatureKeyGet(
        tenant,
        optimizelyFeatureKey,
        browserFamily,
        browserVersion,
        deviceClass,
        ipAddress,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Returns Optimizely\'s decision about which features and experiments a given user is exposed to. Optionally sends an impression event to the Optimizely analytics backend for any decision made for an experiment. This endpoint consolidates key functionality from the Full Stack SDKs into one convenient call.
     * @summary Activate selected features and experiments for the given user.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {OptimizelyActivateContextV2} OptimizelyActivateContextV2
     * @param {Array<string>} [featureKey] Key for the Optimizely Feature
     * @param {Array<string>} [experimentKey] Key for the Optimizely Experiment
     * @param {boolean} [disableTracking] Setting to true will disable impression tracking for experiments.
     * @param {'feature' | 'experiment'} [type] Limit the decisions to either experiment or features
     * @param {boolean} [enabled] Filter the activation response to return only enabled descisions.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async optimizelyV2TenantActivatePost(
      tenant,
      OptimizelyActivateContextV2,
      featureKey,
      experimentKey,
      disableTracking,
      type,
      enabled,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.optimizelyV2TenantActivatePost(
        tenant,
        OptimizelyActivateContextV2,
        featureKey,
        experimentKey,
        disableTracking,
        type,
        enabled,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * For debugging or testing. Overrides an experiment and variation decision for a given user, in local memory only. Do not use this endpoint for production overrides.
     * @summary Override an experiment decision for a user
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {Array<OptimizelyOverrideContextV2Inner>} OptimizelyOverrideContextV2Inner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async optimizelyV2TenantOverridePost(tenant, OptimizelyOverrideContextV2Inner, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.optimizelyV2TenantOverridePost(
        tenant,
        OptimizelyOverrideContextV2Inner,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Send event and user details to Optimizely analytics backend, so you can see metrics for an experiment. You can view metrics either on your Results page or as a data export.
     * @summary Track event
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} eventKey Key of the event we\&#39;re tracking
     * @param {OptimizelyTrackContextV2} OptimizelyTrackContextV2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async optimizelyV2TenantTrackPost(tenant, eventKey, OptimizelyTrackContextV2, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.optimizelyV2TenantTrackPost(
        tenant,
        eventKey,
        OptimizelyTrackContextV2,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * OptimizelyControllerApi - factory interface
 * @export
 */
export const OptimizelyControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = OptimizelyControllerApiFp(configuration);
  return {
    /**
     * Returns Optimizely\'s decision about which features and experiments a given user is exposed to. Optionally sends an impression event to the Optimizely analytics backend for any decision made for an experiment. This endpoint consolidates key functionality from the Full Stack SDKs into one convenient call.
     * @summary Activate selected features and experiments for the given user.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {OptimizelyActivateContextV1} OptimizelyActivateContextV1
     * @param {Array<string>} [featureKey] Key for the Optimizely Feature
     * @param {Array<string>} [experimentKey] Key for the Optimizely Experiment
     * @param {boolean} [disableTracking] Setting to true will disable impression tracking for experiments.
     * @param {'feature' | 'experiment'} [type] Limit the decisions to either experiment or features
     * @param {boolean} [enabled] Filter the activation response to return only enabled descisions.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizelyV1TenantActivatePost(
      tenant,
      OptimizelyActivateContextV1,
      featureKey,
      experimentKey,
      disableTracking,
      type,
      enabled,
      options
    ) {
      return localVarFp
        .optimizelyV1TenantActivatePost(
          tenant,
          OptimizelyActivateContextV1,
          featureKey,
          experimentKey,
          disableTracking,
          type,
          enabled,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * For debugging or testing. Overrides an experiment and variation decision for a given user, in local memory only. Do not use this endpoint for production overrides.
     * @summary Override an experiment decision for a user
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {Array<OptimizelyOverrideContextInner>} OptimizelyOverrideContextInner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizelyV1TenantOverridePost(tenant, OptimizelyOverrideContextInner, options) {
      return localVarFp
        .optimizelyV1TenantOverridePost(tenant, OptimizelyOverrideContextInner, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Send event and user details to Optimizely analytics backend, so you can see metrics for an experiment. You can view metrics either on your Results page or as a data export.
     * @summary Track event
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} eventKey Key of the event we\&#39;re tracking
     * @param {OptimizelyTrackContextV1} OptimizelyTrackContextV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizelyV1TenantTrackPost(tenant, eventKey, OptimizelyTrackContextV1, options) {
      return localVarFp
        .optimizelyV1TenantTrackPost(tenant, eventKey, OptimizelyTrackContextV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} [browserFamily]
     * @param {string} [browserVersion]
     * @param {string} [deviceClass]
     * @param {string} [ipAddress]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    optimizelyV1TenantUserinfoGet(tenant, browserFamily, browserVersion, deviceClass, ipAddress, options) {
      return localVarFp
        .optimizelyV1TenantUserinfoGet(tenant, browserFamily, browserVersion, deviceClass, ipAddress, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} optimizelyFeatureKey
     * @param {string} [browserFamily]
     * @param {string} [browserVersion]
     * @param {string} [deviceClass]
     * @param {string} [ipAddress]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    optimizelyV1TenantUserinfoOptimizelyFeatureKeyGet(
      tenant,
      optimizelyFeatureKey,
      browserFamily,
      browserVersion,
      deviceClass,
      ipAddress,
      options
    ) {
      return localVarFp
        .optimizelyV1TenantUserinfoOptimizelyFeatureKeyGet(
          tenant,
          optimizelyFeatureKey,
          browserFamily,
          browserVersion,
          deviceClass,
          ipAddress,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Returns Optimizely\'s decision about which features and experiments a given user is exposed to. Optionally sends an impression event to the Optimizely analytics backend for any decision made for an experiment. This endpoint consolidates key functionality from the Full Stack SDKs into one convenient call.
     * @summary Activate selected features and experiments for the given user.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {OptimizelyActivateContextV2} OptimizelyActivateContextV2
     * @param {Array<string>} [featureKey] Key for the Optimizely Feature
     * @param {Array<string>} [experimentKey] Key for the Optimizely Experiment
     * @param {boolean} [disableTracking] Setting to true will disable impression tracking for experiments.
     * @param {'feature' | 'experiment'} [type] Limit the decisions to either experiment or features
     * @param {boolean} [enabled] Filter the activation response to return only enabled descisions.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizelyV2TenantActivatePost(
      tenant,
      OptimizelyActivateContextV2,
      featureKey,
      experimentKey,
      disableTracking,
      type,
      enabled,
      options
    ) {
      return localVarFp
        .optimizelyV2TenantActivatePost(
          tenant,
          OptimizelyActivateContextV2,
          featureKey,
          experimentKey,
          disableTracking,
          type,
          enabled,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * For debugging or testing. Overrides an experiment and variation decision for a given user, in local memory only. Do not use this endpoint for production overrides.
     * @summary Override an experiment decision for a user
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {Array<OptimizelyOverrideContextV2Inner>} OptimizelyOverrideContextV2Inner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizelyV2TenantOverridePost(tenant, OptimizelyOverrideContextV2Inner, options) {
      return localVarFp
        .optimizelyV2TenantOverridePost(tenant, OptimizelyOverrideContextV2Inner, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Send event and user details to Optimizely analytics backend, so you can see metrics for an experiment. You can view metrics either on your Results page or as a data export.
     * @summary Track event
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} eventKey Key of the event we\&#39;re tracking
     * @param {OptimizelyTrackContextV2} OptimizelyTrackContextV2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizelyV2TenantTrackPost(tenant, eventKey, OptimizelyTrackContextV2, options) {
      return localVarFp
        .optimizelyV2TenantTrackPost(tenant, eventKey, OptimizelyTrackContextV2, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * OptimizelyControllerApi - object-oriented interface
 * @export
 * @class OptimizelyControllerApi
 * @extends {BaseAPI}
 */
export class OptimizelyControllerApi extends BaseAPI {
  /**
   * Returns Optimizely\'s decision about which features and experiments a given user is exposed to. Optionally sends an impression event to the Optimizely analytics backend for any decision made for an experiment. This endpoint consolidates key functionality from the Full Stack SDKs into one convenient call.
   * @summary Activate selected features and experiments for the given user.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {OptimizelyActivateContextV1} OptimizelyActivateContextV1
   * @param {Array<string>} [featureKey] Key for the Optimizely Feature
   * @param {Array<string>} [experimentKey] Key for the Optimizely Experiment
   * @param {boolean} [disableTracking] Setting to true will disable impression tracking for experiments.
   * @param {'feature' | 'experiment'} [type] Limit the decisions to either experiment or features
   * @param {boolean} [enabled] Filter the activation response to return only enabled descisions.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OptimizelyControllerApi
   */
  optimizelyV1TenantActivatePost(
    tenant,
    OptimizelyActivateContextV1,
    featureKey,
    experimentKey,
    disableTracking,
    type,
    enabled,
    options
  ) {
    return OptimizelyControllerApiFp(this.configuration)
      .optimizelyV1TenantActivatePost(
        tenant,
        OptimizelyActivateContextV1,
        featureKey,
        experimentKey,
        disableTracking,
        type,
        enabled,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * For debugging or testing. Overrides an experiment and variation decision for a given user, in local memory only. Do not use this endpoint for production overrides.
   * @summary Override an experiment decision for a user
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {Array<OptimizelyOverrideContextInner>} OptimizelyOverrideContextInner
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OptimizelyControllerApi
   */
  optimizelyV1TenantOverridePost(tenant, OptimizelyOverrideContextInner, options) {
    return OptimizelyControllerApiFp(this.configuration)
      .optimizelyV1TenantOverridePost(tenant, OptimizelyOverrideContextInner, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Send event and user details to Optimizely analytics backend, so you can see metrics for an experiment. You can view metrics either on your Results page or as a data export.
   * @summary Track event
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} eventKey Key of the event we\&#39;re tracking
   * @param {OptimizelyTrackContextV1} OptimizelyTrackContextV1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OptimizelyControllerApi
   */
  optimizelyV1TenantTrackPost(tenant, eventKey, OptimizelyTrackContextV1, options) {
    return OptimizelyControllerApiFp(this.configuration)
      .optimizelyV1TenantTrackPost(tenant, eventKey, OptimizelyTrackContextV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} [browserFamily]
   * @param {string} [browserVersion]
   * @param {string} [deviceClass]
   * @param {string} [ipAddress]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof OptimizelyControllerApi
   */
  optimizelyV1TenantUserinfoGet(tenant, browserFamily, browserVersion, deviceClass, ipAddress, options) {
    return OptimizelyControllerApiFp(this.configuration)
      .optimizelyV1TenantUserinfoGet(tenant, browserFamily, browserVersion, deviceClass, ipAddress, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} optimizelyFeatureKey
   * @param {string} [browserFamily]
   * @param {string} [browserVersion]
   * @param {string} [deviceClass]
   * @param {string} [ipAddress]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof OptimizelyControllerApi
   */
  optimizelyV1TenantUserinfoOptimizelyFeatureKeyGet(
    tenant,
    optimizelyFeatureKey,
    browserFamily,
    browserVersion,
    deviceClass,
    ipAddress,
    options
  ) {
    return OptimizelyControllerApiFp(this.configuration)
      .optimizelyV1TenantUserinfoOptimizelyFeatureKeyGet(
        tenant,
        optimizelyFeatureKey,
        browserFamily,
        browserVersion,
        deviceClass,
        ipAddress,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Returns Optimizely\'s decision about which features and experiments a given user is exposed to. Optionally sends an impression event to the Optimizely analytics backend for any decision made for an experiment. This endpoint consolidates key functionality from the Full Stack SDKs into one convenient call.
   * @summary Activate selected features and experiments for the given user.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {OptimizelyActivateContextV2} OptimizelyActivateContextV2
   * @param {Array<string>} [featureKey] Key for the Optimizely Feature
   * @param {Array<string>} [experimentKey] Key for the Optimizely Experiment
   * @param {boolean} [disableTracking] Setting to true will disable impression tracking for experiments.
   * @param {'feature' | 'experiment'} [type] Limit the decisions to either experiment or features
   * @param {boolean} [enabled] Filter the activation response to return only enabled descisions.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OptimizelyControllerApi
   */
  optimizelyV2TenantActivatePost(
    tenant,
    OptimizelyActivateContextV2,
    featureKey,
    experimentKey,
    disableTracking,
    type,
    enabled,
    options
  ) {
    return OptimizelyControllerApiFp(this.configuration)
      .optimizelyV2TenantActivatePost(
        tenant,
        OptimizelyActivateContextV2,
        featureKey,
        experimentKey,
        disableTracking,
        type,
        enabled,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * For debugging or testing. Overrides an experiment and variation decision for a given user, in local memory only. Do not use this endpoint for production overrides.
   * @summary Override an experiment decision for a user
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {Array<OptimizelyOverrideContextV2Inner>} OptimizelyOverrideContextV2Inner
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OptimizelyControllerApi
   */
  optimizelyV2TenantOverridePost(tenant, OptimizelyOverrideContextV2Inner, options) {
    return OptimizelyControllerApiFp(this.configuration)
      .optimizelyV2TenantOverridePost(tenant, OptimizelyOverrideContextV2Inner, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Send event and user details to Optimizely analytics backend, so you can see metrics for an experiment. You can view metrics either on your Results page or as a data export.
   * @summary Track event
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} eventKey Key of the event we\&#39;re tracking
   * @param {OptimizelyTrackContextV2} OptimizelyTrackContextV2
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OptimizelyControllerApi
   */
  optimizelyV2TenantTrackPost(tenant, eventKey, OptimizelyTrackContextV2, options) {
    return OptimizelyControllerApiFp(this.configuration)
      .optimizelyV2TenantTrackPost(tenant, eventKey, OptimizelyTrackContextV2, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * OrderControllerApi - axios parameter creator
 * @export
 */
export const OrderControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Used by the customer to retrieve all its orders.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {number} [page]
     * @param {number} [itemsPerPage]
     * @param {number} [ordersAgeLimitInSeconds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderV1TenantOrdersGet: async (tenant, page, itemsPerPage, ordersAgeLimitInSeconds, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("orderV1TenantOrdersGet", "tenant", tenant);
      const localVarPath = `/order/v1/{tenant}/orders`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }
      if (itemsPerPage !== undefined) {
        localVarQueryParameter["itemsPerPage"] = itemsPerPage;
      }
      if (ordersAgeLimitInSeconds !== undefined) {
        localVarQueryParameter["ordersAgeLimitInSeconds"] = ordersAgeLimitInSeconds;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Used by a customer to retrieve a single order.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderV1TenantOrdersOrderNumberGet: async (tenant, orderNumber, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("orderV1TenantOrdersOrderNumberGet", "tenant", tenant);
      // verify required parameter 'orderNumber' is not null or undefined
      assertParamExists("orderV1TenantOrdersOrderNumberGet", "orderNumber", orderNumber);
      const localVarPath = `/order/v1/{tenant}/orders/{orderNumber}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"orderNumber"}}`, encodeURIComponent(String(orderNumber)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Used by a customer to retrieve a single order.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderV1TenantPssOrdersGet: async (tenant, transactionId, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("orderV1TenantPssOrdersGet", "tenant", tenant);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists("orderV1TenantPssOrdersGet", "transactionId", transactionId);
      const localVarPath = `/order/v1/{tenant}/pss/orders`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication basicAuth required
      // http basic authentication required
      setBasicAuthToObject(localVarRequestOptions, configuration);
      if (transactionId !== undefined) {
        localVarQueryParameter["transactionId"] = transactionId;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * OrderControllerApi - functional programming interface
 * @export
 */
export const OrderControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = OrderControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * Used by the customer to retrieve all its orders.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {number} [page]
     * @param {number} [itemsPerPage]
     * @param {number} [ordersAgeLimitInSeconds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async orderV1TenantOrdersGet(tenant, page, itemsPerPage, ordersAgeLimitInSeconds, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.orderV1TenantOrdersGet(
        tenant,
        page,
        itemsPerPage,
        ordersAgeLimitInSeconds,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Used by a customer to retrieve a single order.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async orderV1TenantOrdersOrderNumberGet(tenant, orderNumber, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.orderV1TenantOrdersOrderNumberGet(
        tenant,
        orderNumber,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Used by a customer to retrieve a single order.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async orderV1TenantPssOrdersGet(tenant, transactionId, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.orderV1TenantPssOrdersGet(
        tenant,
        transactionId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * OrderControllerApi - factory interface
 * @export
 */
export const OrderControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = OrderControllerApiFp(configuration);
  return {
    /**
     * Used by the customer to retrieve all its orders.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {number} [page]
     * @param {number} [itemsPerPage]
     * @param {number} [ordersAgeLimitInSeconds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderV1TenantOrdersGet(tenant, page, itemsPerPage, ordersAgeLimitInSeconds, options) {
      return localVarFp
        .orderV1TenantOrdersGet(tenant, page, itemsPerPage, ordersAgeLimitInSeconds, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Used by a customer to retrieve a single order.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderV1TenantOrdersOrderNumberGet(tenant, orderNumber, options) {
      return localVarFp
        .orderV1TenantOrdersOrderNumberGet(tenant, orderNumber, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Used by a customer to retrieve a single order.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderV1TenantPssOrdersGet(tenant, transactionId, options) {
      return localVarFp
        .orderV1TenantPssOrdersGet(tenant, transactionId, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * OrderControllerApi - object-oriented interface
 * @export
 * @class OrderControllerApi
 * @extends {BaseAPI}
 */
export class OrderControllerApi extends BaseAPI {
  /**
   * Used by the customer to retrieve all its orders.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {number} [page]
   * @param {number} [itemsPerPage]
   * @param {number} [ordersAgeLimitInSeconds]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderControllerApi
   */
  orderV1TenantOrdersGet(tenant, page, itemsPerPage, ordersAgeLimitInSeconds, options) {
    return OrderControllerApiFp(this.configuration)
      .orderV1TenantOrdersGet(tenant, page, itemsPerPage, ordersAgeLimitInSeconds, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Used by a customer to retrieve a single order.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} orderNumber
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderControllerApi
   */
  orderV1TenantOrdersOrderNumberGet(tenant, orderNumber, options) {
    return OrderControllerApiFp(this.configuration)
      .orderV1TenantOrdersOrderNumberGet(tenant, orderNumber, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Used by a customer to retrieve a single order.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} transactionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderControllerApi
   */
  orderV1TenantPssOrdersGet(tenant, transactionId, options) {
    return OrderControllerApiFp(this.configuration)
      .orderV1TenantPssOrdersGet(tenant, transactionId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * OrdersControllerApi - axios parameter creator
 * @export
 */
export const OrdersControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Used only for development of the confirmation page
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} id Order id
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    ordersV1TenantIdGet: async (tenant, id, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("ordersV1TenantIdGet", "tenant", tenant);
      // verify required parameter 'id' is not null or undefined
      assertParamExists("ordersV1TenantIdGet", "id", id);
      const localVarPath = `/orders/v1/{tenant}/{id}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * OrdersControllerApi - functional programming interface
 * @export
 */
export const OrdersControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = OrdersControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * Used only for development of the confirmation page
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} id Order id
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async ordersV1TenantIdGet(tenant, id, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.ordersV1TenantIdGet(tenant, id, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * OrdersControllerApi - factory interface
 * @export
 */
export const OrdersControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = OrdersControllerApiFp(configuration);
  return {
    /**
     * Used only for development of the confirmation page
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} id Order id
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    ordersV1TenantIdGet(tenant, id, options) {
      return localVarFp.ordersV1TenantIdGet(tenant, id, options).then((request) => request(axios, basePath));
    }
  };
};
/**
 * OrdersControllerApi - object-oriented interface
 * @export
 * @class OrdersControllerApi
 * @extends {BaseAPI}
 */
export class OrdersControllerApi extends BaseAPI {
  /**
   * Used only for development of the confirmation page
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} id Order id
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof OrdersControllerApi
   */
  ordersV1TenantIdGet(tenant, id, options) {
    return OrdersControllerApiFp(this.configuration)
      .ordersV1TenantIdGet(tenant, id, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * PDPControllerApi - axios parameter creator
 * @export
 */
export const PDPControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Returns response from [/pim/.../variants](#/PIM%20Controller/get__language__pim_v1__tenant__products__upid__variants) extended with notepad info and promotion images
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upid Unique product identifier
     * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
     * @param {string} [cbpUpids] Comma separated list of upids which specifies for wich products another channel based pricing (cbp) should take effekt.
     * @param {string} [cbpChannels] Comma separated list of channels that corresponds to the upids in the query parameter cbpUpids.
     * @param {string} [fields]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languagePdpV1TenantProductsUpidVariantsGet: async (
      language,
      tenant,
      upid,
      channel,
      cbpUpids,
      cbpChannels,
      fields,
      options = {}
    ) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languagePdpV1TenantProductsUpidVariantsGet", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languagePdpV1TenantProductsUpidVariantsGet", "tenant", tenant);
      // verify required parameter 'upid' is not null or undefined
      assertParamExists("languagePdpV1TenantProductsUpidVariantsGet", "upid", upid);
      const localVarPath = `/{language}/pdp/v1/{tenant}/products/{upid}/variants`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"upid"}}`, encodeURIComponent(String(upid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (channel !== undefined) {
        localVarQueryParameter["channel"] = channel;
      }
      if (cbpUpids !== undefined) {
        localVarQueryParameter["cbpUpids"] = cbpUpids;
      }
      if (cbpChannels !== undefined) {
        localVarQueryParameter["cbpChannels"] = cbpChannels;
      }
      if (fields !== undefined) {
        localVarQueryParameter["fields"] = fields;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * PDPControllerApi - functional programming interface
 * @export
 */
export const PDPControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = PDPControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * Returns response from [/pim/.../variants](#/PIM%20Controller/get__language__pim_v1__tenant__products__upid__variants) extended with notepad info and promotion images
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upid Unique product identifier
     * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
     * @param {string} [cbpUpids] Comma separated list of upids which specifies for wich products another channel based pricing (cbp) should take effekt.
     * @param {string} [cbpChannels] Comma separated list of channels that corresponds to the upids in the query parameter cbpUpids.
     * @param {string} [fields]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languagePdpV1TenantProductsUpidVariantsGet(
      language,
      tenant,
      upid,
      channel,
      cbpUpids,
      cbpChannels,
      fields,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languagePdpV1TenantProductsUpidVariantsGet(
        language,
        tenant,
        upid,
        channel,
        cbpUpids,
        cbpChannels,
        fields,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * PDPControllerApi - factory interface
 * @export
 */
export const PDPControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = PDPControllerApiFp(configuration);
  return {
    /**
     * Returns response from [/pim/.../variants](#/PIM%20Controller/get__language__pim_v1__tenant__products__upid__variants) extended with notepad info and promotion images
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upid Unique product identifier
     * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
     * @param {string} [cbpUpids] Comma separated list of upids which specifies for wich products another channel based pricing (cbp) should take effekt.
     * @param {string} [cbpChannels] Comma separated list of channels that corresponds to the upids in the query parameter cbpUpids.
     * @param {string} [fields]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languagePdpV1TenantProductsUpidVariantsGet(
      language,
      tenant,
      upid,
      channel,
      cbpUpids,
      cbpChannels,
      fields,
      options
    ) {
      return localVarFp
        .languagePdpV1TenantProductsUpidVariantsGet(
          language,
          tenant,
          upid,
          channel,
          cbpUpids,
          cbpChannels,
          fields,
          options
        )
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * PDPControllerApi - object-oriented interface
 * @export
 * @class PDPControllerApi
 * @extends {BaseAPI}
 */
export class PDPControllerApi extends BaseAPI {
  /**
   * Returns response from [/pim/.../variants](#/PIM%20Controller/get__language__pim_v1__tenant__products__upid__variants) extended with notepad info and promotion images
   * @param {string} language
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} upid Unique product identifier
   * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
   * @param {string} [cbpUpids] Comma separated list of upids which specifies for wich products another channel based pricing (cbp) should take effekt.
   * @param {string} [cbpChannels] Comma separated list of channels that corresponds to the upids in the query parameter cbpUpids.
   * @param {string} [fields]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PDPControllerApi
   */
  languagePdpV1TenantProductsUpidVariantsGet(language, tenant, upid, channel, cbpUpids, cbpChannels, fields, options) {
    return PDPControllerApiFp(this.configuration)
      .languagePdpV1TenantProductsUpidVariantsGet(
        language,
        tenant,
        upid,
        channel,
        cbpUpids,
        cbpChannels,
        fields,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * PICSServiceApi - axios parameter creator
 * @export
 */
export const PICSServiceApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @summary pharma-interaction data for experts requested by a list of FAM ids
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {PicsInteractionsExpertRequestByFamId} PicsInteractionsExpertRequestByFamId List of FAM IDs and optional list of type clinical relevance (return interactions for all types of clinical relevance if missing)
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expertInteractionsByFamIds: async (tenant, PicsInteractionsExpertRequestByFamId, X_Request_ID, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("expertInteractionsByFamIds", "tenant", tenant);
      // verify required parameter 'PicsInteractionsExpertRequestByFamId' is not null or undefined
      assertParamExists(
        "expertInteractionsByFamIds",
        "PicsInteractionsExpertRequestByFamId",
        PicsInteractionsExpertRequestByFamId
      );
      const localVarPath = `/pics/v1/{tenant}/interactions/expert/by-fam-id`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (X_Request_ID != null) {
        localVarHeaderParameter["X-Request-ID"] = String(X_Request_ID);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        PicsInteractionsExpertRequestByFamId,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary pharma-interaction data for experts requested by a list of product ids
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {PicsInteractionsExpertRequestByProductId} PicsInteractionsExpertRequestByProductId List of productIds (PZN) and optional list of type clinical relevance (return interactions for all types of clinical relevance if missing)
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expertInteractionsByProductIds: async (
      tenant,
      PicsInteractionsExpertRequestByProductId,
      X_Request_ID,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("expertInteractionsByProductIds", "tenant", tenant);
      // verify required parameter 'PicsInteractionsExpertRequestByProductId' is not null or undefined
      assertParamExists(
        "expertInteractionsByProductIds",
        "PicsInteractionsExpertRequestByProductId",
        PicsInteractionsExpertRequestByProductId
      );
      const localVarPath = `/pics/v1/{tenant}/interactions/expert/by-product-id`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (X_Request_ID != null) {
        localVarHeaderParameter["X-Request-ID"] = String(X_Request_ID);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        PicsInteractionsExpertRequestByProductId,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary check for pharma-interaction
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {PicsInteractionsRequest} PicsInteractionsRequest List of productIds (PZN)
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    interactions: async (tenant, PicsInteractionsRequest, X_Request_ID, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("interactions", "tenant", tenant);
      // verify required parameter 'PicsInteractionsRequest' is not null or undefined
      assertParamExists("interactions", "PicsInteractionsRequest", PicsInteractionsRequest);
      const localVarPath = `/pics/v1/{tenant}/interactions`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (X_Request_ID != null) {
        localVarHeaderParameter["X-Request-ID"] = String(X_Request_ID);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        PicsInteractionsRequest,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary pharma-interaction data for layman
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {PicsInteractionsLaymanRequest} PicsInteractionsLaymanRequest List of productIds (PZN) and optional list of type clinical relevance (return interactions for all types of clinical relevance if missing)
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    laymanInteractions: async (tenant, PicsInteractionsLaymanRequest, X_Request_ID, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("laymanInteractions", "tenant", tenant);
      // verify required parameter 'PicsInteractionsLaymanRequest' is not null or undefined
      assertParamExists("laymanInteractions", "PicsInteractionsLaymanRequest", PicsInteractionsLaymanRequest);
      const localVarPath = `/pics/v1/{tenant}/interactions/layman`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (X_Request_ID != null) {
        localVarHeaderParameter["X-Request-ID"] = String(X_Request_ID);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        PicsInteractionsLaymanRequest,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * PICSServiceApi - functional programming interface
 * @export
 */
export const PICSServiceApiFp = function (configuration) {
  const localVarAxiosParamCreator = PICSServiceApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary pharma-interaction data for experts requested by a list of FAM ids
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {PicsInteractionsExpertRequestByFamId} PicsInteractionsExpertRequestByFamId List of FAM IDs and optional list of type clinical relevance (return interactions for all types of clinical relevance if missing)
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async expertInteractionsByFamIds(tenant, PicsInteractionsExpertRequestByFamId, X_Request_ID, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.expertInteractionsByFamIds(
        tenant,
        PicsInteractionsExpertRequestByFamId,
        X_Request_ID,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary pharma-interaction data for experts requested by a list of product ids
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {PicsInteractionsExpertRequestByProductId} PicsInteractionsExpertRequestByProductId List of productIds (PZN) and optional list of type clinical relevance (return interactions for all types of clinical relevance if missing)
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async expertInteractionsByProductIds(tenant, PicsInteractionsExpertRequestByProductId, X_Request_ID, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.expertInteractionsByProductIds(
        tenant,
        PicsInteractionsExpertRequestByProductId,
        X_Request_ID,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary check for pharma-interaction
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {PicsInteractionsRequest} PicsInteractionsRequest List of productIds (PZN)
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async interactions(tenant, PicsInteractionsRequest, X_Request_ID, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.interactions(
        tenant,
        PicsInteractionsRequest,
        X_Request_ID,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary pharma-interaction data for layman
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {PicsInteractionsLaymanRequest} PicsInteractionsLaymanRequest List of productIds (PZN) and optional list of type clinical relevance (return interactions for all types of clinical relevance if missing)
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async laymanInteractions(tenant, PicsInteractionsLaymanRequest, X_Request_ID, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.laymanInteractions(
        tenant,
        PicsInteractionsLaymanRequest,
        X_Request_ID,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * PICSServiceApi - factory interface
 * @export
 */
export const PICSServiceApiFactory = function (configuration, basePath, axios) {
  const localVarFp = PICSServiceApiFp(configuration);
  return {
    /**
     *
     * @summary pharma-interaction data for experts requested by a list of FAM ids
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {PicsInteractionsExpertRequestByFamId} PicsInteractionsExpertRequestByFamId List of FAM IDs and optional list of type clinical relevance (return interactions for all types of clinical relevance if missing)
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expertInteractionsByFamIds(tenant, PicsInteractionsExpertRequestByFamId, X_Request_ID, options) {
      return localVarFp
        .expertInteractionsByFamIds(tenant, PicsInteractionsExpertRequestByFamId, X_Request_ID, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary pharma-interaction data for experts requested by a list of product ids
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {PicsInteractionsExpertRequestByProductId} PicsInteractionsExpertRequestByProductId List of productIds (PZN) and optional list of type clinical relevance (return interactions for all types of clinical relevance if missing)
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expertInteractionsByProductIds(tenant, PicsInteractionsExpertRequestByProductId, X_Request_ID, options) {
      return localVarFp
        .expertInteractionsByProductIds(tenant, PicsInteractionsExpertRequestByProductId, X_Request_ID, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary check for pharma-interaction
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {PicsInteractionsRequest} PicsInteractionsRequest List of productIds (PZN)
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    interactions(tenant, PicsInteractionsRequest, X_Request_ID, options) {
      return localVarFp
        .interactions(tenant, PicsInteractionsRequest, X_Request_ID, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary pharma-interaction data for layman
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {PicsInteractionsLaymanRequest} PicsInteractionsLaymanRequest List of productIds (PZN) and optional list of type clinical relevance (return interactions for all types of clinical relevance if missing)
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    laymanInteractions(tenant, PicsInteractionsLaymanRequest, X_Request_ID, options) {
      return localVarFp
        .laymanInteractions(tenant, PicsInteractionsLaymanRequest, X_Request_ID, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * PICSServiceApi - object-oriented interface
 * @export
 * @class PICSServiceApi
 * @extends {BaseAPI}
 */
export class PICSServiceApi extends BaseAPI {
  /**
   *
   * @summary pharma-interaction data for experts requested by a list of FAM ids
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {PicsInteractionsExpertRequestByFamId} PicsInteractionsExpertRequestByFamId List of FAM IDs and optional list of type clinical relevance (return interactions for all types of clinical relevance if missing)
   * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PICSServiceApi
   */
  expertInteractionsByFamIds(tenant, PicsInteractionsExpertRequestByFamId, X_Request_ID, options) {
    return PICSServiceApiFp(this.configuration)
      .expertInteractionsByFamIds(tenant, PicsInteractionsExpertRequestByFamId, X_Request_ID, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary pharma-interaction data for experts requested by a list of product ids
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {PicsInteractionsExpertRequestByProductId} PicsInteractionsExpertRequestByProductId List of productIds (PZN) and optional list of type clinical relevance (return interactions for all types of clinical relevance if missing)
   * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PICSServiceApi
   */
  expertInteractionsByProductIds(tenant, PicsInteractionsExpertRequestByProductId, X_Request_ID, options) {
    return PICSServiceApiFp(this.configuration)
      .expertInteractionsByProductIds(tenant, PicsInteractionsExpertRequestByProductId, X_Request_ID, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary check for pharma-interaction
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {PicsInteractionsRequest} PicsInteractionsRequest List of productIds (PZN)
   * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PICSServiceApi
   */
  interactions(tenant, PicsInteractionsRequest, X_Request_ID, options) {
    return PICSServiceApiFp(this.configuration)
      .interactions(tenant, PicsInteractionsRequest, X_Request_ID, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary pharma-interaction data for layman
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {PicsInteractionsLaymanRequest} PicsInteractionsLaymanRequest List of productIds (PZN) and optional list of type clinical relevance (return interactions for all types of clinical relevance if missing)
   * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PICSServiceApi
   */
  laymanInteractions(tenant, PicsInteractionsLaymanRequest, X_Request_ID, options) {
    return PICSServiceApiFp(this.configuration)
      .laymanInteractions(tenant, PicsInteractionsLaymanRequest, X_Request_ID, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * PIMControllerApi - axios parameter creator
 * @export
 */
export const PIMControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upids Comma separated list of product identifiers
     * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
     * @param {number} [offset] The number of documents to skip in the results set.
     * @param {number} [limit] The limit specifies the maximum number of documents the endpoint will return. A limit value of 0 is equivalent to setting no limit.
     * @param {string} [fields]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyPimMutilple: async (language, tenant, upids, channel, offset, limit, fields, options = {}) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("bullyPimMutilple", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("bullyPimMutilple", "tenant", tenant);
      // verify required parameter 'upids' is not null or undefined
      assertParamExists("bullyPimMutilple", "upids", upids);
      const localVarPath = `/{language}/pim/v1/{tenant}/products`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (upids !== undefined) {
        localVarQueryParameter["upids"] = upids;
      }
      if (channel !== undefined) {
        localVarQueryParameter["channel"] = channel;
      }
      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }
      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }
      if (fields !== undefined) {
        localVarQueryParameter["fields"] = fields;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upid Unique product identifier
     * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
     * @param {string} [fields]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languagePimV1TenantProductsUpidGet: async (language, tenant, upid, channel, fields, options = {}) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languagePimV1TenantProductsUpidGet", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languagePimV1TenantProductsUpidGet", "tenant", tenant);
      // verify required parameter 'upid' is not null or undefined
      assertParamExists("languagePimV1TenantProductsUpidGet", "upid", upid);
      const localVarPath = `/{language}/pim/v1/{tenant}/products/{upid}`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"upid"}}`, encodeURIComponent(String(upid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (channel !== undefined) {
        localVarQueryParameter["channel"] = channel;
      }
      if (fields !== undefined) {
        localVarQueryParameter["fields"] = fields;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upid Unique product identifier
     * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
     * @param {string} [fields]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languagePimV1TenantProductsUpidVariantsGet: async (language, tenant, upid, channel, fields, options = {}) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languagePimV1TenantProductsUpidVariantsGet", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languagePimV1TenantProductsUpidVariantsGet", "tenant", tenant);
      // verify required parameter 'upid' is not null or undefined
      assertParamExists("languagePimV1TenantProductsUpidVariantsGet", "upid", upid);
      const localVarPath = `/{language}/pim/v1/{tenant}/products/{upid}/variants`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"upid"}}`, encodeURIComponent(String(upid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (channel !== undefined) {
        localVarQueryParameter["channel"] = channel;
      }
      if (fields !== undefined) {
        localVarQueryParameter["fields"] = fields;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upid Unique product identifier
     * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
     * @param {string} [fields]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languagePimV1TenantProductsWithVariantsUpidGet: async (language, tenant, upid, channel, fields, options = {}) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languagePimV1TenantProductsWithVariantsUpidGet", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languagePimV1TenantProductsWithVariantsUpidGet", "tenant", tenant);
      // verify required parameter 'upid' is not null or undefined
      assertParamExists("languagePimV1TenantProductsWithVariantsUpidGet", "upid", upid);
      const localVarPath = `/{language}/pim/v1/{tenant}/products-with-variants/{upid}`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"upid"}}`, encodeURIComponent(String(upid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (channel !== undefined) {
        localVarQueryParameter["channel"] = channel;
      }
      if (fields !== undefined) {
        localVarQueryParameter["fields"] = fields;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * PIMControllerApi - functional programming interface
 * @export
 */
export const PIMControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = PIMControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upids Comma separated list of product identifiers
     * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
     * @param {number} [offset] The number of documents to skip in the results set.
     * @param {number} [limit] The limit specifies the maximum number of documents the endpoint will return. A limit value of 0 is equivalent to setting no limit.
     * @param {string} [fields]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bullyPimMutilple(language, tenant, upids, channel, offset, limit, fields, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bullyPimMutilple(
        language,
        tenant,
        upids,
        channel,
        offset,
        limit,
        fields,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upid Unique product identifier
     * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
     * @param {string} [fields]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languagePimV1TenantProductsUpidGet(language, tenant, upid, channel, fields, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languagePimV1TenantProductsUpidGet(
        language,
        tenant,
        upid,
        channel,
        fields,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upid Unique product identifier
     * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
     * @param {string} [fields]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languagePimV1TenantProductsUpidVariantsGet(language, tenant, upid, channel, fields, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languagePimV1TenantProductsUpidVariantsGet(
        language,
        tenant,
        upid,
        channel,
        fields,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upid Unique product identifier
     * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
     * @param {string} [fields]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languagePimV1TenantProductsWithVariantsUpidGet(language, tenant, upid, channel, fields, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languagePimV1TenantProductsWithVariantsUpidGet(
        language,
        tenant,
        upid,
        channel,
        fields,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * PIMControllerApi - factory interface
 * @export
 */
export const PIMControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = PIMControllerApiFp(configuration);
  return {
    /**
     *
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upids Comma separated list of product identifiers
     * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
     * @param {number} [offset] The number of documents to skip in the results set.
     * @param {number} [limit] The limit specifies the maximum number of documents the endpoint will return. A limit value of 0 is equivalent to setting no limit.
     * @param {string} [fields]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyPimMutilple(language, tenant, upids, channel, offset, limit, fields, options) {
      return localVarFp
        .bullyPimMutilple(language, tenant, upids, channel, offset, limit, fields, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upid Unique product identifier
     * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
     * @param {string} [fields]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languagePimV1TenantProductsUpidGet(language, tenant, upid, channel, fields, options) {
      return localVarFp
        .languagePimV1TenantProductsUpidGet(language, tenant, upid, channel, fields, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upid Unique product identifier
     * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
     * @param {string} [fields]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languagePimV1TenantProductsUpidVariantsGet(language, tenant, upid, channel, fields, options) {
      return localVarFp
        .languagePimV1TenantProductsUpidVariantsGet(language, tenant, upid, channel, fields, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upid Unique product identifier
     * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
     * @param {string} [fields]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languagePimV1TenantProductsWithVariantsUpidGet(language, tenant, upid, channel, fields, options) {
      return localVarFp
        .languagePimV1TenantProductsWithVariantsUpidGet(language, tenant, upid, channel, fields, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * PIMControllerApi - object-oriented interface
 * @export
 * @class PIMControllerApi
 * @extends {BaseAPI}
 */
export class PIMControllerApi extends BaseAPI {
  /**
   *
   * @param {string} language
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} upids Comma separated list of product identifiers
   * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
   * @param {number} [offset] The number of documents to skip in the results set.
   * @param {number} [limit] The limit specifies the maximum number of documents the endpoint will return. A limit value of 0 is equivalent to setting no limit.
   * @param {string} [fields]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PIMControllerApi
   */
  bullyPimMutilple(language, tenant, upids, channel, offset, limit, fields, options) {
    return PIMControllerApiFp(this.configuration)
      .bullyPimMutilple(language, tenant, upids, channel, offset, limit, fields, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} language
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} upid Unique product identifier
   * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
   * @param {string} [fields]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PIMControllerApi
   */
  languagePimV1TenantProductsUpidGet(language, tenant, upid, channel, fields, options) {
    return PIMControllerApiFp(this.configuration)
      .languagePimV1TenantProductsUpidGet(language, tenant, upid, channel, fields, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} language
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} upid Unique product identifier
   * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
   * @param {string} [fields]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PIMControllerApi
   */
  languagePimV1TenantProductsUpidVariantsGet(language, tenant, upid, channel, fields, options) {
    return PIMControllerApiFp(this.configuration)
      .languagePimV1TenantProductsUpidVariantsGet(language, tenant, upid, channel, fields, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} language
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} upid Unique product identifier
   * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
   * @param {string} [fields]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PIMControllerApi
   */
  languagePimV1TenantProductsWithVariantsUpidGet(language, tenant, upid, channel, fields, options) {
    return PIMControllerApiFp(this.configuration)
      .languagePimV1TenantProductsWithVariantsUpidGet(language, tenant, upid, channel, fields, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * PaymentsControllerApi - axios parameter creator
 * @export
 */
export const PaymentsControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {DisableRequestV1} DisableRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentsV1TenantDisablePost: async (tenant, DisableRequestV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("paymentsV1TenantDisablePost", "tenant", tenant);
      // verify required parameter 'DisableRequestV1' is not null or undefined
      assertParamExists("paymentsV1TenantDisablePost", "DisableRequestV1", DisableRequestV1);
      const localVarPath = `/payments/v1/{tenant}/disable`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(DisableRequestV1, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {NotificationsRequestV1} [NotificationsRequestV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentsV1TenantNotificationsPost: async (tenant, NotificationsRequestV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("paymentsV1TenantNotificationsPost", "tenant", tenant);
      const localVarPath = `/payments/v1/{tenant}/notifications`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication basicAuth required
      // http basic authentication required
      setBasicAuthToObject(localVarRequestOptions, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        NotificationsRequestV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderDraftId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentsV1TenantOrderDraftIdPaymentMethodsGet: async (tenant, orderDraftId, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("paymentsV1TenantOrderDraftIdPaymentMethodsGet", "tenant", tenant);
      // verify required parameter 'orderDraftId' is not null or undefined
      assertParamExists("paymentsV1TenantOrderDraftIdPaymentMethodsGet", "orderDraftId", orderDraftId);
      const localVarPath = `/payments/v1/{tenant}/{orderDraftId}/paymentMethods`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderDraftId
     * @param {PaymentsDetailsRequestV1} PaymentsDetailsRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentsV1TenantOrderDraftIdPaymentsDetailsPost: async (
      tenant,
      orderDraftId,
      PaymentsDetailsRequestV1,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("paymentsV1TenantOrderDraftIdPaymentsDetailsPost", "tenant", tenant);
      // verify required parameter 'orderDraftId' is not null or undefined
      assertParamExists("paymentsV1TenantOrderDraftIdPaymentsDetailsPost", "orderDraftId", orderDraftId);
      // verify required parameter 'PaymentsDetailsRequestV1' is not null or undefined
      assertParamExists(
        "paymentsV1TenantOrderDraftIdPaymentsDetailsPost",
        "PaymentsDetailsRequestV1",
        PaymentsDetailsRequestV1
      );
      const localVarPath = `/payments/v1/{tenant}/{orderDraftId}/payments/details`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        PaymentsDetailsRequestV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Performs zero value creditCard authentication or processes the payment
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderDraftId
     * @param {PaymentsRequestV1} PaymentsRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentsV1TenantOrderDraftIdPaymentsPost: async (tenant, orderDraftId, PaymentsRequestV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("paymentsV1TenantOrderDraftIdPaymentsPost", "tenant", tenant);
      // verify required parameter 'orderDraftId' is not null or undefined
      assertParamExists("paymentsV1TenantOrderDraftIdPaymentsPost", "orderDraftId", orderDraftId);
      // verify required parameter 'PaymentsRequestV1' is not null or undefined
      assertParamExists("paymentsV1TenantOrderDraftIdPaymentsPost", "PaymentsRequestV1", PaymentsRequestV1);
      const localVarPath = `/payments/v1/{tenant}/{orderDraftId}/payments`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(PaymentsRequestV1, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {OriginKeysRequestV1} [OriginKeysRequestV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentsV1TenantOriginKeysPost: async (tenant, OriginKeysRequestV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("paymentsV1TenantOriginKeysPost", "tenant", tenant);
      const localVarPath = `/payments/v1/{tenant}/originKeys`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(OriginKeysRequestV1, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * PaymentsControllerApi - functional programming interface
 * @export
 */
export const PaymentsControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = PaymentsControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {DisableRequestV1} DisableRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentsV1TenantDisablePost(tenant, DisableRequestV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsV1TenantDisablePost(
        tenant,
        DisableRequestV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {NotificationsRequestV1} [NotificationsRequestV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentsV1TenantNotificationsPost(tenant, NotificationsRequestV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsV1TenantNotificationsPost(
        tenant,
        NotificationsRequestV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderDraftId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentsV1TenantOrderDraftIdPaymentMethodsGet(tenant, orderDraftId, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsV1TenantOrderDraftIdPaymentMethodsGet(
        tenant,
        orderDraftId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderDraftId
     * @param {PaymentsDetailsRequestV1} PaymentsDetailsRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentsV1TenantOrderDraftIdPaymentsDetailsPost(tenant, orderDraftId, PaymentsDetailsRequestV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsV1TenantOrderDraftIdPaymentsDetailsPost(
        tenant,
        orderDraftId,
        PaymentsDetailsRequestV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Performs zero value creditCard authentication or processes the payment
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderDraftId
     * @param {PaymentsRequestV1} PaymentsRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentsV1TenantOrderDraftIdPaymentsPost(tenant, orderDraftId, PaymentsRequestV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsV1TenantOrderDraftIdPaymentsPost(
        tenant,
        orderDraftId,
        PaymentsRequestV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {OriginKeysRequestV1} [OriginKeysRequestV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentsV1TenantOriginKeysPost(tenant, OriginKeysRequestV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsV1TenantOriginKeysPost(
        tenant,
        OriginKeysRequestV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * PaymentsControllerApi - factory interface
 * @export
 */
export const PaymentsControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = PaymentsControllerApiFp(configuration);
  return {
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {DisableRequestV1} DisableRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentsV1TenantDisablePost(tenant, DisableRequestV1, options) {
      return localVarFp
        .paymentsV1TenantDisablePost(tenant, DisableRequestV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {NotificationsRequestV1} [NotificationsRequestV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentsV1TenantNotificationsPost(tenant, NotificationsRequestV1, options) {
      return localVarFp
        .paymentsV1TenantNotificationsPost(tenant, NotificationsRequestV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderDraftId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentsV1TenantOrderDraftIdPaymentMethodsGet(tenant, orderDraftId, options) {
      return localVarFp
        .paymentsV1TenantOrderDraftIdPaymentMethodsGet(tenant, orderDraftId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderDraftId
     * @param {PaymentsDetailsRequestV1} PaymentsDetailsRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentsV1TenantOrderDraftIdPaymentsDetailsPost(tenant, orderDraftId, PaymentsDetailsRequestV1, options) {
      return localVarFp
        .paymentsV1TenantOrderDraftIdPaymentsDetailsPost(tenant, orderDraftId, PaymentsDetailsRequestV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Performs zero value creditCard authentication or processes the payment
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} orderDraftId
     * @param {PaymentsRequestV1} PaymentsRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentsV1TenantOrderDraftIdPaymentsPost(tenant, orderDraftId, PaymentsRequestV1, options) {
      return localVarFp
        .paymentsV1TenantOrderDraftIdPaymentsPost(tenant, orderDraftId, PaymentsRequestV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {OriginKeysRequestV1} [OriginKeysRequestV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentsV1TenantOriginKeysPost(tenant, OriginKeysRequestV1, options) {
      return localVarFp
        .paymentsV1TenantOriginKeysPost(tenant, OriginKeysRequestV1, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * PaymentsControllerApi - object-oriented interface
 * @export
 * @class PaymentsControllerApi
 * @extends {BaseAPI}
 */
export class PaymentsControllerApi extends BaseAPI {
  /**
   *
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {DisableRequestV1} DisableRequestV1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsControllerApi
   */
  paymentsV1TenantDisablePost(tenant, DisableRequestV1, options) {
    return PaymentsControllerApiFp(this.configuration)
      .paymentsV1TenantDisablePost(tenant, DisableRequestV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {NotificationsRequestV1} [NotificationsRequestV1]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsControllerApi
   */
  paymentsV1TenantNotificationsPost(tenant, NotificationsRequestV1, options) {
    return PaymentsControllerApiFp(this.configuration)
      .paymentsV1TenantNotificationsPost(tenant, NotificationsRequestV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} orderDraftId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsControllerApi
   */
  paymentsV1TenantOrderDraftIdPaymentMethodsGet(tenant, orderDraftId, options) {
    return PaymentsControllerApiFp(this.configuration)
      .paymentsV1TenantOrderDraftIdPaymentMethodsGet(tenant, orderDraftId, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} orderDraftId
   * @param {PaymentsDetailsRequestV1} PaymentsDetailsRequestV1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsControllerApi
   */
  paymentsV1TenantOrderDraftIdPaymentsDetailsPost(tenant, orderDraftId, PaymentsDetailsRequestV1, options) {
    return PaymentsControllerApiFp(this.configuration)
      .paymentsV1TenantOrderDraftIdPaymentsDetailsPost(tenant, orderDraftId, PaymentsDetailsRequestV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Performs zero value creditCard authentication or processes the payment
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} orderDraftId
   * @param {PaymentsRequestV1} PaymentsRequestV1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsControllerApi
   */
  paymentsV1TenantOrderDraftIdPaymentsPost(tenant, orderDraftId, PaymentsRequestV1, options) {
    return PaymentsControllerApiFp(this.configuration)
      .paymentsV1TenantOrderDraftIdPaymentsPost(tenant, orderDraftId, PaymentsRequestV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {OriginKeysRequestV1} [OriginKeysRequestV1]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsControllerApi
   */
  paymentsV1TenantOriginKeysPost(tenant, OriginKeysRequestV1, options) {
    return PaymentsControllerApiFp(this.configuration)
      .paymentsV1TenantOriginKeysPost(tenant, OriginKeysRequestV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * PersistentCartControllerApi - axios parameter creator
 * @export
 */
export const PersistentCartControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languagePersistentCartV1TenantCartsIdDelete: async (id, tenant, language, options = {}) => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("languagePersistentCartV1TenantCartsIdDelete", "id", id);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languagePersistentCartV1TenantCartsIdDelete", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languagePersistentCartV1TenantCartsIdDelete", "language", language);
      const localVarPath = `/{language}/persistent-cart/v1/{tenant}/carts/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "DELETE", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {string} entryId PathParam entryId
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languagePersistentCartV1TenantCartsIdEntriesEntryIdDelete: async (id, entryId, tenant, language, options = {}) => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("languagePersistentCartV1TenantCartsIdEntriesEntryIdDelete", "id", id);
      // verify required parameter 'entryId' is not null or undefined
      assertParamExists("languagePersistentCartV1TenantCartsIdEntriesEntryIdDelete", "entryId", entryId);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languagePersistentCartV1TenantCartsIdEntriesEntryIdDelete", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languagePersistentCartV1TenantCartsIdEntriesEntryIdDelete", "language", language);
      const localVarPath = `/{language}/persistent-cart/v1/{tenant}/carts/{id}/entries/{entryId}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)))
        .replace(`{${"entryId"}}`, encodeURIComponent(String(entryId)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "DELETE", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {string} entryId PathParam entryId
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languagePersistentCartV1TenantCartsIdEntriesEntryIdGet: async (id, entryId, tenant, language, options = {}) => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("languagePersistentCartV1TenantCartsIdEntriesEntryIdGet", "id", id);
      // verify required parameter 'entryId' is not null or undefined
      assertParamExists("languagePersistentCartV1TenantCartsIdEntriesEntryIdGet", "entryId", entryId);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languagePersistentCartV1TenantCartsIdEntriesEntryIdGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languagePersistentCartV1TenantCartsIdEntriesEntryIdGet", "language", language);
      const localVarPath = `/{language}/persistent-cart/v1/{tenant}/carts/{id}/entries/{entryId}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)))
        .replace(`{${"entryId"}}`, encodeURIComponent(String(entryId)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {string} entryId PathParam entryId
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languagePersistentCartV1TenantCartsIdEntriesEntryIdPut: async (
      id,
      entryId,
      tenant,
      language,
      body,
      options = {}
    ) => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("languagePersistentCartV1TenantCartsIdEntriesEntryIdPut", "id", id);
      // verify required parameter 'entryId' is not null or undefined
      assertParamExists("languagePersistentCartV1TenantCartsIdEntriesEntryIdPut", "entryId", entryId);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languagePersistentCartV1TenantCartsIdEntriesEntryIdPut", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languagePersistentCartV1TenantCartsIdEntriesEntryIdPut", "language", language);
      const localVarPath = `/{language}/persistent-cart/v1/{tenant}/carts/{id}/entries/{entryId}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)))
        .replace(`{${"entryId"}}`, encodeURIComponent(String(entryId)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "PUT", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languagePersistentCartV1TenantCartsIdEntriesPost: async (id, tenant, language, body, options = {}) => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("languagePersistentCartV1TenantCartsIdEntriesPost", "id", id);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languagePersistentCartV1TenantCartsIdEntriesPost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languagePersistentCartV1TenantCartsIdEntriesPost", "language", language);
      const localVarPath = `/{language}/persistent-cart/v1/{tenant}/carts/{id}/entries`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languagePersistentCartV1TenantCartsIdGet: async (id, tenant, language, options = {}) => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("languagePersistentCartV1TenantCartsIdGet", "id", id);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languagePersistentCartV1TenantCartsIdGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languagePersistentCartV1TenantCartsIdGet", "language", language);
      const localVarPath = `/{language}/persistent-cart/v1/{tenant}/carts/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languagePersistentCartV1TenantCartsIdPatch: async (id, tenant, language, body, options = {}) => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("languagePersistentCartV1TenantCartsIdPatch", "id", id);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languagePersistentCartV1TenantCartsIdPatch", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languagePersistentCartV1TenantCartsIdPatch", "language", language);
      const localVarPath = `/{language}/persistent-cart/v1/{tenant}/carts/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "PATCH", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languagePersistentCartV1TenantCartsPost: async (tenant, language, body, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languagePersistentCartV1TenantCartsPost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languagePersistentCartV1TenantCartsPost", "language", language);
      const localVarPath = `/{language}/persistent-cart/v1/{tenant}/carts`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languagePersistentCartV1TenantHealthGet: async (tenant, language, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languagePersistentCartV1TenantHealthGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languagePersistentCartV1TenantHealthGet", "language", language);
      const localVarPath = `/{language}/persistent-cart/v1/{tenant}/health`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * PersistentCartControllerApi - functional programming interface
 * @export
 */
export const PersistentCartControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = PersistentCartControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languagePersistentCartV1TenantCartsIdDelete(id, tenant, language, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languagePersistentCartV1TenantCartsIdDelete(
        id,
        tenant,
        language,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {string} entryId PathParam entryId
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languagePersistentCartV1TenantCartsIdEntriesEntryIdDelete(id, entryId, tenant, language, options) {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.languagePersistentCartV1TenantCartsIdEntriesEntryIdDelete(
          id,
          entryId,
          tenant,
          language,
          options
        );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {string} entryId PathParam entryId
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languagePersistentCartV1TenantCartsIdEntriesEntryIdGet(id, entryId, tenant, language, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languagePersistentCartV1TenantCartsIdEntriesEntryIdGet(
        id,
        entryId,
        tenant,
        language,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {string} entryId PathParam entryId
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languagePersistentCartV1TenantCartsIdEntriesEntryIdPut(id, entryId, tenant, language, body, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languagePersistentCartV1TenantCartsIdEntriesEntryIdPut(
        id,
        entryId,
        tenant,
        language,
        body,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languagePersistentCartV1TenantCartsIdEntriesPost(id, tenant, language, body, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languagePersistentCartV1TenantCartsIdEntriesPost(
        id,
        tenant,
        language,
        body,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languagePersistentCartV1TenantCartsIdGet(id, tenant, language, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languagePersistentCartV1TenantCartsIdGet(
        id,
        tenant,
        language,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languagePersistentCartV1TenantCartsIdPatch(id, tenant, language, body, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languagePersistentCartV1TenantCartsIdPatch(
        id,
        tenant,
        language,
        body,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languagePersistentCartV1TenantCartsPost(tenant, language, body, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languagePersistentCartV1TenantCartsPost(
        tenant,
        language,
        body,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languagePersistentCartV1TenantHealthGet(tenant, language, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languagePersistentCartV1TenantHealthGet(
        tenant,
        language,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * PersistentCartControllerApi - factory interface
 * @export
 */
export const PersistentCartControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = PersistentCartControllerApiFp(configuration);
  return {
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languagePersistentCartV1TenantCartsIdDelete(id, tenant, language, options) {
      return localVarFp
        .languagePersistentCartV1TenantCartsIdDelete(id, tenant, language, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {string} entryId PathParam entryId
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languagePersistentCartV1TenantCartsIdEntriesEntryIdDelete(id, entryId, tenant, language, options) {
      return localVarFp
        .languagePersistentCartV1TenantCartsIdEntriesEntryIdDelete(id, entryId, tenant, language, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {string} entryId PathParam entryId
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languagePersistentCartV1TenantCartsIdEntriesEntryIdGet(id, entryId, tenant, language, options) {
      return localVarFp
        .languagePersistentCartV1TenantCartsIdEntriesEntryIdGet(id, entryId, tenant, language, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {string} entryId PathParam entryId
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languagePersistentCartV1TenantCartsIdEntriesEntryIdPut(id, entryId, tenant, language, body, options) {
      return localVarFp
        .languagePersistentCartV1TenantCartsIdEntriesEntryIdPut(id, entryId, tenant, language, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languagePersistentCartV1TenantCartsIdEntriesPost(id, tenant, language, body, options) {
      return localVarFp
        .languagePersistentCartV1TenantCartsIdEntriesPost(id, tenant, language, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languagePersistentCartV1TenantCartsIdGet(id, tenant, language, options) {
      return localVarFp
        .languagePersistentCartV1TenantCartsIdGet(id, tenant, language, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languagePersistentCartV1TenantCartsIdPatch(id, tenant, language, body, options) {
      return localVarFp
        .languagePersistentCartV1TenantCartsIdPatch(id, tenant, language, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languagePersistentCartV1TenantCartsPost(tenant, language, body, options) {
      return localVarFp
        .languagePersistentCartV1TenantCartsPost(tenant, language, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languagePersistentCartV1TenantHealthGet(tenant, language, options) {
      return localVarFp
        .languagePersistentCartV1TenantHealthGet(tenant, language, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * PersistentCartControllerApi - object-oriented interface
 * @export
 * @class PersistentCartControllerApi
 * @extends {BaseAPI}
 */
export class PersistentCartControllerApi extends BaseAPI {
  /**
   *
   * @param {string} id PathParam id
   * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersistentCartControllerApi
   */
  languagePersistentCartV1TenantCartsIdDelete(id, tenant, language, options) {
    return PersistentCartControllerApiFp(this.configuration)
      .languagePersistentCartV1TenantCartsIdDelete(id, tenant, language, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} id PathParam id
   * @param {string} entryId PathParam entryId
   * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersistentCartControllerApi
   */
  languagePersistentCartV1TenantCartsIdEntriesEntryIdDelete(id, entryId, tenant, language, options) {
    return PersistentCartControllerApiFp(this.configuration)
      .languagePersistentCartV1TenantCartsIdEntriesEntryIdDelete(id, entryId, tenant, language, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} id PathParam id
   * @param {string} entryId PathParam entryId
   * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersistentCartControllerApi
   */
  languagePersistentCartV1TenantCartsIdEntriesEntryIdGet(id, entryId, tenant, language, options) {
    return PersistentCartControllerApiFp(this.configuration)
      .languagePersistentCartV1TenantCartsIdEntriesEntryIdGet(id, entryId, tenant, language, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} id PathParam id
   * @param {string} entryId PathParam entryId
   * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {object} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersistentCartControllerApi
   */
  languagePersistentCartV1TenantCartsIdEntriesEntryIdPut(id, entryId, tenant, language, body, options) {
    return PersistentCartControllerApiFp(this.configuration)
      .languagePersistentCartV1TenantCartsIdEntriesEntryIdPut(id, entryId, tenant, language, body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} id PathParam id
   * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {object} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersistentCartControllerApi
   */
  languagePersistentCartV1TenantCartsIdEntriesPost(id, tenant, language, body, options) {
    return PersistentCartControllerApiFp(this.configuration)
      .languagePersistentCartV1TenantCartsIdEntriesPost(id, tenant, language, body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} id PathParam id
   * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersistentCartControllerApi
   */
  languagePersistentCartV1TenantCartsIdGet(id, tenant, language, options) {
    return PersistentCartControllerApiFp(this.configuration)
      .languagePersistentCartV1TenantCartsIdGet(id, tenant, language, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} id PathParam id
   * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {object} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersistentCartControllerApi
   */
  languagePersistentCartV1TenantCartsIdPatch(id, tenant, language, body, options) {
    return PersistentCartControllerApiFp(this.configuration)
      .languagePersistentCartV1TenantCartsIdPatch(id, tenant, language, body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {object} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersistentCartControllerApi
   */
  languagePersistentCartV1TenantCartsPost(tenant, language, body, options) {
    return PersistentCartControllerApiFp(this.configuration)
      .languagePersistentCartV1TenantCartsPost(tenant, language, body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersistentCartControllerApi
   */
  languagePersistentCartV1TenantHealthGet(tenant, language, options) {
    return PersistentCartControllerApiFp(this.configuration)
      .languagePersistentCartV1TenantHealthGet(tenant, language, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * PersonalLayoutControllerV1Api - axios parameter creator
 * @export
 */
export const PersonalLayoutControllerV1ApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Get personal widget layout and data for app home screen
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} variant variant
     * @param {string} [zipCode] zipCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personalLayoutV1TenantLanguageVariantAppsHomeGet: async (tenant, language, variant, zipCode, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("personalLayoutV1TenantLanguageVariantAppsHomeGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("personalLayoutV1TenantLanguageVariantAppsHomeGet", "language", language);
      // verify required parameter 'variant' is not null or undefined
      assertParamExists("personalLayoutV1TenantLanguageVariantAppsHomeGet", "variant", variant);
      const localVarPath = `/personal-layout/v1/{tenant}/{language}/{variant}/apps/home`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"variant"}}`, encodeURIComponent(String(variant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (zipCode !== undefined) {
        localVarQueryParameter["zipCode"] = zipCode;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * PersonalLayoutControllerV1Api - functional programming interface
 * @export
 */
export const PersonalLayoutControllerV1ApiFp = function (configuration) {
  const localVarAxiosParamCreator = PersonalLayoutControllerV1ApiAxiosParamCreator(configuration);
  return {
    /**
     * Get personal widget layout and data for app home screen
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} variant variant
     * @param {string} [zipCode] zipCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personalLayoutV1TenantLanguageVariantAppsHomeGet(tenant, language, variant, zipCode, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.personalLayoutV1TenantLanguageVariantAppsHomeGet(
        tenant,
        language,
        variant,
        zipCode,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * PersonalLayoutControllerV1Api - factory interface
 * @export
 */
export const PersonalLayoutControllerV1ApiFactory = function (configuration, basePath, axios) {
  const localVarFp = PersonalLayoutControllerV1ApiFp(configuration);
  return {
    /**
     * Get personal widget layout and data for app home screen
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} variant variant
     * @param {string} [zipCode] zipCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personalLayoutV1TenantLanguageVariantAppsHomeGet(tenant, language, variant, zipCode, options) {
      return localVarFp
        .personalLayoutV1TenantLanguageVariantAppsHomeGet(tenant, language, variant, zipCode, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * PersonalLayoutControllerV1Api - object-oriented interface
 * @export
 * @class PersonalLayoutControllerV1Api
 * @extends {BaseAPI}
 */
export class PersonalLayoutControllerV1Api extends BaseAPI {
  /**
   * Get personal widget layout and data for app home screen
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {string} variant variant
   * @param {string} [zipCode] zipCode
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonalLayoutControllerV1Api
   */
  personalLayoutV1TenantLanguageVariantAppsHomeGet(tenant, language, variant, zipCode, options) {
    return PersonalLayoutControllerV1ApiFp(this.configuration)
      .personalLayoutV1TenantLanguageVariantAppsHomeGet(tenant, language, variant, zipCode, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * PrescriptionControllerApi - axios parameter creator
 * @export
 */
export const PrescriptionControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Creates a quick checkout order.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {QuickCheckoutBodyV1} QuickCheckoutBodyV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageCheckoutPost: async (tenant, language, QuickCheckoutBodyV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageCheckoutPost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageCheckoutPost", "language", language);
      // verify required parameter 'QuickCheckoutBodyV1' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageCheckoutPost", "QuickCheckoutBodyV1", QuickCheckoutBodyV1);
      const localVarPath = `/prescription/v1/{tenant}/{language}/checkout`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(QuickCheckoutBodyV1, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Claims prescriptions by provided datamatrixurls. Checks if they match with provided insurance numbers. Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returns an 5xx error - the whole request will be rejected with 5xx error as well.
     * @summary Claims multiple prescriptions, checks if they match with provided insurance numbers and returns them together with product data.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {ClaimPrescriptionsByInsuranceNumbersRequestObject} ClaimPrescriptionsByInsuranceNumbersRequestObject
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageClaimPrescriptionsByInsuranceNumbersPost: async (
      tenant,
      language,
      ClaimPrescriptionsByInsuranceNumbersRequestObject,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageClaimPrescriptionsByInsuranceNumbersPost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageClaimPrescriptionsByInsuranceNumbersPost", "language", language);
      // verify required parameter 'ClaimPrescriptionsByInsuranceNumbersRequestObject' is not null or undefined
      assertParamExists(
        "prescriptionV1TenantLanguageClaimPrescriptionsByInsuranceNumbersPost",
        "ClaimPrescriptionsByInsuranceNumbersRequestObject",
        ClaimPrescriptionsByInsuranceNumbersRequestObject
      );
      const localVarPath = `/prescription/v1/{tenant}/{language}/claimPrescriptionsByInsuranceNumbers`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        ClaimPrescriptionsByInsuranceNumbersRequestObject,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Claims prescriptions by provided datamatrixurls. Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returns an 5xx error - the whole request will be rejected with 5xx error as well.
     * @summary Claims multiple prescriptions and returns them together with product data.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {DatamatruxurlsArray} DatamatruxurlsArray
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageClaimPrescriptionsPost: async (tenant, language, DatamatruxurlsArray, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageClaimPrescriptionsPost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageClaimPrescriptionsPost", "language", language);
      // verify required parameter 'DatamatruxurlsArray' is not null or undefined
      assertParamExists(
        "prescriptionV1TenantLanguageClaimPrescriptionsPost",
        "DatamatruxurlsArray",
        DatamatruxurlsArray
      );
      const localVarPath = `/prescription/v1/{tenant}/{language}/claimPrescriptions`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(DatamatruxurlsArray, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Receives an array of datamatrixurl components, converts them into image buffer.
     * @summary Creates image from datamatrixurl components.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest} PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageCreateImageFromUrlPost: async (
      tenant,
      language,
      PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageCreateImageFromUrlPost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageCreateImageFromUrlPost", "language", language);
      // verify required parameter 'PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest' is not null or undefined
      assertParamExists(
        "prescriptionV1TenantLanguageCreateImageFromUrlPost",
        "PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest",
        PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest
      );
      const localVarPath = `/prescription/v1/{tenant}/{language}/createImageFromUrl`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Responds with DatamatrixUrls for given token.
     * @summary Fetches DatamatrixUrls that correspond to the token param through eRX Service
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} datamatrixUrlsToken Token used to fetch corresponding datamatrix urls
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet: async (
      tenant,
      language,
      datamatrixUrlsToken,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet", "language", language);
      // verify required parameter 'datamatrixUrlsToken' is not null or undefined
      assertParamExists(
        "prescriptionV1TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet",
        "datamatrixUrlsToken",
        datamatrixUrlsToken
      );
      const localVarPath = `/prescription/v1/{tenant}/{language}/datamatrixUrls/{datamatrixUrlsToken}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"datamatrixUrlsToken"}}`, encodeURIComponent(String(datamatrixUrlsToken)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Sends voucher email event to mail assembly service.
     * @summary Sends an email to customer for erx voucher.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {ErxVoucherEmailBodyV1} ErxVoucherEmailBodyV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageEmailVoucherPost: async (tenant, language, ErxVoucherEmailBodyV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageEmailVoucherPost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageEmailVoucherPost", "language", language);
      // verify required parameter 'ErxVoucherEmailBodyV1' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageEmailVoucherPost", "ErxVoucherEmailBodyV1", ErxVoucherEmailBodyV1);
      const localVarPath = `/prescription/v1/{tenant}/{language}/email/voucher`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(ErxVoucherEmailBodyV1, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returnes an 5xx error - the whole request will be rejected with 5xx error as well.
     * @summary Fetch multiple prescriptions that are already claimed together with product data.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {HashedTokensPayload} HashedTokensPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageGetPrescriptionsPost: async (tenant, language, HashedTokensPayload, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageGetPrescriptionsPost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageGetPrescriptionsPost", "language", language);
      // verify required parameter 'HashedTokensPayload' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageGetPrescriptionsPost", "HashedTokensPayload", HashedTokensPayload);
      const localVarPath = `/prescription/v1/{tenant}/{language}/getPrescriptions`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(HashedTokensPayload, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
     * @summary Aborts prescription, removes the dataMatrixUrl from the prescription.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageHashedTokenAbortedPost: async (tenant, language, hashedToken, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageHashedTokenAbortedPost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageHashedTokenAbortedPost", "language", language);
      // verify required parameter 'hashedToken' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageHashedTokenAbortedPost", "hashedToken", hashedToken);
      const localVarPath = `/prescription/v1/{tenant}/{language}/{hashedToken}/aborted`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"hashedToken"}}`, encodeURIComponent(String(hashedToken)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
     * @summary Closes prescription, removes the dataMatrixUrl from the prescription.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageHashedTokenClosedPost: async (tenant, language, hashedToken, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageHashedTokenClosedPost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageHashedTokenClosedPost", "language", language);
      // verify required parameter 'hashedToken' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageHashedTokenClosedPost", "hashedToken", hashedToken);
      const localVarPath = `/prescription/v1/{tenant}/{language}/{hashedToken}/closed`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"hashedToken"}}`, encodeURIComponent(String(hashedToken)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
     * @summary Unclaims prescription from eRX.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageHashedTokenDelete: async (tenant, language, hashedToken, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageHashedTokenDelete", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageHashedTokenDelete", "language", language);
      // verify required parameter 'hashedToken' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageHashedTokenDelete", "hashedToken", hashedToken);
      const localVarPath = `/prescription/v1/{tenant}/{language}/{hashedToken}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"hashedToken"}}`, encodeURIComponent(String(hashedToken)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "DELETE", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
     * @summary Unclaims prescription from eRX.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageHashedTokenDeletePost: async (tenant, language, hashedToken, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageHashedTokenDeletePost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageHashedTokenDeletePost", "language", language);
      // verify required parameter 'hashedToken' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageHashedTokenDeletePost", "hashedToken", hashedToken);
      const localVarPath = `/prescription/v1/{tenant}/{language}/{hashedToken}/delete`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"hashedToken"}}`, encodeURIComponent(String(hashedToken)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Gets the ePrescription from the eRX service, and on successful response, it returns the same set of data as in the claim call. If the prescription is unclaimed, it will return an indicative error message.\'
     * @summary Get an already claimed ePrescription by providing hashed token.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {boolean} [useMDS] QueryParam useMDS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageHashedTokenGet: async (tenant, language, hashedToken, useMDS, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageHashedTokenGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageHashedTokenGet", "language", language);
      // verify required parameter 'hashedToken' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageHashedTokenGet", "hashedToken", hashedToken);
      const localVarPath = `/prescription/v1/{tenant}/{language}/{hashedToken}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"hashedToken"}}`, encodeURIComponent(String(hashedToken)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (useMDS !== undefined) {
        localVarQueryParameter["useMDS"] = useMDS;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
     * @summary Rejects prescription, removes the dataMatrixUrl from the prescription.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageHashedTokenRejectedPost: async (tenant, language, hashedToken, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageHashedTokenRejectedPost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageHashedTokenRejectedPost", "language", language);
      // verify required parameter 'hashedToken' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageHashedTokenRejectedPost", "hashedToken", hashedToken);
      const localVarPath = `/prescription/v1/{tenant}/{language}/{hashedToken}/rejected`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"hashedToken"}}`, encodeURIComponent(String(hashedToken)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Get the health status of eRX service
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageHealthGet: async (tenant, language, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageHealthGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageHealthGet", "language", language);
      const localVarPath = `/prescription/v1/{tenant}/{language}/health`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Receives the extracted dataMatrixURL (which contains a task id) from the client, and makes a request to the eRX service, claiming the prescription item(s). It may then make a request to the Swap service, potentially swapping the prescription item(s) received from eRX service in the previous step. It then populates the product data for all prescription item(s) and returns the fully renderable payload to the client
     * @summary Claim prescription given original, non-hashed tokens.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {DataMatrixURL} DataMatrixURL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguagePost: async (tenant, language, DataMatrixURL, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguagePost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguagePost", "language", language);
      // verify required parameter 'DataMatrixURL' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguagePost", "DataMatrixURL", DataMatrixURL);
      const localVarPath = `/prescription/v1/{tenant}/{language}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(DataMatrixURL, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * When called the SAE eRX Service will provide a dedicated link for putting the eRX into the eRX Manager that can be later visited.
     * @summary Provisioning eRX data for given e-prescription
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} X_API_KEY
     * @param {DatamatrixUrlComponentsList} DatamatrixUrlComponentsList
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageTelemedDeliverPost: async (
      tenant,
      language,
      X_API_KEY,
      DatamatrixUrlComponentsList,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageTelemedDeliverPost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageTelemedDeliverPost", "language", language);
      // verify required parameter 'X_API_KEY' is not null or undefined
      assertParamExists("prescriptionV1TenantLanguageTelemedDeliverPost", "X_API_KEY", X_API_KEY);
      // verify required parameter 'DatamatrixUrlComponentsList' is not null or undefined
      assertParamExists(
        "prescriptionV1TenantLanguageTelemedDeliverPost",
        "DatamatrixUrlComponentsList",
        DatamatrixUrlComponentsList
      );
      const localVarPath = `/prescription/v1/{tenant}/{language}/telemed/deliver`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (X_API_KEY != null) {
        localVarHeaderParameter["X-API-KEY"] = String(X_API_KEY);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        DatamatrixUrlComponentsList,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Creates a quick checkout order.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {QuickCheckoutBodyV1} QuickCheckoutBodyV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageCheckoutPost: async (tenant, language, QuickCheckoutBodyV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageCheckoutPost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageCheckoutPost", "language", language);
      // verify required parameter 'QuickCheckoutBodyV1' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageCheckoutPost", "QuickCheckoutBodyV1", QuickCheckoutBodyV1);
      const localVarPath = `/prescription/v3/{tenant}/{language}/checkout`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(QuickCheckoutBodyV1, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Claims prescriptions by provided datamatrixurls. Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returnes an 5xx error - the whole request will be rejected with 5xx error as well.
     * @summary Claims multiple prescriptions and returns them together with product data.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {DatamatruxurlsArray} DatamatruxurlsArray
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageClaimPrescriptionsPost: async (tenant, language, DatamatruxurlsArray, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageClaimPrescriptionsPost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageClaimPrescriptionsPost", "language", language);
      // verify required parameter 'DatamatruxurlsArray' is not null or undefined
      assertParamExists(
        "prescriptionV3TenantLanguageClaimPrescriptionsPost",
        "DatamatruxurlsArray",
        DatamatruxurlsArray
      );
      const localVarPath = `/prescription/v3/{tenant}/{language}/claimPrescriptions`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(DatamatruxurlsArray, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Receives an array of datamatrixurl components, converts them into image buffer.
     * @summary Creates image from datamatrixurl components.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest} PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageCreateImageFromUrlPost: async (
      tenant,
      language,
      PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageCreateImageFromUrlPost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageCreateImageFromUrlPost", "language", language);
      // verify required parameter 'PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest' is not null or undefined
      assertParamExists(
        "prescriptionV3TenantLanguageCreateImageFromUrlPost",
        "PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest",
        PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest
      );
      const localVarPath = `/prescription/v3/{tenant}/{language}/createImageFromUrl`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Responds with DatamatrixUrls for given token.
     * @summary Fetches DatamatrixUrls that correspond to the token param through eRX Service
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} datamatrixUrlsToken Token used to fetch corresponding datamatrix urls
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet: async (
      tenant,
      language,
      datamatrixUrlsToken,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet", "language", language);
      // verify required parameter 'datamatrixUrlsToken' is not null or undefined
      assertParamExists(
        "prescriptionV3TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet",
        "datamatrixUrlsToken",
        datamatrixUrlsToken
      );
      const localVarPath = `/prescription/v3/{tenant}/{language}/datamatrixUrls/{datamatrixUrlsToken}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"datamatrixUrlsToken"}}`, encodeURIComponent(String(datamatrixUrlsToken)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Sends voucher email event to mail assembly service.
     * @summary Sends an email to customer for erx voucher.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {ErxVoucherEmailBodyV1} ErxVoucherEmailBodyV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageEmailVoucherPost: async (tenant, language, ErxVoucherEmailBodyV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageEmailVoucherPost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageEmailVoucherPost", "language", language);
      // verify required parameter 'ErxVoucherEmailBodyV1' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageEmailVoucherPost", "ErxVoucherEmailBodyV1", ErxVoucherEmailBodyV1);
      const localVarPath = `/prescription/v3/{tenant}/{language}/email/voucher`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(ErxVoucherEmailBodyV1, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Receives an array of files in base64 format, converts them into binary and sends files to the erx service. Service responds with extracted datamatrixurls array.
     * @summary Extracts prescription data from images or pdf that contain datamatrixurl.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {PrescriptionFilesArray} PrescriptionFilesArray
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageExtractFromFilesPost: async (
      tenant,
      language,
      PrescriptionFilesArray,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageExtractFromFilesPost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageExtractFromFilesPost", "language", language);
      // verify required parameter 'PrescriptionFilesArray' is not null or undefined
      assertParamExists(
        "prescriptionV3TenantLanguageExtractFromFilesPost",
        "PrescriptionFilesArray",
        PrescriptionFilesArray
      );
      const localVarPath = `/prescription/v3/{tenant}/{language}/extractFromFiles`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        PrescriptionFilesArray,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returnes an 5xx error - the whole request will be rejected with 5xx error as well.
     * @summary Fetch multiple prescriptions that are already claimed together with product data.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {HashedTokensPayload} HashedTokensPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageGetPrescriptionsPost: async (tenant, language, HashedTokensPayload, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageGetPrescriptionsPost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageGetPrescriptionsPost", "language", language);
      // verify required parameter 'HashedTokensPayload' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageGetPrescriptionsPost", "HashedTokensPayload", HashedTokensPayload);
      const localVarPath = `/prescription/v3/{tenant}/{language}/getPrescriptions`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(HashedTokensPayload, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
     * @summary Aborts prescription, removes the dataMatrixUrl from the prescription.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageHashedTokenAbortedPost: async (tenant, language, hashedToken, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageHashedTokenAbortedPost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageHashedTokenAbortedPost", "language", language);
      // verify required parameter 'hashedToken' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageHashedTokenAbortedPost", "hashedToken", hashedToken);
      const localVarPath = `/prescription/v3/{tenant}/{language}/{hashedToken}/aborted`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"hashedToken"}}`, encodeURIComponent(String(hashedToken)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
     * @summary Closes prescription, removes the dataMatrixUrl from the prescription.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageHashedTokenClosedPost: async (tenant, language, hashedToken, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageHashedTokenClosedPost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageHashedTokenClosedPost", "language", language);
      // verify required parameter 'hashedToken' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageHashedTokenClosedPost", "hashedToken", hashedToken);
      const localVarPath = `/prescription/v3/{tenant}/{language}/{hashedToken}/closed`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"hashedToken"}}`, encodeURIComponent(String(hashedToken)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
     * @summary Unclaims prescription from eRX.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageHashedTokenDelete: async (tenant, language, hashedToken, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageHashedTokenDelete", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageHashedTokenDelete", "language", language);
      // verify required parameter 'hashedToken' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageHashedTokenDelete", "hashedToken", hashedToken);
      const localVarPath = `/prescription/v3/{tenant}/{language}/{hashedToken}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"hashedToken"}}`, encodeURIComponent(String(hashedToken)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "DELETE", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
     * @summary Unclaims prescription from eRX.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageHashedTokenDeletePost: async (tenant, language, hashedToken, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageHashedTokenDeletePost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageHashedTokenDeletePost", "language", language);
      // verify required parameter 'hashedToken' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageHashedTokenDeletePost", "hashedToken", hashedToken);
      const localVarPath = `/prescription/v3/{tenant}/{language}/{hashedToken}/delete`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"hashedToken"}}`, encodeURIComponent(String(hashedToken)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Gets the ePrescription from the eRX service, and on successful response, it returns the same set of data as in the claim call. If the prescription is unclaimed, it will return an indicative error message.\'
     * @summary Get an already claimed ePrescription by providing hashed token.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageHashedTokenGet: async (tenant, language, hashedToken, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageHashedTokenGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageHashedTokenGet", "language", language);
      // verify required parameter 'hashedToken' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageHashedTokenGet", "hashedToken", hashedToken);
      const localVarPath = `/prescription/v3/{tenant}/{language}/{hashedToken}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"hashedToken"}}`, encodeURIComponent(String(hashedToken)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
     * @summary Rejects prescription, removes the dataMatrixUrl from the prescription.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageHashedTokenRejectedPost: async (tenant, language, hashedToken, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageHashedTokenRejectedPost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageHashedTokenRejectedPost", "language", language);
      // verify required parameter 'hashedToken' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageHashedTokenRejectedPost", "hashedToken", hashedToken);
      const localVarPath = `/prescription/v3/{tenant}/{language}/{hashedToken}/rejected`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"hashedToken"}}`, encodeURIComponent(String(hashedToken)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Get the health status of eRX service
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageHealthGet: async (tenant, language, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageHealthGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageHealthGet", "language", language);
      const localVarPath = `/prescription/v3/{tenant}/{language}/health`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Receives the extracted dataMatrixURL (which contains a task id) from the client, and makes a request to the eRX service, claiming the prescription item(s). It may then make a request to the Swap service, potentially swapping the prescription item(s) received from eRX service in the previous step. It then populates the product data for all prescription item(s) and returns the fully renderable payload to the client
     * @summary Claim prescription given original, non-hashed tokens.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {DataMatrixURL} DataMatrixURL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguagePost: async (tenant, language, DataMatrixURL, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguagePost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguagePost", "language", language);
      // verify required parameter 'DataMatrixURL' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguagePost", "DataMatrixURL", DataMatrixURL);
      const localVarPath = `/prescription/v3/{tenant}/{language}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(DataMatrixURL, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * When called the SAE eRX Service will provide a dedicated link for putting the eRX into the eRX Manager that can be later visited.
     * @summary Provisioning eRX data for given e-prescription
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} X_API_KEY
     * @param {DatamatrixUrlComponentsList} DatamatrixUrlComponentsList
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageTelemedDeliverPost: async (
      tenant,
      language,
      X_API_KEY,
      DatamatrixUrlComponentsList,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageTelemedDeliverPost", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageTelemedDeliverPost", "language", language);
      // verify required parameter 'X_API_KEY' is not null or undefined
      assertParamExists("prescriptionV3TenantLanguageTelemedDeliverPost", "X_API_KEY", X_API_KEY);
      // verify required parameter 'DatamatrixUrlComponentsList' is not null or undefined
      assertParamExists(
        "prescriptionV3TenantLanguageTelemedDeliverPost",
        "DatamatrixUrlComponentsList",
        DatamatrixUrlComponentsList
      );
      const localVarPath = `/prescription/v3/{tenant}/{language}/telemed/deliver`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (X_API_KEY != null) {
        localVarHeaderParameter["X-API-KEY"] = String(X_API_KEY);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        DatamatrixUrlComponentsList,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * PrescriptionControllerApi - functional programming interface
 * @export
 */
export const PrescriptionControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = PrescriptionControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * Creates a quick checkout order.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {QuickCheckoutBodyV1} QuickCheckoutBodyV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV1TenantLanguageCheckoutPost(tenant, language, QuickCheckoutBodyV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionV1TenantLanguageCheckoutPost(
        tenant,
        language,
        QuickCheckoutBodyV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Claims prescriptions by provided datamatrixurls. Checks if they match with provided insurance numbers. Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returns an 5xx error - the whole request will be rejected with 5xx error as well.
     * @summary Claims multiple prescriptions, checks if they match with provided insurance numbers and returns them together with product data.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {ClaimPrescriptionsByInsuranceNumbersRequestObject} ClaimPrescriptionsByInsuranceNumbersRequestObject
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV1TenantLanguageClaimPrescriptionsByInsuranceNumbersPost(
      tenant,
      language,
      ClaimPrescriptionsByInsuranceNumbersRequestObject,
      options
    ) {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.prescriptionV1TenantLanguageClaimPrescriptionsByInsuranceNumbersPost(
          tenant,
          language,
          ClaimPrescriptionsByInsuranceNumbersRequestObject,
          options
        );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Claims prescriptions by provided datamatrixurls. Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returns an 5xx error - the whole request will be rejected with 5xx error as well.
     * @summary Claims multiple prescriptions and returns them together with product data.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {DatamatruxurlsArray} DatamatruxurlsArray
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV1TenantLanguageClaimPrescriptionsPost(tenant, language, DatamatruxurlsArray, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionV1TenantLanguageClaimPrescriptionsPost(
        tenant,
        language,
        DatamatruxurlsArray,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Receives an array of datamatrixurl components, converts them into image buffer.
     * @summary Creates image from datamatrixurl components.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest} PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV1TenantLanguageCreateImageFromUrlPost(
      tenant,
      language,
      PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionV1TenantLanguageCreateImageFromUrlPost(
        tenant,
        language,
        PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Responds with DatamatrixUrls for given token.
     * @summary Fetches DatamatrixUrls that correspond to the token param through eRX Service
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} datamatrixUrlsToken Token used to fetch corresponding datamatrix urls
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV1TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet(
      tenant,
      language,
      datamatrixUrlsToken,
      options
    ) {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.prescriptionV1TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet(
          tenant,
          language,
          datamatrixUrlsToken,
          options
        );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Sends voucher email event to mail assembly service.
     * @summary Sends an email to customer for erx voucher.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {ErxVoucherEmailBodyV1} ErxVoucherEmailBodyV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV1TenantLanguageEmailVoucherPost(tenant, language, ErxVoucherEmailBodyV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionV1TenantLanguageEmailVoucherPost(
        tenant,
        language,
        ErxVoucherEmailBodyV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returnes an 5xx error - the whole request will be rejected with 5xx error as well.
     * @summary Fetch multiple prescriptions that are already claimed together with product data.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {HashedTokensPayload} HashedTokensPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV1TenantLanguageGetPrescriptionsPost(tenant, language, HashedTokensPayload, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionV1TenantLanguageGetPrescriptionsPost(
        tenant,
        language,
        HashedTokensPayload,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
     * @summary Aborts prescription, removes the dataMatrixUrl from the prescription.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV1TenantLanguageHashedTokenAbortedPost(tenant, language, hashedToken, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionV1TenantLanguageHashedTokenAbortedPost(
        tenant,
        language,
        hashedToken,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
     * @summary Closes prescription, removes the dataMatrixUrl from the prescription.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV1TenantLanguageHashedTokenClosedPost(tenant, language, hashedToken, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionV1TenantLanguageHashedTokenClosedPost(
        tenant,
        language,
        hashedToken,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
     * @summary Unclaims prescription from eRX.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV1TenantLanguageHashedTokenDelete(tenant, language, hashedToken, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionV1TenantLanguageHashedTokenDelete(
        tenant,
        language,
        hashedToken,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
     * @summary Unclaims prescription from eRX.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV1TenantLanguageHashedTokenDeletePost(tenant, language, hashedToken, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionV1TenantLanguageHashedTokenDeletePost(
        tenant,
        language,
        hashedToken,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Gets the ePrescription from the eRX service, and on successful response, it returns the same set of data as in the claim call. If the prescription is unclaimed, it will return an indicative error message.\'
     * @summary Get an already claimed ePrescription by providing hashed token.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {boolean} [useMDS] QueryParam useMDS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV1TenantLanguageHashedTokenGet(tenant, language, hashedToken, useMDS, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionV1TenantLanguageHashedTokenGet(
        tenant,
        language,
        hashedToken,
        useMDS,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
     * @summary Rejects prescription, removes the dataMatrixUrl from the prescription.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV1TenantLanguageHashedTokenRejectedPost(tenant, language, hashedToken, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionV1TenantLanguageHashedTokenRejectedPost(
        tenant,
        language,
        hashedToken,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Get the health status of eRX service
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV1TenantLanguageHealthGet(tenant, language, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionV1TenantLanguageHealthGet(
        tenant,
        language,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Receives the extracted dataMatrixURL (which contains a task id) from the client, and makes a request to the eRX service, claiming the prescription item(s). It may then make a request to the Swap service, potentially swapping the prescription item(s) received from eRX service in the previous step. It then populates the product data for all prescription item(s) and returns the fully renderable payload to the client
     * @summary Claim prescription given original, non-hashed tokens.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {DataMatrixURL} DataMatrixURL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV1TenantLanguagePost(tenant, language, DataMatrixURL, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionV1TenantLanguagePost(
        tenant,
        language,
        DataMatrixURL,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * When called the SAE eRX Service will provide a dedicated link for putting the eRX into the eRX Manager that can be later visited.
     * @summary Provisioning eRX data for given e-prescription
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} X_API_KEY
     * @param {DatamatrixUrlComponentsList} DatamatrixUrlComponentsList
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV1TenantLanguageTelemedDeliverPost(
      tenant,
      language,
      X_API_KEY,
      DatamatrixUrlComponentsList,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionV1TenantLanguageTelemedDeliverPost(
        tenant,
        language,
        X_API_KEY,
        DatamatrixUrlComponentsList,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Creates a quick checkout order.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {QuickCheckoutBodyV1} QuickCheckoutBodyV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV3TenantLanguageCheckoutPost(tenant, language, QuickCheckoutBodyV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionV3TenantLanguageCheckoutPost(
        tenant,
        language,
        QuickCheckoutBodyV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Claims prescriptions by provided datamatrixurls. Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returnes an 5xx error - the whole request will be rejected with 5xx error as well.
     * @summary Claims multiple prescriptions and returns them together with product data.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {DatamatruxurlsArray} DatamatruxurlsArray
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV3TenantLanguageClaimPrescriptionsPost(tenant, language, DatamatruxurlsArray, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionV3TenantLanguageClaimPrescriptionsPost(
        tenant,
        language,
        DatamatruxurlsArray,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Receives an array of datamatrixurl components, converts them into image buffer.
     * @summary Creates image from datamatrixurl components.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest} PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV3TenantLanguageCreateImageFromUrlPost(
      tenant,
      language,
      PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionV3TenantLanguageCreateImageFromUrlPost(
        tenant,
        language,
        PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Responds with DatamatrixUrls for given token.
     * @summary Fetches DatamatrixUrls that correspond to the token param through eRX Service
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} datamatrixUrlsToken Token used to fetch corresponding datamatrix urls
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV3TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet(
      tenant,
      language,
      datamatrixUrlsToken,
      options
    ) {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.prescriptionV3TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet(
          tenant,
          language,
          datamatrixUrlsToken,
          options
        );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Sends voucher email event to mail assembly service.
     * @summary Sends an email to customer for erx voucher.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {ErxVoucherEmailBodyV1} ErxVoucherEmailBodyV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV3TenantLanguageEmailVoucherPost(tenant, language, ErxVoucherEmailBodyV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionV3TenantLanguageEmailVoucherPost(
        tenant,
        language,
        ErxVoucherEmailBodyV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Receives an array of files in base64 format, converts them into binary and sends files to the erx service. Service responds with extracted datamatrixurls array.
     * @summary Extracts prescription data from images or pdf that contain datamatrixurl.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {PrescriptionFilesArray} PrescriptionFilesArray
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV3TenantLanguageExtractFromFilesPost(tenant, language, PrescriptionFilesArray, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionV3TenantLanguageExtractFromFilesPost(
        tenant,
        language,
        PrescriptionFilesArray,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returnes an 5xx error - the whole request will be rejected with 5xx error as well.
     * @summary Fetch multiple prescriptions that are already claimed together with product data.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {HashedTokensPayload} HashedTokensPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV3TenantLanguageGetPrescriptionsPost(tenant, language, HashedTokensPayload, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionV3TenantLanguageGetPrescriptionsPost(
        tenant,
        language,
        HashedTokensPayload,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
     * @summary Aborts prescription, removes the dataMatrixUrl from the prescription.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV3TenantLanguageHashedTokenAbortedPost(tenant, language, hashedToken, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionV3TenantLanguageHashedTokenAbortedPost(
        tenant,
        language,
        hashedToken,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
     * @summary Closes prescription, removes the dataMatrixUrl from the prescription.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV3TenantLanguageHashedTokenClosedPost(tenant, language, hashedToken, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionV3TenantLanguageHashedTokenClosedPost(
        tenant,
        language,
        hashedToken,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
     * @summary Unclaims prescription from eRX.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV3TenantLanguageHashedTokenDelete(tenant, language, hashedToken, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionV3TenantLanguageHashedTokenDelete(
        tenant,
        language,
        hashedToken,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
     * @summary Unclaims prescription from eRX.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV3TenantLanguageHashedTokenDeletePost(tenant, language, hashedToken, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionV3TenantLanguageHashedTokenDeletePost(
        tenant,
        language,
        hashedToken,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Gets the ePrescription from the eRX service, and on successful response, it returns the same set of data as in the claim call. If the prescription is unclaimed, it will return an indicative error message.\'
     * @summary Get an already claimed ePrescription by providing hashed token.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV3TenantLanguageHashedTokenGet(tenant, language, hashedToken, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionV3TenantLanguageHashedTokenGet(
        tenant,
        language,
        hashedToken,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
     * @summary Rejects prescription, removes the dataMatrixUrl from the prescription.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV3TenantLanguageHashedTokenRejectedPost(tenant, language, hashedToken, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionV3TenantLanguageHashedTokenRejectedPost(
        tenant,
        language,
        hashedToken,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Get the health status of eRX service
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV3TenantLanguageHealthGet(tenant, language, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionV3TenantLanguageHealthGet(
        tenant,
        language,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Receives the extracted dataMatrixURL (which contains a task id) from the client, and makes a request to the eRX service, claiming the prescription item(s). It may then make a request to the Swap service, potentially swapping the prescription item(s) received from eRX service in the previous step. It then populates the product data for all prescription item(s) and returns the fully renderable payload to the client
     * @summary Claim prescription given original, non-hashed tokens.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {DataMatrixURL} DataMatrixURL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV3TenantLanguagePost(tenant, language, DataMatrixURL, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionV3TenantLanguagePost(
        tenant,
        language,
        DataMatrixURL,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * When called the SAE eRX Service will provide a dedicated link for putting the eRX into the eRX Manager that can be later visited.
     * @summary Provisioning eRX data for given e-prescription
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} X_API_KEY
     * @param {DatamatrixUrlComponentsList} DatamatrixUrlComponentsList
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prescriptionV3TenantLanguageTelemedDeliverPost(
      tenant,
      language,
      X_API_KEY,
      DatamatrixUrlComponentsList,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionV3TenantLanguageTelemedDeliverPost(
        tenant,
        language,
        X_API_KEY,
        DatamatrixUrlComponentsList,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * PrescriptionControllerApi - factory interface
 * @export
 */
export const PrescriptionControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = PrescriptionControllerApiFp(configuration);
  return {
    /**
     * Creates a quick checkout order.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {QuickCheckoutBodyV1} QuickCheckoutBodyV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageCheckoutPost(tenant, language, QuickCheckoutBodyV1, options) {
      return localVarFp
        .prescriptionV1TenantLanguageCheckoutPost(tenant, language, QuickCheckoutBodyV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Claims prescriptions by provided datamatrixurls. Checks if they match with provided insurance numbers. Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returns an 5xx error - the whole request will be rejected with 5xx error as well.
     * @summary Claims multiple prescriptions, checks if they match with provided insurance numbers and returns them together with product data.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {ClaimPrescriptionsByInsuranceNumbersRequestObject} ClaimPrescriptionsByInsuranceNumbersRequestObject
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageClaimPrescriptionsByInsuranceNumbersPost(
      tenant,
      language,
      ClaimPrescriptionsByInsuranceNumbersRequestObject,
      options
    ) {
      return localVarFp
        .prescriptionV1TenantLanguageClaimPrescriptionsByInsuranceNumbersPost(
          tenant,
          language,
          ClaimPrescriptionsByInsuranceNumbersRequestObject,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Claims prescriptions by provided datamatrixurls. Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returns an 5xx error - the whole request will be rejected with 5xx error as well.
     * @summary Claims multiple prescriptions and returns them together with product data.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {DatamatruxurlsArray} DatamatruxurlsArray
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageClaimPrescriptionsPost(tenant, language, DatamatruxurlsArray, options) {
      return localVarFp
        .prescriptionV1TenantLanguageClaimPrescriptionsPost(tenant, language, DatamatruxurlsArray, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Receives an array of datamatrixurl components, converts them into image buffer.
     * @summary Creates image from datamatrixurl components.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest} PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageCreateImageFromUrlPost(
      tenant,
      language,
      PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest,
      options
    ) {
      return localVarFp
        .prescriptionV1TenantLanguageCreateImageFromUrlPost(
          tenant,
          language,
          PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Responds with DatamatrixUrls for given token.
     * @summary Fetches DatamatrixUrls that correspond to the token param through eRX Service
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} datamatrixUrlsToken Token used to fetch corresponding datamatrix urls
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet(tenant, language, datamatrixUrlsToken, options) {
      return localVarFp
        .prescriptionV1TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet(
          tenant,
          language,
          datamatrixUrlsToken,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Sends voucher email event to mail assembly service.
     * @summary Sends an email to customer for erx voucher.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {ErxVoucherEmailBodyV1} ErxVoucherEmailBodyV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageEmailVoucherPost(tenant, language, ErxVoucherEmailBodyV1, options) {
      return localVarFp
        .prescriptionV1TenantLanguageEmailVoucherPost(tenant, language, ErxVoucherEmailBodyV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returnes an 5xx error - the whole request will be rejected with 5xx error as well.
     * @summary Fetch multiple prescriptions that are already claimed together with product data.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {HashedTokensPayload} HashedTokensPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageGetPrescriptionsPost(tenant, language, HashedTokensPayload, options) {
      return localVarFp
        .prescriptionV1TenantLanguageGetPrescriptionsPost(tenant, language, HashedTokensPayload, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
     * @summary Aborts prescription, removes the dataMatrixUrl from the prescription.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageHashedTokenAbortedPost(tenant, language, hashedToken, options) {
      return localVarFp
        .prescriptionV1TenantLanguageHashedTokenAbortedPost(tenant, language, hashedToken, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
     * @summary Closes prescription, removes the dataMatrixUrl from the prescription.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageHashedTokenClosedPost(tenant, language, hashedToken, options) {
      return localVarFp
        .prescriptionV1TenantLanguageHashedTokenClosedPost(tenant, language, hashedToken, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
     * @summary Unclaims prescription from eRX.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageHashedTokenDelete(tenant, language, hashedToken, options) {
      return localVarFp
        .prescriptionV1TenantLanguageHashedTokenDelete(tenant, language, hashedToken, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
     * @summary Unclaims prescription from eRX.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageHashedTokenDeletePost(tenant, language, hashedToken, options) {
      return localVarFp
        .prescriptionV1TenantLanguageHashedTokenDeletePost(tenant, language, hashedToken, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Gets the ePrescription from the eRX service, and on successful response, it returns the same set of data as in the claim call. If the prescription is unclaimed, it will return an indicative error message.\'
     * @summary Get an already claimed ePrescription by providing hashed token.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {boolean} [useMDS] QueryParam useMDS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageHashedTokenGet(tenant, language, hashedToken, useMDS, options) {
      return localVarFp
        .prescriptionV1TenantLanguageHashedTokenGet(tenant, language, hashedToken, useMDS, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
     * @summary Rejects prescription, removes the dataMatrixUrl from the prescription.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageHashedTokenRejectedPost(tenant, language, hashedToken, options) {
      return localVarFp
        .prescriptionV1TenantLanguageHashedTokenRejectedPost(tenant, language, hashedToken, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get the health status of eRX service
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageHealthGet(tenant, language, options) {
      return localVarFp
        .prescriptionV1TenantLanguageHealthGet(tenant, language, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Receives the extracted dataMatrixURL (which contains a task id) from the client, and makes a request to the eRX service, claiming the prescription item(s). It may then make a request to the Swap service, potentially swapping the prescription item(s) received from eRX service in the previous step. It then populates the product data for all prescription item(s) and returns the fully renderable payload to the client
     * @summary Claim prescription given original, non-hashed tokens.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {DataMatrixURL} DataMatrixURL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguagePost(tenant, language, DataMatrixURL, options) {
      return localVarFp
        .prescriptionV1TenantLanguagePost(tenant, language, DataMatrixURL, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * When called the SAE eRX Service will provide a dedicated link for putting the eRX into the eRX Manager that can be later visited.
     * @summary Provisioning eRX data for given e-prescription
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} X_API_KEY
     * @param {DatamatrixUrlComponentsList} DatamatrixUrlComponentsList
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV1TenantLanguageTelemedDeliverPost(tenant, language, X_API_KEY, DatamatrixUrlComponentsList, options) {
      return localVarFp
        .prescriptionV1TenantLanguageTelemedDeliverPost(
          tenant,
          language,
          X_API_KEY,
          DatamatrixUrlComponentsList,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Creates a quick checkout order.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {QuickCheckoutBodyV1} QuickCheckoutBodyV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageCheckoutPost(tenant, language, QuickCheckoutBodyV1, options) {
      return localVarFp
        .prescriptionV3TenantLanguageCheckoutPost(tenant, language, QuickCheckoutBodyV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Claims prescriptions by provided datamatrixurls. Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returnes an 5xx error - the whole request will be rejected with 5xx error as well.
     * @summary Claims multiple prescriptions and returns them together with product data.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {DatamatruxurlsArray} DatamatruxurlsArray
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageClaimPrescriptionsPost(tenant, language, DatamatruxurlsArray, options) {
      return localVarFp
        .prescriptionV3TenantLanguageClaimPrescriptionsPost(tenant, language, DatamatruxurlsArray, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Receives an array of datamatrixurl components, converts them into image buffer.
     * @summary Creates image from datamatrixurl components.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest} PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageCreateImageFromUrlPost(
      tenant,
      language,
      PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest,
      options
    ) {
      return localVarFp
        .prescriptionV3TenantLanguageCreateImageFromUrlPost(
          tenant,
          language,
          PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Responds with DatamatrixUrls for given token.
     * @summary Fetches DatamatrixUrls that correspond to the token param through eRX Service
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} datamatrixUrlsToken Token used to fetch corresponding datamatrix urls
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet(tenant, language, datamatrixUrlsToken, options) {
      return localVarFp
        .prescriptionV3TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet(
          tenant,
          language,
          datamatrixUrlsToken,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Sends voucher email event to mail assembly service.
     * @summary Sends an email to customer for erx voucher.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {ErxVoucherEmailBodyV1} ErxVoucherEmailBodyV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageEmailVoucherPost(tenant, language, ErxVoucherEmailBodyV1, options) {
      return localVarFp
        .prescriptionV3TenantLanguageEmailVoucherPost(tenant, language, ErxVoucherEmailBodyV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Receives an array of files in base64 format, converts them into binary and sends files to the erx service. Service responds with extracted datamatrixurls array.
     * @summary Extracts prescription data from images or pdf that contain datamatrixurl.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {PrescriptionFilesArray} PrescriptionFilesArray
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageExtractFromFilesPost(tenant, language, PrescriptionFilesArray, options) {
      return localVarFp
        .prescriptionV3TenantLanguageExtractFromFilesPost(tenant, language, PrescriptionFilesArray, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returnes an 5xx error - the whole request will be rejected with 5xx error as well.
     * @summary Fetch multiple prescriptions that are already claimed together with product data.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {HashedTokensPayload} HashedTokensPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageGetPrescriptionsPost(tenant, language, HashedTokensPayload, options) {
      return localVarFp
        .prescriptionV3TenantLanguageGetPrescriptionsPost(tenant, language, HashedTokensPayload, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
     * @summary Aborts prescription, removes the dataMatrixUrl from the prescription.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageHashedTokenAbortedPost(tenant, language, hashedToken, options) {
      return localVarFp
        .prescriptionV3TenantLanguageHashedTokenAbortedPost(tenant, language, hashedToken, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
     * @summary Closes prescription, removes the dataMatrixUrl from the prescription.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageHashedTokenClosedPost(tenant, language, hashedToken, options) {
      return localVarFp
        .prescriptionV3TenantLanguageHashedTokenClosedPost(tenant, language, hashedToken, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
     * @summary Unclaims prescription from eRX.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageHashedTokenDelete(tenant, language, hashedToken, options) {
      return localVarFp
        .prescriptionV3TenantLanguageHashedTokenDelete(tenant, language, hashedToken, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
     * @summary Unclaims prescription from eRX.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageHashedTokenDeletePost(tenant, language, hashedToken, options) {
      return localVarFp
        .prescriptionV3TenantLanguageHashedTokenDeletePost(tenant, language, hashedToken, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Gets the ePrescription from the eRX service, and on successful response, it returns the same set of data as in the claim call. If the prescription is unclaimed, it will return an indicative error message.\'
     * @summary Get an already claimed ePrescription by providing hashed token.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageHashedTokenGet(tenant, language, hashedToken, options) {
      return localVarFp
        .prescriptionV3TenantLanguageHashedTokenGet(tenant, language, hashedToken, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
     * @summary Rejects prescription, removes the dataMatrixUrl from the prescription.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} hashedToken The prescription\&#39;s hashed token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageHashedTokenRejectedPost(tenant, language, hashedToken, options) {
      return localVarFp
        .prescriptionV3TenantLanguageHashedTokenRejectedPost(tenant, language, hashedToken, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get the health status of eRX service
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageHealthGet(tenant, language, options) {
      return localVarFp
        .prescriptionV3TenantLanguageHealthGet(tenant, language, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Receives the extracted dataMatrixURL (which contains a task id) from the client, and makes a request to the eRX service, claiming the prescription item(s). It may then make a request to the Swap service, potentially swapping the prescription item(s) received from eRX service in the previous step. It then populates the product data for all prescription item(s) and returns the fully renderable payload to the client
     * @summary Claim prescription given original, non-hashed tokens.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {DataMatrixURL} DataMatrixURL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguagePost(tenant, language, DataMatrixURL, options) {
      return localVarFp
        .prescriptionV3TenantLanguagePost(tenant, language, DataMatrixURL, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * When called the SAE eRX Service will provide a dedicated link for putting the eRX into the eRX Manager that can be later visited.
     * @summary Provisioning eRX data for given e-prescription
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} language
     * @param {string} X_API_KEY
     * @param {DatamatrixUrlComponentsList} DatamatrixUrlComponentsList
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prescriptionV3TenantLanguageTelemedDeliverPost(tenant, language, X_API_KEY, DatamatrixUrlComponentsList, options) {
      return localVarFp
        .prescriptionV3TenantLanguageTelemedDeliverPost(
          tenant,
          language,
          X_API_KEY,
          DatamatrixUrlComponentsList,
          options
        )
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * PrescriptionControllerApi - object-oriented interface
 * @export
 * @class PrescriptionControllerApi
 * @extends {BaseAPI}
 */
export class PrescriptionControllerApi extends BaseAPI {
  /**
   * Creates a quick checkout order.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {QuickCheckoutBodyV1} QuickCheckoutBodyV1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV1TenantLanguageCheckoutPost(tenant, language, QuickCheckoutBodyV1, options) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV1TenantLanguageCheckoutPost(tenant, language, QuickCheckoutBodyV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Claims prescriptions by provided datamatrixurls. Checks if they match with provided insurance numbers. Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returns an 5xx error - the whole request will be rejected with 5xx error as well.
   * @summary Claims multiple prescriptions, checks if they match with provided insurance numbers and returns them together with product data.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {ClaimPrescriptionsByInsuranceNumbersRequestObject} ClaimPrescriptionsByInsuranceNumbersRequestObject
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV1TenantLanguageClaimPrescriptionsByInsuranceNumbersPost(
    tenant,
    language,
    ClaimPrescriptionsByInsuranceNumbersRequestObject,
    options
  ) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV1TenantLanguageClaimPrescriptionsByInsuranceNumbersPost(
        tenant,
        language,
        ClaimPrescriptionsByInsuranceNumbersRequestObject,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Claims prescriptions by provided datamatrixurls. Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returns an 5xx error - the whole request will be rejected with 5xx error as well.
   * @summary Claims multiple prescriptions and returns them together with product data.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {DatamatruxurlsArray} DatamatruxurlsArray
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV1TenantLanguageClaimPrescriptionsPost(tenant, language, DatamatruxurlsArray, options) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV1TenantLanguageClaimPrescriptionsPost(tenant, language, DatamatruxurlsArray, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Receives an array of datamatrixurl components, converts them into image buffer.
   * @summary Creates image from datamatrixurl components.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest} PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV1TenantLanguageCreateImageFromUrlPost(
    tenant,
    language,
    PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest,
    options
  ) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV1TenantLanguageCreateImageFromUrlPost(
        tenant,
        language,
        PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Responds with DatamatrixUrls for given token.
   * @summary Fetches DatamatrixUrls that correspond to the token param through eRX Service
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {string} datamatrixUrlsToken Token used to fetch corresponding datamatrix urls
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV1TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet(tenant, language, datamatrixUrlsToken, options) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV1TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet(tenant, language, datamatrixUrlsToken, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Sends voucher email event to mail assembly service.
   * @summary Sends an email to customer for erx voucher.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {ErxVoucherEmailBodyV1} ErxVoucherEmailBodyV1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV1TenantLanguageEmailVoucherPost(tenant, language, ErxVoucherEmailBodyV1, options) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV1TenantLanguageEmailVoucherPost(tenant, language, ErxVoucherEmailBodyV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returnes an 5xx error - the whole request will be rejected with 5xx error as well.
   * @summary Fetch multiple prescriptions that are already claimed together with product data.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {HashedTokensPayload} HashedTokensPayload
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV1TenantLanguageGetPrescriptionsPost(tenant, language, HashedTokensPayload, options) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV1TenantLanguageGetPrescriptionsPost(tenant, language, HashedTokensPayload, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
   * @summary Aborts prescription, removes the dataMatrixUrl from the prescription.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {string} hashedToken The prescription\&#39;s hashed token.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV1TenantLanguageHashedTokenAbortedPost(tenant, language, hashedToken, options) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV1TenantLanguageHashedTokenAbortedPost(tenant, language, hashedToken, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
   * @summary Closes prescription, removes the dataMatrixUrl from the prescription.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {string} hashedToken The prescription\&#39;s hashed token.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV1TenantLanguageHashedTokenClosedPost(tenant, language, hashedToken, options) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV1TenantLanguageHashedTokenClosedPost(tenant, language, hashedToken, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
   * @summary Unclaims prescription from eRX.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {string} hashedToken The prescription\&#39;s hashed token.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV1TenantLanguageHashedTokenDelete(tenant, language, hashedToken, options) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV1TenantLanguageHashedTokenDelete(tenant, language, hashedToken, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
   * @summary Unclaims prescription from eRX.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {string} hashedToken The prescription\&#39;s hashed token.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV1TenantLanguageHashedTokenDeletePost(tenant, language, hashedToken, options) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV1TenantLanguageHashedTokenDeletePost(tenant, language, hashedToken, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Gets the ePrescription from the eRX service, and on successful response, it returns the same set of data as in the claim call. If the prescription is unclaimed, it will return an indicative error message.\'
   * @summary Get an already claimed ePrescription by providing hashed token.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {string} hashedToken The prescription\&#39;s hashed token.
   * @param {boolean} [useMDS] QueryParam useMDS
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV1TenantLanguageHashedTokenGet(tenant, language, hashedToken, useMDS, options) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV1TenantLanguageHashedTokenGet(tenant, language, hashedToken, useMDS, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
   * @summary Rejects prescription, removes the dataMatrixUrl from the prescription.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {string} hashedToken The prescription\&#39;s hashed token.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV1TenantLanguageHashedTokenRejectedPost(tenant, language, hashedToken, options) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV1TenantLanguageHashedTokenRejectedPost(tenant, language, hashedToken, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get the health status of eRX service
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV1TenantLanguageHealthGet(tenant, language, options) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV1TenantLanguageHealthGet(tenant, language, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Receives the extracted dataMatrixURL (which contains a task id) from the client, and makes a request to the eRX service, claiming the prescription item(s). It may then make a request to the Swap service, potentially swapping the prescription item(s) received from eRX service in the previous step. It then populates the product data for all prescription item(s) and returns the fully renderable payload to the client
   * @summary Claim prescription given original, non-hashed tokens.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {DataMatrixURL} DataMatrixURL
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV1TenantLanguagePost(tenant, language, DataMatrixURL, options) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV1TenantLanguagePost(tenant, language, DataMatrixURL, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * When called the SAE eRX Service will provide a dedicated link for putting the eRX into the eRX Manager that can be later visited.
   * @summary Provisioning eRX data for given e-prescription
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {string} X_API_KEY
   * @param {DatamatrixUrlComponentsList} DatamatrixUrlComponentsList
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV1TenantLanguageTelemedDeliverPost(tenant, language, X_API_KEY, DatamatrixUrlComponentsList, options) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV1TenantLanguageTelemedDeliverPost(tenant, language, X_API_KEY, DatamatrixUrlComponentsList, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Creates a quick checkout order.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {QuickCheckoutBodyV1} QuickCheckoutBodyV1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV3TenantLanguageCheckoutPost(tenant, language, QuickCheckoutBodyV1, options) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV3TenantLanguageCheckoutPost(tenant, language, QuickCheckoutBodyV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Claims prescriptions by provided datamatrixurls. Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returnes an 5xx error - the whole request will be rejected with 5xx error as well.
   * @summary Claims multiple prescriptions and returns them together with product data.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {DatamatruxurlsArray} DatamatruxurlsArray
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV3TenantLanguageClaimPrescriptionsPost(tenant, language, DatamatruxurlsArray, options) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV3TenantLanguageClaimPrescriptionsPost(tenant, language, DatamatruxurlsArray, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Receives an array of datamatrixurl components, converts them into image buffer.
   * @summary Creates image from datamatrixurl components.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest} PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV3TenantLanguageCreateImageFromUrlPost(
    tenant,
    language,
    PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest,
    options
  ) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV3TenantLanguageCreateImageFromUrlPost(
        tenant,
        language,
        PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Responds with DatamatrixUrls for given token.
   * @summary Fetches DatamatrixUrls that correspond to the token param through eRX Service
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {string} datamatrixUrlsToken Token used to fetch corresponding datamatrix urls
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV3TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet(tenant, language, datamatrixUrlsToken, options) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV3TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet(tenant, language, datamatrixUrlsToken, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Sends voucher email event to mail assembly service.
   * @summary Sends an email to customer for erx voucher.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {ErxVoucherEmailBodyV1} ErxVoucherEmailBodyV1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV3TenantLanguageEmailVoucherPost(tenant, language, ErxVoucherEmailBodyV1, options) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV3TenantLanguageEmailVoucherPost(tenant, language, ErxVoucherEmailBodyV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Receives an array of files in base64 format, converts them into binary and sends files to the erx service. Service responds with extracted datamatrixurls array.
   * @summary Extracts prescription data from images or pdf that contain datamatrixurl.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {PrescriptionFilesArray} PrescriptionFilesArray
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV3TenantLanguageExtractFromFilesPost(tenant, language, PrescriptionFilesArray, options) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV3TenantLanguageExtractFromFilesPost(tenant, language, PrescriptionFilesArray, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returnes an 5xx error - the whole request will be rejected with 5xx error as well.
   * @summary Fetch multiple prescriptions that are already claimed together with product data.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {HashedTokensPayload} HashedTokensPayload
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV3TenantLanguageGetPrescriptionsPost(tenant, language, HashedTokensPayload, options) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV3TenantLanguageGetPrescriptionsPost(tenant, language, HashedTokensPayload, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
   * @summary Aborts prescription, removes the dataMatrixUrl from the prescription.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {string} hashedToken The prescription\&#39;s hashed token.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV3TenantLanguageHashedTokenAbortedPost(tenant, language, hashedToken, options) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV3TenantLanguageHashedTokenAbortedPost(tenant, language, hashedToken, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
   * @summary Closes prescription, removes the dataMatrixUrl from the prescription.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {string} hashedToken The prescription\&#39;s hashed token.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV3TenantLanguageHashedTokenClosedPost(tenant, language, hashedToken, options) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV3TenantLanguageHashedTokenClosedPost(tenant, language, hashedToken, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
   * @summary Unclaims prescription from eRX.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {string} hashedToken The prescription\&#39;s hashed token.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV3TenantLanguageHashedTokenDelete(tenant, language, hashedToken, options) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV3TenantLanguageHashedTokenDelete(tenant, language, hashedToken, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
   * @summary Unclaims prescription from eRX.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {string} hashedToken The prescription\&#39;s hashed token.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV3TenantLanguageHashedTokenDeletePost(tenant, language, hashedToken, options) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV3TenantLanguageHashedTokenDeletePost(tenant, language, hashedToken, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Gets the ePrescription from the eRX service, and on successful response, it returns the same set of data as in the claim call. If the prescription is unclaimed, it will return an indicative error message.\'
   * @summary Get an already claimed ePrescription by providing hashed token.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {string} hashedToken The prescription\&#39;s hashed token.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV3TenantLanguageHashedTokenGet(tenant, language, hashedToken, options) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV3TenantLanguageHashedTokenGet(tenant, language, hashedToken, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
   * @summary Rejects prescription, removes the dataMatrixUrl from the prescription.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {string} hashedToken The prescription\&#39;s hashed token.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV3TenantLanguageHashedTokenRejectedPost(tenant, language, hashedToken, options) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV3TenantLanguageHashedTokenRejectedPost(tenant, language, hashedToken, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get the health status of eRX service
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV3TenantLanguageHealthGet(tenant, language, options) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV3TenantLanguageHealthGet(tenant, language, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Receives the extracted dataMatrixURL (which contains a task id) from the client, and makes a request to the eRX service, claiming the prescription item(s). It may then make a request to the Swap service, potentially swapping the prescription item(s) received from eRX service in the previous step. It then populates the product data for all prescription item(s) and returns the fully renderable payload to the client
   * @summary Claim prescription given original, non-hashed tokens.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {DataMatrixURL} DataMatrixURL
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV3TenantLanguagePost(tenant, language, DataMatrixURL, options) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV3TenantLanguagePost(tenant, language, DataMatrixURL, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * When called the SAE eRX Service will provide a dedicated link for putting the eRX into the eRX Manager that can be later visited.
   * @summary Provisioning eRX data for given e-prescription
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} language
   * @param {string} X_API_KEY
   * @param {DatamatrixUrlComponentsList} DatamatrixUrlComponentsList
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrescriptionControllerApi
   */
  prescriptionV3TenantLanguageTelemedDeliverPost(tenant, language, X_API_KEY, DatamatrixUrlComponentsList, options) {
    return PrescriptionControllerApiFp(this.configuration)
      .prescriptionV3TenantLanguageTelemedDeliverPost(tenant, language, X_API_KEY, DatamatrixUrlComponentsList, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * ProductControllerApi - axios parameter creator
 * @export
 */
export const ProductControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @param {string} ids PathParam ids
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {string} [page] QueryParam page
     * @param {string} [resultsPerPage] QueryParam resultsPerPage
     * @param {string} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyProductsMutilple: async (ids, tenant, language, page, resultsPerPage, fields, options = {}) => {
      // verify required parameter 'ids' is not null or undefined
      assertParamExists("bullyProductsMutilple", "ids", ids);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("bullyProductsMutilple", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("bullyProductsMutilple", "language", language);
      const localVarPath = `/{language}/products/v3/{tenant}/multiple/{ids}`
        .replace(`{${"ids"}}`, encodeURIComponent(String(ids)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }
      if (resultsPerPage !== undefined) {
        localVarQueryParameter["resultsPerPage"] = resultsPerPage;
      }
      if (fields !== undefined) {
        localVarQueryParameter["fields"] = fields;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {string} [page] QueryParam page
     * @param {string} [resultsPerPage] QueryParam resultsPerPage
     * @param {string} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageProductsV3TenantCategoryIdGet: async (id, tenant, language, page, resultsPerPage, fields, options = {}) => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("languageProductsV3TenantCategoryIdGet", "id", id);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageProductsV3TenantCategoryIdGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageProductsV3TenantCategoryIdGet", "language", language);
      const localVarPath = `/{language}/products/v3/{tenant}/category/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }
      if (resultsPerPage !== undefined) {
        localVarQueryParameter["resultsPerPage"] = resultsPerPage;
      }
      if (fields !== undefined) {
        localVarQueryParameter["fields"] = fields;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {string} [channel] QueryParam channel
     * @param {string} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageProductsV3TenantIdGet: async (id, tenant, language, channel, fields, options = {}) => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("languageProductsV3TenantIdGet", "id", id);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageProductsV3TenantIdGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageProductsV3TenantIdGet", "language", language);
      const localVarPath = `/{language}/products/v3/{tenant}/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (channel !== undefined) {
        localVarQueryParameter["channel"] = channel;
      }
      if (fields !== undefined) {
        localVarQueryParameter["fields"] = fields;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {string} [channel] QueryParam channel
     * @param {string} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageProductsV3TenantIdProductWithVariantsGet: async (id, tenant, language, channel, fields, options = {}) => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("languageProductsV3TenantIdProductWithVariantsGet", "id", id);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageProductsV3TenantIdProductWithVariantsGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageProductsV3TenantIdProductWithVariantsGet", "language", language);
      const localVarPath = `/{language}/products/v3/{tenant}/{id}/productWithVariants`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (channel !== undefined) {
        localVarQueryParameter["channel"] = channel;
      }
      if (fields !== undefined) {
        localVarQueryParameter["fields"] = fields;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {string} [channel] QueryParam channel
     * @param {string} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageProductsV3TenantIdVariantsGet: async (id, tenant, language, channel, fields, options = {}) => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("languageProductsV3TenantIdVariantsGet", "id", id);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageProductsV3TenantIdVariantsGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageProductsV3TenantIdVariantsGet", "language", language);
      const localVarPath = `/{language}/products/v3/{tenant}/{id}/variants`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (channel !== undefined) {
        localVarQueryParameter["channel"] = channel;
      }
      if (fields !== undefined) {
        localVarQueryParameter["fields"] = fields;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * ProductControllerApi - functional programming interface
 * @export
 */
export const ProductControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = ProductControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} ids PathParam ids
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {string} [page] QueryParam page
     * @param {string} [resultsPerPage] QueryParam resultsPerPage
     * @param {string} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bullyProductsMutilple(ids, tenant, language, page, resultsPerPage, fields, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bullyProductsMutilple(
        ids,
        tenant,
        language,
        page,
        resultsPerPage,
        fields,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {string} [page] QueryParam page
     * @param {string} [resultsPerPage] QueryParam resultsPerPage
     * @param {string} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageProductsV3TenantCategoryIdGet(id, tenant, language, page, resultsPerPage, fields, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageProductsV3TenantCategoryIdGet(
        id,
        tenant,
        language,
        page,
        resultsPerPage,
        fields,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {string} [channel] QueryParam channel
     * @param {string} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageProductsV3TenantIdGet(id, tenant, language, channel, fields, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageProductsV3TenantIdGet(
        id,
        tenant,
        language,
        channel,
        fields,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {string} [channel] QueryParam channel
     * @param {string} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageProductsV3TenantIdProductWithVariantsGet(id, tenant, language, channel, fields, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageProductsV3TenantIdProductWithVariantsGet(
        id,
        tenant,
        language,
        channel,
        fields,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {string} [channel] QueryParam channel
     * @param {string} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageProductsV3TenantIdVariantsGet(id, tenant, language, channel, fields, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageProductsV3TenantIdVariantsGet(
        id,
        tenant,
        language,
        channel,
        fields,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * ProductControllerApi - factory interface
 * @export
 */
export const ProductControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = ProductControllerApiFp(configuration);
  return {
    /**
     *
     * @param {string} ids PathParam ids
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {string} [page] QueryParam page
     * @param {string} [resultsPerPage] QueryParam resultsPerPage
     * @param {string} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bullyProductsMutilple(ids, tenant, language, page, resultsPerPage, fields, options) {
      return localVarFp
        .bullyProductsMutilple(ids, tenant, language, page, resultsPerPage, fields, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {string} [page] QueryParam page
     * @param {string} [resultsPerPage] QueryParam resultsPerPage
     * @param {string} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageProductsV3TenantCategoryIdGet(id, tenant, language, page, resultsPerPage, fields, options) {
      return localVarFp
        .languageProductsV3TenantCategoryIdGet(id, tenant, language, page, resultsPerPage, fields, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {string} [channel] QueryParam channel
     * @param {string} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageProductsV3TenantIdGet(id, tenant, language, channel, fields, options) {
      return localVarFp
        .languageProductsV3TenantIdGet(id, tenant, language, channel, fields, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {string} [channel] QueryParam channel
     * @param {string} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageProductsV3TenantIdProductWithVariantsGet(id, tenant, language, channel, fields, options) {
      return localVarFp
        .languageProductsV3TenantIdProductWithVariantsGet(id, tenant, language, channel, fields, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {string} [channel] QueryParam channel
     * @param {string} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageProductsV3TenantIdVariantsGet(id, tenant, language, channel, fields, options) {
      return localVarFp
        .languageProductsV3TenantIdVariantsGet(id, tenant, language, channel, fields, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * ProductControllerApi - object-oriented interface
 * @export
 * @class ProductControllerApi
 * @extends {BaseAPI}
 */
export class ProductControllerApi extends BaseAPI {
  /**
   *
   * @param {string} ids PathParam ids
   * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {string} [page] QueryParam page
   * @param {string} [resultsPerPage] QueryParam resultsPerPage
   * @param {string} [fields] QueryParam fields
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductControllerApi
   */
  bullyProductsMutilple(ids, tenant, language, page, resultsPerPage, fields, options) {
    return ProductControllerApiFp(this.configuration)
      .bullyProductsMutilple(ids, tenant, language, page, resultsPerPage, fields, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} id PathParam id
   * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {string} [page] QueryParam page
   * @param {string} [resultsPerPage] QueryParam resultsPerPage
   * @param {string} [fields] QueryParam fields
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductControllerApi
   */
  languageProductsV3TenantCategoryIdGet(id, tenant, language, page, resultsPerPage, fields, options) {
    return ProductControllerApiFp(this.configuration)
      .languageProductsV3TenantCategoryIdGet(id, tenant, language, page, resultsPerPage, fields, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} id PathParam id
   * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {string} [channel] QueryParam channel
   * @param {string} [fields] QueryParam fields
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductControllerApi
   */
  languageProductsV3TenantIdGet(id, tenant, language, channel, fields, options) {
    return ProductControllerApiFp(this.configuration)
      .languageProductsV3TenantIdGet(id, tenant, language, channel, fields, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} id PathParam id
   * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {string} [channel] QueryParam channel
   * @param {string} [fields] QueryParam fields
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductControllerApi
   */
  languageProductsV3TenantIdProductWithVariantsGet(id, tenant, language, channel, fields, options) {
    return ProductControllerApiFp(this.configuration)
      .languageProductsV3TenantIdProductWithVariantsGet(id, tenant, language, channel, fields, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} id PathParam id
   * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {string} [channel] QueryParam channel
   * @param {string} [fields] QueryParam fields
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductControllerApi
   */
  languageProductsV3TenantIdVariantsGet(id, tenant, language, channel, fields, options) {
    return ProductControllerApiFp(this.configuration)
      .languageProductsV3TenantIdVariantsGet(id, tenant, language, channel, fields, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * ProductRatingControllerApi - axios parameter creator
 * @export
 */
export const ProductRatingControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {boolean} [isWidget] isWidget rating
     * @param {'rating' | 'author' | 'date'} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageRatingsV2TenantCategoryIdGet: async (id, tenant, language, isWidget, fields, options = {}) => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("languageRatingsV2TenantCategoryIdGet", "id", id);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageRatingsV2TenantCategoryIdGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageRatingsV2TenantCategoryIdGet", "language", language);
      const localVarPath = `/{language}/ratings/v2/{tenant}/category/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (isWidget !== undefined) {
        localVarQueryParameter["isWidget"] = isWidget;
      }
      if (fields !== undefined) {
        localVarQueryParameter["fields"] = fields;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {number} [page] QueryParam page
     * @param {boolean} [isWidget] isWidget rating
     * @param {number} [perPage] QueryParam perPage
     * @param {string} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageRatingsV2TenantProductIdGet: async (
      id,
      tenant,
      language,
      page,
      isWidget,
      perPage,
      fields,
      options = {}
    ) => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("languageRatingsV2TenantProductIdGet", "id", id);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageRatingsV2TenantProductIdGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageRatingsV2TenantProductIdGet", "language", language);
      const localVarPath = `/{language}/ratings/v2/{tenant}/product/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }
      if (isWidget !== undefined) {
        localVarQueryParameter["isWidget"] = isWidget;
      }
      if (perPage !== undefined) {
        localVarQueryParameter["perPage"] = perPage;
      }
      if (fields !== undefined) {
        localVarQueryParameter["fields"] = fields;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * ProductRatingControllerApi - functional programming interface
 * @export
 */
export const ProductRatingControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = ProductRatingControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {boolean} [isWidget] isWidget rating
     * @param {'rating' | 'author' | 'date'} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageRatingsV2TenantCategoryIdGet(id, tenant, language, isWidget, fields, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageRatingsV2TenantCategoryIdGet(
        id,
        tenant,
        language,
        isWidget,
        fields,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {number} [page] QueryParam page
     * @param {boolean} [isWidget] isWidget rating
     * @param {number} [perPage] QueryParam perPage
     * @param {string} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageRatingsV2TenantProductIdGet(id, tenant, language, page, isWidget, perPage, fields, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageRatingsV2TenantProductIdGet(
        id,
        tenant,
        language,
        page,
        isWidget,
        perPage,
        fields,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * ProductRatingControllerApi - factory interface
 * @export
 */
export const ProductRatingControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = ProductRatingControllerApiFp(configuration);
  return {
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {boolean} [isWidget] isWidget rating
     * @param {'rating' | 'author' | 'date'} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageRatingsV2TenantCategoryIdGet(id, tenant, language, isWidget, fields, options) {
      return localVarFp
        .languageRatingsV2TenantCategoryIdGet(id, tenant, language, isWidget, fields, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id PathParam id
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {number} [page] QueryParam page
     * @param {boolean} [isWidget] isWidget rating
     * @param {number} [perPage] QueryParam perPage
     * @param {string} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageRatingsV2TenantProductIdGet(id, tenant, language, page, isWidget, perPage, fields, options) {
      return localVarFp
        .languageRatingsV2TenantProductIdGet(id, tenant, language, page, isWidget, perPage, fields, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * ProductRatingControllerApi - object-oriented interface
 * @export
 * @class ProductRatingControllerApi
 * @extends {BaseAPI}
 */
export class ProductRatingControllerApi extends BaseAPI {
  /**
   *
   * @param {string} id PathParam id
   * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {boolean} [isWidget] isWidget rating
   * @param {'rating' | 'author' | 'date'} [fields] QueryParam fields
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductRatingControllerApi
   */
  languageRatingsV2TenantCategoryIdGet(id, tenant, language, isWidget, fields, options) {
    return ProductRatingControllerApiFp(this.configuration)
      .languageRatingsV2TenantCategoryIdGet(id, tenant, language, isWidget, fields, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} id PathParam id
   * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {number} [page] QueryParam page
   * @param {boolean} [isWidget] isWidget rating
   * @param {number} [perPage] QueryParam perPage
   * @param {string} [fields] QueryParam fields
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductRatingControllerApi
   */
  languageRatingsV2TenantProductIdGet(id, tenant, language, page, isWidget, perPage, fields, options) {
    return ProductRatingControllerApiFp(this.configuration)
      .languageRatingsV2TenantProductIdGet(id, tenant, language, page, isWidget, perPage, fields, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * ProductReviewControllerApi - axios parameter creator
 * @export
 */
export const ProductReviewControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Get latest active reviews for a specific category (only one review per upid). Use \"all\" as a category code to get for all categories
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} categoryCode
     * @param {number} [limit] The limit specifies the maximum number of documents the endpoint will return. A limit value of 0 is equivalent to setting no limit.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet: async (
      language,
      tenant,
      categoryCode,
      limit,
      options = {}
    ) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet", "tenant", tenant);
      // verify required parameter 'categoryCode' is not null or undefined
      assertParamExists("productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet", "categoryCode", categoryCode);
      const localVarPath = `/product-review/v1/{language}/{tenant}/category/{categoryCode}/reviews`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"categoryCode"}}`, encodeURIComponent(String(categoryCode)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * check whether the customer has already rated a certain upid - returns review if positive and empty object if negative
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upid Unique product identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productReviewV1LanguageTenantProductsUpidGet: async (language, tenant, upid, options = {}) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("productReviewV1LanguageTenantProductsUpidGet", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("productReviewV1LanguageTenantProductsUpidGet", "tenant", tenant);
      // verify required parameter 'upid' is not null or undefined
      assertParamExists("productReviewV1LanguageTenantProductsUpidGet", "upid", upid);
      const localVarPath = `/product-review/v1/{language}/{tenant}/products/{upid}`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"upid"}}`, encodeURIComponent(String(upid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Post a new product review for a variant
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {ReviewRequestV1} ReviewRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productReviewV1LanguageTenantReviewsPost: async (language, tenant, ReviewRequestV1, options = {}) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("productReviewV1LanguageTenantReviewsPost", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("productReviewV1LanguageTenantReviewsPost", "tenant", tenant);
      // verify required parameter 'ReviewRequestV1' is not null or undefined
      assertParamExists("productReviewV1LanguageTenantReviewsPost", "ReviewRequestV1", ReviewRequestV1);
      const localVarPath = `/product-review/v1/{language}/{tenant}/reviews`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(ReviewRequestV1, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Get rating stats for a certain variant for all languages (only active reviews)
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} variant_code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet: async (
      language,
      tenant,
      variant_code,
      options = {}
    ) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet", "tenant", tenant);
      // verify required parameter 'variant_code' is not null or undefined
      assertParamExists("productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet", "variant_code", variant_code);
      const localVarPath = `/product-review/v1/{language}/{tenant}/variants/{variant_code}/all/summary`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"variant_code"}}`, encodeURIComponent(String(variant_code)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Get all active reviews for a certain variant
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} variant_code
     * @param {number} [page]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productReviewV1LanguageTenantVariantsVariantCodeReviewsGet: async (
      language,
      tenant,
      variant_code,
      page,
      pageSize,
      options = {}
    ) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("productReviewV1LanguageTenantVariantsVariantCodeReviewsGet", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("productReviewV1LanguageTenantVariantsVariantCodeReviewsGet", "tenant", tenant);
      // verify required parameter 'variant_code' is not null or undefined
      assertParamExists("productReviewV1LanguageTenantVariantsVariantCodeReviewsGet", "variant_code", variant_code);
      const localVarPath = `/product-review/v1/{language}/{tenant}/variants/{variant_code}/reviews`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"variant_code"}}`, encodeURIComponent(String(variant_code)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }
      if (pageSize !== undefined) {
        localVarQueryParameter["pageSize"] = pageSize;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Get rating stats for a certain variant (only active reviews)
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} variant_code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productReviewV1LanguageTenantVariantsVariantCodeSummaryGet: async (
      language,
      tenant,
      variant_code,
      options = {}
    ) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("productReviewV1LanguageTenantVariantsVariantCodeSummaryGet", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("productReviewV1LanguageTenantVariantsVariantCodeSummaryGet", "tenant", tenant);
      // verify required parameter 'variant_code' is not null or undefined
      assertParamExists("productReviewV1LanguageTenantVariantsVariantCodeSummaryGet", "variant_code", variant_code);
      const localVarPath = `/product-review/v1/{language}/{tenant}/variants/{variant_code}/summary`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"variant_code"}}`, encodeURIComponent(String(variant_code)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * ProductReviewControllerApi - functional programming interface
 * @export
 */
export const ProductReviewControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = ProductReviewControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * Get latest active reviews for a specific category (only one review per upid). Use \"all\" as a category code to get for all categories
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} categoryCode
     * @param {number} [limit] The limit specifies the maximum number of documents the endpoint will return. A limit value of 0 is equivalent to setting no limit.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet(language, tenant, categoryCode, limit, options) {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet(
          language,
          tenant,
          categoryCode,
          limit,
          options
        );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * check whether the customer has already rated a certain upid - returns review if positive and empty object if negative
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upid Unique product identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async productReviewV1LanguageTenantProductsUpidGet(language, tenant, upid, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.productReviewV1LanguageTenantProductsUpidGet(
        language,
        tenant,
        upid,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Post a new product review for a variant
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {ReviewRequestV1} ReviewRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async productReviewV1LanguageTenantReviewsPost(language, tenant, ReviewRequestV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.productReviewV1LanguageTenantReviewsPost(
        language,
        tenant,
        ReviewRequestV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Get rating stats for a certain variant for all languages (only active reviews)
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} variant_code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet(language, tenant, variant_code, options) {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet(
          language,
          tenant,
          variant_code,
          options
        );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Get all active reviews for a certain variant
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} variant_code
     * @param {number} [page]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async productReviewV1LanguageTenantVariantsVariantCodeReviewsGet(
      language,
      tenant,
      variant_code,
      page,
      pageSize,
      options
    ) {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.productReviewV1LanguageTenantVariantsVariantCodeReviewsGet(
          language,
          tenant,
          variant_code,
          page,
          pageSize,
          options
        );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Get rating stats for a certain variant (only active reviews)
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} variant_code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async productReviewV1LanguageTenantVariantsVariantCodeSummaryGet(language, tenant, variant_code, options) {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.productReviewV1LanguageTenantVariantsVariantCodeSummaryGet(
          language,
          tenant,
          variant_code,
          options
        );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * ProductReviewControllerApi - factory interface
 * @export
 */
export const ProductReviewControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = ProductReviewControllerApiFp(configuration);
  return {
    /**
     * Get latest active reviews for a specific category (only one review per upid). Use \"all\" as a category code to get for all categories
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} categoryCode
     * @param {number} [limit] The limit specifies the maximum number of documents the endpoint will return. A limit value of 0 is equivalent to setting no limit.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet(language, tenant, categoryCode, limit, options) {
      return localVarFp
        .productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet(language, tenant, categoryCode, limit, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * check whether the customer has already rated a certain upid - returns review if positive and empty object if negative
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upid Unique product identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productReviewV1LanguageTenantProductsUpidGet(language, tenant, upid, options) {
      return localVarFp
        .productReviewV1LanguageTenantProductsUpidGet(language, tenant, upid, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Post a new product review for a variant
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {ReviewRequestV1} ReviewRequestV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productReviewV1LanguageTenantReviewsPost(language, tenant, ReviewRequestV1, options) {
      return localVarFp
        .productReviewV1LanguageTenantReviewsPost(language, tenant, ReviewRequestV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get rating stats for a certain variant for all languages (only active reviews)
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} variant_code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet(language, tenant, variant_code, options) {
      return localVarFp
        .productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet(language, tenant, variant_code, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get all active reviews for a certain variant
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} variant_code
     * @param {number} [page]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productReviewV1LanguageTenantVariantsVariantCodeReviewsGet(
      language,
      tenant,
      variant_code,
      page,
      pageSize,
      options
    ) {
      return localVarFp
        .productReviewV1LanguageTenantVariantsVariantCodeReviewsGet(
          language,
          tenant,
          variant_code,
          page,
          pageSize,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Get rating stats for a certain variant (only active reviews)
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} variant_code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productReviewV1LanguageTenantVariantsVariantCodeSummaryGet(language, tenant, variant_code, options) {
      return localVarFp
        .productReviewV1LanguageTenantVariantsVariantCodeSummaryGet(language, tenant, variant_code, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * ProductReviewControllerApi - object-oriented interface
 * @export
 * @class ProductReviewControllerApi
 * @extends {BaseAPI}
 */
export class ProductReviewControllerApi extends BaseAPI {
  /**
   * Get latest active reviews for a specific category (only one review per upid). Use \"all\" as a category code to get for all categories
   * @param {string} language
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} categoryCode
   * @param {number} [limit] The limit specifies the maximum number of documents the endpoint will return. A limit value of 0 is equivalent to setting no limit.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductReviewControllerApi
   */
  productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet(language, tenant, categoryCode, limit, options) {
    return ProductReviewControllerApiFp(this.configuration)
      .productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet(language, tenant, categoryCode, limit, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * check whether the customer has already rated a certain upid - returns review if positive and empty object if negative
   * @param {string} language
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} upid Unique product identifier
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductReviewControllerApi
   */
  productReviewV1LanguageTenantProductsUpidGet(language, tenant, upid, options) {
    return ProductReviewControllerApiFp(this.configuration)
      .productReviewV1LanguageTenantProductsUpidGet(language, tenant, upid, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Post a new product review for a variant
   * @param {string} language
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {ReviewRequestV1} ReviewRequestV1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductReviewControllerApi
   */
  productReviewV1LanguageTenantReviewsPost(language, tenant, ReviewRequestV1, options) {
    return ProductReviewControllerApiFp(this.configuration)
      .productReviewV1LanguageTenantReviewsPost(language, tenant, ReviewRequestV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get rating stats for a certain variant for all languages (only active reviews)
   * @param {string} language
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} variant_code
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductReviewControllerApi
   */
  productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet(language, tenant, variant_code, options) {
    return ProductReviewControllerApiFp(this.configuration)
      .productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet(language, tenant, variant_code, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get all active reviews for a certain variant
   * @param {string} language
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} variant_code
   * @param {number} [page]
   * @param {number} [pageSize]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductReviewControllerApi
   */
  productReviewV1LanguageTenantVariantsVariantCodeReviewsGet(language, tenant, variant_code, page, pageSize, options) {
    return ProductReviewControllerApiFp(this.configuration)
      .productReviewV1LanguageTenantVariantsVariantCodeReviewsGet(
        language,
        tenant,
        variant_code,
        page,
        pageSize,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get rating stats for a certain variant (only active reviews)
   * @param {string} language
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} variant_code
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductReviewControllerApi
   */
  productReviewV1LanguageTenantVariantsVariantCodeSummaryGet(language, tenant, variant_code, options) {
    return ProductReviewControllerApiFp(this.configuration)
      .productReviewV1LanguageTenantVariantsVariantCodeSummaryGet(language, tenant, variant_code, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * RecentOrdersControllerV1Api - axios parameter creator
 * @export
 */
export const RecentOrdersControllerV1ApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Gets last orders enriched with products for rebuy.
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {number} [itemsPerPage]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageRecentOrdersV1TenantGet: async (language, tenant, itemsPerPage, page, options = {}) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageRecentOrdersV1TenantGet", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageRecentOrdersV1TenantGet", "tenant", tenant);
      const localVarPath = `/{language}/recent-orders/v1/{tenant}`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (itemsPerPage !== undefined) {
        localVarQueryParameter["itemsPerPage"] = itemsPerPage;
      }
      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Gets last orders enriched with products for rebuy.
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {number} [itemsPerPage]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageRecentOrdersV2TenantGet: async (language, tenant, itemsPerPage, page, options = {}) => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageRecentOrdersV2TenantGet", "language", language);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageRecentOrdersV2TenantGet", "tenant", tenant);
      const localVarPath = `/{language}/recent-orders/v2/{tenant}`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (itemsPerPage !== undefined) {
        localVarQueryParameter["itemsPerPage"] = itemsPerPage;
      }
      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * RecentOrdersControllerV1Api - functional programming interface
 * @export
 */
export const RecentOrdersControllerV1ApiFp = function (configuration) {
  const localVarAxiosParamCreator = RecentOrdersControllerV1ApiAxiosParamCreator(configuration);
  return {
    /**
     * Gets last orders enriched with products for rebuy.
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {number} [itemsPerPage]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageRecentOrdersV1TenantGet(language, tenant, itemsPerPage, page, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageRecentOrdersV1TenantGet(
        language,
        tenant,
        itemsPerPage,
        page,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Gets last orders enriched with products for rebuy.
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {number} [itemsPerPage]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageRecentOrdersV2TenantGet(language, tenant, itemsPerPage, page, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageRecentOrdersV2TenantGet(
        language,
        tenant,
        itemsPerPage,
        page,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * RecentOrdersControllerV1Api - factory interface
 * @export
 */
export const RecentOrdersControllerV1ApiFactory = function (configuration, basePath, axios) {
  const localVarFp = RecentOrdersControllerV1ApiFp(configuration);
  return {
    /**
     * Gets last orders enriched with products for rebuy.
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {number} [itemsPerPage]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageRecentOrdersV1TenantGet(language, tenant, itemsPerPage, page, options) {
      return localVarFp
        .languageRecentOrdersV1TenantGet(language, tenant, itemsPerPage, page, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Gets last orders enriched with products for rebuy.
     * @param {string} language
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {number} [itemsPerPage]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageRecentOrdersV2TenantGet(language, tenant, itemsPerPage, page, options) {
      return localVarFp
        .languageRecentOrdersV2TenantGet(language, tenant, itemsPerPage, page, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * RecentOrdersControllerV1Api - object-oriented interface
 * @export
 * @class RecentOrdersControllerV1Api
 * @extends {BaseAPI}
 */
export class RecentOrdersControllerV1Api extends BaseAPI {
  /**
   * Gets last orders enriched with products for rebuy.
   * @param {string} language
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {number} [itemsPerPage]
   * @param {number} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RecentOrdersControllerV1Api
   */
  languageRecentOrdersV1TenantGet(language, tenant, itemsPerPage, page, options) {
    return RecentOrdersControllerV1ApiFp(this.configuration)
      .languageRecentOrdersV1TenantGet(language, tenant, itemsPerPage, page, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Gets last orders enriched with products for rebuy.
   * @param {string} language
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {number} [itemsPerPage]
   * @param {number} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RecentOrdersControllerV1Api
   */
  languageRecentOrdersV2TenantGet(language, tenant, itemsPerPage, page, options) {
    return RecentOrdersControllerV1ApiFp(this.configuration)
      .languageRecentOrdersV2TenantGet(language, tenant, itemsPerPage, page, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * RedPointsMultiplierControllerApi - axios parameter creator
 * @export
 */
export const RedPointsMultiplierControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * This endpoint allows the offer-service to get redpoints multiplier
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redPointsMultiplierServiceAppGetMultiplier: async (tenant, upid, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("redPointsMultiplierServiceAppGetMultiplier", "tenant", tenant);
      // verify required parameter 'upid' is not null or undefined
      assertParamExists("redPointsMultiplierServiceAppGetMultiplier", "upid", upid);
      const localVarPath = `/redpointsmultiplier/v1/{tenant}/multiplier`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication basicAuth required
      // http basic authentication required
      setBasicAuthToObject(localVarRequestOptions, configuration);
      if (upid !== undefined) {
        localVarQueryParameter["upid"] = upid;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * RedPointsMultiplierControllerApi - functional programming interface
 * @export
 */
export const RedPointsMultiplierControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = RedPointsMultiplierControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * This endpoint allows the offer-service to get redpoints multiplier
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async redPointsMultiplierServiceAppGetMultiplier(tenant, upid, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.redPointsMultiplierServiceAppGetMultiplier(
        tenant,
        upid,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * RedPointsMultiplierControllerApi - factory interface
 * @export
 */
export const RedPointsMultiplierControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = RedPointsMultiplierControllerApiFp(configuration);
  return {
    /**
     * This endpoint allows the offer-service to get redpoints multiplier
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} upid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redPointsMultiplierServiceAppGetMultiplier(tenant, upid, options) {
      return localVarFp
        .redPointsMultiplierServiceAppGetMultiplier(tenant, upid, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * RedPointsMultiplierControllerApi - object-oriented interface
 * @export
 * @class RedPointsMultiplierControllerApi
 * @extends {BaseAPI}
 */
export class RedPointsMultiplierControllerApi extends BaseAPI {
  /**
   * This endpoint allows the offer-service to get redpoints multiplier
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} upid
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RedPointsMultiplierControllerApi
   */
  redPointsMultiplierServiceAppGetMultiplier(tenant, upid, options) {
    return RedPointsMultiplierControllerApiFp(this.configuration)
      .redPointsMultiplierServiceAppGetMultiplier(tenant, upid, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * RedpointsControllerApi - axios parameter creator
 * @export
 */
export const RedpointsControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @summary Return information about the given customer
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} id
     * @param {string} [optInCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV1TenantCustomersIdGet: async (tenant, id, optInCode, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("redpointsV1TenantCustomersIdGet", "tenant", tenant);
      // verify required parameter 'id' is not null or undefined
      assertParamExists("redpointsV1TenantCustomersIdGet", "id", id);
      const localVarPath = `/redpoints/v1/{tenant}/customers/{id}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (optInCode !== undefined) {
        localVarQueryParameter["optInCode"] = optInCode;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Creates an optIn code
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} id
     * @param {string} [email]
     * @param {string} [optInType]
     * @param {RedpointsPostOptInRequestV1} [RedpointsPostOptInRequestV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV1TenantCustomersIdInterestedPost: async (
      tenant,
      id,
      email,
      optInType,
      RedpointsPostOptInRequestV1,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("redpointsV1TenantCustomersIdInterestedPost", "tenant", tenant);
      // verify required parameter 'id' is not null or undefined
      assertParamExists("redpointsV1TenantCustomersIdInterestedPost", "id", id);
      const localVarPath = `/redpoints/v1/{tenant}/customers/{id}/interested`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (email !== undefined) {
        localVarQueryParameter["email"] = email;
      }
      if (optInType !== undefined) {
        localVarQueryParameter["optInType"] = optInType;
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        RedpointsPostOptInRequestV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Returns the redpoints registration status for given customer
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV1TenantCustomersIdRegistrationstatusGet: async (tenant, id, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("redpointsV1TenantCustomersIdRegistrationstatusGet", "tenant", tenant);
      // verify required parameter 'id' is not null or undefined
      assertParamExists("redpointsV1TenantCustomersIdRegistrationstatusGet", "id", id);
      const localVarPath = `/redpoints/v1/{tenant}/customers/{id}/registrationstatus`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Get event by customerId and eventId
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} shopCustomerId
     * @param {string} eventId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV1TenantCustomersShopCustomerIdEventsEventIdGet: async (tenant, shopCustomerId, eventId, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("redpointsV1TenantCustomersShopCustomerIdEventsEventIdGet", "tenant", tenant);
      // verify required parameter 'shopCustomerId' is not null or undefined
      assertParamExists("redpointsV1TenantCustomersShopCustomerIdEventsEventIdGet", "shopCustomerId", shopCustomerId);
      // verify required parameter 'eventId' is not null or undefined
      assertParamExists("redpointsV1TenantCustomersShopCustomerIdEventsEventIdGet", "eventId", eventId);
      const localVarPath = `/redpoints/v1/{tenant}/customers/{shopCustomerId}/events/{eventId}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"shopCustomerId"}}`, encodeURIComponent(String(shopCustomerId)))
        .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Get all events by customerId (e.g. EA123456)
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} shopCustomerId
     * @param {number} [page]
     * @param {number} [itemsPerPage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV1TenantCustomersShopCustomerIdEventsGet: async (
      tenant,
      shopCustomerId,
      page,
      itemsPerPage,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("redpointsV1TenantCustomersShopCustomerIdEventsGet", "tenant", tenant);
      // verify required parameter 'shopCustomerId' is not null or undefined
      assertParamExists("redpointsV1TenantCustomersShopCustomerIdEventsGet", "shopCustomerId", shopCustomerId);
      const localVarPath = `/redpoints/v1/{tenant}/customers/{shopCustomerId}/events`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"shopCustomerId"}}`, encodeURIComponent(String(shopCustomerId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }
      if (itemsPerPage !== undefined) {
        localVarQueryParameter["itemsPerPage"] = itemsPerPage;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Receive a list of points collected and points redeemed per order for the order IDs provided.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} shopCustomerId
     * @param {RedpointsPostOrdersRequestV1} [RedpointsPostOrdersRequestV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV1TenantCustomersShopCustomerIdOrdersPost: async (
      tenant,
      shopCustomerId,
      RedpointsPostOrdersRequestV1,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("redpointsV1TenantCustomersShopCustomerIdOrdersPost", "tenant", tenant);
      // verify required parameter 'shopCustomerId' is not null or undefined
      assertParamExists("redpointsV1TenantCustomersShopCustomerIdOrdersPost", "shopCustomerId", shopCustomerId);
      const localVarPath = `/redpoints/v1/{tenant}/customers/{shopCustomerId}/orders`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"shopCustomerId"}}`, encodeURIComponent(String(shopCustomerId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        RedpointsPostOrdersRequestV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Receive information about an order in the past
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} shopCustomerId
     * @param {string} shopOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV1TenantCustomersShopCustomerIdOrdersShopOrderIdGet: async (
      tenant,
      shopCustomerId,
      shopOrderId,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("redpointsV1TenantCustomersShopCustomerIdOrdersShopOrderIdGet", "tenant", tenant);
      // verify required parameter 'shopCustomerId' is not null or undefined
      assertParamExists(
        "redpointsV1TenantCustomersShopCustomerIdOrdersShopOrderIdGet",
        "shopCustomerId",
        shopCustomerId
      );
      // verify required parameter 'shopOrderId' is not null or undefined
      assertParamExists("redpointsV1TenantCustomersShopCustomerIdOrdersShopOrderIdGet", "shopOrderId", shopOrderId);
      const localVarPath = `/redpoints/v1/{tenant}/customers/{shopCustomerId}/orders/{shopOrderId}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"shopCustomerId"}}`, encodeURIComponent(String(shopCustomerId)))
        .replace(`{${"shopOrderId"}}`, encodeURIComponent(String(shopOrderId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Checks the optIn code
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} optInCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV1TenantOptinOptInCodeGet: async (tenant, optInCode, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("redpointsV1TenantOptinOptInCodeGet", "tenant", tenant);
      // verify required parameter 'optInCode' is not null or undefined
      assertParamExists("redpointsV1TenantOptinOptInCodeGet", "optInCode", optInCode);
      const localVarPath = `/redpoints/v1/{tenant}/optin/{optInCode}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"optInCode"}}`, encodeURIComponent(String(optInCode)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Confirm an opt in and register the customer in RedPoints if not already registered
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} optInCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV1TenantOptinOptInCodePost: async (tenant, optInCode, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("redpointsV1TenantOptinOptInCodePost", "tenant", tenant);
      // verify required parameter 'optInCode' is not null or undefined
      assertParamExists("redpointsV1TenantOptinOptInCodePost", "optInCode", optInCode);
      const localVarPath = `/redpoints/v1/{tenant}/optin/{optInCode}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"optInCode"}}`, encodeURIComponent(String(optInCode)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Get redpoints and RX calculations
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {number} totalVoucherDiscountCents
     * @param {RedpointsOrderPointsRequestV1} RedpointsOrderPointsRequestV1
     * @param {string} [shopCartId]
     * @param {number} [totalRedeemedRedpointsDiscountCents]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV1TenantOrderpointsPost: async (
      tenant,
      totalVoucherDiscountCents,
      RedpointsOrderPointsRequestV1,
      shopCartId,
      totalRedeemedRedpointsDiscountCents,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("redpointsV1TenantOrderpointsPost", "tenant", tenant);
      // verify required parameter 'totalVoucherDiscountCents' is not null or undefined
      assertParamExists("redpointsV1TenantOrderpointsPost", "totalVoucherDiscountCents", totalVoucherDiscountCents);
      // verify required parameter 'RedpointsOrderPointsRequestV1' is not null or undefined
      assertParamExists(
        "redpointsV1TenantOrderpointsPost",
        "RedpointsOrderPointsRequestV1",
        RedpointsOrderPointsRequestV1
      );
      const localVarPath = `/redpoints/v1/{tenant}/orderpoints`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (shopCartId !== undefined) {
        localVarQueryParameter["shopCartId"] = shopCartId;
      }
      if (totalVoucherDiscountCents !== undefined) {
        localVarQueryParameter["totalVoucherDiscountCents"] = totalVoucherDiscountCents;
      }
      if (totalRedeemedRedpointsDiscountCents !== undefined) {
        localVarQueryParameter["totalRedeemedRedpointsDiscountCents"] = totalRedeemedRedpointsDiscountCents;
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        RedpointsOrderPointsRequestV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * RedpointsControllerApi - functional programming interface
 * @export
 */
export const RedpointsControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = RedpointsControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Return information about the given customer
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} id
     * @param {string} [optInCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async redpointsV1TenantCustomersIdGet(tenant, id, optInCode, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.redpointsV1TenantCustomersIdGet(
        tenant,
        id,
        optInCode,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Creates an optIn code
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} id
     * @param {string} [email]
     * @param {string} [optInType]
     * @param {RedpointsPostOptInRequestV1} [RedpointsPostOptInRequestV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async redpointsV1TenantCustomersIdInterestedPost(
      tenant,
      id,
      email,
      optInType,
      RedpointsPostOptInRequestV1,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.redpointsV1TenantCustomersIdInterestedPost(
        tenant,
        id,
        email,
        optInType,
        RedpointsPostOptInRequestV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Returns the redpoints registration status for given customer
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async redpointsV1TenantCustomersIdRegistrationstatusGet(tenant, id, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.redpointsV1TenantCustomersIdRegistrationstatusGet(
        tenant,
        id,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Get event by customerId and eventId
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} shopCustomerId
     * @param {string} eventId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async redpointsV1TenantCustomersShopCustomerIdEventsEventIdGet(tenant, shopCustomerId, eventId, options) {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.redpointsV1TenantCustomersShopCustomerIdEventsEventIdGet(
          tenant,
          shopCustomerId,
          eventId,
          options
        );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Get all events by customerId (e.g. EA123456)
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} shopCustomerId
     * @param {number} [page]
     * @param {number} [itemsPerPage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async redpointsV1TenantCustomersShopCustomerIdEventsGet(tenant, shopCustomerId, page, itemsPerPage, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.redpointsV1TenantCustomersShopCustomerIdEventsGet(
        tenant,
        shopCustomerId,
        page,
        itemsPerPage,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Receive a list of points collected and points redeemed per order for the order IDs provided.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} shopCustomerId
     * @param {RedpointsPostOrdersRequestV1} [RedpointsPostOrdersRequestV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async redpointsV1TenantCustomersShopCustomerIdOrdersPost(
      tenant,
      shopCustomerId,
      RedpointsPostOrdersRequestV1,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.redpointsV1TenantCustomersShopCustomerIdOrdersPost(
        tenant,
        shopCustomerId,
        RedpointsPostOrdersRequestV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Receive information about an order in the past
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} shopCustomerId
     * @param {string} shopOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async redpointsV1TenantCustomersShopCustomerIdOrdersShopOrderIdGet(tenant, shopCustomerId, shopOrderId, options) {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.redpointsV1TenantCustomersShopCustomerIdOrdersShopOrderIdGet(
          tenant,
          shopCustomerId,
          shopOrderId,
          options
        );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Checks the optIn code
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} optInCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async redpointsV1TenantOptinOptInCodeGet(tenant, optInCode, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.redpointsV1TenantOptinOptInCodeGet(
        tenant,
        optInCode,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Confirm an opt in and register the customer in RedPoints if not already registered
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} optInCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async redpointsV1TenantOptinOptInCodePost(tenant, optInCode, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.redpointsV1TenantOptinOptInCodePost(
        tenant,
        optInCode,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Get redpoints and RX calculations
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {number} totalVoucherDiscountCents
     * @param {RedpointsOrderPointsRequestV1} RedpointsOrderPointsRequestV1
     * @param {string} [shopCartId]
     * @param {number} [totalRedeemedRedpointsDiscountCents]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async redpointsV1TenantOrderpointsPost(
      tenant,
      totalVoucherDiscountCents,
      RedpointsOrderPointsRequestV1,
      shopCartId,
      totalRedeemedRedpointsDiscountCents,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.redpointsV1TenantOrderpointsPost(
        tenant,
        totalVoucherDiscountCents,
        RedpointsOrderPointsRequestV1,
        shopCartId,
        totalRedeemedRedpointsDiscountCents,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * RedpointsControllerApi - factory interface
 * @export
 */
export const RedpointsControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = RedpointsControllerApiFp(configuration);
  return {
    /**
     *
     * @summary Return information about the given customer
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} id
     * @param {string} [optInCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV1TenantCustomersIdGet(tenant, id, optInCode, options) {
      return localVarFp
        .redpointsV1TenantCustomersIdGet(tenant, id, optInCode, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Creates an optIn code
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} id
     * @param {string} [email]
     * @param {string} [optInType]
     * @param {RedpointsPostOptInRequestV1} [RedpointsPostOptInRequestV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV1TenantCustomersIdInterestedPost(tenant, id, email, optInType, RedpointsPostOptInRequestV1, options) {
      return localVarFp
        .redpointsV1TenantCustomersIdInterestedPost(tenant, id, email, optInType, RedpointsPostOptInRequestV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Returns the redpoints registration status for given customer
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV1TenantCustomersIdRegistrationstatusGet(tenant, id, options) {
      return localVarFp
        .redpointsV1TenantCustomersIdRegistrationstatusGet(tenant, id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get event by customerId and eventId
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} shopCustomerId
     * @param {string} eventId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV1TenantCustomersShopCustomerIdEventsEventIdGet(tenant, shopCustomerId, eventId, options) {
      return localVarFp
        .redpointsV1TenantCustomersShopCustomerIdEventsEventIdGet(tenant, shopCustomerId, eventId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all events by customerId (e.g. EA123456)
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} shopCustomerId
     * @param {number} [page]
     * @param {number} [itemsPerPage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV1TenantCustomersShopCustomerIdEventsGet(tenant, shopCustomerId, page, itemsPerPage, options) {
      return localVarFp
        .redpointsV1TenantCustomersShopCustomerIdEventsGet(tenant, shopCustomerId, page, itemsPerPage, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Receive a list of points collected and points redeemed per order for the order IDs provided.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} shopCustomerId
     * @param {RedpointsPostOrdersRequestV1} [RedpointsPostOrdersRequestV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV1TenantCustomersShopCustomerIdOrdersPost(tenant, shopCustomerId, RedpointsPostOrdersRequestV1, options) {
      return localVarFp
        .redpointsV1TenantCustomersShopCustomerIdOrdersPost(
          tenant,
          shopCustomerId,
          RedpointsPostOrdersRequestV1,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Receive information about an order in the past
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} shopCustomerId
     * @param {string} shopOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV1TenantCustomersShopCustomerIdOrdersShopOrderIdGet(tenant, shopCustomerId, shopOrderId, options) {
      return localVarFp
        .redpointsV1TenantCustomersShopCustomerIdOrdersShopOrderIdGet(tenant, shopCustomerId, shopOrderId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Checks the optIn code
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} optInCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV1TenantOptinOptInCodeGet(tenant, optInCode, options) {
      return localVarFp
        .redpointsV1TenantOptinOptInCodeGet(tenant, optInCode, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Confirm an opt in and register the customer in RedPoints if not already registered
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} optInCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV1TenantOptinOptInCodePost(tenant, optInCode, options) {
      return localVarFp
        .redpointsV1TenantOptinOptInCodePost(tenant, optInCode, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get redpoints and RX calculations
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {number} totalVoucherDiscountCents
     * @param {RedpointsOrderPointsRequestV1} RedpointsOrderPointsRequestV1
     * @param {string} [shopCartId]
     * @param {number} [totalRedeemedRedpointsDiscountCents]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV1TenantOrderpointsPost(
      tenant,
      totalVoucherDiscountCents,
      RedpointsOrderPointsRequestV1,
      shopCartId,
      totalRedeemedRedpointsDiscountCents,
      options
    ) {
      return localVarFp
        .redpointsV1TenantOrderpointsPost(
          tenant,
          totalVoucherDiscountCents,
          RedpointsOrderPointsRequestV1,
          shopCartId,
          totalRedeemedRedpointsDiscountCents,
          options
        )
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * RedpointsControllerApi - object-oriented interface
 * @export
 * @class RedpointsControllerApi
 * @extends {BaseAPI}
 */
export class RedpointsControllerApi extends BaseAPI {
  /**
   *
   * @summary Return information about the given customer
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} id
   * @param {string} [optInCode]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RedpointsControllerApi
   */
  redpointsV1TenantCustomersIdGet(tenant, id, optInCode, options) {
    return RedpointsControllerApiFp(this.configuration)
      .redpointsV1TenantCustomersIdGet(tenant, id, optInCode, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Creates an optIn code
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} id
   * @param {string} [email]
   * @param {string} [optInType]
   * @param {RedpointsPostOptInRequestV1} [RedpointsPostOptInRequestV1]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RedpointsControllerApi
   */
  redpointsV1TenantCustomersIdInterestedPost(tenant, id, email, optInType, RedpointsPostOptInRequestV1, options) {
    return RedpointsControllerApiFp(this.configuration)
      .redpointsV1TenantCustomersIdInterestedPost(tenant, id, email, optInType, RedpointsPostOptInRequestV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Returns the redpoints registration status for given customer
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RedpointsControllerApi
   */
  redpointsV1TenantCustomersIdRegistrationstatusGet(tenant, id, options) {
    return RedpointsControllerApiFp(this.configuration)
      .redpointsV1TenantCustomersIdRegistrationstatusGet(tenant, id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get event by customerId and eventId
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} shopCustomerId
   * @param {string} eventId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RedpointsControllerApi
   */
  redpointsV1TenantCustomersShopCustomerIdEventsEventIdGet(tenant, shopCustomerId, eventId, options) {
    return RedpointsControllerApiFp(this.configuration)
      .redpointsV1TenantCustomersShopCustomerIdEventsEventIdGet(tenant, shopCustomerId, eventId, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get all events by customerId (e.g. EA123456)
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} shopCustomerId
   * @param {number} [page]
   * @param {number} [itemsPerPage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RedpointsControllerApi
   */
  redpointsV1TenantCustomersShopCustomerIdEventsGet(tenant, shopCustomerId, page, itemsPerPage, options) {
    return RedpointsControllerApiFp(this.configuration)
      .redpointsV1TenantCustomersShopCustomerIdEventsGet(tenant, shopCustomerId, page, itemsPerPage, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Receive a list of points collected and points redeemed per order for the order IDs provided.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} shopCustomerId
   * @param {RedpointsPostOrdersRequestV1} [RedpointsPostOrdersRequestV1]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RedpointsControllerApi
   */
  redpointsV1TenantCustomersShopCustomerIdOrdersPost(tenant, shopCustomerId, RedpointsPostOrdersRequestV1, options) {
    return RedpointsControllerApiFp(this.configuration)
      .redpointsV1TenantCustomersShopCustomerIdOrdersPost(tenant, shopCustomerId, RedpointsPostOrdersRequestV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Receive information about an order in the past
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} shopCustomerId
   * @param {string} shopOrderId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RedpointsControllerApi
   */
  redpointsV1TenantCustomersShopCustomerIdOrdersShopOrderIdGet(tenant, shopCustomerId, shopOrderId, options) {
    return RedpointsControllerApiFp(this.configuration)
      .redpointsV1TenantCustomersShopCustomerIdOrdersShopOrderIdGet(tenant, shopCustomerId, shopOrderId, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Checks the optIn code
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} optInCode
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RedpointsControllerApi
   */
  redpointsV1TenantOptinOptInCodeGet(tenant, optInCode, options) {
    return RedpointsControllerApiFp(this.configuration)
      .redpointsV1TenantOptinOptInCodeGet(tenant, optInCode, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Confirm an opt in and register the customer in RedPoints if not already registered
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} optInCode
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RedpointsControllerApi
   */
  redpointsV1TenantOptinOptInCodePost(tenant, optInCode, options) {
    return RedpointsControllerApiFp(this.configuration)
      .redpointsV1TenantOptinOptInCodePost(tenant, optInCode, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get redpoints and RX calculations
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {number} totalVoucherDiscountCents
   * @param {RedpointsOrderPointsRequestV1} RedpointsOrderPointsRequestV1
   * @param {string} [shopCartId]
   * @param {number} [totalRedeemedRedpointsDiscountCents]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RedpointsControllerApi
   */
  redpointsV1TenantOrderpointsPost(
    tenant,
    totalVoucherDiscountCents,
    RedpointsOrderPointsRequestV1,
    shopCartId,
    totalRedeemedRedpointsDiscountCents,
    options
  ) {
    return RedpointsControllerApiFp(this.configuration)
      .redpointsV1TenantOrderpointsPost(
        tenant,
        totalVoucherDiscountCents,
        RedpointsOrderPointsRequestV1,
        shopCartId,
        totalRedeemedRedpointsDiscountCents,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * RedpointsControllerV2Api - axios parameter creator
 * @export
 */
export const RedpointsControllerV2ApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @summary Return information about the the customer. Extracts customer\'s id from jwt token.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV2TenantCustomerGet: async (tenant, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("redpointsV2TenantCustomerGet", "tenant", tenant);
      const localVarPath = `/redpoints/v2/{tenant}/customer`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Get event by customerId extracted by JWT and eventId
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} eventId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV2TenantEventsEventIdGet: async (tenant, eventId, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("redpointsV2TenantEventsEventIdGet", "tenant", tenant);
      // verify required parameter 'eventId' is not null or undefined
      assertParamExists("redpointsV2TenantEventsEventIdGet", "eventId", eventId);
      const localVarPath = `/redpoints/v2/{tenant}/events/{eventId}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Get all events by customerId extracted by JWT (e.g. EA123456)
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {number} [page]
     * @param {number} [itemsPerPage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV2TenantEventsGet: async (tenant, page, itemsPerPage, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("redpointsV2TenantEventsGet", "tenant", tenant);
      const localVarPath = `/redpoints/v2/{tenant}/events`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }
      if (itemsPerPage !== undefined) {
        localVarQueryParameter["itemsPerPage"] = itemsPerPage;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Creates an optIn code for the customer extracted by JWT.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} [email]
     * @param {string} [optInType]
     * @param {RedpointsPostOptInRequestV1} [RedpointsPostOptInRequestV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV2TenantInterestedPost: async (tenant, email, optInType, RedpointsPostOptInRequestV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("redpointsV2TenantInterestedPost", "tenant", tenant);
      const localVarPath = `/redpoints/v2/{tenant}/interested`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (email !== undefined) {
        localVarQueryParameter["email"] = email;
      }
      if (optInType !== undefined) {
        localVarQueryParameter["optInType"] = optInType;
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        RedpointsPostOptInRequestV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Receive a list of points collected and points redeemed per order for the order IDs provided for the customer extracted by JWT.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {RedpointsPostOrdersRequestV1} [RedpointsPostOrdersRequestV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV2TenantOrdersPost: async (tenant, RedpointsPostOrdersRequestV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("redpointsV2TenantOrdersPost", "tenant", tenant);
      const localVarPath = `/redpoints/v2/{tenant}/orders`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        RedpointsPostOrdersRequestV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Receive information about an order in the past for the customer extracted by JWT.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} shopOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV2TenantOrdersShopOrderIdGet: async (tenant, shopOrderId, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("redpointsV2TenantOrdersShopOrderIdGet", "tenant", tenant);
      // verify required parameter 'shopOrderId' is not null or undefined
      assertParamExists("redpointsV2TenantOrdersShopOrderIdGet", "shopOrderId", shopOrderId);
      const localVarPath = `/redpoints/v2/{tenant}/orders/{shopOrderId}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"shopOrderId"}}`, encodeURIComponent(String(shopOrderId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Returns the redpoints registration status for the customer. Extracts customer\'s id from jwt token.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV2TenantRegistrationstatusGet: async (tenant, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("redpointsV2TenantRegistrationstatusGet", "tenant", tenant);
      const localVarPath = `/redpoints/v2/{tenant}/registrationstatus`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * RedpointsControllerV2Api - functional programming interface
 * @export
 */
export const RedpointsControllerV2ApiFp = function (configuration) {
  const localVarAxiosParamCreator = RedpointsControllerV2ApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Return information about the the customer. Extracts customer\'s id from jwt token.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async redpointsV2TenantCustomerGet(tenant, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.redpointsV2TenantCustomerGet(tenant, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Get event by customerId extracted by JWT and eventId
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} eventId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async redpointsV2TenantEventsEventIdGet(tenant, eventId, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.redpointsV2TenantEventsEventIdGet(
        tenant,
        eventId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Get all events by customerId extracted by JWT (e.g. EA123456)
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {number} [page]
     * @param {number} [itemsPerPage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async redpointsV2TenantEventsGet(tenant, page, itemsPerPage, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.redpointsV2TenantEventsGet(
        tenant,
        page,
        itemsPerPage,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Creates an optIn code for the customer extracted by JWT.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} [email]
     * @param {string} [optInType]
     * @param {RedpointsPostOptInRequestV1} [RedpointsPostOptInRequestV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async redpointsV2TenantInterestedPost(tenant, email, optInType, RedpointsPostOptInRequestV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.redpointsV2TenantInterestedPost(
        tenant,
        email,
        optInType,
        RedpointsPostOptInRequestV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Receive a list of points collected and points redeemed per order for the order IDs provided for the customer extracted by JWT.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {RedpointsPostOrdersRequestV1} [RedpointsPostOrdersRequestV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async redpointsV2TenantOrdersPost(tenant, RedpointsPostOrdersRequestV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.redpointsV2TenantOrdersPost(
        tenant,
        RedpointsPostOrdersRequestV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Receive information about an order in the past for the customer extracted by JWT.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} shopOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async redpointsV2TenantOrdersShopOrderIdGet(tenant, shopOrderId, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.redpointsV2TenantOrdersShopOrderIdGet(
        tenant,
        shopOrderId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Returns the redpoints registration status for the customer. Extracts customer\'s id from jwt token.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async redpointsV2TenantRegistrationstatusGet(tenant, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.redpointsV2TenantRegistrationstatusGet(tenant, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * RedpointsControllerV2Api - factory interface
 * @export
 */
export const RedpointsControllerV2ApiFactory = function (configuration, basePath, axios) {
  const localVarFp = RedpointsControllerV2ApiFp(configuration);
  return {
    /**
     *
     * @summary Return information about the the customer. Extracts customer\'s id from jwt token.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV2TenantCustomerGet(tenant, options) {
      return localVarFp.redpointsV2TenantCustomerGet(tenant, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get event by customerId extracted by JWT and eventId
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} eventId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV2TenantEventsEventIdGet(tenant, eventId, options) {
      return localVarFp
        .redpointsV2TenantEventsEventIdGet(tenant, eventId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all events by customerId extracted by JWT (e.g. EA123456)
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {number} [page]
     * @param {number} [itemsPerPage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV2TenantEventsGet(tenant, page, itemsPerPage, options) {
      return localVarFp
        .redpointsV2TenantEventsGet(tenant, page, itemsPerPage, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Creates an optIn code for the customer extracted by JWT.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} [email]
     * @param {string} [optInType]
     * @param {RedpointsPostOptInRequestV1} [RedpointsPostOptInRequestV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV2TenantInterestedPost(tenant, email, optInType, RedpointsPostOptInRequestV1, options) {
      return localVarFp
        .redpointsV2TenantInterestedPost(tenant, email, optInType, RedpointsPostOptInRequestV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Receive a list of points collected and points redeemed per order for the order IDs provided for the customer extracted by JWT.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {RedpointsPostOrdersRequestV1} [RedpointsPostOrdersRequestV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV2TenantOrdersPost(tenant, RedpointsPostOrdersRequestV1, options) {
      return localVarFp
        .redpointsV2TenantOrdersPost(tenant, RedpointsPostOrdersRequestV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Receive information about an order in the past for the customer extracted by JWT.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} shopOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV2TenantOrdersShopOrderIdGet(tenant, shopOrderId, options) {
      return localVarFp
        .redpointsV2TenantOrdersShopOrderIdGet(tenant, shopOrderId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Returns the redpoints registration status for the customer. Extracts customer\'s id from jwt token.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV2TenantRegistrationstatusGet(tenant, options) {
      return localVarFp
        .redpointsV2TenantRegistrationstatusGet(tenant, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * RedpointsControllerV2Api - object-oriented interface
 * @export
 * @class RedpointsControllerV2Api
 * @extends {BaseAPI}
 */
export class RedpointsControllerV2Api extends BaseAPI {
  /**
   *
   * @summary Return information about the the customer. Extracts customer\'s id from jwt token.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RedpointsControllerV2Api
   */
  redpointsV2TenantCustomerGet(tenant, options) {
    return RedpointsControllerV2ApiFp(this.configuration)
      .redpointsV2TenantCustomerGet(tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get event by customerId extracted by JWT and eventId
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} eventId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RedpointsControllerV2Api
   */
  redpointsV2TenantEventsEventIdGet(tenant, eventId, options) {
    return RedpointsControllerV2ApiFp(this.configuration)
      .redpointsV2TenantEventsEventIdGet(tenant, eventId, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get all events by customerId extracted by JWT (e.g. EA123456)
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {number} [page]
   * @param {number} [itemsPerPage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RedpointsControllerV2Api
   */
  redpointsV2TenantEventsGet(tenant, page, itemsPerPage, options) {
    return RedpointsControllerV2ApiFp(this.configuration)
      .redpointsV2TenantEventsGet(tenant, page, itemsPerPage, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Creates an optIn code for the customer extracted by JWT.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} [email]
   * @param {string} [optInType]
   * @param {RedpointsPostOptInRequestV1} [RedpointsPostOptInRequestV1]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RedpointsControllerV2Api
   */
  redpointsV2TenantInterestedPost(tenant, email, optInType, RedpointsPostOptInRequestV1, options) {
    return RedpointsControllerV2ApiFp(this.configuration)
      .redpointsV2TenantInterestedPost(tenant, email, optInType, RedpointsPostOptInRequestV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Receive a list of points collected and points redeemed per order for the order IDs provided for the customer extracted by JWT.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {RedpointsPostOrdersRequestV1} [RedpointsPostOrdersRequestV1]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RedpointsControllerV2Api
   */
  redpointsV2TenantOrdersPost(tenant, RedpointsPostOrdersRequestV1, options) {
    return RedpointsControllerV2ApiFp(this.configuration)
      .redpointsV2TenantOrdersPost(tenant, RedpointsPostOrdersRequestV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Receive information about an order in the past for the customer extracted by JWT.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} shopOrderId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RedpointsControllerV2Api
   */
  redpointsV2TenantOrdersShopOrderIdGet(tenant, shopOrderId, options) {
    return RedpointsControllerV2ApiFp(this.configuration)
      .redpointsV2TenantOrdersShopOrderIdGet(tenant, shopOrderId, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Returns the redpoints registration status for the customer. Extracts customer\'s id from jwt token.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RedpointsControllerV2Api
   */
  redpointsV2TenantRegistrationstatusGet(tenant, options) {
    return RedpointsControllerV2ApiFp(this.configuration)
      .redpointsV2TenantRegistrationstatusGet(tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * RedpointsControllerV3Api - axios parameter creator
 * @export
 */
export const RedpointsControllerV3ApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @summary Aggregates events and customer call.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {number} [page]
     * @param {number} [itemsPerPage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV3TenantCustomerEventsGet: async (tenant, page, itemsPerPage, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("redpointsV3TenantCustomerEventsGet", "tenant", tenant);
      const localVarPath = `/redpoints/v3/{tenant}/customer-events`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }
      if (itemsPerPage !== undefined) {
        localVarQueryParameter["itemsPerPage"] = itemsPerPage;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Creates an optIn code for the customer. Also submits orders of last 24h
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {RedpointsInterestedRequestBodyV1} [RedpointsInterestedRequestBodyV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV3TenantInterestedPost: async (tenant, RedpointsInterestedRequestBodyV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("redpointsV3TenantInterestedPost", "tenant", tenant);
      const localVarPath = `/redpoints/v3/{tenant}/interested`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        RedpointsInterestedRequestBodyV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Add a Smart Patient RedPoints transfer. Extracts customer\'s id from jwt token.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {RedpointsCustomAction} RedpointsCustomAction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV3TenantSmartpatientactionsPost: async (tenant, RedpointsCustomAction, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("redpointsV3TenantSmartpatientactionsPost", "tenant", tenant);
      // verify required parameter 'RedpointsCustomAction' is not null or undefined
      assertParamExists("redpointsV3TenantSmartpatientactionsPost", "RedpointsCustomAction", RedpointsCustomAction);
      const localVarPath = `/redpoints/v3/{tenant}/smartpatientactions`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(RedpointsCustomAction, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * RedpointsControllerV3Api - functional programming interface
 * @export
 */
export const RedpointsControllerV3ApiFp = function (configuration) {
  const localVarAxiosParamCreator = RedpointsControllerV3ApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Aggregates events and customer call.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {number} [page]
     * @param {number} [itemsPerPage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async redpointsV3TenantCustomerEventsGet(tenant, page, itemsPerPage, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.redpointsV3TenantCustomerEventsGet(
        tenant,
        page,
        itemsPerPage,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Creates an optIn code for the customer. Also submits orders of last 24h
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {RedpointsInterestedRequestBodyV1} [RedpointsInterestedRequestBodyV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async redpointsV3TenantInterestedPost(tenant, RedpointsInterestedRequestBodyV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.redpointsV3TenantInterestedPost(
        tenant,
        RedpointsInterestedRequestBodyV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Add a Smart Patient RedPoints transfer. Extracts customer\'s id from jwt token.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {RedpointsCustomAction} RedpointsCustomAction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async redpointsV3TenantSmartpatientactionsPost(tenant, RedpointsCustomAction, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.redpointsV3TenantSmartpatientactionsPost(
        tenant,
        RedpointsCustomAction,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * RedpointsControllerV3Api - factory interface
 * @export
 */
export const RedpointsControllerV3ApiFactory = function (configuration, basePath, axios) {
  const localVarFp = RedpointsControllerV3ApiFp(configuration);
  return {
    /**
     *
     * @summary Aggregates events and customer call.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {number} [page]
     * @param {number} [itemsPerPage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV3TenantCustomerEventsGet(tenant, page, itemsPerPage, options) {
      return localVarFp
        .redpointsV3TenantCustomerEventsGet(tenant, page, itemsPerPage, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Creates an optIn code for the customer. Also submits orders of last 24h
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {RedpointsInterestedRequestBodyV1} [RedpointsInterestedRequestBodyV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV3TenantInterestedPost(tenant, RedpointsInterestedRequestBodyV1, options) {
      return localVarFp
        .redpointsV3TenantInterestedPost(tenant, RedpointsInterestedRequestBodyV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Add a Smart Patient RedPoints transfer. Extracts customer\'s id from jwt token.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {RedpointsCustomAction} RedpointsCustomAction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redpointsV3TenantSmartpatientactionsPost(tenant, RedpointsCustomAction, options) {
      return localVarFp
        .redpointsV3TenantSmartpatientactionsPost(tenant, RedpointsCustomAction, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * RedpointsControllerV3Api - object-oriented interface
 * @export
 * @class RedpointsControllerV3Api
 * @extends {BaseAPI}
 */
export class RedpointsControllerV3Api extends BaseAPI {
  /**
   *
   * @summary Aggregates events and customer call.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {number} [page]
   * @param {number} [itemsPerPage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RedpointsControllerV3Api
   */
  redpointsV3TenantCustomerEventsGet(tenant, page, itemsPerPage, options) {
    return RedpointsControllerV3ApiFp(this.configuration)
      .redpointsV3TenantCustomerEventsGet(tenant, page, itemsPerPage, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Creates an optIn code for the customer. Also submits orders of last 24h
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {RedpointsInterestedRequestBodyV1} [RedpointsInterestedRequestBodyV1]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RedpointsControllerV3Api
   */
  redpointsV3TenantInterestedPost(tenant, RedpointsInterestedRequestBodyV1, options) {
    return RedpointsControllerV3ApiFp(this.configuration)
      .redpointsV3TenantInterestedPost(tenant, RedpointsInterestedRequestBodyV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Add a Smart Patient RedPoints transfer. Extracts customer\'s id from jwt token.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {RedpointsCustomAction} RedpointsCustomAction
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RedpointsControllerV3Api
   */
  redpointsV3TenantSmartpatientactionsPost(tenant, RedpointsCustomAction, options) {
    return RedpointsControllerV3ApiFp(this.configuration)
      .redpointsV3TenantSmartpatientactionsPost(tenant, RedpointsCustomAction, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * ReturnLabelControllerApi - axios parameter creator
 * @export
 */
export const ReturnLabelControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Request return label for listed products
     * @param {string} suborderId
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    returnlabelV1TenantSuborderIdGet: async (suborderId, tenant, options = {}) => {
      // verify required parameter 'suborderId' is not null or undefined
      assertParamExists("returnlabelV1TenantSuborderIdGet", "suborderId", suborderId);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("returnlabelV1TenantSuborderIdGet", "tenant", tenant);
      const localVarPath = `/returnlabel/v1/{tenant}/{suborderId}`
        .replace(`{${"suborderId"}}`, encodeURIComponent(String(suborderId)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication basicAuth required
      // http basic authentication required
      setBasicAuthToObject(localVarRequestOptions, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Request return label for listed products
     * @param {string} suborderId
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {CreateReturnLabelRequestBodyV1} CreateReturnLabelRequestBodyV1 Return Label request body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    returnlabelV1TenantSuborderIdPost: async (suborderId, tenant, CreateReturnLabelRequestBodyV1, options = {}) => {
      // verify required parameter 'suborderId' is not null or undefined
      assertParamExists("returnlabelV1TenantSuborderIdPost", "suborderId", suborderId);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("returnlabelV1TenantSuborderIdPost", "tenant", tenant);
      // verify required parameter 'CreateReturnLabelRequestBodyV1' is not null or undefined
      assertParamExists(
        "returnlabelV1TenantSuborderIdPost",
        "CreateReturnLabelRequestBodyV1",
        CreateReturnLabelRequestBodyV1
      );
      const localVarPath = `/returnlabel/v1/{tenant}/{suborderId}`
        .replace(`{${"suborderId"}}`, encodeURIComponent(String(suborderId)))
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication basicAuth required
      // http basic authentication required
      setBasicAuthToObject(localVarRequestOptions, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        CreateReturnLabelRequestBodyV1,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * ReturnLabelControllerApi - functional programming interface
 * @export
 */
export const ReturnLabelControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = ReturnLabelControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * Request return label for listed products
     * @param {string} suborderId
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async returnlabelV1TenantSuborderIdGet(suborderId, tenant, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.returnlabelV1TenantSuborderIdGet(
        suborderId,
        tenant,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Request return label for listed products
     * @param {string} suborderId
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {CreateReturnLabelRequestBodyV1} CreateReturnLabelRequestBodyV1 Return Label request body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async returnlabelV1TenantSuborderIdPost(suborderId, tenant, CreateReturnLabelRequestBodyV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.returnlabelV1TenantSuborderIdPost(
        suborderId,
        tenant,
        CreateReturnLabelRequestBodyV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * ReturnLabelControllerApi - factory interface
 * @export
 */
export const ReturnLabelControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = ReturnLabelControllerApiFp(configuration);
  return {
    /**
     * Request return label for listed products
     * @param {string} suborderId
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    returnlabelV1TenantSuborderIdGet(suborderId, tenant, options) {
      return localVarFp
        .returnlabelV1TenantSuborderIdGet(suborderId, tenant, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Request return label for listed products
     * @param {string} suborderId
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {CreateReturnLabelRequestBodyV1} CreateReturnLabelRequestBodyV1 Return Label request body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    returnlabelV1TenantSuborderIdPost(suborderId, tenant, CreateReturnLabelRequestBodyV1, options) {
      return localVarFp
        .returnlabelV1TenantSuborderIdPost(suborderId, tenant, CreateReturnLabelRequestBodyV1, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * ReturnLabelControllerApi - object-oriented interface
 * @export
 * @class ReturnLabelControllerApi
 * @extends {BaseAPI}
 */
export class ReturnLabelControllerApi extends BaseAPI {
  /**
   * Request return label for listed products
   * @param {string} suborderId
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReturnLabelControllerApi
   */
  returnlabelV1TenantSuborderIdGet(suborderId, tenant, options) {
    return ReturnLabelControllerApiFp(this.configuration)
      .returnlabelV1TenantSuborderIdGet(suborderId, tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Request return label for listed products
   * @param {string} suborderId
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {CreateReturnLabelRequestBodyV1} CreateReturnLabelRequestBodyV1 Return Label request body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReturnLabelControllerApi
   */
  returnlabelV1TenantSuborderIdPost(suborderId, tenant, CreateReturnLabelRequestBodyV1, options) {
    return ReturnLabelControllerApiFp(this.configuration)
      .returnlabelV1TenantSuborderIdPost(suborderId, tenant, CreateReturnLabelRequestBodyV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * SWAPServiceApi - axios parameter creator
 * @export
 */
export const SWAPServiceApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @summary Returns a list of substitutions - currently only German tenants are being supported
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {SwapExchangeRequest} SwapExchangeRequest Prescriptions resolved from Data Matrix codes
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubstitutionsByProductIds: async (tenant, SwapExchangeRequest, X_Request_ID, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("getSubstitutionsByProductIds", "tenant", tenant);
      // verify required parameter 'SwapExchangeRequest' is not null or undefined
      assertParamExists("getSubstitutionsByProductIds", "SwapExchangeRequest", SwapExchangeRequest);
      const localVarPath = `/swap/v1/{tenant}/substitutions`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication basicAuth required
      // http basic authentication required
      setBasicAuthToObject(localVarRequestOptions, configuration);
      if (X_Request_ID != null) {
        localVarHeaderParameter["X-Request-ID"] = String(X_Request_ID);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(SwapExchangeRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Provides list of possible alternatives for provided products and additional parameters
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {AlternativesRequest} AlternativesRequest Body of request for product alternatives
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    swapServiceApiAlternatives: async (tenant, AlternativesRequest, X_Request_ID, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("swapServiceApiAlternatives", "tenant", tenant);
      // verify required parameter 'AlternativesRequest' is not null or undefined
      assertParamExists("swapServiceApiAlternatives", "AlternativesRequest", AlternativesRequest);
      const localVarPath = `/swap/v2/{tenant}/alternatives`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (X_Request_ID != null) {
        localVarHeaderParameter["X-Request-ID"] = String(X_Request_ID);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(AlternativesRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Returns a list of substitutions - currently only German tenants are being supported
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {SwapSubstitutionsRequest} SwapSubstitutionsRequest Body of request for product substitutions
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    swapServiceApiSubstitutions: async (tenant, SwapSubstitutionsRequest, X_Request_ID, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("swapServiceApiSubstitutions", "tenant", tenant);
      // verify required parameter 'SwapSubstitutionsRequest' is not null or undefined
      assertParamExists("swapServiceApiSubstitutions", "SwapSubstitutionsRequest", SwapSubstitutionsRequest);
      const localVarPath = `/swap/v2/{tenant}/substitutions`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (X_Request_ID != null) {
        localVarHeaderParameter["X-Request-ID"] = String(X_Request_ID);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        SwapSubstitutionsRequest,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * SWAPServiceApi - functional programming interface
 * @export
 */
export const SWAPServiceApiFp = function (configuration) {
  const localVarAxiosParamCreator = SWAPServiceApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Returns a list of substitutions - currently only German tenants are being supported
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {SwapExchangeRequest} SwapExchangeRequest Prescriptions resolved from Data Matrix codes
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSubstitutionsByProductIds(tenant, SwapExchangeRequest, X_Request_ID, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getSubstitutionsByProductIds(
        tenant,
        SwapExchangeRequest,
        X_Request_ID,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Provides list of possible alternatives for provided products and additional parameters
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {AlternativesRequest} AlternativesRequest Body of request for product alternatives
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async swapServiceApiAlternatives(tenant, AlternativesRequest, X_Request_ID, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.swapServiceApiAlternatives(
        tenant,
        AlternativesRequest,
        X_Request_ID,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Returns a list of substitutions - currently only German tenants are being supported
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {SwapSubstitutionsRequest} SwapSubstitutionsRequest Body of request for product substitutions
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async swapServiceApiSubstitutions(tenant, SwapSubstitutionsRequest, X_Request_ID, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.swapServiceApiSubstitutions(
        tenant,
        SwapSubstitutionsRequest,
        X_Request_ID,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * SWAPServiceApi - factory interface
 * @export
 */
export const SWAPServiceApiFactory = function (configuration, basePath, axios) {
  const localVarFp = SWAPServiceApiFp(configuration);
  return {
    /**
     *
     * @summary Returns a list of substitutions - currently only German tenants are being supported
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {SwapExchangeRequest} SwapExchangeRequest Prescriptions resolved from Data Matrix codes
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubstitutionsByProductIds(tenant, SwapExchangeRequest, X_Request_ID, options) {
      return localVarFp
        .getSubstitutionsByProductIds(tenant, SwapExchangeRequest, X_Request_ID, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Provides list of possible alternatives for provided products and additional parameters
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {AlternativesRequest} AlternativesRequest Body of request for product alternatives
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    swapServiceApiAlternatives(tenant, AlternativesRequest, X_Request_ID, options) {
      return localVarFp
        .swapServiceApiAlternatives(tenant, AlternativesRequest, X_Request_ID, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Returns a list of substitutions - currently only German tenants are being supported
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {SwapSubstitutionsRequest} SwapSubstitutionsRequest Body of request for product substitutions
     * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    swapServiceApiSubstitutions(tenant, SwapSubstitutionsRequest, X_Request_ID, options) {
      return localVarFp
        .swapServiceApiSubstitutions(tenant, SwapSubstitutionsRequest, X_Request_ID, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * SWAPServiceApi - object-oriented interface
 * @export
 * @class SWAPServiceApi
 * @extends {BaseAPI}
 */
export class SWAPServiceApi extends BaseAPI {
  /**
   *
   * @summary Returns a list of substitutions - currently only German tenants are being supported
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {SwapExchangeRequest} SwapExchangeRequest Prescriptions resolved from Data Matrix codes
   * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SWAPServiceApi
   */
  getSubstitutionsByProductIds(tenant, SwapExchangeRequest, X_Request_ID, options) {
    return SWAPServiceApiFp(this.configuration)
      .getSubstitutionsByProductIds(tenant, SwapExchangeRequest, X_Request_ID, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Provides list of possible alternatives for provided products and additional parameters
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {AlternativesRequest} AlternativesRequest Body of request for product alternatives
   * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SWAPServiceApi
   */
  swapServiceApiAlternatives(tenant, AlternativesRequest, X_Request_ID, options) {
    return SWAPServiceApiFp(this.configuration)
      .swapServiceApiAlternatives(tenant, AlternativesRequest, X_Request_ID, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Returns a list of substitutions - currently only German tenants are being supported
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {SwapSubstitutionsRequest} SwapSubstitutionsRequest Body of request for product substitutions
   * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SWAPServiceApi
   */
  swapServiceApiSubstitutions(tenant, SwapSubstitutionsRequest, X_Request_ID, options) {
    return SWAPServiceApiFp(this.configuration)
      .swapServiceApiSubstitutions(tenant, SwapSubstitutionsRequest, X_Request_ID, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * SearchControllerApi - axios parameter creator
 * @export
 */
export const SearchControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {string} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageSearchEsV2TenantGet: async (tenant, language, fields, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageSearchEsV2TenantGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageSearchEsV2TenantGet", "language", language);
      const localVarPath = `/{language}/search-es/v2/{tenant}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (fields !== undefined) {
        localVarQueryParameter["fields"] = fields;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} query QueryParam query
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageSearchEsV2TenantSuggestGet: async (query, tenant, language, options = {}) => {
      // verify required parameter 'query' is not null or undefined
      assertParamExists("languageSearchEsV2TenantSuggestGet", "query", query);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("languageSearchEsV2TenantSuggestGet", "tenant", tenant);
      // verify required parameter 'language' is not null or undefined
      assertParamExists("languageSearchEsV2TenantSuggestGet", "language", language);
      const localVarPath = `/{language}/search-es/v2/{tenant}/suggest`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"language"}}`, encodeURIComponent(String(language)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (query !== undefined) {
        localVarQueryParameter["query"] = query;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * SearchControllerApi - functional programming interface
 * @export
 */
export const SearchControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = SearchControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {string} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageSearchEsV2TenantGet(tenant, language, fields, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageSearchEsV2TenantGet(
        tenant,
        language,
        fields,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} query QueryParam query
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageSearchEsV2TenantSuggestGet(query, tenant, language, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.languageSearchEsV2TenantSuggestGet(
        query,
        tenant,
        language,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * SearchControllerApi - factory interface
 * @export
 */
export const SearchControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = SearchControllerApiFp(configuration);
  return {
    /**
     *
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {string} [fields] QueryParam fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageSearchEsV2TenantGet(tenant, language, fields, options) {
      return localVarFp
        .languageSearchEsV2TenantGet(tenant, language, fields, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} query QueryParam query
     * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
     * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageSearchEsV2TenantSuggestGet(query, tenant, language, options) {
      return localVarFp
        .languageSearchEsV2TenantSuggestGet(query, tenant, language, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * SearchControllerApi - object-oriented interface
 * @export
 * @class SearchControllerApi
 * @extends {BaseAPI}
 */
export class SearchControllerApi extends BaseAPI {
  /**
   *
   * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {string} [fields] QueryParam fields
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchControllerApi
   */
  languageSearchEsV2TenantGet(tenant, language, fields, options) {
    return SearchControllerApiFp(this.configuration)
      .languageSearchEsV2TenantGet(tenant, language, fields, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} query QueryParam query
   * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
   * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchControllerApi
   */
  languageSearchEsV2TenantSuggestGet(query, tenant, language, options) {
    return SearchControllerApiFp(this.configuration)
      .languageSearchEsV2TenantSuggestGet(query, tenant, language, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * SellerControllerApi - axios parameter creator
 * @export
 */
export const SellerControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @summary Retreives a list of sellers
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} ids A comma seperated list of seller ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sellerV1TenantGet: async (tenant, ids, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("sellerV1TenantGet", "tenant", tenant);
      // verify required parameter 'ids' is not null or undefined
      assertParamExists("sellerV1TenantGet", "ids", ids);
      const localVarPath = `/seller/v1/{tenant}`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (ids !== undefined) {
        localVarQueryParameter["ids"] = ids;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Returns single property that tells us if the customer is allowed to evaluate this mirakl order.
     * @summary Checks if customer is allowed to rate given mirakl order
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} sellerId the dedicated instance path selector
     * @param {string} orderId order id
     * @param {string} subOrderId mirakl order id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sellerV1TenantSellerIdCanEvaluateOrderOrderIdSubOrderIdGet: async (
      tenant,
      sellerId,
      orderId,
      subOrderId,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("sellerV1TenantSellerIdCanEvaluateOrderOrderIdSubOrderIdGet", "tenant", tenant);
      // verify required parameter 'sellerId' is not null or undefined
      assertParamExists("sellerV1TenantSellerIdCanEvaluateOrderOrderIdSubOrderIdGet", "sellerId", sellerId);
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists("sellerV1TenantSellerIdCanEvaluateOrderOrderIdSubOrderIdGet", "orderId", orderId);
      // verify required parameter 'subOrderId' is not null or undefined
      assertParamExists("sellerV1TenantSellerIdCanEvaluateOrderOrderIdSubOrderIdGet", "subOrderId", subOrderId);
      const localVarPath = `/seller/v1/{tenant}/{sellerId}/canEvaluateOrder/{orderId}/{subOrderId}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)))
        .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)))
        .replace(`{${"subOrderId"}}`, encodeURIComponent(String(subOrderId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Returns single property that tells us if the customer is allowed to evaluate this mirakl order.
     * @summary Checks if customer is allowed to rate given mirakl order
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} sellerId the dedicated instance path selector
     * @param {string} subOrderId mirakl order id
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    sellerV1TenantSellerIdCanEvaluateOrderSubOrderIdGet: async (tenant, sellerId, subOrderId, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("sellerV1TenantSellerIdCanEvaluateOrderSubOrderIdGet", "tenant", tenant);
      // verify required parameter 'sellerId' is not null or undefined
      assertParamExists("sellerV1TenantSellerIdCanEvaluateOrderSubOrderIdGet", "sellerId", sellerId);
      // verify required parameter 'subOrderId' is not null or undefined
      assertParamExists("sellerV1TenantSellerIdCanEvaluateOrderSubOrderIdGet", "subOrderId", subOrderId);
      const localVarPath = `/seller/v1/{tenant}/{sellerId}/canEvaluateOrder/{subOrderId}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)))
        .replace(`{${"subOrderId"}}`, encodeURIComponent(String(subOrderId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Create evaluation to a specific mirakl order
     * @summary Create evaluation to a specific mirakl order
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} sellerId the dedicated instance path selector
     * @param {string} subOrderId the dedicated instance path selector
     * @param {SellerV1EvaluationRequest} [SellerV1EvaluationRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    sellerV1TenantSellerIdEvaluateSubOrderIdPost: async (
      tenant,
      sellerId,
      subOrderId,
      SellerV1EvaluationRequest,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("sellerV1TenantSellerIdEvaluateSubOrderIdPost", "tenant", tenant);
      // verify required parameter 'sellerId' is not null or undefined
      assertParamExists("sellerV1TenantSellerIdEvaluateSubOrderIdPost", "sellerId", sellerId);
      // verify required parameter 'subOrderId' is not null or undefined
      assertParamExists("sellerV1TenantSellerIdEvaluateSubOrderIdPost", "subOrderId", subOrderId);
      const localVarPath = `/seller/v1/{tenant}/{sellerId}/evaluate/{subOrderId}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)))
        .replace(`{${"subOrderId"}}`, encodeURIComponent(String(subOrderId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        SellerV1EvaluationRequest,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Create evaluation to a specific mirakl order
     * @summary Create evaluation to a specific mirakl order
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} sellerId the dedicated instance path selector
     * @param {string} orderId order id
     * @param {string} subOrderId mirakl order id
     * @param {SellerV1EvaluationRequest} [SellerV1EvaluationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sellerV1TenantSellerIdEvaluationOrderIdSubOrderIdPost: async (
      tenant,
      sellerId,
      orderId,
      subOrderId,
      SellerV1EvaluationRequest,
      options = {}
    ) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("sellerV1TenantSellerIdEvaluationOrderIdSubOrderIdPost", "tenant", tenant);
      // verify required parameter 'sellerId' is not null or undefined
      assertParamExists("sellerV1TenantSellerIdEvaluationOrderIdSubOrderIdPost", "sellerId", sellerId);
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists("sellerV1TenantSellerIdEvaluationOrderIdSubOrderIdPost", "orderId", orderId);
      // verify required parameter 'subOrderId' is not null or undefined
      assertParamExists("sellerV1TenantSellerIdEvaluationOrderIdSubOrderIdPost", "subOrderId", subOrderId);
      const localVarPath = `/seller/v1/{tenant}/{sellerId}/evaluation/{orderId}/{subOrderId}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)))
        .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)))
        .replace(`{${"subOrderId"}}`, encodeURIComponent(String(subOrderId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        SellerV1EvaluationRequest,
        localVarRequestOptions,
        configuration
      );
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * The sellers\' evaluations can be marked as not visible by the marketplace\'s operator. This endpoint\'s response will __only contain evaluations market as visible__.
     * @summary Retrieves a list of visible seller evaluations
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} sellerId the dedicated instance path selector
     * @param {number} [offset] starting index of retrieved evaluations\&#39; list
     * @param {number} [limit] the maximum count of evaluations retrieved
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sellerV1TenantSellerIdEvaluationsGet: async (tenant, sellerId, offset, limit, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("sellerV1TenantSellerIdEvaluationsGet", "tenant", tenant);
      // verify required parameter 'sellerId' is not null or undefined
      assertParamExists("sellerV1TenantSellerIdEvaluationsGet", "sellerId", sellerId);
      const localVarPath = `/seller/v1/{tenant}/{sellerId}/evaluations`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }
      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Retreives a single seller
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} sellerId the dedicated instance path selector
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sellerV1TenantSellerIdGet: async (tenant, sellerId, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("sellerV1TenantSellerIdGet", "tenant", tenant);
      // verify required parameter 'sellerId' is not null or undefined
      assertParamExists("sellerV1TenantSellerIdGet", "sellerId", sellerId);
      const localVarPath = `/seller/v1/{tenant}/{sellerId}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * SellerControllerApi - functional programming interface
 * @export
 */
export const SellerControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = SellerControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Retreives a list of sellers
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} ids A comma seperated list of seller ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sellerV1TenantGet(tenant, ids, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sellerV1TenantGet(tenant, ids, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Returns single property that tells us if the customer is allowed to evaluate this mirakl order.
     * @summary Checks if customer is allowed to rate given mirakl order
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} sellerId the dedicated instance path selector
     * @param {string} orderId order id
     * @param {string} subOrderId mirakl order id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sellerV1TenantSellerIdCanEvaluateOrderOrderIdSubOrderIdGet(tenant, sellerId, orderId, subOrderId, options) {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.sellerV1TenantSellerIdCanEvaluateOrderOrderIdSubOrderIdGet(
          tenant,
          sellerId,
          orderId,
          subOrderId,
          options
        );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Returns single property that tells us if the customer is allowed to evaluate this mirakl order.
     * @summary Checks if customer is allowed to rate given mirakl order
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} sellerId the dedicated instance path selector
     * @param {string} subOrderId mirakl order id
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async sellerV1TenantSellerIdCanEvaluateOrderSubOrderIdGet(tenant, sellerId, subOrderId, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sellerV1TenantSellerIdCanEvaluateOrderSubOrderIdGet(
        tenant,
        sellerId,
        subOrderId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Create evaluation to a specific mirakl order
     * @summary Create evaluation to a specific mirakl order
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} sellerId the dedicated instance path selector
     * @param {string} subOrderId the dedicated instance path selector
     * @param {SellerV1EvaluationRequest} [SellerV1EvaluationRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async sellerV1TenantSellerIdEvaluateSubOrderIdPost(
      tenant,
      sellerId,
      subOrderId,
      SellerV1EvaluationRequest,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sellerV1TenantSellerIdEvaluateSubOrderIdPost(
        tenant,
        sellerId,
        subOrderId,
        SellerV1EvaluationRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Create evaluation to a specific mirakl order
     * @summary Create evaluation to a specific mirakl order
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} sellerId the dedicated instance path selector
     * @param {string} orderId order id
     * @param {string} subOrderId mirakl order id
     * @param {SellerV1EvaluationRequest} [SellerV1EvaluationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sellerV1TenantSellerIdEvaluationOrderIdSubOrderIdPost(
      tenant,
      sellerId,
      orderId,
      subOrderId,
      SellerV1EvaluationRequest,
      options
    ) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sellerV1TenantSellerIdEvaluationOrderIdSubOrderIdPost(
        tenant,
        sellerId,
        orderId,
        subOrderId,
        SellerV1EvaluationRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * The sellers\' evaluations can be marked as not visible by the marketplace\'s operator. This endpoint\'s response will __only contain evaluations market as visible__.
     * @summary Retrieves a list of visible seller evaluations
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} sellerId the dedicated instance path selector
     * @param {number} [offset] starting index of retrieved evaluations\&#39; list
     * @param {number} [limit] the maximum count of evaluations retrieved
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sellerV1TenantSellerIdEvaluationsGet(tenant, sellerId, offset, limit, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sellerV1TenantSellerIdEvaluationsGet(
        tenant,
        sellerId,
        offset,
        limit,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Retreives a single seller
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} sellerId the dedicated instance path selector
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sellerV1TenantSellerIdGet(tenant, sellerId, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sellerV1TenantSellerIdGet(tenant, sellerId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * SellerControllerApi - factory interface
 * @export
 */
export const SellerControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = SellerControllerApiFp(configuration);
  return {
    /**
     *
     * @summary Retreives a list of sellers
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} ids A comma seperated list of seller ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sellerV1TenantGet(tenant, ids, options) {
      return localVarFp.sellerV1TenantGet(tenant, ids, options).then((request) => request(axios, basePath));
    },
    /**
     * Returns single property that tells us if the customer is allowed to evaluate this mirakl order.
     * @summary Checks if customer is allowed to rate given mirakl order
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} sellerId the dedicated instance path selector
     * @param {string} orderId order id
     * @param {string} subOrderId mirakl order id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sellerV1TenantSellerIdCanEvaluateOrderOrderIdSubOrderIdGet(tenant, sellerId, orderId, subOrderId, options) {
      return localVarFp
        .sellerV1TenantSellerIdCanEvaluateOrderOrderIdSubOrderIdGet(tenant, sellerId, orderId, subOrderId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Returns single property that tells us if the customer is allowed to evaluate this mirakl order.
     * @summary Checks if customer is allowed to rate given mirakl order
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} sellerId the dedicated instance path selector
     * @param {string} subOrderId mirakl order id
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    sellerV1TenantSellerIdCanEvaluateOrderSubOrderIdGet(tenant, sellerId, subOrderId, options) {
      return localVarFp
        .sellerV1TenantSellerIdCanEvaluateOrderSubOrderIdGet(tenant, sellerId, subOrderId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Create evaluation to a specific mirakl order
     * @summary Create evaluation to a specific mirakl order
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} sellerId the dedicated instance path selector
     * @param {string} subOrderId the dedicated instance path selector
     * @param {SellerV1EvaluationRequest} [SellerV1EvaluationRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    sellerV1TenantSellerIdEvaluateSubOrderIdPost(tenant, sellerId, subOrderId, SellerV1EvaluationRequest, options) {
      return localVarFp
        .sellerV1TenantSellerIdEvaluateSubOrderIdPost(tenant, sellerId, subOrderId, SellerV1EvaluationRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Create evaluation to a specific mirakl order
     * @summary Create evaluation to a specific mirakl order
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} sellerId the dedicated instance path selector
     * @param {string} orderId order id
     * @param {string} subOrderId mirakl order id
     * @param {SellerV1EvaluationRequest} [SellerV1EvaluationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sellerV1TenantSellerIdEvaluationOrderIdSubOrderIdPost(
      tenant,
      sellerId,
      orderId,
      subOrderId,
      SellerV1EvaluationRequest,
      options
    ) {
      return localVarFp
        .sellerV1TenantSellerIdEvaluationOrderIdSubOrderIdPost(
          tenant,
          sellerId,
          orderId,
          subOrderId,
          SellerV1EvaluationRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * The sellers\' evaluations can be marked as not visible by the marketplace\'s operator. This endpoint\'s response will __only contain evaluations market as visible__.
     * @summary Retrieves a list of visible seller evaluations
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} sellerId the dedicated instance path selector
     * @param {number} [offset] starting index of retrieved evaluations\&#39; list
     * @param {number} [limit] the maximum count of evaluations retrieved
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sellerV1TenantSellerIdEvaluationsGet(tenant, sellerId, offset, limit, options) {
      return localVarFp
        .sellerV1TenantSellerIdEvaluationsGet(tenant, sellerId, offset, limit, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Retreives a single seller
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} sellerId the dedicated instance path selector
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sellerV1TenantSellerIdGet(tenant, sellerId, options) {
      return localVarFp
        .sellerV1TenantSellerIdGet(tenant, sellerId, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * SellerControllerApi - object-oriented interface
 * @export
 * @class SellerControllerApi
 * @extends {BaseAPI}
 */
export class SellerControllerApi extends BaseAPI {
  /**
   *
   * @summary Retreives a list of sellers
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} ids A comma seperated list of seller ids
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SellerControllerApi
   */
  sellerV1TenantGet(tenant, ids, options) {
    return SellerControllerApiFp(this.configuration)
      .sellerV1TenantGet(tenant, ids, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Returns single property that tells us if the customer is allowed to evaluate this mirakl order.
   * @summary Checks if customer is allowed to rate given mirakl order
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} sellerId the dedicated instance path selector
   * @param {string} orderId order id
   * @param {string} subOrderId mirakl order id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SellerControllerApi
   */
  sellerV1TenantSellerIdCanEvaluateOrderOrderIdSubOrderIdGet(tenant, sellerId, orderId, subOrderId, options) {
    return SellerControllerApiFp(this.configuration)
      .sellerV1TenantSellerIdCanEvaluateOrderOrderIdSubOrderIdGet(tenant, sellerId, orderId, subOrderId, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Returns single property that tells us if the customer is allowed to evaluate this mirakl order.
   * @summary Checks if customer is allowed to rate given mirakl order
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} sellerId the dedicated instance path selector
   * @param {string} subOrderId mirakl order id
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof SellerControllerApi
   */
  sellerV1TenantSellerIdCanEvaluateOrderSubOrderIdGet(tenant, sellerId, subOrderId, options) {
    return SellerControllerApiFp(this.configuration)
      .sellerV1TenantSellerIdCanEvaluateOrderSubOrderIdGet(tenant, sellerId, subOrderId, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create evaluation to a specific mirakl order
   * @summary Create evaluation to a specific mirakl order
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} sellerId the dedicated instance path selector
   * @param {string} subOrderId the dedicated instance path selector
   * @param {SellerV1EvaluationRequest} [SellerV1EvaluationRequest]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof SellerControllerApi
   */
  sellerV1TenantSellerIdEvaluateSubOrderIdPost(tenant, sellerId, subOrderId, SellerV1EvaluationRequest, options) {
    return SellerControllerApiFp(this.configuration)
      .sellerV1TenantSellerIdEvaluateSubOrderIdPost(tenant, sellerId, subOrderId, SellerV1EvaluationRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create evaluation to a specific mirakl order
   * @summary Create evaluation to a specific mirakl order
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} sellerId the dedicated instance path selector
   * @param {string} orderId order id
   * @param {string} subOrderId mirakl order id
   * @param {SellerV1EvaluationRequest} [SellerV1EvaluationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SellerControllerApi
   */
  sellerV1TenantSellerIdEvaluationOrderIdSubOrderIdPost(
    tenant,
    sellerId,
    orderId,
    subOrderId,
    SellerV1EvaluationRequest,
    options
  ) {
    return SellerControllerApiFp(this.configuration)
      .sellerV1TenantSellerIdEvaluationOrderIdSubOrderIdPost(
        tenant,
        sellerId,
        orderId,
        subOrderId,
        SellerV1EvaluationRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * The sellers\' evaluations can be marked as not visible by the marketplace\'s operator. This endpoint\'s response will __only contain evaluations market as visible__.
   * @summary Retrieves a list of visible seller evaluations
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} sellerId the dedicated instance path selector
   * @param {number} [offset] starting index of retrieved evaluations\&#39; list
   * @param {number} [limit] the maximum count of evaluations retrieved
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SellerControllerApi
   */
  sellerV1TenantSellerIdEvaluationsGet(tenant, sellerId, offset, limit, options) {
    return SellerControllerApiFp(this.configuration)
      .sellerV1TenantSellerIdEvaluationsGet(tenant, sellerId, offset, limit, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Retreives a single seller
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} sellerId the dedicated instance path selector
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SellerControllerApi
   */
  sellerV1TenantSellerIdGet(tenant, sellerId, options) {
    return SellerControllerApiFp(this.configuration)
      .sellerV1TenantSellerIdGet(tenant, sellerId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * SepaDataStorageControllerApi - axios parameter creator
 * @export
 */
export const SepaDataStorageControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Endpoint to get SEPA data for a customer which would be natively handled by Shop-Apotheke.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sepaV1TenantGet: async (tenant, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("sepaV1TenantGet", "tenant", tenant);
      const localVarPath = `/sepa/v1/{tenant}`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Endpoint to delete SEPA data for a customer which would be natively handled by Shop-Apotheke.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sepaV1TenantIdDelete: async (tenant, id, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("sepaV1TenantIdDelete", "tenant", tenant);
      // verify required parameter 'id' is not null or undefined
      assertParamExists("sepaV1TenantIdDelete", "id", id);
      const localVarPath = `/sepa/v1/{tenant}/{id}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "DELETE", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Endpoint to update SEPA data for a customer which would be natively handled by Shop-Apotheke.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} id
     * @param {SepaDataV1} [SepaDataV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sepaV1TenantIdPut: async (tenant, id, SepaDataV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("sepaV1TenantIdPut", "tenant", tenant);
      // verify required parameter 'id' is not null or undefined
      assertParamExists("sepaV1TenantIdPut", "id", id);
      const localVarPath = `/sepa/v1/{tenant}/{id}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "PUT", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(SepaDataV1, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Endpoint to delete the migrated SEPA data of customer in Sepa-Data-Storage (for internal usage only)
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sepaV1TenantMigSepaDataIdDelete: async (tenant, id, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("sepaV1TenantMigSepaDataIdDelete", "tenant", tenant);
      // verify required parameter 'id' is not null or undefined
      assertParamExists("sepaV1TenantMigSepaDataIdDelete", "id", id);
      const localVarPath = `/sepa/v1/{tenant}/mig/sepaData/{id}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "DELETE", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Endpoint to migrate SEPA data of customers from LMS to Sepa-Data-Storage (for internal usage only)
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {MigrateSepaDataV1} MigrateSepaDataV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sepaV1TenantMigSepaDataPost: async (tenant, MigrateSepaDataV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("sepaV1TenantMigSepaDataPost", "tenant", tenant);
      // verify required parameter 'MigrateSepaDataV1' is not null or undefined
      assertParamExists("sepaV1TenantMigSepaDataPost", "MigrateSepaDataV1", MigrateSepaDataV1);
      const localVarPath = `/sepa/v1/{tenant}/mig/sepaData`.replace(
        `{${"tenant"}}`,
        encodeURIComponent(String(tenant))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(MigrateSepaDataV1, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Endpoint to save SEPA data for a customer which would be natively handled by Shop-Apotheke.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {SepaDataV1} [SepaDataV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sepaV1TenantPost: async (tenant, SepaDataV1, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("sepaV1TenantPost", "tenant", tenant);
      const localVarPath = `/sepa/v1/{tenant}`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "POST", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(SepaDataV1, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * SepaDataStorageControllerApi - functional programming interface
 * @export
 */
export const SepaDataStorageControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = SepaDataStorageControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * Endpoint to get SEPA data for a customer which would be natively handled by Shop-Apotheke.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sepaV1TenantGet(tenant, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sepaV1TenantGet(tenant, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Endpoint to delete SEPA data for a customer which would be natively handled by Shop-Apotheke.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sepaV1TenantIdDelete(tenant, id, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sepaV1TenantIdDelete(tenant, id, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Endpoint to update SEPA data for a customer which would be natively handled by Shop-Apotheke.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} id
     * @param {SepaDataV1} [SepaDataV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sepaV1TenantIdPut(tenant, id, SepaDataV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sepaV1TenantIdPut(tenant, id, SepaDataV1, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Endpoint to delete the migrated SEPA data of customer in Sepa-Data-Storage (for internal usage only)
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sepaV1TenantMigSepaDataIdDelete(tenant, id, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sepaV1TenantMigSepaDataIdDelete(tenant, id, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Endpoint to migrate SEPA data of customers from LMS to Sepa-Data-Storage (for internal usage only)
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {MigrateSepaDataV1} MigrateSepaDataV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sepaV1TenantMigSepaDataPost(tenant, MigrateSepaDataV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sepaV1TenantMigSepaDataPost(
        tenant,
        MigrateSepaDataV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Endpoint to save SEPA data for a customer which would be natively handled by Shop-Apotheke.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {SepaDataV1} [SepaDataV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sepaV1TenantPost(tenant, SepaDataV1, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sepaV1TenantPost(tenant, SepaDataV1, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * SepaDataStorageControllerApi - factory interface
 * @export
 */
export const SepaDataStorageControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = SepaDataStorageControllerApiFp(configuration);
  return {
    /**
     * Endpoint to get SEPA data for a customer which would be natively handled by Shop-Apotheke.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sepaV1TenantGet(tenant, options) {
      return localVarFp.sepaV1TenantGet(tenant, options).then((request) => request(axios, basePath));
    },
    /**
     * Endpoint to delete SEPA data for a customer which would be natively handled by Shop-Apotheke.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sepaV1TenantIdDelete(tenant, id, options) {
      return localVarFp.sepaV1TenantIdDelete(tenant, id, options).then((request) => request(axios, basePath));
    },
    /**
     * Endpoint to update SEPA data for a customer which would be natively handled by Shop-Apotheke.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} id
     * @param {SepaDataV1} [SepaDataV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sepaV1TenantIdPut(tenant, id, SepaDataV1, options) {
      return localVarFp.sepaV1TenantIdPut(tenant, id, SepaDataV1, options).then((request) => request(axios, basePath));
    },
    /**
     * Endpoint to delete the migrated SEPA data of customer in Sepa-Data-Storage (for internal usage only)
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sepaV1TenantMigSepaDataIdDelete(tenant, id, options) {
      return localVarFp
        .sepaV1TenantMigSepaDataIdDelete(tenant, id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Endpoint to migrate SEPA data of customers from LMS to Sepa-Data-Storage (for internal usage only)
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {MigrateSepaDataV1} MigrateSepaDataV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sepaV1TenantMigSepaDataPost(tenant, MigrateSepaDataV1, options) {
      return localVarFp
        .sepaV1TenantMigSepaDataPost(tenant, MigrateSepaDataV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Endpoint to save SEPA data for a customer which would be natively handled by Shop-Apotheke.
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {SepaDataV1} [SepaDataV1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sepaV1TenantPost(tenant, SepaDataV1, options) {
      return localVarFp.sepaV1TenantPost(tenant, SepaDataV1, options).then((request) => request(axios, basePath));
    }
  };
};
/**
 * SepaDataStorageControllerApi - object-oriented interface
 * @export
 * @class SepaDataStorageControllerApi
 * @extends {BaseAPI}
 */
export class SepaDataStorageControllerApi extends BaseAPI {
  /**
   * Endpoint to get SEPA data for a customer which would be natively handled by Shop-Apotheke.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SepaDataStorageControllerApi
   */
  sepaV1TenantGet(tenant, options) {
    return SepaDataStorageControllerApiFp(this.configuration)
      .sepaV1TenantGet(tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Endpoint to delete SEPA data for a customer which would be natively handled by Shop-Apotheke.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SepaDataStorageControllerApi
   */
  sepaV1TenantIdDelete(tenant, id, options) {
    return SepaDataStorageControllerApiFp(this.configuration)
      .sepaV1TenantIdDelete(tenant, id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Endpoint to update SEPA data for a customer which would be natively handled by Shop-Apotheke.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} id
   * @param {SepaDataV1} [SepaDataV1]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SepaDataStorageControllerApi
   */
  sepaV1TenantIdPut(tenant, id, SepaDataV1, options) {
    return SepaDataStorageControllerApiFp(this.configuration)
      .sepaV1TenantIdPut(tenant, id, SepaDataV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Endpoint to delete the migrated SEPA data of customer in Sepa-Data-Storage (for internal usage only)
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SepaDataStorageControllerApi
   */
  sepaV1TenantMigSepaDataIdDelete(tenant, id, options) {
    return SepaDataStorageControllerApiFp(this.configuration)
      .sepaV1TenantMigSepaDataIdDelete(tenant, id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Endpoint to migrate SEPA data of customers from LMS to Sepa-Data-Storage (for internal usage only)
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {MigrateSepaDataV1} MigrateSepaDataV1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SepaDataStorageControllerApi
   */
  sepaV1TenantMigSepaDataPost(tenant, MigrateSepaDataV1, options) {
    return SepaDataStorageControllerApiFp(this.configuration)
      .sepaV1TenantMigSepaDataPost(tenant, MigrateSepaDataV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Endpoint to save SEPA data for a customer which would be natively handled by Shop-Apotheke.
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {SepaDataV1} [SepaDataV1]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SepaDataStorageControllerApi
   */
  sepaV1TenantPost(tenant, SepaDataV1, options) {
    return SepaDataStorageControllerApiFp(this.configuration)
      .sepaV1TenantPost(tenant, SepaDataV1, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * ToggleControllerApi - axios parameter creator
 * @export
 */
export const ToggleControllerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @summary Get toggles by tenant
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    toggleV1TenantTogglesGet: async (tenant, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("toggleV1TenantTogglesGet", "tenant", tenant);
      const localVarPath = `/toggle/v1/{tenant}/toggles`.replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Get toggle by tenant and toggleName
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} toggleName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    toggleV1TenantTogglesToggleNameGet: async (tenant, toggleName, options = {}) => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("toggleV1TenantTogglesToggleNameGet", "tenant", tenant);
      // verify required parameter 'toggleName' is not null or undefined
      assertParamExists("toggleV1TenantTogglesToggleNameGet", "toggleName", toggleName);
      const localVarPath = `/toggle/v1/{tenant}/toggles/{toggleName}`
        .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
        .replace(`{${"toggleName"}}`, encodeURIComponent(String(toggleName)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Get all toggles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    toggleV1TogglesGet: async (options = {}) => {
      const localVarPath = `/toggle/v1/toggles`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Get toggle by toggleName for all tenants.
     * @param {string} toggleName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    toggleV1TogglesToggleNameGet: async (toggleName, options = {}) => {
      // verify required parameter 'toggleName' is not null or undefined
      assertParamExists("toggleV1TogglesToggleNameGet", "toggleName", toggleName);
      const localVarPath = `/toggle/v1/toggles/{toggleName}`.replace(
        `{${"toggleName"}}`,
        encodeURIComponent(String(toggleName))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: "GET", ...baseOptions, ...options};
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * ToggleControllerApi - functional programming interface
 * @export
 */
export const ToggleControllerApiFp = function (configuration) {
  const localVarAxiosParamCreator = ToggleControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get toggles by tenant
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async toggleV1TenantTogglesGet(tenant, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.toggleV1TenantTogglesGet(tenant, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Get toggle by tenant and toggleName
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} toggleName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async toggleV1TenantTogglesToggleNameGet(tenant, toggleName, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.toggleV1TenantTogglesToggleNameGet(
        tenant,
        toggleName,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Get all toggles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async toggleV1TogglesGet(options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.toggleV1TogglesGet(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Get toggle by toggleName for all tenants.
     * @param {string} toggleName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async toggleV1TogglesToggleNameGet(toggleName, options) {
      const localVarAxiosArgs = await localVarAxiosParamCreator.toggleV1TogglesToggleNameGet(toggleName, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};
/**
 * ToggleControllerApi - factory interface
 * @export
 */
export const ToggleControllerApiFactory = function (configuration, basePath, axios) {
  const localVarFp = ToggleControllerApiFp(configuration);
  return {
    /**
     *
     * @summary Get toggles by tenant
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    toggleV1TenantTogglesGet(tenant, options) {
      return localVarFp.toggleV1TenantTogglesGet(tenant, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get toggle by tenant and toggleName
     * @param {string} tenant The tenant, e.g. com-dev or com.
     * @param {string} toggleName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    toggleV1TenantTogglesToggleNameGet(tenant, toggleName, options) {
      return localVarFp
        .toggleV1TenantTogglesToggleNameGet(tenant, toggleName, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all toggles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    toggleV1TogglesGet(options) {
      return localVarFp.toggleV1TogglesGet(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get toggle by toggleName for all tenants.
     * @param {string} toggleName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    toggleV1TogglesToggleNameGet(toggleName, options) {
      return localVarFp.toggleV1TogglesToggleNameGet(toggleName, options).then((request) => request(axios, basePath));
    }
  };
};
/**
 * ToggleControllerApi - object-oriented interface
 * @export
 * @class ToggleControllerApi
 * @extends {BaseAPI}
 */
export class ToggleControllerApi extends BaseAPI {
  /**
   *
   * @summary Get toggles by tenant
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ToggleControllerApi
   */
  toggleV1TenantTogglesGet(tenant, options) {
    return ToggleControllerApiFp(this.configuration)
      .toggleV1TenantTogglesGet(tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get toggle by tenant and toggleName
   * @param {string} tenant The tenant, e.g. com-dev or com.
   * @param {string} toggleName
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ToggleControllerApi
   */
  toggleV1TenantTogglesToggleNameGet(tenant, toggleName, options) {
    return ToggleControllerApiFp(this.configuration)
      .toggleV1TenantTogglesToggleNameGet(tenant, toggleName, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get all toggles
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ToggleControllerApi
   */
  toggleV1TogglesGet(options) {
    return ToggleControllerApiFp(this.configuration)
      .toggleV1TogglesGet(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get toggle by toggleName for all tenants.
   * @param {string} toggleName
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ToggleControllerApi
   */
  toggleV1TogglesToggleNameGet(toggleName, options) {
    return ToggleControllerApiFp(this.configuration)
      .toggleV1TogglesToggleNameGet(toggleName, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
